import './style.css';
import { jsx as d, jsxs as I, Fragment as a1 } from "react/jsx-runtime";
import * as At from "react";
import W, { forwardRef as Lr, useImperativeHandle as Cs, useState as ae, useContext as Se, Children as vl, useEffect as K, useRef as X, useMemo as ve, useLayoutEffect as Ln, useReducer as ni, useCallback as ar, Fragment as lt, isValidElement as yl, cloneElement as xl, createElement as wl, createContext as Re, createRef as l1 } from "react";
import { createPortal as Q1 } from "react-dom";
var zt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Qi = { exports: {} };
(function(t, e) {
  var r = 200, n = "__lodash_hash_undefined__", i = 9007199254740991, s = "[object Arguments]", o = "[object Array]", l = "[object Boolean]", c = "[object Date]", u = "[object Error]", f = "[object Function]", C = "[object GeneratorFunction]", v = "[object Map]", w = "[object Number]", g = "[object Object]", b = "[object Promise]", _ = "[object RegExp]", h = "[object Set]", y = "[object String]", E = "[object Symbol]", T = "[object WeakMap]", $ = "[object ArrayBuffer]", L = "[object DataView]", z = "[object Float32Array]", P = "[object Float64Array]", B = "[object Int8Array]", q = "[object Int16Array]", N = "[object Int32Array]", R = "[object Uint8Array]", D = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", se = "[object Uint32Array]", Y = /[\\^$.*+?()[\]{}|]/g, ie = /\w*$/, F = /^\[object .+?Constructor\]$/, O = /^(?:0|[1-9]\d*)$/, k = {};
  k[s] = k[o] = k[$] = k[L] = k[l] = k[c] = k[z] = k[P] = k[B] = k[q] = k[N] = k[v] = k[w] = k[g] = k[_] = k[h] = k[y] = k[E] = k[R] = k[D] = k[Q] = k[se] = !0, k[u] = k[f] = k[T] = !1;
  var U = typeof zt == "object" && zt && zt.Object === Object && zt, V = typeof self == "object" && self && self.Object === Object && self, H = U || V || Function("return this")(), le = e && !e.nodeType && e, me = le && !0 && t && !t.nodeType && t, we = me && me.exports === le;
  function Pe(a, m) {
    return a.set(m[0], m[1]), a;
  }
  function it(a, m) {
    return a.add(m), a;
  }
  function ke(a, m) {
    for (var x = -1, A = a ? a.length : 0; ++x < A && m(a[x], x, a) !== !1; )
      ;
    return a;
  }
  function Ae(a, m) {
    for (var x = -1, A = m.length, ne = a.length; ++x < A; )
      a[ne + x] = m[x];
    return a;
  }
  function Yt(a, m, x, A) {
    var ne = -1, ce = a ? a.length : 0;
    for (A && ce && (x = a[++ne]); ++ne < ce; )
      x = m(x, a[ne], ne, a);
    return x;
  }
  function Jt(a, m) {
    for (var x = -1, A = Array(a); ++x < a; )
      A[x] = m(x);
    return A;
  }
  function Cr(a, m) {
    return a == null ? void 0 : a[m];
  }
  function yt(a) {
    var m = !1;
    if (a != null && typeof a.toString != "function")
      try {
        m = !!(a + "");
      } catch {
      }
    return m;
  }
  function xt(a) {
    var m = -1, x = Array(a.size);
    return a.forEach(function(A, ne) {
      x[++m] = [ne, A];
    }), x;
  }
  function wt(a, m) {
    return function(x) {
      return a(m(x));
    };
  }
  function ft(a) {
    var m = -1, x = Array(a.size);
    return a.forEach(function(A) {
      x[++m] = A;
    }), x;
  }
  var gr = Array.prototype, vr = Function.prototype, Ye = Object.prototype, st = H["__core-js_shared__"], Ft = function() {
    var a = /[^.]+$/.exec(st && st.keys && st.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }(), Rt = vr.toString, Ee = Ye.hasOwnProperty, ot = Ye.toString, $r = RegExp(
    "^" + Rt.call(Ee).replace(Y, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), bt = we ? H.Buffer : void 0, Zt = H.Symbol, Kt = H.Uint8Array, jr = wt(Object.getPrototypeOf, Object), pt = Object.create, yr = Ye.propertyIsEnumerable, Fr = gr.splice, Xt = Object.getOwnPropertySymbols, xr = bt ? bt.isBuffer : void 0, Rr = wt(Object.keys, Object), ht = Z(H, "DataView"), ze = Z(H, "Map"), Je = Z(H, "Promise"), mt = Z(H, "Set"), Ct = Z(H, "WeakMap"), Ne = Z(Object, "create"), er = Fe(ht), tr = Fe(ze), Ir = Fe(Je), Dr = Fe(mt), Vr = Fe(Ct), _t = Zt ? Zt.prototype : void 0, rr = _t ? _t.valueOf : void 0;
  function Me(a) {
    var m = -1, x = a ? a.length : 0;
    for (this.clear(); ++m < x; ) {
      var A = a[m];
      this.set(A[0], A[1]);
    }
  }
  function zr() {
    this.__data__ = Ne ? Ne(null) : {};
  }
  function Br(a) {
    return this.has(a) && delete this.__data__[a];
  }
  function Wr(a) {
    var m = this.__data__;
    if (Ne) {
      var x = m[a];
      return x === n ? void 0 : x;
    }
    return Ee.call(m, a) ? m[a] : void 0;
  }
  function Hr(a) {
    var m = this.__data__;
    return Ne ? m[a] !== void 0 : Ee.call(m, a);
  }
  function Gr(a, m) {
    var x = this.__data__;
    return x[a] = Ne && m === void 0 ? n : m, this;
  }
  Me.prototype.clear = zr, Me.prototype.delete = Br, Me.prototype.get = Wr, Me.prototype.has = Hr, Me.prototype.set = Gr;
  function be(a) {
    var m = -1, x = a ? a.length : 0;
    for (this.clear(); ++m < x; ) {
      var A = a[m];
      this.set(A[0], A[1]);
    }
  }
  function qr() {
    this.__data__ = [];
  }
  function Ie(a) {
    var m = this.__data__, x = Ze(m, a);
    if (x < 0)
      return !1;
    var A = m.length - 1;
    return x == A ? m.pop() : Fr.call(m, x, 1), !0;
  }
  function Ur(a) {
    var m = this.__data__, x = Ze(m, a);
    return x < 0 ? void 0 : m[x][1];
  }
  function Qr(a) {
    return Ze(this.__data__, a) > -1;
  }
  function Yr(a, m) {
    var x = this.__data__, A = Ze(x, a);
    return A < 0 ? x.push([a, m]) : x[A][1] = m, this;
  }
  be.prototype.clear = qr, be.prototype.delete = Ie, be.prototype.get = Ur, be.prototype.has = Qr, be.prototype.set = Yr;
  function $e(a) {
    var m = -1, x = a ? a.length : 0;
    for (this.clear(); ++m < x; ) {
      var A = a[m];
      this.set(A[0], A[1]);
    }
  }
  function Jr() {
    this.__data__ = {
      hash: new Me(),
      map: new (ze || be)(),
      string: new Me()
    };
  }
  function Zr(a) {
    return J(this, a).delete(a);
  }
  function Kr(a) {
    return J(this, a).get(a);
  }
  function Xr(a) {
    return J(this, a).has(a);
  }
  function en(a, m) {
    return J(this, a).set(a, m), this;
  }
  $e.prototype.clear = Jr, $e.prototype.delete = Zr, $e.prototype.get = Kr, $e.prototype.has = Xr, $e.prototype.set = en;
  function je(a) {
    this.__data__ = new be(a);
  }
  function nr() {
    this.__data__ = new be();
  }
  function wr(a) {
    return this.__data__.delete(a);
  }
  function tn(a) {
    return this.__data__.get(a);
  }
  function rn(a) {
    return this.__data__.has(a);
  }
  function br(a, m) {
    var x = this.__data__;
    if (x instanceof be) {
      var A = x.__data__;
      if (!ze || A.length < r - 1)
        return A.push([a, m]), this;
      x = this.__data__ = new $e(A);
    }
    return x.set(a, m), this;
  }
  je.prototype.clear = nr, je.prototype.delete = wr, je.prototype.get = tn, je.prototype.has = rn, je.prototype.set = br;
  function nn(a, m) {
    var x = ir(a) || Oi(a) ? Jt(a.length, String) : [], A = x.length, ne = !!A;
    for (var ce in a)
      (m || Ee.call(a, ce)) && !(ne && (ce == "length" || De(ce, A))) && x.push(ce);
    return x;
  }
  function It(a, m, x) {
    var A = a[m];
    (!(Ee.call(a, m) && pn(A, x)) || x === void 0 && !(m in a)) && (a[m] = x);
  }
  function Ze(a, m) {
    for (var x = a.length; x--; )
      if (pn(a[x][0], m))
        return x;
    return -1;
  }
  function _r(a, m) {
    return a && j(m, sr(m), a);
  }
  function St(a, m, x, A, ne, ce, he) {
    var de;
    if (A && (de = ce ? A(a, ne, ce, he) : A(a)), de !== void 0)
      return de;
    if (!Tt(a))
      return a;
    var Cn = ir(a);
    if (Cn) {
      if (de = Le(a), !m)
        return M(a, de);
    } else {
      var Be = ue(a), gn = Be == f || Be == C;
      if (Pi(a))
        return an(a, m);
      if (Be == g || Be == s || gn && !ce) {
        if (yt(a))
          return ce ? a : {};
        if (de = Oe(gn ? {} : a), !m)
          return G(a, _r(de, a));
      } else {
        if (!k[Be])
          return ce ? a : {};
        de = at(a, Be, St, m);
      }
    }
    he || (he = new je());
    var vn = he.get(a);
    if (vn)
      return vn;
    if (he.set(a, de), !Cn)
      var yn = x ? re(a) : sr(a);
    return ke(yn || a, function(or, kt) {
      yn && (kt = or, or = a[kt]), It(de, kt, St(or, m, x, A, kt, a, he));
    }), de;
  }
  function Sr(a) {
    return Tt(a) ? pt(a) : {};
  }
  function Er(a, m, x) {
    var A = m(a);
    return ir(a) ? A : Ae(A, x(a));
  }
  function sn(a) {
    return ot.call(a);
  }
  function on(a) {
    if (!Tt(a) || kr(a))
      return !1;
    var m = mn(a) || yt(a) ? $r : F;
    return m.test(Fe(a));
  }
  function Tr(a) {
    if (!Dt(a))
      return Rr(a);
    var m = [];
    for (var x in Object(a))
      Ee.call(a, x) && x != "constructor" && m.push(x);
    return m;
  }
  function an(a, m) {
    if (m)
      return a.slice();
    var x = new a.constructor(a.length);
    return a.copy(x), x;
  }
  function Et(a) {
    var m = new a.constructor(a.byteLength);
    return new Kt(m).set(new Kt(a)), m;
  }
  function ln(a, m) {
    var x = m ? Et(a.buffer) : a.buffer;
    return new a.constructor(x, a.byteOffset, a.byteLength);
  }
  function cn(a, m, x) {
    var A = m ? x(xt(a), !0) : xt(a);
    return Yt(A, Pe, new a.constructor());
  }
  function un(a) {
    var m = new a.constructor(a.source, ie.exec(a));
    return m.lastIndex = a.lastIndex, m;
  }
  function dn(a, m, x) {
    var A = m ? x(ft(a), !0) : ft(a);
    return Yt(A, it, new a.constructor());
  }
  function p(a) {
    return rr ? Object(rr.call(a)) : {};
  }
  function S(a, m) {
    var x = m ? Et(a.buffer) : a.buffer;
    return new a.constructor(x, a.byteOffset, a.length);
  }
  function M(a, m) {
    var x = -1, A = a.length;
    for (m || (m = Array(A)); ++x < A; )
      m[x] = a[x];
    return m;
  }
  function j(a, m, x, A) {
    x || (x = {});
    for (var ne = -1, ce = m.length; ++ne < ce; ) {
      var he = m[ne], de = A ? A(x[he], a[he], he, x, a) : void 0;
      It(x, he, de === void 0 ? a[he] : de);
    }
    return x;
  }
  function G(a, m) {
    return j(a, Ce(a), m);
  }
  function re(a) {
    return Er(a, sr, Ce);
  }
  function J(a, m) {
    var x = a.__data__;
    return fn(m) ? x[typeof m == "string" ? "string" : "hash"] : x.map;
  }
  function Z(a, m) {
    var x = Cr(a, m);
    return on(x) ? x : void 0;
  }
  var Ce = Xt ? wt(Xt, Object) : $i, ue = sn;
  (ht && ue(new ht(new ArrayBuffer(1))) != L || ze && ue(new ze()) != v || Je && ue(Je.resolve()) != b || mt && ue(new mt()) != h || Ct && ue(new Ct()) != T) && (ue = function(a) {
    var m = ot.call(a), x = m == g ? a.constructor : void 0, A = x ? Fe(x) : void 0;
    if (A)
      switch (A) {
        case er:
          return L;
        case tr:
          return v;
        case Ir:
          return b;
        case Dr:
          return h;
        case Vr:
          return T;
      }
    return m;
  });
  function Le(a) {
    var m = a.length, x = a.constructor(m);
    return m && typeof a[0] == "string" && Ee.call(a, "index") && (x.index = a.index, x.input = a.input), x;
  }
  function Oe(a) {
    return typeof a.constructor == "function" && !Dt(a) ? Sr(jr(a)) : {};
  }
  function at(a, m, x, A) {
    var ne = a.constructor;
    switch (m) {
      case $:
        return Et(a);
      case l:
      case c:
        return new ne(+a);
      case L:
        return ln(a, A);
      case z:
      case P:
      case B:
      case q:
      case N:
      case R:
      case D:
      case Q:
      case se:
        return S(a, A);
      case v:
        return cn(a, A, x);
      case w:
      case y:
        return new ne(a);
      case _:
        return un(a);
      case h:
        return dn(a, A, x);
      case E:
        return p(a);
    }
  }
  function De(a, m) {
    return m = m ?? i, !!m && (typeof a == "number" || O.test(a)) && a > -1 && a % 1 == 0 && a < m;
  }
  function fn(a) {
    var m = typeof a;
    return m == "string" || m == "number" || m == "symbol" || m == "boolean" ? a !== "__proto__" : a === null;
  }
  function kr(a) {
    return !!Ft && Ft in a;
  }
  function Dt(a) {
    var m = a && a.constructor, x = typeof m == "function" && m.prototype || Ye;
    return a === x;
  }
  function Fe(a) {
    if (a != null) {
      try {
        return Rt.call(a);
      } catch {
      }
      try {
        return a + "";
      } catch {
      }
    }
    return "";
  }
  function Mi(a) {
    return St(a, !0, !0);
  }
  function pn(a, m) {
    return a === m || a !== a && m !== m;
  }
  function Oi(a) {
    return Li(a) && Ee.call(a, "callee") && (!yr.call(a, "callee") || ot.call(a) == s);
  }
  var ir = Array.isArray;
  function hn(a) {
    return a != null && Ai(a.length) && !mn(a);
  }
  function Li(a) {
    return Ni(a) && hn(a);
  }
  var Pi = xr || ji;
  function mn(a) {
    var m = Tt(a) ? ot.call(a) : "";
    return m == f || m == C;
  }
  function Ai(a) {
    return typeof a == "number" && a > -1 && a % 1 == 0 && a <= i;
  }
  function Tt(a) {
    var m = typeof a;
    return !!a && (m == "object" || m == "function");
  }
  function Ni(a) {
    return !!a && typeof a == "object";
  }
  function sr(a) {
    return hn(a) ? nn(a) : Tr(a);
  }
  function $i() {
    return [];
  }
  function ji() {
    return !1;
  }
  t.exports = Mi;
})(Qi, Qi.exports);
var lr = Qi.exports, Sn = function() {
  return Sn = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (e[s] = r[s]);
    }
    return e;
  }, Sn.apply(this, arguments);
};
function bl(t, e, r, n) {
  function i(s) {
    return s instanceof r ? s : new r(function(o) {
      o(s);
    });
  }
  return new (r || (r = Promise))(function(s, o) {
    function l(f) {
      try {
        u(n.next(f));
      } catch (C) {
        o(C);
      }
    }
    function c(f) {
      try {
        u(n.throw(f));
      } catch (C) {
        o(C);
      }
    }
    function u(f) {
      f.done ? s(f.value) : i(f.value).then(l, c);
    }
    u((n = n.apply(t, e || [])).next());
  });
}
function _l(t, e) {
  var r = { label: 0, sent: function() {
    if (s[0] & 1)
      throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(u) {
    return function(f) {
      return c([u, f]);
    };
  }
  function c(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (r = 0)), r; )
      try {
        if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done)
          return s;
        switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
          case 0:
          case 1:
            s = u;
            break;
          case 4:
            return r.label++, { value: u[1], done: !1 };
          case 5:
            r.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              r = 0;
              continue;
            }
            if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
              r.label = u[1];
              break;
            }
            if (u[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = u;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(u);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        u = e.call(t, r);
      } catch (f) {
        u = [6, f], i = 0;
      } finally {
        n = s = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function Hn(t, e, r, n, i) {
  return bl(this, void 0, void 0, function() {
    var s, o;
    return _l(this, function(l) {
      switch (l.label) {
        case 0:
          if (r === void 0)
            return [
              2
              /*return*/
            ];
          o = 0, l.label = 1;
        case 1:
          return o < r.length ? [4, r[o](t, e, n, i, r)] : [3, 4];
        case 2:
          if (s = l.sent(), s === "canceled")
            return [3, 4];
          l.label = 3;
        case 3:
          return o++, [3, 1];
        case 4:
          return s !== "canceled" ? [2, s] : [
            2
            /*return*/
          ];
      }
    });
  });
}
var Yi = function(t, e) {
  return e === void 0 && (e = {}), t ? {
    trackedAnalytics: Sn({ sdkCode: t.sdkCode, sdkSemver: t.sdkSemver, techVersion: t.techVersion }, e)
  } : null;
}, Sl = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      var s = this;
      this.isMounted = !0, this.imgElement = e, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var o = lr(r);
      Hn(e, o, n, this.htmlPluginState, i).then(function(l) {
        if (s.isMounted) {
          s.htmlPluginState.pluginEventSubscription.forEach(function(u) {
            u();
          });
          var c = Yi(i, l);
          s.imgElement.setAttribute("src", o.toURL(c));
        }
      });
    }
    return t.prototype.update = function(e, r, n) {
      var i = this, s = lr(e);
      Hn(this.imgElement, s, r, this.htmlPluginState).then(function(o) {
        if (i.isMounted) {
          var l = Yi(n, o);
          i.imgElement.setAttribute("src", s.toURL(l));
        }
      });
    }, t.prototype.unmount = function() {
      this.isMounted = !1;
    }, t;
  }()
);
class ye {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(e) {
    this.values = [], this.delimiter = ":", this.hasValue(e) && this.addValue(e);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(e) {
    return typeof e < "u" && e !== null && e !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(e) {
    return Array.isArray(e) ? this.values = this.values.concat(e) : this.values.push(e), this.values = this.values.filter((r) => this.hasValue(r)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(e) {
    return this.delimiter = e, this;
  }
}
class El extends Error {
  constructor(e = "Unsupported") {
    super(e);
  }
}
function gs(t) {
  return new El(t);
}
function Tl() {
  return this._qualifierModel || { error: gs(`unsupported qualifier ${this.constructor.name}`) };
}
class kl {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return Tl.apply(this);
  }
}
class ee extends kl {
  constructor(e, r) {
    super(), this.delimiter = "_", this.key = e, r instanceof ye ? this.qualifierValue = r : (this.qualifierValue = new ye(), this.qualifierValue.addValue(r));
  }
  toString() {
    const { key: e, delimiter: r, qualifierValue: n } = this;
    return `${e}${r}${n.toString()}`;
  }
  addValue(e) {
    return this.qualifierValue.addValue(e), this;
  }
}
class Ke extends ee {
  constructor(e, r) {
    let n;
    r ? n = new ye([e, `${r}`]).setDelimiter(":") : n = e, super("fl", n), this.flagValue = r;
  }
  toString() {
    return super.toString().replace(/\./, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
}
function Ml(t, e) {
  const r = Array.from(t.entries());
  return e.forEach((n) => {
    r.push(["fl", n]);
  }), r.sort().map((n) => n[1]);
}
function Ol() {
  var t, e, r;
  const n = this._actionModel && Object.keys(this._actionModel).length, i = (r = (e = (t = this._actionModel) === null || t === void 0 ? void 0 : t.source) === null || e === void 0 ? void 0 : e.transformation) === null || r === void 0 ? void 0 : r.error;
  return i && i instanceof Error ? { error: i } : n ? this._actionModel : { error: gs(`unsupported action ${this.constructor.name}`) };
}
class Ll {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return Ol.apply(this);
  }
}
class nt extends Ll {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(e) {
    return this.actionTag = e, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), Ml(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(e) {
    if (typeof e == "string") {
      const [r, n] = e.toLowerCase().split("_");
      r === "fl" ? this.flags.push(new Ke(n)) : this.qualifiers.set(r, new ee(r, n));
    } else
      this.qualifiers.set(e.key, e);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(e) {
    return typeof e == "string" ? this.flags.push(new Ke(e)) : e instanceof Ke && this.flags.push(e), this;
  }
  addValueToQualifier(e, r) {
    return this.qualifiers.get(e).addValue(r), this;
  }
}
class vs extends nt {
  constructor(e) {
    super(), this.regionType = e, this._actionModel.regionType = e;
  }
}
class ii extends vs {
  constructor() {
    super("custom");
  }
  /**
   * @description The x position in pixels.
   * @param {number | string} x
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ee("x", e)), this;
  }
  /**
   * @description The y position in pixels.
   * @param {number | string} y
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ee("y", e)), this;
  }
  /**
   * @description The width of the region in pixels.
   * @param {number | string} width
   */
  width(e) {
    return this._actionModel.width = e, this.addQualifier(new ee("w", e)), this;
  }
  /**
   * @description The height of the region in pixels.
   * @param {number | string} height
   */
  height(e) {
    return this._actionModel.height = e, this.addQualifier(new ee("h", e)), this;
  }
  static fromJson(e) {
    const r = new ii();
    return e.width && r.width(e.width), e.height && r.height(e.height), e.x && r.x(e.x), e.y && r.y(e.y), r;
  }
}
function Pl() {
  return new ii();
}
function Y1() {
  return new vs("faces");
}
function Al() {
  return new vs("ocr_text");
}
class Nl extends nt {
  constructor(e) {
    super(), this._actionModel = {}, this._strength = e, this._actionModel.actionType = "blur", this._actionModel.strength = e;
  }
  /**
   * @description Specifies the region to blur.
   * @param {NamedRegion} blurRegion
   */
  region(e) {
    return this._region = e, this._actionModel.region = e.toJson(), this;
  }
  /**
   * @description Sets the strength of the blur effect.
   * @param {number | string} strength
   */
  strength(e) {
    return this._strength = e, this._actionModel.strength = e, this;
  }
  prepareQualifiers() {
    const e = this._strength ? `:${this._strength}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((n) => this.addQualifier(n)), this._region.regionType === "custom" && this.addQualifier(new ee("e", `blur_region${e}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new ee("e", `blur_region${e}`)), this.addQualifier(new ee("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new ee("e", `blur_faces${e}`))) : this.addQualifier(new ee("e", `blur${e}`));
  }
  static fromJson(e) {
    const { strength: r, region: n } = e, i = new this(r);
    return r && i.strength(r), n && n.regionType === "faces" && i.region(Y1()), n && n.regionType === "ocr_text" && i.region(Al()), n && n.regionType === "custom" && i.region(ii.fromJson(n)), i;
  }
}
function fr(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    e[t[r]] = r;
  }), e;
}
const J1 = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad"
}, $l = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, Z1 = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, K1 = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, jl = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, X1 = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, Fl = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
}, Rl = fr(X1);
fr(Fl);
const Il = fr(J1), Dl = fr($l), eo = fr(Z1);
fr(K1);
fr(jl);
class to extends nt {
  constructor(e, r) {
    super(), this._actionModel = {}, this._actionModel.actionType = eo[e] || e;
    const n = this.createEffectQualifier(e, r);
    this.addQualifier(n);
  }
  createEffectQualifier(e, r) {
    let n;
    return r ? n = new ye([e, `${r}`]).setDelimiter(":") : n = new ye(e), new ee("e", n);
  }
  static fromJson(e) {
    const { actionType: r, level: n, strength: i } = e, s = Z1[r] || r;
    return new this(s, n || i);
  }
}
class Vl extends to {
  constructor(e, r) {
    super(e, r), this.LEVEL_NAME = "level", this._actionModel = {}, this.effectType = e, this._actionModel.actionType = eo[e] || e, r && this.setLevel(r);
  }
  /**
   *
   * @description Sets the effect level for the action
   * @param {string | number} level - The strength of the effect
   * @protected
   */
  setLevel(e) {
    this._actionModel[this.LEVEL_NAME] = e;
    const r = this.createEffectQualifier(this.effectType, e);
    return this.addQualifier(r), this;
  }
}
function si(t) {
  return t && (t.match(/^#/) ? `rgb:${t.substr(1)}` : t);
}
class zl extends nt {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "vectorize";
  }
  /**
   * @description The number of colors. (Range: 2 to 30, Server default: 10)
   * @param {number | string} num
   * @return {this}
   */
  numOfColors(e) {
    return this._actionModel.numOfColors = e, this._numOfColors = e, this;
  }
  /**
   * @description The level of detail. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 1000). (Server default: 300)
   * @param {number | string} num
   * @return {this}
   */
  detailsLevel(e) {
    return this._actionModel.detailLevel = e, this._detailsLevel = e, this;
  }
  /**
   * @description The size of speckles to suppress. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 100, Server default: 2)
   * @param {number | string} num
   * @return {this}
   */
  despeckleLevel(e) {
    return this._actionModel.despeckleLevel = e, this._despeckleLevel = e, this;
  }
  /**
   * @description The corner threshold. Specify 100 for no smoothing (polygon corners), 0 for completely smooth corners. (Range: 0 to 100, Default: 25)
   * @param {number | string} num
   * @return {this}
   */
  cornersLevel(e) {
    return this._actionModel.cornersLevel = e, this._cornersLevel = e, this;
  }
  /**
   * @description The optimization value. Specify 100 for least optimization and the largest file. (Range: 0 to 100, Server default: 100).
   * @param {number} num
   * @return {this}
   */
  paths(e) {
    return this._actionModel.paths = e, this._paths = e, this;
  }
  prepareQualifiers() {
    let e = "vectorize";
    this._numOfColors && (e += `:${new ye(`colors:${this._numOfColors}`).toString()}`), this._detailsLevel && (e += `:${new ye(`detail:${this._detailsLevel}`).toString()}`), this._despeckleLevel && (e += `:${new ye(`despeckle:${this._despeckleLevel}`).toString()}`), this._paths && (e += `:${new ye(`paths:${this._paths}`).toString()}`), this._cornersLevel && (e += `:${new ye(`corners:${this._cornersLevel}`).toString()}`), this.addQualifier(new ee("e", e));
  }
  static fromJson(e) {
    const { actionType: r, paths: n, cornersLevel: i, despeckleLevel: s, detailLevel: o, numOfColors: l } = e, c = new this();
    return n && c.paths(n), i && c.cornersLevel(i), s && c.despeckleLevel(s), o && c.detailsLevel(o), l && c.numOfColors(l), c;
  }
}
class Bl extends Vl {
  level(e) {
    return this._actionModel.level = e, this.setLevel(e);
  }
}
class Wl extends nt {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "assistColorblind", this.addQualifier(new ee("e", new ye("assist_colorblind")));
  }
  /**
   * @description Replaces problematic colors with colors that are easier to differentiate.
   * @return {this}
   */
  xray() {
    return this._actionModel.type = "xray", this.addQualifier(new ee("e", new ye(["assist_colorblind", "xray"]).setDelimiter(":")));
  }
  /**
   * @description Applies stripes of the specified intensity to help people with common color blind conditions to differentiate between colors that are similar for them.
   * @param {number | string} strength The intensity of the stripes. (Range: 1 to 100, Server default: 10)
   * @return {this}
   */
  stripesStrength(e) {
    return this._actionModel.type = "stripes", this._actionModel.stripesStrength = e, this.addQualifier(new ee("e", new ye(["assist_colorblind", e]).setDelimiter(":")));
  }
  static fromJson(e) {
    const { actionType: r, type: n, stripesStrength: i } = e, s = new this();
    return n === "xray" && s.xray(), n === "stripes" && i && s.stripesStrength(i), s;
  }
}
class Hl extends Bl {
  /**
   * @description The color to use for colorization. Specify HTML name or RGB hex code. (Server default: gray)
   * @param {string} color HTML name(red, green, etc.) or RGB hex code. (Server default: gray)
   * @return {this}
   */
  color(e) {
    return this._actionModel.color = e, this.addQualifier(new ee("co", new ye(si(e))));
  }
  static fromJson(e) {
    const { actionType: r, level: n, color: i } = e, s = new this(r, n);
    return i && s.color(i), s;
  }
}
class Gl extends nt {
  constructor(e) {
    super(), this._actionModel = {}, this._squareSize = e, this._actionModel.actionType = "pixelate", this._actionModel.squareSize = e;
  }
  /**
   * @description Specifies the region to piexlate.
   * @param {NamedRegion} pixelateRegion
   */
  region(e) {
    return this._region = e, this._actionModel.region = { regionType: this._region.regionType }, this;
  }
  /**
   * @description Sets the squareSize of the pixelate effect.
   * @param {number | string} squareSize
   */
  squareSize(e) {
    return this._squareSize = e, this._actionModel.squareSize = e, this;
  }
  prepareQualifiers() {
    const e = this._squareSize ? `:${this._squareSize}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((n) => this.addQualifier(n)), this._region.regionType === "custom" && this.addQualifier(new ee("e", `pixelate_region${e}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new ee("e", `pixelate_region${e}`)), this.addQualifier(new ee("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new ee("e", `pixelate_faces${e}`))) : this.addQualifier(new ee("e", `pixelate${e}`));
  }
  static fromJson(e) {
    const { region: r, squareSize: n } = e, i = new this(n);
    return n && i.squareSize(n), r && r.regionType === "faces" && i.region(Y1()), r && r.regionType === "custom" && i.region(Pl()), i;
  }
}
function ql(t) {
  return new Nl(t);
}
function Ul() {
  return new to("grayscale");
}
function c1(t) {
  return new Hl("colorize", t);
}
function Ql() {
  return new zl();
}
function Yl() {
  return new Wl();
}
function Jl(t) {
  return new Gl(t);
}
class Zl extends nt {
  constructor(e) {
    super(), this._actionModel = {}, this.addQualifier(new ee("b", new ye(si(e)).setDelimiter("_"))), this._actionModel.color = e, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(e) {
    const { color: r } = e;
    return new this(r);
  }
}
class u1 {
  constructor(e) {
    this.raw = e;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: gs(`unsupported action ${this.constructor.name}`) };
  }
}
function Kl(t) {
  const e = t;
  return "error" in e && !!e.error;
}
function Xl() {
  return new Ke("ignore_aspect_ratio");
}
function e3() {
  return new Ke("lossy");
}
function t3() {
  return new Ke("preserve_transparency");
}
function r3(t) {
  return new Ke("progressive", t);
}
function n3() {
  return new Ke("region_relative");
}
function i3() {
  return new Ke("relative");
}
class ys extends ye {
  constructor(e) {
    super(e), this.val = e;
  }
  getValue() {
    return this.val;
  }
}
class ro extends nt {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(e, r, n) {
    super(), this._actionModel = {};
    let i;
    r instanceof ys ? i = r.getValue() : i = r, this._actionModel.actionType = Dl[e], this._actionModel[n] = i, this.addQualifier(new ee(e, r));
  }
}
class s3 extends Ke {
  constructor(e) {
    super("progressive", e);
  }
}
class Ji extends ro {
  constructor(e, r) {
    super(e, r, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(e3()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(e) {
    return e instanceof s3 ? (this._actionModel.progressive = { mode: e.getFlagValue() }, this.addFlag(e)) : (this._actionModel.progressive = { mode: e }, this.addFlag(r3(e))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(t3()), this;
  }
  static fromJson(e) {
    const { formatType: r, lossy: n, progressive: i, preserveTransparency: s } = e;
    let o;
    return r ? o = new this("f", r) : o = new this("f"), i && (i.mode ? o.progressive(i.mode) : o.progressive()), n && o.lossy(), s && o.preserveTransparency(), o;
  }
}
class Pr {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(e) {
    let r;
    if (typeof e == "string") {
      if (e.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      r = new u1(e);
    } else
      r = e;
    return this.actions.push(r), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(e) {
    return e instanceof Pr ? this.actions = this.actions.concat(e.actions) : this.actions.push(new u1(e)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((e) => e.toString()).filter((e) => e).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(e) {
    return this.addAction(e);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(e) {
    return this.addAction(e);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(e) {
    return this.addAction(e);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(e) {
    return this.addAction(new Ji("q", e)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(e) {
    return this.addAction(new Ji("f", e)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(e) {
    return e.setLayerType("u"), this.addAction(e);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(e) {
    return this.addAction(e);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(e) {
    return this.addAction(e);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(e) {
    return this.addAction(e);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(e) {
    return this.addAction(new Zl(e));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(e) {
    return this.addAction(e);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(e) {
    const r = new nt();
    let n = e;
    return typeof e == "string" && (n = new Ke(e)), r.addQualifier(n), this.addAction(r);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(e) {
    return this.addAction(e);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(e) {
    return this.addAction(e);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(e) {
    return this.addAction(e);
  }
  toJson() {
    const e = [];
    for (const r of this.actions) {
      const n = r.toJson();
      if (Kl(n))
        return n;
      e.push(n);
    }
    return { actions: e };
  }
}
function d1(t) {
  const e = t.toString();
  return e.match(/[A-Z]/gi) || e.length > 1 && e[0] === "0" ? e : !isNaN(parseFloat(e)) && e.indexOf(":") === -1 && e.indexOf(".") === -1 ? `${e}.0` : e;
}
class o3 extends ye {
}
class no extends nt {
  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  constructor(e, r, n) {
    super(), this._actionModel = { dimensions: {} }, this._actionModel.actionType = Il[e] || e, this.addQualifier(new ee("c", e)), r && this.width(r), n && this.height(n);
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  height(e) {
    return this._actionModel.dimensions.height = e, this.addQualifier(new ee("h", e));
  }
  /**
   * @description Sets the width of the resize
   * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  width(e) {
    return this._actionModel.dimensions.width = e, this.addQualifier(new ee("w", e));
  }
  /**
   * @description Sets the aspect ratio of the asset.
   * For a list of supported types see {@link Qualifiers.AspectRatio|
    * AspectRatio values}
   * @param {AspectRatioType|number|string} ratio The new aspect ratio, specified as a percentage or ratio.
   * @return {this}
   */
  aspectRatio(e) {
    if (e instanceof o3)
      return this._actionModel.dimensions.aspectRatio = `${e}`, this.addQualifier(new ee("ar", e));
    if (typeof e == "number" || typeof e == "string")
      return this._actionModel.dimensions.aspectRatio = d1(e), this.addQualifier(new ee("ar", d1(e)));
    if (e instanceof Ke)
      return this._actionModel.dimensions.aspectRatio = `${e.qualifierValue}`, this.addFlag(e);
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
   * @return {this}
   */
  relative() {
    return this._actionModel.relative = !0, this.addFlag(i3());
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
   * @return {this}
   */
  regionRelative() {
    return this._actionModel.regionRelative = !0, this.addFlag(n3());
  }
  static fromJson(e) {
    const { actionType: r, dimensions: n, relative: i, regionRelative: s } = e, { aspectRatio: o, width: l, height: c } = n, u = J1[r] || r, f = new this(u, l, c);
    return o && f.aspectRatio(o === "ignore_aspect_ratio" ? Xl() : o), i && f.relative(), s && f.regionRelative(), f;
  }
}
class oi extends ee {
  /**
   * @param value, an array containing (GravityObject | AutoGravity | string) or a string;
   */
  constructor(e) {
    super("g", new ye(e));
  }
}
class io extends oi {
  constructor() {
    super("auto");
  }
  /**
   * @description Autofocuses on objects, allowing their priority within the algorithm to be configured.
   * @param {AutoFocus} AutoFocusObjects
   */
  autoFocus(...e) {
    return this.addValue(e), this;
  }
}
class so extends oi {
  constructor(e) {
    super(e);
  }
  /**
   * @description Specifies the gravity to use if none of the other gravity objects are found.
   * @param {Qualifiers.Gravity.AutoGravity} val
   */
  fallbackGravity(e) {
    return this.addValue(e.qualifierValue), this;
  }
}
class oo extends oi {
  constructor(e) {
    super(e);
  }
}
function a3(t) {
  return new oo(t);
}
function ao(...t) {
  const e = [...t];
  return new so(e);
}
function lo() {
  return new io();
}
class ai extends ye {
  constructor(e) {
    super(), this.name = e;
  }
  toString() {
    return this.name;
  }
}
function l3() {
  return new ai("ocr_text");
}
function c3(t) {
  return t && `${t}`.split(":")[0] === "auto";
}
function u3(t) {
  const e = xs(t);
  return ["north", "center", "east", "west", "south", "north_west", "south_east", "south_west", "north_east"].includes(e);
}
function xs(t) {
  return `${t}`.replace("g_", "");
}
function d3(t) {
  return {
    compass: xs(t),
    gravityType: "direction"
  };
}
function f3(t) {
  return xs(t) === "ocr_text";
}
function p3() {
  return {
    gravityType: "ocr"
  };
}
function h3(t) {
  return `${t.qualifierValue}`.split(":")[0] === "auto";
}
function m3(t) {
  const r = t.toString().split("_"), n = {
    object: r[0]
  };
  return r.length > 1 && (r[1] === "avoid" ? n.avoid = !0 : n.weight = +r[1]), n;
}
function co(t) {
  let e;
  const r = t === "auto" ? new io() : t;
  return `${t}`.startsWith("auto:") ? e = `${t}`.split(":").filter((i) => i !== "auto") : e = r.qualifierValue.values.filter((i) => i !== "auto"), {
    gravityType: "auto",
    autoFocus: e.map(m3)
  };
}
function C3(t) {
  const e = `${t}`.split(":").includes("auto"), r = t.qualifierValue.values, i = {
    gravityType: "object",
    focusOnObjects: (e ? r.slice(0, r.length - 1) : r).map((s) => `${s}`)
  };
  if (e) {
    const s = r[r.length - 1].values.slice(1), o = lo().autoFocus(...s);
    i.fallbackGravity = co(o);
  }
  return i;
}
function g3(t) {
  const r = t.split(":").map((n) => new ai(n));
  return new so(r);
}
function v3(t) {
  return u3(t) ? d3(t) : f3(t) ? p3() : c3(t) || h3(t) ? co(t) : C3(typeof t == "string" ? g3(t) : t);
}
class ws extends ye {
  constructor(e, r) {
    super(), this._weight = r, this.focusOn = e, this.shouldAvoid = !1;
  }
  /**
   * @summary qualifier
   * @description Specifies the object to focus on automatically
   * Accepts an AutoFocusObject (which is just a wrapper for a FocusOn object, but with extra method: avoid, weight)
   * @param {Qualifiers.FocusOn} obj The object to focus on.
   * @param {number} weight
   */
  static focusOn(e, r) {
    return new ws(e, r);
  }
  shouldAddWeight() {
    return typeof this._weight == "number" || typeof this._weight == "string" || this.shouldAvoid;
  }
  /**
   * @summary qualifier
   * @desc Get the name of the of the object
   */
  getName() {
    return this.focusOn.name;
  }
  /**
   * @summary qualifier
   * @desc Get the weight for the object
   */
  getWeight() {
    return this.shouldAvoid ? "avoid" : this._weight;
  }
  /**
   * @summary qualifier
   * @desc Return the string representation of this QualifierValue
   */
  toString() {
    return this.shouldAddWeight() ? `${this.getName()}_${this.getWeight()}` : `${this.getName()}`;
  }
  /**
   * @summary qualifier
   * @description Sets the importance level of the object within the automatic gravity algorithm
   * @param {numebr} w The focus weight for the object
   * @return {this}
   */
  weight(e) {
    return this._weight = e, this;
  }
  /**
   * @summary qualifier
   * @description Attempts to avoid the detected object in the image
   * @return {this}
   */
  avoid() {
    return this.shouldAvoid = !0, this;
  }
}
class uo extends ye {
  constructor(e) {
    super(), this.val = e;
  }
  toString() {
    return this.val;
  }
}
function y3(t) {
  return t.gravityType === "direction";
}
function x3(t) {
  return t.gravityType === "ocr";
}
function w3(t) {
  return t.gravityType === "auto";
}
function b3(t) {
  const { object: e, weight: r, avoid: n } = t, i = new ws(new ai(e));
  return (r || r === 0) && i.weight(r), n && i.avoid(), i;
}
function fo(t) {
  const r = (t.autoFocus || []).map(b3);
  return lo().autoFocus(...r);
}
function _3(t) {
  const e = (t.focusOnObjects || []).map((n) => new ai(n)), r = ao(...e);
  if (t.fallbackGravity) {
    const n = fo(t.fallbackGravity);
    r.fallbackGravity(n);
  }
  return r;
}
function S3(t) {
  return y3(t) ? new oo(new uo(t.compass)) : x3(t) ? ao(l3()) : w3(t) ? fo(t) : _3(t);
}
class bs extends no {
  /**
   * @description Which part of the original image to include.
   * @param {Qualifiers.Gravity} gravity
   */
  gravity(e) {
    this._actionModel.gravity = v3(e);
    const r = typeof e == "string" ? new ee("g", e) : e;
    return this.addQualifier(r);
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.gravity && r.gravity(S3(e.gravity)), r;
  }
}
class Pn extends ee {
  constructor(e) {
    super("b"), e && this.addValue(e);
  }
}
const po = 100, E3 = 0;
class T3 extends Pn {
  /**
   * @description Sets the intensity of the blur.
   * @param {number} value - The intensity of the blur.
   */
  intensity(e) {
    return this.intensityLevel = e, this;
  }
  /**
   * @description Sets the brightness of the background.
   * @param {number} value - The brightness of the background.
   */
  brightness(e) {
    return this.brightnessLevel = e, this;
  }
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function
   */
  toString() {
    const e = this.intensityLevel !== void 0 ? `:${this.intensityLevel}` : "", r = this.brightnessLevel !== void 0 ? this.intensityLevel !== void 0 ? `:${this.brightnessLevel}` : `:${po}:${this.brightnessLevel}` : "";
    return `b_blurred${e}${r}`;
  }
}
var ho = T3;
class _s extends Pn {
  constructor() {
    super(), this._palette = [];
  }
  /**
   * @description Selects the strongest contrasting color to use for padding.
   * @return {this}
   */
  contrast() {
    return this._contrast = !0, this;
  }
  /**
   * @description Defines the custom colors to use when resizing using content-aware padding.
   * @param {...string} colors One or more colors - Example: palette('green', 'red', blue')
   * @return {this}
   */
  palette(...e) {
    return this._palette = e.map((r) => si(r)), this;
  }
}
class mo extends _s {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Co extends _s {
  /**
   *
   * @description Sets the number of predominant colors to use (2 or 4).
   * @param {number} num
   * @return {this}
   */
  gradientColors(e) {
    return this._gradientColors = e, this;
  }
  /**
   * @description Sets the direction for a background gradient fade effect.
   * @param {Qualifiers.GradientDirection | GradientDirectionType | string} direction Use one of these functions
   * provided by {@link Qualifiers.GradientDirection|GradientDirection}
   * @return {this}
   */
  gradientDirection(e) {
    return this._gradientDirection = e, this;
  }
}
class go extends Co {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class vo extends Co {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class yo extends _s {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class xo extends Pn {
  constructor() {
    super("gen_fill"), this._backgroundType = "generativeFill";
  }
  prompt(e) {
    return this._prompt = e, this;
  }
  getPrompt() {
    return this._prompt;
  }
  getBackgroundType() {
    return this._backgroundType;
  }
  /**
   * @description
   * Override the toString() function to explicitly stringify the qualifier.
   */
  toString() {
    return `b_gen_fill${this._prompt ? `:prompt_${this._prompt}` : ""}`;
  }
}
function wo(t) {
  return `${t}`.replace("b_", "");
}
function k3() {
  return { backgroundType: "auto" };
}
function M3(t) {
  const { intensityLevel: e, brightnessLevel: r } = t, n = {
    backgroundType: "blurred"
  };
  return (e || e === 0) && (n.intensity = e), (r || r === 0) && (n.brightness = r), n;
}
function Ss(t) {
  const e = t._contrast, r = t._palette, n = {
    backgroundType: ""
  };
  return e && (n.contrast = !0), r && (n.palette = r), n;
}
function O3(t) {
  return Object.assign(Object.assign({}, Ss(t)), { backgroundType: "border" });
}
function bo(t) {
  const e = t._gradientColors, r = `${t._gradientDirection}`, n = Ss(t);
  return e && (n.gradientColors = e), r && (n.gradientDirection = r), n;
}
function L3(t) {
  return Object.assign(Object.assign({}, bo(t)), { backgroundType: "borderGradient" });
}
function P3(t) {
  return {
    backgroundType: "color",
    color: wo(t)
  };
}
function A3(t) {
  return Object.assign(Object.assign({}, Ss(t)), { backgroundType: "predominant" });
}
function N3(t) {
  return Object.assign(Object.assign({}, bo(t)), { backgroundType: "predominantGradient" });
}
function $3(t) {
  return Object.assign({ backgroundType: t.getBackgroundType() }, t.getPrompt() ? { prompt: t.getPrompt() } : {});
}
function j3(t) {
  return wo(t) === "auto" ? k3() : t instanceof ho ? M3(t) : t instanceof mo ? O3(t) : t instanceof go ? L3(t) : t instanceof yo ? A3(t) : t instanceof vo ? N3(t) : t instanceof xo ? $3(t) : P3(t);
}
function F3() {
  return new ys("svg");
}
function Es() {
  return new ys("auto");
}
function _o() {
  return new mo();
}
function So() {
  return new Pn("auto");
}
function Eo() {
  return new go();
}
function To() {
  return new vo();
}
function ko() {
  return new yo();
}
function Mo(t) {
  return new Pn(si(t));
}
function R3() {
  return new ho();
}
function Oo() {
  return new xo();
}
const Lo = {
  auto: So,
  border: _o,
  borderGradient: Eo,
  predominantGradient: To,
  predominant: ko,
  color: Mo,
  blurred: R3,
  generativeFill: Oo
};
function I3(t) {
  const { brightness: e, intensity: r } = t, n = Lo.blurred();
  return n.brightness(e ?? E3), n.intensity(r ?? po), n;
}
function f1(t, e) {
  const { gradientColors: r, gradientDirection: n, contrast: i, palette: s } = e;
  return i && t.contrast(), s && t.palette(...s), r && t.gradientColors(+r), n && t.gradientDirection(n), t;
}
function p1(t, e) {
  const { contrast: r, palette: n } = e;
  return r && t.contrast(), n && t.palette(...n), t;
}
function D3(t, e) {
  const { prompt: r } = e;
  return r && t.prompt(r), t;
}
function V3(t) {
  const { backgroundType: e } = t;
  switch (e) {
    case "auto":
      return So();
    case "blurred":
      return I3(t);
    case "border":
      return p1(_o(), t);
    case "borderGradient":
      return f1(Eo(), t);
    case "predominant":
      return p1(ko(), t);
    case "predominantGradient":
      return f1(To(), t);
    case "generativeFill":
      return D3(Oo(), t);
    default:
      return Mo(t.color);
  }
}
class z3 extends bs {
  /**
   * @description Sets the background.
   * @param {Qualifiers.Background} backgroundQualifier Defines the background color to use instead of
   * transparent background areas or when resizing with padding.
   */
  background(e) {
    return this._actionModel.background = j3(e), this.addQualifier(e);
  }
  /**
   * @description Horizontal position for custom-coordinates based padding.
   * @param {number} x The x position.
   */
  offsetX(e) {
    return this._actionModel.x = e, this.addQualifier(new ee("x", e));
  }
  /**
   * @description Vertical position for custom-coordinates based padding
   * @param {number} y The y position.
   */
  offsetY(e) {
    return this._actionModel.y = e, this.addQualifier(new ee("y", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.background && r.background(V3(e.background)), e.x && r.offsetX(e.x), e.y && r.offsetY(e.y), e.zoom && r.zoom(e.zoom), r;
  }
}
class B3 extends no {
  /**
   * @description Changes the aspect ratio of an image while retaining all important content and avoiding unnatural
   * distortions.
   * @return {this}
   */
  liquidRescaling() {
    return this.addQualifier(new oi("liquid"));
  }
}
class W3 extends bs {
  /**
   * @description Horizontal position for custom-coordinates based cropping.
   * @param {number} x The x position.
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ee("x", e));
  }
  /**
   * @description Vertical position for custom-coordinates based cropping
   * @param {number} y The y position.
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ee("y", e));
  }
  /**
   * @description Controls how much of the original image surrounding the face to keep when using either the 'crop' or 'thumb' cropping modes with face detection.
   * @param {number | string} z The zoom factor. (Default: 1.0)
   */
  zoom(e) {
    return this._actionModel.zoom = e, this.addQualifier(new ee("z", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.x && r.x(e.x), e.y && r.y(e.y), e.zoom && r.zoom(e.zoom), r;
  }
}
class H3 extends bs {
  /**
   * @description Absolute X position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} x The x position.
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new ee("x", e));
  }
  /**
   * @description Absolute Y position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} y The y position.
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new ee("y", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.x && r.x(e.x), e.y && r.y(e.y), r;
  }
}
function G3(t, e) {
  return new B3("scale", t, e);
}
function q3(t, e) {
  return new W3("crop", t, e);
}
function U3(t, e) {
  return new H3("fill", t, e);
}
function Q3(t, e) {
  return new z3("pad", t, e);
}
class Y3 extends ro {
  /**
   * @param {Qualifiers.Quality} qualityValue a Quality value
   */
  constructor(e) {
    super("q", e.toString(), "level");
  }
  /**
   * Selet the Chroma sub sampling</br>
   * <b>Learn more</b>: {@link https://cloudinary.com/documentation/image_optimization#toggle_chroma_subsampling|Toggling chroma subsampling}
   * @param {420 | 444 | number} type The chroma sub sampling type
   */
  chromaSubSampling(e) {
    this._actionModel.chromaSubSampling = X1[e];
    const r = new ye([this._actionModel.level, e]);
    return r.setDelimiter(":"), this.addQualifier(new ee("q", r));
  }
  /**
   * Controls the final quality by setting a maximum quantization percentage
   * @param {number} val
   */
  quantization(e) {
    this._actionModel.quantization = e;
    const r = new ye([this._actionModel.level, `qmax_${e}`]).setDelimiter(":");
    return this.addQualifier(new ee("q", r));
  }
  static fromJson(e) {
    const { level: r, chromaSubSampling: n, quantization: i } = e, s = K1[r] || r, o = new this(s);
    if (n) {
      const l = Rl[n.toUpperCase()];
      l && o.chromaSubSampling(+l);
    }
    return i && o.quantization(i), o;
  }
}
function li(t) {
  return new Ji("f", t);
}
function ci(t) {
  return new Y3(t);
}
function J3() {
  return new uo("north_east");
}
c1(70).color("black"), c1(40).color("white"), Ul(), Yl();
new Pr().effect(Ql()).delivery(ci("auto")).delivery(li(F3()));
new Pr().effect(Jl()).delivery(ci("auto")).delivery(li(Es()));
new Pr().effect(ql(2e3)).delivery(ci("auto")).delivery(li(Es()));
new Pr().resize(Q3("iw_div_2").aspectRatio(1).background(Lo.auto())).resize(q3(1, 1).gravity(a3(J3()))).resize(U3().height("ih").width("iw")).delivery(ci("auto")).delivery(li(Es()));
var h1 = {
  flv: "x-flv",
  "3gp": "3gpp",
  mov: "quicktime",
  mpg: "mpeg",
  avi: "x-msvideo",
  wmv: "x-ms-wmv",
  ogv: "ogg",
  webm: "webm",
  mp4: "mp4"
}, m1 = "?_a=", Z3 = (
  /** @class */
  function() {
    function t(e, r, n, i, s, o, l) {
      var c = this;
      this.mimeType = "video", this.mimeSubTypes = h1, this.videoElement = e, this.originalVideo = r, this.videoOptions = l, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var u = lr(r);
      Hn(e, r, i, this.htmlPluginState).then(function() {
        c.htmlPluginState.pluginEventSubscription.forEach(function(f) {
          f();
        }), c.setVideoAttributes(s, o), c.handleSourceToVideo(u, n);
      });
    }
    return t.prototype.handleSourceToVideo = function(e, r) {
      var n = this;
      if (r)
        this.generateUserSources(e, r);
      else {
        var i = ["webm", "mp4", "ogv"];
        i.forEach(function(s) {
          n.appendSourceTag(lr(e), s);
        });
      }
    }, t.prototype.generateUserSources = function(e, r) {
      var n = this;
      r.map(function(i) {
        var s = i.type, o = i.codecs, l = i.transcode;
        return n.appendSourceTag(lr(e).transcode(l), s, n.buildMimeType(s, o));
      });
    }, t.prototype.appendSourceTag = function(e, r, n) {
      var i, s = document.createElement("source"), o = (i = this.videoOptions) === null || i === void 0 ? void 0 : i.useFetchFormat;
      o && e.format(r);
      var l = e.toURL(), c = l.split(m1), u = c[1] ? "".concat(m1).concat(c[1]) : "", f = o ? "" : ".".concat(r);
      s.src = "".concat(c[0]).concat(f).concat(u), s.type = n || "video/".concat(h1[r] || r), this.videoElement.appendChild(s);
    }, t.prototype.buildMimeType = function(e, r) {
      var n = "".concat(this.mimeType, "/").concat(this.mimeSubTypes[e] || e);
      return r && (n += "; codecs=" + (Array.isArray(r) ? r.join(", ") : r)), n;
    }, t.prototype.setVideoAttributes = function(e, r) {
      var n;
      if (e === void 0 && (e = {}), r === "auto") {
        var i = lr(this.originalVideo);
        e.poster = i.quality("auto").format("jpg").addTransformation("so_auto").toURL();
      } else
        r && (e.poster = (n = r.toURL) === null || n === void 0 ? void 0 : n.call(r));
      for (var s = 0, o = Object.entries(e); s < o.length; s++) {
        var l = o[s], c = l[0], u = l[1];
        u && this.videoElement.setAttribute(c, c === "poster" ? u : "");
      }
    }, t.prototype.update = function(e, r, n, i, s) {
      var o = this;
      if (e !== this.originalVideo) {
        for (var l = this.videoElement.getElementsByTagName("SOURCE"); l[0]; )
          l[0].parentNode.removeChild(l[0]);
        Hn(this.videoElement, e, n, this.htmlPluginState).then(function() {
          o.setVideoAttributes(i, s), o.handleSourceToVideo(e, r), o.videoElement.load();
        });
      }
    }, t;
  }()
), K3 = "Expected a function", C1 = 0 / 0, X3 = "[object Symbol]", e2 = /^\s+|\s+$/g, t2 = /^[-+]0x[0-9a-f]+$/i, r2 = /^0b[01]+$/i, n2 = /^0o[0-7]+$/i, i2 = parseInt, s2 = typeof zt == "object" && zt && zt.Object === Object && zt, o2 = typeof self == "object" && self && self.Object === Object && self, a2 = s2 || o2 || Function("return this")(), l2 = Object.prototype, c2 = l2.toString, u2 = Math.max, d2 = Math.min, Fi = function() {
  return a2.Date.now();
};
function f2(t, e, r) {
  var n, i, s, o, l, c, u = 0, f = !1, C = !1, v = !0;
  if (typeof t != "function")
    throw new TypeError(K3);
  e = g1(e) || 0, Zi(r) && (f = !!r.leading, C = "maxWait" in r, s = C ? u2(g1(r.maxWait) || 0, e) : s, v = "trailing" in r ? !!r.trailing : v);
  function w(L) {
    var z = n, P = i;
    return n = i = void 0, u = L, o = t.apply(P, z), o;
  }
  function g(L) {
    return u = L, l = setTimeout(h, e), f ? w(L) : o;
  }
  function b(L) {
    var z = L - c, P = L - u, B = e - z;
    return C ? d2(B, s - P) : B;
  }
  function _(L) {
    var z = L - c, P = L - u;
    return c === void 0 || z >= e || z < 0 || C && P >= s;
  }
  function h() {
    var L = Fi();
    if (_(L))
      return y(L);
    l = setTimeout(h, b(L));
  }
  function y(L) {
    return l = void 0, v && n ? w(L) : (n = i = void 0, o);
  }
  function E() {
    l !== void 0 && clearTimeout(l), u = 0, n = c = i = l = void 0;
  }
  function T() {
    return l === void 0 ? o : y(Fi());
  }
  function $() {
    var L = Fi(), z = _(L);
    if (n = arguments, i = this, c = L, z) {
      if (l === void 0)
        return g(c);
      if (C)
        return l = setTimeout(h, e), w(c);
    }
    return l === void 0 && (l = setTimeout(h, e)), o;
  }
  return $.cancel = E, $.flush = T, $;
}
function Zi(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function p2(t) {
  return !!t && typeof t == "object";
}
function h2(t) {
  return typeof t == "symbol" || p2(t) && c2.call(t) == X3;
}
function g1(t) {
  if (typeof t == "number")
    return t;
  if (h2(t))
    return C1;
  if (Zi(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Zi(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace(e2, "");
  var r = r2.test(t);
  return r || n2.test(t) ? i2(t.slice(2), r ? 2 : 8) : t2.test(t) ? C1 : +t;
}
var m2 = f2;
function C2(t) {
  return typeof t == "number";
}
function Po() {
  return typeof window < "u";
}
function g2(t) {
  return t instanceof HTMLImageElement;
}
var v2 = {
  accessibility: !1,
  lazyload: !1,
  placeholder: !1,
  responsive: !1
}, y2 = function(t) {
  return t.replace("bound ", "").replace("Plugin", "");
}, x2 = function(t, e) {
  t === void 0 && (t = []);
  var r = t.reduce(function(n, i) {
    var s, o = i.name;
    return Sn(Sn({}, n), (s = {}, s[y2(o)] = !0, s));
  }, v2);
  return r[e];
};
function Xe(t) {
  var e = t === void 0 ? {} : t, r = e.steps;
  return w2.bind(null, r);
}
function w2(t, e, r, n, i, s) {
  if (!Po())
    return !0;
  if (g2(e))
    return new Promise(function(o) {
      n.cleanupCallbacks.push(function() {
        window.removeEventListener("resize", u), o("canceled");
      });
      var l = Yi(i, { responsive: !0 });
      r.addAction(new nt().setActionTag("responsive"));
      var c = !x2(s, "placeholder");
      c ? v1(t, e, r, l) : Ao(t, e, r);
      var u;
      n.pluginEventSubscription.push(function() {
        window.addEventListener("resize", u = m2(function() {
          v1(t, e, r, l);
        }, 100));
      }), o({ responsive: !0 });
    });
}
function v1(t, e, r, n) {
  Ao(t, e, r), e.src = r.toURL(n);
}
function Ao(t, e, r) {
  var n = e.parentElement.clientWidth;
  if (C2(t)) {
    var i = t;
    n = Math.ceil(n / i) * i;
  } else
    Array.isArray(t) && (n = t.reduce(function(s, o) {
      return Math.abs(o - n) < Math.abs(s - n) ? o : s;
    }));
  r.transformation.actions.forEach(function(s, o) {
    s instanceof nt && s.getActionTag() === "responsive" && (r.transformation.actions[o] = G3(n).setActionTag("responsive"));
  });
}
function b2(t, e, r) {
  var n = lr(e);
  if (t)
    for (var i = 0; i < t.length; i++) {
      var s = t[i](null, n);
      if (!s)
        break;
    }
  return n.toURL(r ? { trackedAnalytics: r } : null);
}
function Gn(t) {
  t.cleanupCallbacks.forEach(function(e) {
    e();
  });
}
var Ki = function(t, e) {
  return Ki = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Ki(t, e);
};
function No(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Ki(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var En = function() {
  return En = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (e[s] = r[s]);
    }
    return e;
  }, En.apply(this, arguments);
};
function $o(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(t); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
  return r;
}
var Tn = { exports: {} }, pe = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var y1 = Object.getOwnPropertySymbols, _2 = Object.prototype.hasOwnProperty, S2 = Object.prototype.propertyIsEnumerable;
function E2(t) {
  if (t == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}
function T2() {
  try {
    if (!Object.assign)
      return !1;
    var t = new String("abc");
    if (t[5] = "de", Object.getOwnPropertyNames(t)[0] === "5")
      return !1;
    for (var e = {}, r = 0; r < 10; r++)
      e["_" + String.fromCharCode(r)] = r;
    var n = Object.getOwnPropertyNames(e).map(function(s) {
      return e[s];
    });
    if (n.join("") !== "0123456789")
      return !1;
    var i = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(s) {
      i[s] = s;
    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
  } catch {
    return !1;
  }
}
var jo = T2() ? Object.assign : function(t, e) {
  for (var r, n = E2(t), i, s = 1; s < arguments.length; s++) {
    r = Object(arguments[s]);
    for (var o in r)
      _2.call(r, o) && (n[o] = r[o]);
    if (y1) {
      i = y1(r);
      for (var l = 0; l < i.length; l++)
        S2.call(r, i[l]) && (n[i[l]] = r[i[l]]);
    }
  }
  return n;
};
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ts = jo, dt = typeof Symbol == "function" && Symbol.for, An = dt ? Symbol.for("react.element") : 60103, k2 = dt ? Symbol.for("react.portal") : 60106, M2 = dt ? Symbol.for("react.fragment") : 60107, O2 = dt ? Symbol.for("react.strict_mode") : 60108, L2 = dt ? Symbol.for("react.profiler") : 60114, P2 = dt ? Symbol.for("react.provider") : 60109, A2 = dt ? Symbol.for("react.context") : 60110, N2 = dt ? Symbol.for("react.forward_ref") : 60112, $2 = dt ? Symbol.for("react.suspense") : 60113, j2 = dt ? Symbol.for("react.memo") : 60115, F2 = dt ? Symbol.for("react.lazy") : 60116, x1 = typeof Symbol == "function" && Symbol.iterator;
function Nn(t) {
  for (var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, r = 1; r < arguments.length; r++)
    e += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var Fo = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, Ro = {};
function Ar(t, e, r) {
  this.props = t, this.context = e, this.refs = Ro, this.updater = r || Fo;
}
Ar.prototype.isReactComponent = {};
Ar.prototype.setState = function(t, e) {
  if (typeof t != "object" && typeof t != "function" && t != null)
    throw Error(Nn(85));
  this.updater.enqueueSetState(this, t, e, "setState");
};
Ar.prototype.forceUpdate = function(t) {
  this.updater.enqueueForceUpdate(this, t, "forceUpdate");
};
function Io() {
}
Io.prototype = Ar.prototype;
function ks(t, e, r) {
  this.props = t, this.context = e, this.refs = Ro, this.updater = r || Fo;
}
var Ms = ks.prototype = new Io();
Ms.constructor = ks;
Ts(Ms, Ar.prototype);
Ms.isPureReactComponent = !0;
var Os = { current: null }, Do = Object.prototype.hasOwnProperty, Vo = { key: !0, ref: !0, __self: !0, __source: !0 };
function zo(t, e, r) {
  var n, i = {}, s = null, o = null;
  if (e != null)
    for (n in e.ref !== void 0 && (o = e.ref), e.key !== void 0 && (s = "" + e.key), e)
      Do.call(e, n) && !Vo.hasOwnProperty(n) && (i[n] = e[n]);
  var l = arguments.length - 2;
  if (l === 1)
    i.children = r;
  else if (1 < l) {
    for (var c = Array(l), u = 0; u < l; u++)
      c[u] = arguments[u + 2];
    i.children = c;
  }
  if (t && t.defaultProps)
    for (n in l = t.defaultProps, l)
      i[n] === void 0 && (i[n] = l[n]);
  return { $$typeof: An, type: t, key: s, ref: o, props: i, _owner: Os.current };
}
function R2(t, e) {
  return { $$typeof: An, type: t.type, key: e, ref: t.ref, props: t.props, _owner: t._owner };
}
function Ls(t) {
  return typeof t == "object" && t !== null && t.$$typeof === An;
}
function I2(t) {
  var e = { "=": "=0", ":": "=2" };
  return "$" + ("" + t).replace(/[=:]/g, function(r) {
    return e[r];
  });
}
var Bo = /\/+/g, qn = [];
function Wo(t, e, r, n) {
  if (qn.length) {
    var i = qn.pop();
    return i.result = t, i.keyPrefix = e, i.func = r, i.context = n, i.count = 0, i;
  }
  return { result: t, keyPrefix: e, func: r, context: n, count: 0 };
}
function Ho(t) {
  t.result = null, t.keyPrefix = null, t.func = null, t.context = null, t.count = 0, 10 > qn.length && qn.push(t);
}
function Xi(t, e, r, n) {
  var i = typeof t;
  (i === "undefined" || i === "boolean") && (t = null);
  var s = !1;
  if (t === null)
    s = !0;
  else
    switch (i) {
      case "string":
      case "number":
        s = !0;
        break;
      case "object":
        switch (t.$$typeof) {
          case An:
          case k2:
            s = !0;
        }
    }
  if (s)
    return r(n, t, e === "" ? "." + Ri(t, 0) : e), 1;
  if (s = 0, e = e === "" ? "." : e + ":", Array.isArray(t))
    for (var o = 0; o < t.length; o++) {
      i = t[o];
      var l = e + Ri(i, o);
      s += Xi(i, l, r, n);
    }
  else if (t === null || typeof t != "object" ? l = null : (l = x1 && t[x1] || t["@@iterator"], l = typeof l == "function" ? l : null), typeof l == "function")
    for (t = l.call(t), o = 0; !(i = t.next()).done; )
      i = i.value, l = e + Ri(i, o++), s += Xi(i, l, r, n);
  else if (i === "object")
    throw r = "" + t, Error(Nn(31, r === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : r, ""));
  return s;
}
function es(t, e, r) {
  return t == null ? 0 : Xi(t, "", e, r);
}
function Ri(t, e) {
  return typeof t == "object" && t !== null && t.key != null ? I2(t.key) : e.toString(36);
}
function D2(t, e) {
  t.func.call(t.context, e, t.count++);
}
function V2(t, e, r) {
  var n = t.result, i = t.keyPrefix;
  t = t.func.call(t.context, e, t.count++), Array.isArray(t) ? ts(t, n, r, function(s) {
    return s;
  }) : t != null && (Ls(t) && (t = R2(t, i + (!t.key || e && e.key === t.key ? "" : ("" + t.key).replace(Bo, "$&/") + "/") + r)), n.push(t));
}
function ts(t, e, r, n, i) {
  var s = "";
  r != null && (s = ("" + r).replace(Bo, "$&/") + "/"), e = Wo(e, s, n, i), es(t, V2, e), Ho(e);
}
var Go = { current: null };
function jt() {
  var t = Go.current;
  if (t === null)
    throw Error(Nn(321));
  return t;
}
var z2 = { ReactCurrentDispatcher: Go, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: Os, IsSomeRendererActing: { current: !1 }, assign: Ts };
pe.Children = { map: function(t, e, r) {
  if (t == null)
    return t;
  var n = [];
  return ts(t, n, null, e, r), n;
}, forEach: function(t, e, r) {
  if (t == null)
    return t;
  e = Wo(null, null, e, r), es(t, D2, e), Ho(e);
}, count: function(t) {
  return es(t, function() {
    return null;
  }, null);
}, toArray: function(t) {
  var e = [];
  return ts(t, e, null, function(r) {
    return r;
  }), e;
}, only: function(t) {
  if (!Ls(t))
    throw Error(Nn(143));
  return t;
} };
pe.Component = Ar;
pe.Fragment = M2;
pe.Profiler = L2;
pe.PureComponent = ks;
pe.StrictMode = O2;
pe.Suspense = $2;
pe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = z2;
pe.cloneElement = function(t, e, r) {
  if (t == null)
    throw Error(Nn(267, t));
  var n = Ts({}, t.props), i = t.key, s = t.ref, o = t._owner;
  if (e != null) {
    if (e.ref !== void 0 && (s = e.ref, o = Os.current), e.key !== void 0 && (i = "" + e.key), t.type && t.type.defaultProps)
      var l = t.type.defaultProps;
    for (c in e)
      Do.call(e, c) && !Vo.hasOwnProperty(c) && (n[c] = e[c] === void 0 && l !== void 0 ? l[c] : e[c]);
  }
  var c = arguments.length - 2;
  if (c === 1)
    n.children = r;
  else if (1 < c) {
    l = Array(c);
    for (var u = 0; u < c; u++)
      l[u] = arguments[u + 2];
    n.children = l;
  }
  return {
    $$typeof: An,
    type: t.type,
    key: i,
    ref: s,
    props: n,
    _owner: o
  };
};
pe.createContext = function(t, e) {
  return e === void 0 && (e = null), t = { $$typeof: A2, _calculateChangedBits: e, _currentValue: t, _currentValue2: t, _threadCount: 0, Provider: null, Consumer: null }, t.Provider = { $$typeof: P2, _context: t }, t.Consumer = t;
};
pe.createElement = zo;
pe.createFactory = function(t) {
  var e = zo.bind(null, t);
  return e.type = t, e;
};
pe.createRef = function() {
  return { current: null };
};
pe.forwardRef = function(t) {
  return { $$typeof: N2, render: t };
};
pe.isValidElement = Ls;
pe.lazy = function(t) {
  return { $$typeof: F2, _ctor: t, _status: -1, _result: null };
};
pe.memo = function(t, e) {
  return { $$typeof: j2, type: t, compare: e === void 0 ? null : e };
};
pe.useCallback = function(t, e) {
  return jt().useCallback(t, e);
};
pe.useContext = function(t, e) {
  return jt().useContext(t, e);
};
pe.useDebugValue = function() {
};
pe.useEffect = function(t, e) {
  return jt().useEffect(t, e);
};
pe.useImperativeHandle = function(t, e, r) {
  return jt().useImperativeHandle(t, e, r);
};
pe.useLayoutEffect = function(t, e) {
  return jt().useLayoutEffect(t, e);
};
pe.useMemo = function(t, e) {
  return jt().useMemo(t, e);
};
pe.useReducer = function(t, e, r) {
  return jt().useReducer(t, e, r);
};
pe.useRef = function(t) {
  return jt().useRef(t);
};
pe.useState = function(t) {
  return jt().useState(t);
};
pe.version = "16.14.0";
var fe = {}, B2 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", W2 = B2, H2 = Function.call.bind(Object.prototype.hasOwnProperty), rs = function() {
};
if (process.env.NODE_ENV !== "production") {
  var G2 = W2, ns = {}, q2 = H2;
  rs = function(t) {
    var e = "Warning: " + t;
    typeof console < "u" && console.error(e);
    try {
      throw new Error(e);
    } catch {
    }
  };
}
function qo(t, e, r, n, i) {
  if (process.env.NODE_ENV !== "production") {
    for (var s in t)
      if (q2(t, s)) {
        var o;
        try {
          if (typeof t[s] != "function") {
            var l = Error(
              (n || "React class") + ": " + r + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
            );
            throw l.name = "Invariant Violation", l;
          }
          o = t[s](e, s, n, r, null, G2);
        } catch (u) {
          o = u;
        }
        if (o && !(o instanceof Error) && rs(
          (n || "React class") + ": type specification of " + r + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof o + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
        ), o instanceof Error && !(o.message in ns)) {
          ns[o.message] = !0;
          var c = i ? i() : "";
          rs(
            "Failed " + r + " type: " + o.message + (c ?? "")
          );
        }
      }
  }
}
qo.resetWarningCache = function() {
  process.env.NODE_ENV !== "production" && (ns = {});
};
var U2 = qo;
/** @license React v16.14.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
process.env.NODE_ENV !== "production" && function() {
  var t = jo, e = U2, r = "16.14.0", n = typeof Symbol == "function" && Symbol.for, i = n ? Symbol.for("react.element") : 60103, s = n ? Symbol.for("react.portal") : 60106, o = n ? Symbol.for("react.fragment") : 60107, l = n ? Symbol.for("react.strict_mode") : 60108, c = n ? Symbol.for("react.profiler") : 60114, u = n ? Symbol.for("react.provider") : 60109, f = n ? Symbol.for("react.context") : 60110, C = n ? Symbol.for("react.concurrent_mode") : 60111, v = n ? Symbol.for("react.forward_ref") : 60112, w = n ? Symbol.for("react.suspense") : 60113, g = n ? Symbol.for("react.suspense_list") : 60120, b = n ? Symbol.for("react.memo") : 60115, _ = n ? Symbol.for("react.lazy") : 60116, h = n ? Symbol.for("react.block") : 60121, y = n ? Symbol.for("react.fundamental") : 60117, E = n ? Symbol.for("react.responder") : 60118, T = n ? Symbol.for("react.scope") : 60119, $ = typeof Symbol == "function" && Symbol.iterator, L = "@@iterator";
  function z(p) {
    if (p === null || typeof p != "object")
      return null;
    var S = $ && p[$] || p[L];
    return typeof S == "function" ? S : null;
  }
  var P = {
    /**
     * @internal
     * @type {ReactComponent}
     */
    current: null
  }, B = {
    suspense: null
  }, q = {
    /**
     * @internal
     * @type {ReactComponent}
     */
    current: null
  }, N = /^(.*)[\\\/]/;
  function R(p, S, M) {
    var j = "";
    if (S) {
      var G = S.fileName, re = G.replace(N, "");
      if (/^index\./.test(re)) {
        var J = G.match(N);
        if (J) {
          var Z = J[1];
          if (Z) {
            var Ce = Z.replace(N, "");
            re = Ce + "/" + re;
          }
        }
      }
      j = " (at " + re + ":" + S.lineNumber + ")";
    } else
      M && (j = " (created by " + M + ")");
    return `
    in ` + (p || "Unknown") + j;
  }
  var D = 1;
  function Q(p) {
    return p._status === D ? p._result : null;
  }
  function se(p, S, M) {
    var j = S.displayName || S.name || "";
    return p.displayName || (j !== "" ? M + "(" + j + ")" : M);
  }
  function Y(p) {
    if (p == null)
      return null;
    if (typeof p.tag == "number" && H("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof p == "function")
      return p.displayName || p.name || null;
    if (typeof p == "string")
      return p;
    switch (p) {
      case o:
        return "Fragment";
      case s:
        return "Portal";
      case c:
        return "Profiler";
      case l:
        return "StrictMode";
      case w:
        return "Suspense";
      case g:
        return "SuspenseList";
    }
    if (typeof p == "object")
      switch (p.$$typeof) {
        case f:
          return "Context.Consumer";
        case u:
          return "Context.Provider";
        case v:
          return se(p, p.render, "ForwardRef");
        case b:
          return Y(p.type);
        case h:
          return Y(p.render);
        case _: {
          var S = p, M = Q(S);
          if (M)
            return Y(M);
          break;
        }
      }
    return null;
  }
  var ie = {}, F = null;
  function O(p) {
    F = p;
  }
  ie.getCurrentStack = null, ie.getStackAddendum = function() {
    var p = "";
    if (F) {
      var S = Y(F.type), M = F._owner;
      p += R(S, F._source, M && Y(M.type));
    }
    var j = ie.getCurrentStack;
    return j && (p += j() || ""), p;
  };
  var k = {
    current: !1
  }, U = {
    ReactCurrentDispatcher: P,
    ReactCurrentBatchConfig: B,
    ReactCurrentOwner: q,
    IsSomeRendererActing: k,
    // Used by renderers to avoid bundling object-assign twice in UMD bundles:
    assign: t
  };
  t(U, {
    // These should not be included in production.
    ReactDebugCurrentFrame: ie,
    // Shim for React DOM 16.0.0 which still destructured (but not used) this.
    // TODO: remove in React 17.0.
    ReactComponentTreeHook: {}
  });
  function V(p) {
    {
      for (var S = arguments.length, M = new Array(S > 1 ? S - 1 : 0), j = 1; j < S; j++)
        M[j - 1] = arguments[j];
      le("warn", p, M);
    }
  }
  function H(p) {
    {
      for (var S = arguments.length, M = new Array(S > 1 ? S - 1 : 0), j = 1; j < S; j++)
        M[j - 1] = arguments[j];
      le("error", p, M);
    }
  }
  function le(p, S, M) {
    {
      var j = M.length > 0 && typeof M[M.length - 1] == "string" && M[M.length - 1].indexOf(`
    in`) === 0;
      if (!j) {
        var G = U.ReactDebugCurrentFrame, re = G.getStackAddendum();
        re !== "" && (S += "%s", M = M.concat([re]));
      }
      var J = M.map(function(ue) {
        return "" + ue;
      });
      J.unshift("Warning: " + S), Function.prototype.apply.call(console[p], console, J);
      try {
        var Z = 0, Ce = "Warning: " + S.replace(/%s/g, function() {
          return M[Z++];
        });
        throw new Error(Ce);
      } catch {
      }
    }
  }
  var me = {};
  function we(p, S) {
    {
      var M = p.constructor, j = M && (M.displayName || M.name) || "ReactClass", G = j + "." + S;
      if (me[G])
        return;
      H("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", S, j), me[G] = !0;
    }
  }
  var Pe = {
    /**
     * Checks whether or not this composite component is mounted.
     * @param {ReactClass} publicInstance The instance we want to test.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function(p) {
      return !1;
    },
    /**
     * Forces an update. This should only be invoked when it is known with
     * certainty that we are **not** in a DOM transaction.
     *
     * You may want to call this when you know that some deeper aspect of the
     * component's state has changed but `setState` was not called.
     *
     * This will not invoke `shouldComponentUpdate`, but it will invoke
     * `componentWillUpdate` and `componentDidUpdate`.
     *
     * @param {ReactClass} publicInstance The instance that should rerender.
     * @param {?function} callback Called after component is updated.
     * @param {?string} callerName name of the calling function in the public API.
     * @internal
     */
    enqueueForceUpdate: function(p, S, M) {
      we(p, "forceUpdate");
    },
    /**
     * Replaces all of the state. Always use this or `setState` to mutate state.
     * You should treat `this.state` as immutable.
     *
     * There is no guarantee that `this.state` will be immediately updated, so
     * accessing `this.state` after calling this method may return the old value.
     *
     * @param {ReactClass} publicInstance The instance that should rerender.
     * @param {object} completeState Next state.
     * @param {?function} callback Called after component is updated.
     * @param {?string} callerName name of the calling function in the public API.
     * @internal
     */
    enqueueReplaceState: function(p, S, M, j) {
      we(p, "replaceState");
    },
    /**
     * Sets a subset of the state. This only exists because _pendingState is
     * internal. This provides a merging strategy that is not available to deep
     * properties which is confusing. TODO: Expose pendingState or don't use it
     * during the merge.
     *
     * @param {ReactClass} publicInstance The instance that should rerender.
     * @param {object} partialState Next partial state to be merged with state.
     * @param {?function} callback Called after component is updated.
     * @param {?string} Name of the calling function in the public API.
     * @internal
     */
    enqueueSetState: function(p, S, M, j) {
      we(p, "setState");
    }
  }, it = {};
  Object.freeze(it);
  function ke(p, S, M) {
    this.props = p, this.context = S, this.refs = it, this.updater = M || Pe;
  }
  ke.prototype.isReactComponent = {}, ke.prototype.setState = function(p, S) {
    if (!(typeof p == "object" || typeof p == "function" || p == null))
      throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, p, S, "setState");
  }, ke.prototype.forceUpdate = function(p) {
    this.updater.enqueueForceUpdate(this, p, "forceUpdate");
  };
  {
    var Ae = {
      isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
      replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
    }, Yt = function(p, S) {
      Object.defineProperty(ke.prototype, p, {
        get: function() {
          V("%s(...) is deprecated in plain JavaScript React classes. %s", S[0], S[1]);
        }
      });
    };
    for (var Jt in Ae)
      Ae.hasOwnProperty(Jt) && Yt(Jt, Ae[Jt]);
  }
  function Cr() {
  }
  Cr.prototype = ke.prototype;
  function yt(p, S, M) {
    this.props = p, this.context = S, this.refs = it, this.updater = M || Pe;
  }
  var xt = yt.prototype = new Cr();
  xt.constructor = yt, t(xt, ke.prototype), xt.isPureReactComponent = !0;
  function wt() {
    var p = {
      current: null
    };
    return Object.seal(p), p;
  }
  var ft = Object.prototype.hasOwnProperty, gr = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  }, vr, Ye, st;
  st = {};
  function Ft(p) {
    if (ft.call(p, "ref")) {
      var S = Object.getOwnPropertyDescriptor(p, "ref").get;
      if (S && S.isReactWarning)
        return !1;
    }
    return p.ref !== void 0;
  }
  function Rt(p) {
    if (ft.call(p, "key")) {
      var S = Object.getOwnPropertyDescriptor(p, "key").get;
      if (S && S.isReactWarning)
        return !1;
    }
    return p.key !== void 0;
  }
  function Ee(p, S) {
    var M = function() {
      vr || (vr = !0, H("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", S));
    };
    M.isReactWarning = !0, Object.defineProperty(p, "key", {
      get: M,
      configurable: !0
    });
  }
  function ot(p, S) {
    var M = function() {
      Ye || (Ye = !0, H("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", S));
    };
    M.isReactWarning = !0, Object.defineProperty(p, "ref", {
      get: M,
      configurable: !0
    });
  }
  function $r(p) {
    if (typeof p.ref == "string" && q.current && p.__self && q.current.stateNode !== p.__self) {
      var S = Y(q.current.type);
      st[S] || (H('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref', Y(q.current.type), p.ref), st[S] = !0);
    }
  }
  var bt = function(p, S, M, j, G, re, J) {
    var Z = {
      // This tag allows us to uniquely identify this as a React Element
      $$typeof: i,
      // Built-in properties that belong on the element
      type: p,
      key: S,
      ref: M,
      props: J,
      // Record the component responsible for creating this element.
      _owner: re
    };
    return Z._store = {}, Object.defineProperty(Z._store, "validated", {
      configurable: !1,
      enumerable: !1,
      writable: !0,
      value: !1
    }), Object.defineProperty(Z, "_self", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: j
    }), Object.defineProperty(Z, "_source", {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: G
    }), Object.freeze && (Object.freeze(Z.props), Object.freeze(Z)), Z;
  };
  function Zt(p, S, M) {
    var j, G = {}, re = null, J = null, Z = null, Ce = null;
    if (S != null) {
      Ft(S) && (J = S.ref, $r(S)), Rt(S) && (re = "" + S.key), Z = S.__self === void 0 ? null : S.__self, Ce = S.__source === void 0 ? null : S.__source;
      for (j in S)
        ft.call(S, j) && !gr.hasOwnProperty(j) && (G[j] = S[j]);
    }
    var ue = arguments.length - 2;
    if (ue === 1)
      G.children = M;
    else if (ue > 1) {
      for (var Le = Array(ue), Oe = 0; Oe < ue; Oe++)
        Le[Oe] = arguments[Oe + 2];
      Object.freeze && Object.freeze(Le), G.children = Le;
    }
    if (p && p.defaultProps) {
      var at = p.defaultProps;
      for (j in at)
        G[j] === void 0 && (G[j] = at[j]);
    }
    if (re || J) {
      var De = typeof p == "function" ? p.displayName || p.name || "Unknown" : p;
      re && Ee(G, De), J && ot(G, De);
    }
    return bt(p, re, J, Z, Ce, q.current, G);
  }
  function Kt(p, S) {
    var M = bt(p.type, S, p.ref, p._self, p._source, p._owner, p.props);
    return M;
  }
  function jr(p, S, M) {
    if (p == null)
      throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + p + ".");
    var j, G = t({}, p.props), re = p.key, J = p.ref, Z = p._self, Ce = p._source, ue = p._owner;
    if (S != null) {
      Ft(S) && (J = S.ref, ue = q.current), Rt(S) && (re = "" + S.key);
      var Le;
      p.type && p.type.defaultProps && (Le = p.type.defaultProps);
      for (j in S)
        ft.call(S, j) && !gr.hasOwnProperty(j) && (S[j] === void 0 && Le !== void 0 ? G[j] = Le[j] : G[j] = S[j]);
    }
    var Oe = arguments.length - 2;
    if (Oe === 1)
      G.children = M;
    else if (Oe > 1) {
      for (var at = Array(Oe), De = 0; De < Oe; De++)
        at[De] = arguments[De + 2];
      G.children = at;
    }
    return bt(p.type, re, J, Z, Ce, ue, G);
  }
  function pt(p) {
    return typeof p == "object" && p !== null && p.$$typeof === i;
  }
  var yr = ".", Fr = ":";
  function Xt(p) {
    var S = /[=:]/g, M = {
      "=": "=0",
      ":": "=2"
    }, j = ("" + p).replace(S, function(G) {
      return M[G];
    });
    return "$" + j;
  }
  var xr = !1, Rr = /\/+/g;
  function ht(p) {
    return ("" + p).replace(Rr, "$&/");
  }
  var ze = 10, Je = [];
  function mt(p, S, M, j) {
    if (Je.length) {
      var G = Je.pop();
      return G.result = p, G.keyPrefix = S, G.func = M, G.context = j, G.count = 0, G;
    } else
      return {
        result: p,
        keyPrefix: S,
        func: M,
        context: j,
        count: 0
      };
  }
  function Ct(p) {
    p.result = null, p.keyPrefix = null, p.func = null, p.context = null, p.count = 0, Je.length < ze && Je.push(p);
  }
  function Ne(p, S, M, j) {
    var G = typeof p;
    (G === "undefined" || G === "boolean") && (p = null);
    var re = !1;
    if (p === null)
      re = !0;
    else
      switch (G) {
        case "string":
        case "number":
          re = !0;
          break;
        case "object":
          switch (p.$$typeof) {
            case i:
            case s:
              re = !0;
          }
      }
    if (re)
      return M(
        j,
        p,
        // If it's the only child, treat the name as if it was wrapped in an array
        // so that it's consistent if the number of children grows.
        S === "" ? yr + tr(p, 0) : S
      ), 1;
    var J, Z, Ce = 0, ue = S === "" ? yr : S + Fr;
    if (Array.isArray(p))
      for (var Le = 0; Le < p.length; Le++)
        J = p[Le], Z = ue + tr(J, Le), Ce += Ne(J, Z, M, j);
    else {
      var Oe = z(p);
      if (typeof Oe == "function") {
        Oe === p.entries && (xr || V("Using Maps as children is deprecated and will be removed in a future major release. Consider converting children to an array of keyed ReactElements instead."), xr = !0);
        for (var at = Oe.call(p), De, fn = 0; !(De = at.next()).done; )
          J = De.value, Z = ue + tr(J, fn++), Ce += Ne(J, Z, M, j);
      } else if (G === "object") {
        var kr = "";
        kr = " If you meant to render a collection of children, use an array instead." + ie.getStackAddendum();
        var Dt = "" + p;
        throw Error("Objects are not valid as a React child (found: " + (Dt === "[object Object]" ? "object with keys {" + Object.keys(p).join(", ") + "}" : Dt) + ")." + kr);
      }
    }
    return Ce;
  }
  function er(p, S, M) {
    return p == null ? 0 : Ne(p, "", S, M);
  }
  function tr(p, S) {
    return typeof p == "object" && p !== null && p.key != null ? Xt(p.key) : S.toString(36);
  }
  function Ir(p, S, M) {
    var j = p.func, G = p.context;
    j.call(G, S, p.count++);
  }
  function Dr(p, S, M) {
    if (p == null)
      return p;
    var j = mt(null, null, S, M);
    er(p, Ir, j), Ct(j);
  }
  function Vr(p, S, M) {
    var j = p.result, G = p.keyPrefix, re = p.func, J = p.context, Z = re.call(J, S, p.count++);
    Array.isArray(Z) ? _t(Z, j, M, function(Ce) {
      return Ce;
    }) : Z != null && (pt(Z) && (Z = Kt(
      Z,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      G + (Z.key && (!S || S.key !== Z.key) ? ht(Z.key) + "/" : "") + M
    )), j.push(Z));
  }
  function _t(p, S, M, j, G) {
    var re = "";
    M != null && (re = ht(M) + "/");
    var J = mt(S, re, j, G);
    er(p, Vr, J), Ct(J);
  }
  function rr(p, S, M) {
    if (p == null)
      return p;
    var j = [];
    return _t(p, j, null, S, M), j;
  }
  function Me(p) {
    return er(p, function() {
      return null;
    }, null);
  }
  function zr(p) {
    var S = [];
    return _t(p, S, null, function(M) {
      return M;
    }), S;
  }
  function Br(p) {
    if (!pt(p))
      throw Error("React.Children.only expected to receive a single React element child.");
    return p;
  }
  function Wr(p, S) {
    S === void 0 ? S = null : S !== null && typeof S != "function" && H("createContext: Expected the optional second argument to be a function. Instead received: %s", S);
    var M = {
      $$typeof: f,
      _calculateChangedBits: S,
      // As a workaround to support multiple concurrent renderers, we categorize
      // some renderers as primary and others as secondary. We only expect
      // there to be two concurrent renderers at most: React Native (primary) and
      // Fabric (secondary); React DOM (primary) and React ART (secondary).
      // Secondary renderers store their context values on separate fields.
      _currentValue: p,
      _currentValue2: p,
      // Used to track how many concurrent renderers this context currently
      // supports within in a single renderer. Such as parallel server rendering.
      _threadCount: 0,
      // These are circular
      Provider: null,
      Consumer: null
    };
    M.Provider = {
      $$typeof: u,
      _context: M
    };
    var j = !1, G = !1;
    {
      var re = {
        $$typeof: f,
        _context: M,
        _calculateChangedBits: M._calculateChangedBits
      };
      Object.defineProperties(re, {
        Provider: {
          get: function() {
            return G || (G = !0, H("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), M.Provider;
          },
          set: function(J) {
            M.Provider = J;
          }
        },
        _currentValue: {
          get: function() {
            return M._currentValue;
          },
          set: function(J) {
            M._currentValue = J;
          }
        },
        _currentValue2: {
          get: function() {
            return M._currentValue2;
          },
          set: function(J) {
            M._currentValue2 = J;
          }
        },
        _threadCount: {
          get: function() {
            return M._threadCount;
          },
          set: function(J) {
            M._threadCount = J;
          }
        },
        Consumer: {
          get: function() {
            return j || (j = !0, H("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), M.Consumer;
          }
        }
      }), M.Consumer = re;
    }
    return M._currentRenderer = null, M._currentRenderer2 = null, M;
  }
  function Hr(p) {
    var S = {
      $$typeof: _,
      _ctor: p,
      // React uses these fields to store the result.
      _status: -1,
      _result: null
    };
    {
      var M, j;
      Object.defineProperties(S, {
        defaultProps: {
          configurable: !0,
          get: function() {
            return M;
          },
          set: function(G) {
            H("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), M = G, Object.defineProperty(S, "defaultProps", {
              enumerable: !0
            });
          }
        },
        propTypes: {
          configurable: !0,
          get: function() {
            return j;
          },
          set: function(G) {
            H("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), j = G, Object.defineProperty(S, "propTypes", {
              enumerable: !0
            });
          }
        }
      });
    }
    return S;
  }
  function Gr(p) {
    return p != null && p.$$typeof === b ? H("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof p != "function" ? H("forwardRef requires a render function but was given %s.", p === null ? "null" : typeof p) : p.length !== 0 && p.length !== 2 && H("forwardRef render functions accept exactly two parameters: props and ref. %s", p.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), p != null && (p.defaultProps != null || p.propTypes != null) && H("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"), {
      $$typeof: v,
      render: p
    };
  }
  function be(p) {
    return typeof p == "string" || typeof p == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
    p === o || p === C || p === c || p === l || p === w || p === g || typeof p == "object" && p !== null && (p.$$typeof === _ || p.$$typeof === b || p.$$typeof === u || p.$$typeof === f || p.$$typeof === v || p.$$typeof === y || p.$$typeof === E || p.$$typeof === T || p.$$typeof === h);
  }
  function qr(p, S) {
    return be(p) || H("memo: The first argument must be a component. Instead received: %s", p === null ? "null" : typeof p), {
      $$typeof: b,
      type: p,
      compare: S === void 0 ? null : S
    };
  }
  function Ie() {
    var p = P.current;
    if (p === null)
      throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.`);
    return p;
  }
  function Ur(p, S) {
    var M = Ie();
    if (S !== void 0 && H("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", S, typeof S == "number" && Array.isArray(arguments[2]) ? `

Did you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks` : ""), p._context !== void 0) {
      var j = p._context;
      j.Consumer === p ? H("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : j.Provider === p && H("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
    }
    return M.useContext(p, S);
  }
  function Qr(p) {
    var S = Ie();
    return S.useState(p);
  }
  function Yr(p, S, M) {
    var j = Ie();
    return j.useReducer(p, S, M);
  }
  function $e(p) {
    var S = Ie();
    return S.useRef(p);
  }
  function Jr(p, S) {
    var M = Ie();
    return M.useEffect(p, S);
  }
  function Zr(p, S) {
    var M = Ie();
    return M.useLayoutEffect(p, S);
  }
  function Kr(p, S) {
    var M = Ie();
    return M.useCallback(p, S);
  }
  function Xr(p, S) {
    var M = Ie();
    return M.useMemo(p, S);
  }
  function en(p, S, M) {
    var j = Ie();
    return j.useImperativeHandle(p, S, M);
  }
  function je(p, S) {
    {
      var M = Ie();
      return M.useDebugValue(p, S);
    }
  }
  var nr;
  nr = !1;
  function wr() {
    if (q.current) {
      var p = Y(q.current.type);
      if (p)
        return `

Check the render method of \`` + p + "`.";
    }
    return "";
  }
  function tn(p) {
    if (p !== void 0) {
      var S = p.fileName.replace(/^.*[\\\/]/, ""), M = p.lineNumber;
      return `

Check your code at ` + S + ":" + M + ".";
    }
    return "";
  }
  function rn(p) {
    return p != null ? tn(p.__source) : "";
  }
  var br = {};
  function nn(p) {
    var S = wr();
    if (!S) {
      var M = typeof p == "string" ? p : p.displayName || p.name;
      M && (S = `

Check the top-level render call using <` + M + ">.");
    }
    return S;
  }
  function It(p, S) {
    if (!(!p._store || p._store.validated || p.key != null)) {
      p._store.validated = !0;
      var M = nn(S);
      if (!br[M]) {
        br[M] = !0;
        var j = "";
        p && p._owner && p._owner !== q.current && (j = " It was passed a child from " + Y(p._owner.type) + "."), O(p), H('Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.', M, j), O(null);
      }
    }
  }
  function Ze(p, S) {
    if (typeof p == "object") {
      if (Array.isArray(p))
        for (var M = 0; M < p.length; M++) {
          var j = p[M];
          pt(j) && It(j, S);
        }
      else if (pt(p))
        p._store && (p._store.validated = !0);
      else if (p) {
        var G = z(p);
        if (typeof G == "function" && G !== p.entries)
          for (var re = G.call(p), J; !(J = re.next()).done; )
            pt(J.value) && It(J.value, S);
      }
    }
  }
  function _r(p) {
    {
      var S = p.type;
      if (S == null || typeof S == "string")
        return;
      var M = Y(S), j;
      if (typeof S == "function")
        j = S.propTypes;
      else if (typeof S == "object" && (S.$$typeof === v || // Note: Memo only checks outer props here.
      // Inner props are checked in the reconciler.
      S.$$typeof === b))
        j = S.propTypes;
      else
        return;
      j ? (O(p), e(j, p.props, "prop", M, ie.getStackAddendum), O(null)) : S.PropTypes !== void 0 && !nr && (nr = !0, H("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", M || "Unknown")), typeof S.getDefaultProps == "function" && !S.getDefaultProps.isReactClassApproved && H("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
  }
  function St(p) {
    {
      O(p);
      for (var S = Object.keys(p.props), M = 0; M < S.length; M++) {
        var j = S[M];
        if (j !== "children" && j !== "key") {
          H("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", j);
          break;
        }
      }
      p.ref !== null && H("Invalid attribute `ref` supplied to `React.Fragment`."), O(null);
    }
  }
  function Sr(p, S, M) {
    var j = be(p);
    if (!j) {
      var G = "";
      (p === void 0 || typeof p == "object" && p !== null && Object.keys(p).length === 0) && (G += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
      var re = rn(S);
      re ? G += re : G += wr();
      var J;
      p === null ? J = "null" : Array.isArray(p) ? J = "array" : p !== void 0 && p.$$typeof === i ? (J = "<" + (Y(p.type) || "Unknown") + " />", G = " Did you accidentally export a JSX literal instead of a component?") : J = typeof p, H("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", J, G);
    }
    var Z = Zt.apply(this, arguments);
    if (Z == null)
      return Z;
    if (j)
      for (var Ce = 2; Ce < arguments.length; Ce++)
        Ze(arguments[Ce], p);
    return p === o ? St(Z) : _r(Z), Z;
  }
  var Er = !1;
  function sn(p) {
    var S = Sr.bind(null, p);
    return S.type = p, Er || (Er = !0, V("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(S, "type", {
      enumerable: !1,
      get: function() {
        return V("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
          value: p
        }), p;
      }
    }), S;
  }
  function on(p, S, M) {
    for (var j = jr.apply(this, arguments), G = 2; G < arguments.length; G++)
      Ze(arguments[G], j.type);
    return _r(j), j;
  }
  try {
    var Tr = Object.freeze({}), an = /* @__PURE__ */ new Map([[Tr, null]]), Et = /* @__PURE__ */ new Set([Tr]);
    an.set(0, 0), Et.add(0);
  } catch {
  }
  var ln = Sr, cn = on, un = sn, dn = {
    map: rr,
    forEach: Dr,
    count: Me,
    toArray: zr,
    only: Br
  };
  fe.Children = dn, fe.Component = ke, fe.Fragment = o, fe.Profiler = c, fe.PureComponent = yt, fe.StrictMode = l, fe.Suspense = w, fe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = U, fe.cloneElement = cn, fe.createContext = Wr, fe.createElement = ln, fe.createFactory = un, fe.createRef = wt, fe.forwardRef = Gr, fe.isValidElement = pt, fe.lazy = Hr, fe.memo = qr, fe.useCallback = Kr, fe.useContext = Ur, fe.useDebugValue = je, fe.useEffect = Jr, fe.useImperativeHandle = en, fe.useLayoutEffect = Zr, fe.useMemo = Xr, fe.useReducer = Yr, fe.useRef = $e, fe.useState = Qr, fe.version = r;
}();
process.env.NODE_ENV === "production" ? Tn.exports = pe : Tn.exports = fe;
var Mr = Tn.exports, Ii = {
  sdkSemver: "1.13.0",
  techVersion: Mr.version,
  sdkCode: "J"
};
(function(t) {
  No(e, t);
  function e(r) {
    var n = t.call(this, r) || this;
    return n.imageRef = Mr.createRef(), n;
  }
  return e.prototype.componentDidMount = function() {
    this.htmlLayerInstance = new Sl(this.imageRef.current, this.props.cldImg, this.props.plugins, Ii);
  }, e.prototype.componentDidUpdate = function() {
    Gn(this.htmlLayerInstance.htmlPluginState), this.htmlLayerInstance.update(this.props.cldImg, this.props.plugins, Ii);
  }, e.prototype.componentWillUnmount = function() {
    Gn(this.htmlLayerInstance.htmlPluginState), this.htmlLayerInstance.unmount();
  }, e.prototype.render = function() {
    var r = this.props;
    r.cldImg, r.plugins;
    var n = $o(r, ["cldImg", "plugins"]);
    if (Po())
      return Mr.createElement("img", En({ suppressHydrationWarning: !0 }, n, { ref: this.imageRef }));
    var i = b2(this.props.plugins, this.props.cldImg, Ii);
    return Mr.createElement("img", En({}, n, { src: i }));
  }, e;
})(Mr.Component);
var Q2 = ["controls", "loop", "muted", "poster", "preload", "autoplay", "playsinline"];
(function(t) {
  No(e, t);
  function e(r) {
    var n = t.call(this, r) || this;
    return n.videoRef = Tn.exports.createRef(), n.attachRef = n.attachRef.bind(n), n;
  }
  return e.prototype.componentDidMount = function() {
    this.htmlVideoLayerInstance = new Z3(this.videoRef && this.videoRef.current, this.props.cldVid, this.props.sources, this.props.plugins, this.getVideoAttributes(), this.props.cldPoster, {
      useFetchFormat: this.props.useFetchFormat
    });
  }, e.prototype.componentDidUpdate = function() {
    Gn(this.htmlVideoLayerInstance.htmlPluginState), this.htmlVideoLayerInstance.update(this.props.cldVid, this.props.sources, this.props.plugins, this.getVideoAttributes(), this.props.cldPoster);
  }, e.prototype.componentWillUnmount = function() {
    Gn(this.htmlVideoLayerInstance.htmlPluginState);
  }, e.prototype.getVideoAttributes = function() {
    var r = this, n = {};
    return Q2.forEach(function(i) {
      i in r.props && (n[i] = r.props[i]);
    }), n;
  }, e.prototype.attachRef = function(r) {
    this.videoRef.current = r;
    var n = this.props.innerRef;
    n && (n instanceof Function ? n(r) : n.current = r);
  }, e.prototype.render = function() {
    var r = this.props;
    r.cldVid, r.cldPoster, r.plugins, r.sources, r.innerRef, r.useFetchFormat;
    var n = $o(r, ["cldVid", "cldPoster", "plugins", "sources", "innerRef", "useFetchFormat"]);
    return Mr.createElement("video", En({}, n, { ref: this.attachRef }));
  }, e;
})(Tn.exports.Component);
function Uo(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Y2 = function t(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var n, i, s;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length)
        return !1;
      for (i = n; i-- !== 0; )
        if (!t(e[i], r[i]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === r.toString();
    if (s = Object.keys(e), n = s.length, n !== Object.keys(r).length)
      return !1;
    for (i = n; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, s[i]))
        return !1;
    for (i = n; i-- !== 0; ) {
      var o = s[i];
      if (!t(e[o], r[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
};
const J2 = /* @__PURE__ */ Uo(Y2);
function Z2(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function K2(t) {
  var e = Z2(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function Nt() {
  return Nt = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Nt.apply(this, arguments);
}
function $n(t, e) {
  if (t == null)
    return {};
  var r = {}, n = Object.keys(t), i, s;
  for (s = 0; s < n.length; s++)
    i = n[s], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
const Ot = {
  NOT_LOADED: "NOT_LOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  FAILED: "FAILED",
  AUTH_FAILURE: "AUTH_FAILURE"
}, X2 = "https://maps.googleapis.com/maps/api/js";
class Un {
  /**
   * Loads the Google Maps API with the specified parameters.
   * Since the Maps library can only be loaded once per page, this will
   * produce a warning when called multiple times with different
   * parameters.
   *
   * The returned promise resolves when loading completes
   * and rejects in case of an error or when the loading was aborted.
   */
  static async load(e, r) {
    var n;
    const i = e.libraries ? e.libraries.split(",") : [], s = this.serializeParams(e);
    (n = window.google) != null && (n = n.maps) != null && n.importLibrary ? (this.serializedApiParams || (this.loadingStatus = Ot.LOADED), r(this.loadingStatus)) : (this.serializedApiParams = s, this.initImportLibrary(e, r)), this.serializedApiParams && this.serializedApiParams !== s && console.warn("The maps API has already been loaded with different parameters and will not be loaded again. Refresh the page for new values to have effect.");
    for (const o of ["maps", ...i])
      await google.maps.importLibrary(o);
  }
  static serializeParams(e) {
    return [e.v, e.key, e.language, e.region, e.authReferrerPolicy, e.solutionChannel].join("/");
  }
  static initImportLibrary(e, r) {
    if (window.google || (window.google = {}), window.google.maps || (window.google.maps = {}), window.google.maps.importLibrary) {
      console.warn("initImportLibrary can only be called once.", e);
      return;
    }
    let n = null;
    const i = (s) => n || (n = new Promise((o, l) => {
      var c;
      const u = document.createElement("script"), f = new URLSearchParams();
      for (const [C, v] of Object.entries(e)) {
        const w = C.replace(/[A-Z]/g, (g) => "_" + g[0].toLowerCase());
        f.set(w, v);
      }
      f.set("libraries", s), f.set("loading", "async"), f.set("callback", "__googleMapsCallback__"), u.async = !0, u.src = X2 + "?" + f.toString(), window.__googleMapsCallback__ = () => {
        this.loadingStatus = Ot.LOADED, r(this.loadingStatus), o();
      }, window.gm_authFailure = () => {
        this.loadingStatus = Ot.AUTH_FAILURE, r(this.loadingStatus);
      }, u.onerror = () => {
        this.loadingStatus = Ot.FAILED, r(this.loadingStatus), l(new Error("The Google Maps JavaScript API could not load."));
      }, u.nonce = ((c = document.querySelector("script[nonce]")) == null ? void 0 : c.nonce) || "", this.loadingStatus = Ot.LOADING, r(this.loadingStatus), document.head.append(u);
    }), n);
    google.maps.importLibrary = (s) => i(s).then(() => google.maps.importLibrary(s));
  }
}
Un.loadingStatus = Ot.NOT_LOADED;
Un.serializedApiParams = void 0;
const e6 = ["onLoad", "apiKey", "version", "libraries"], t6 = ["children"], ui = W.createContext(null);
function r6() {
  const [t, e] = ae({});
  return {
    mapInstances: t,
    addMapInstance: (r, n = "default") => {
      e((i) => Nt({}, i, {
        [n]: r
      }));
    },
    removeMapInstance: (r = "default") => {
      e((n) => $n(n, [r].map(K2)));
    },
    clearMapInstances: () => {
      e({});
    }
  };
}
function n6(t) {
  const {
    onLoad: e,
    apiKey: r,
    version: n,
    libraries: i = []
  } = t, s = $n(t, e6), [o, l] = ae(Un.loadingStatus), [c, u] = ni((w, g) => Nt({}, w, {
    [g.name]: g.value
  }), {}), f = ve(() => i == null ? void 0 : i.join(","), [i]), C = ve(() => JSON.stringify(Nt({
    apiKey: r,
    version: n
  }, s)), [r, n, s]), v = ar(async (w) => {
    var g;
    if (c[w])
      return c[w];
    if (!((g = google) != null && (g = g.maps) != null && g.importLibrary))
      throw new Error("[api-provider-internal] importLibrary was called before google.maps.importLibrary was defined.");
    const b = await window.google.maps.importLibrary(w);
    return u({
      name: w,
      value: b
    }), b;
  }, [c]);
  return K(
    () => {
      (async () => {
        try {
          const w = Nt({
            key: r
          }, s);
          n && (w.v = n), (f == null ? void 0 : f.length) > 0 && (w.libraries = f), await Un.load(w, (g) => l(g));
          for (const g of ["core", "maps", ...i])
            await v(g);
          e && e();
        } catch (w) {
          console.error("<ApiProvider> failed to load Google Maps API", w);
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, f, C]
  ), {
    status: o,
    loadedLibraries: c,
    importLibrary: v
  };
}
const i6 = (t) => {
  const {
    children: e
  } = t, r = $n(t, t6), {
    mapInstances: n,
    addMapInstance: i,
    removeMapInstance: s,
    clearMapInstances: o
  } = r6(), {
    status: l,
    loadedLibraries: c,
    importLibrary: u
  } = n6(r);
  return /* @__PURE__ */ W.createElement(ui.Provider, {
    value: {
      mapInstances: n,
      addMapInstance: i,
      removeMapInstance: s,
      clearMapInstances: o,
      status: l,
      loadedLibraries: c,
      importLibrary: u
    }
  }, e);
};
function s6(t, e) {
  for (const r of c6) {
    const n = e[r], i = Qo[r];
    K(() => {
      if (!t || !n)
        return;
      const s = google.maps.event.addListener(t, i, (o) => {
        n(o6(i, t, o));
      });
      return () => s.remove();
    }, [t, i, n]);
  }
}
function o6(t, e, r) {
  const n = {
    type: t,
    map: e,
    detail: {},
    stoppable: !1,
    stop: () => {
    }
  };
  if (a6.includes(t)) {
    const s = n, o = e.getCenter(), l = e.getZoom(), c = e.getHeading() || 0, u = e.getTilt() || 0, f = e.getBounds();
    return (!o || !f || !Number.isFinite(l)) && console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), s.detail = {
      center: (o == null ? void 0 : o.toJSON()) || {
        lat: 0,
        lng: 0
      },
      zoom: l || 0,
      heading: c,
      tilt: u,
      bounds: (f == null ? void 0 : f.toJSON()) || {
        north: 90,
        east: 180,
        south: -90,
        west: -180
      }
    }, s;
  } else if (l6.includes(t)) {
    var i;
    if (!r)
      throw new Error("[createEvent] mouse events must provide a srcEvent");
    const s = n;
    return s.domEvent = r.domEvent, s.stoppable = !0, s.stop = () => r.stop(), s.detail = {
      latLng: ((i = r.latLng) == null ? void 0 : i.toJSON()) || null,
      placeId: r.placeId
    }, s;
  }
  return n;
}
const Qo = {
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onContextmenu: "contextmenu",
  onDblclick: "dblclick",
  onDrag: "drag",
  onDragend: "dragend",
  onDragstart: "dragstart",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onIsFractionalZoomEnabledChanged: "isfractionalzoomenabled_changed",
  onMapCapabilitiesChanged: "mapcapabilities_changed",
  onMapTypeIdChanged: "maptypeid_changed",
  onMousemove: "mousemove",
  onMouseout: "mouseout",
  onMouseover: "mouseover",
  onProjectionChanged: "projection_changed",
  onRenderingTypeChanged: "renderingtype_changed",
  onTilesLoaded: "tilesloaded",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
  // note: onCameraChanged is an alias for the bounds_changed event,
  // since that is going to be fired in every situation where the camera is
  // updated.
  onCameraChanged: "bounds_changed"
}, a6 = ["bounds_changed", "center_changed", "heading_changed", "projection_changed", "tilt_changed", "zoom_changed"], l6 = ["click", "contextmenu", "dblclick", "mousemove", "mouseout", "mouseover"], c6 = Object.keys(Qo);
function u6(t, e) {
  const r = X(void 0);
  (!r.current || !J2(e, r.current)) && (r.current = e), K(t, r.current);
}
const d6 = /* @__PURE__ */ new Set(["backgroundColor", "clickableIcons", "controlSize", "disableDefaultUI", "disableDoubleClickZoom", "draggable", "draggableCursor", "draggingCursor", "fullscreenControl", "fullscreenControlOptions", "gestureHandling", "isFractionalZoomEnabled", "keyboardShortcuts", "mapTypeControl", "mapTypeControlOptions", "mapTypeId", "maxZoom", "minZoom", "noClear", "panControl", "panControlOptions", "restriction", "rotateControl", "rotateControlOptions", "scaleControl", "scaleControlOptions", "scrollwheel", "streetView", "streetViewControl", "streetViewControlOptions", "styles", "zoomControl", "zoomControlOptions"]);
function f6(t, e) {
  const r = {}, n = Object.keys(e);
  for (const i of n)
    d6.has(i) && (r[i] = e[i]);
  u6(() => {
    t && t.setOptions(r);
  }, [r]);
}
function Yo() {
  var t;
  return ((t = Se(ui)) == null ? void 0 : t.status) || Ot.NOT_LOADED;
}
function p6(t, e) {
  const {
    viewport: r,
    viewState: n
  } = e, i = !!r;
  return Ln(() => {
    if (!t || !n)
      return;
    const {
      latitude: s,
      longitude: o,
      bearing: l,
      pitch: c,
      zoom: u
    } = n;
    t.moveCamera({
      center: {
        lat: s,
        lng: o
      },
      heading: l,
      tilt: c,
      zoom: u + 1
    });
  }, [t, n]), i;
}
function h6(t) {
  return !t || typeof t != "object" || !("lat" in t && "lng" in t) ? !1 : Number.isFinite(t.lat) && Number.isFinite(t.lng);
}
function m6(t, e) {
  if (!t || !e)
    return !1;
  const r = Qn(t), n = Qn(e);
  return !(r.lat !== n.lat || r.lng !== n.lng);
}
function Qn(t) {
  return h6(t) ? t : t.toJSON();
}
function C6(t, e, r) {
  const n = r.center ? Qn(r.center) : null;
  let i = null, s = null;
  n && Number.isFinite(n.lat) && Number.isFinite(n.lng) && (i = n.lat, s = n.lng);
  const o = Number.isFinite(r.zoom) ? r.zoom : null, l = Number.isFinite(r.heading) ? r.heading : null, c = Number.isFinite(r.tilt) ? r.tilt : null;
  Ln(() => {
    if (!t)
      return;
    const u = {};
    let f = !1;
    i !== null && s !== null && (e.current.center.lat !== i || e.current.center.lng !== s) && (u.center = {
      lat: i,
      lng: s
    }, f = !0), o !== null && e.current.zoom !== o && (u.zoom = o, f = !0), l !== null && e.current.heading !== l && (u.heading = l, f = !0), c !== null && e.current.tilt !== c && (u.tilt = c, f = !0), f && t.moveCamera(u);
  });
}
const g6 = () => {
  const t = {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 999,
    display: "flex",
    flexFlow: "column nowrap",
    textAlign: "center",
    justifyContent: "center",
    fontSize: ".8rem",
    color: "rgba(0,0,0,0.6)",
    background: "#dddddd",
    padding: "1rem 1.5rem"
  };
  return /* @__PURE__ */ W.createElement("div", {
    style: t
  }, /* @__PURE__ */ W.createElement("h2", null, "Error: AuthFailure"), /* @__PURE__ */ W.createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", /* @__PURE__ */ W.createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function v6() {
  const [t, e] = ae(null), r = ar((n) => e(n), [e]);
  return [t, r];
}
function Jo() {
  return Yo() === Ot.LOADED;
}
function y6() {
  const [, t] = ni((e) => e + 1, 0);
  return t;
}
function x6(t, e) {
  const r = t.getCenter(), n = t.getZoom(), i = t.getHeading() || 0, s = t.getTilt() || 0, o = t.getBounds();
  (!r || !o || !Number.isFinite(n)) && console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), Object.assign(e.current, {
    center: (r == null ? void 0 : r.toJSON()) || {
      lat: 0,
      lng: 0
    },
    zoom: n || 0,
    heading: i,
    tilt: s
  });
}
function w6(t) {
  const e = y6(), r = X({
    center: {
      lat: 0,
      lng: 0
    },
    heading: 0,
    tilt: 0,
    zoom: 0
  });
  return K(() => {
    if (!t)
      return;
    const n = google.maps.event.addListener(t, "bounds_changed", () => {
      x6(t, r), e();
    });
    return () => n.remove();
  }, [t, e]), r;
}
const b6 = ["id", "defaultBounds", "defaultCenter", "defaultZoom", "defaultHeading", "defaultTilt"];
function _6(t, e) {
  const r = Jo(), [n, i] = ae(null), [s, o] = v6(), l = w6(n), {
    id: c,
    defaultBounds: u,
    defaultCenter: f,
    defaultZoom: C,
    defaultHeading: v,
    defaultTilt: w
  } = t, g = $n(t, b6);
  !g.center && f && (g.center = f), !g.zoom && Number.isFinite(C) && (g.zoom = C), !g.heading && Number.isFinite(v) && (g.heading = v), !g.tilt && Number.isFinite(w) && (g.tilt = w);
  for (const _ of Object.keys(g))
    g[_] === void 0 && delete g[_];
  const b = X();
  return K(
    () => {
      if (!s || !r)
        return;
      const {
        addMapInstance: _,
        removeMapInstance: h
      } = e, y = t.mapId, E = new google.maps.Map(s, g);
      if (i(E), _(E, c), u && E.fitBounds(u), b.current) {
        const {
          mapId: T,
          cameraState: $
        } = b.current;
        T !== y && E.setOptions($);
      }
      return () => {
        b.current = {
          mapId: y,
          // eslint-disable-next-line react-hooks/exhaustive-deps
          cameraState: l.current
        }, google.maps.event.clearInstanceListeners(E), i(null), h(c);
      };
    },
    // some dependencies are ignored in the list below:
    //  - defaultBounds and the default* camera props will only be used once, and
    //    changes should be ignored
    //  - mapOptions has special hooks that take care of updating the options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [s, r, c, t.mapId]
  ), [n, o, l];
}
const di = W.createContext(null), Zo = (t) => {
  const {
    children: e,
    id: r,
    className: n,
    style: i
  } = t, s = Se(ui), o = Yo();
  if (!s)
    throw new Error("<Map> can only be used inside an <ApiProvider> component.");
  const [l, c, u] = _6(t, s);
  C6(l, u, t), s6(l, t), f6(l, t);
  const f = p6(l, t), C = !!t.controlled;
  K(() => {
    if (l)
      return f && l.setOptions({
        disableDefaultUI: !0
      }), (f || C) && l.setOptions({
        gestureHandling: "none",
        keyboardShortcuts: !1
      }), () => {
        l.setOptions({
          gestureHandling: t.gestureHandling,
          keyboardShortcuts: t.keyboardShortcuts
        });
      };
  }, [l, f, C, t.gestureHandling, t.keyboardShortcuts]);
  const v = t.center ? Qn(t.center) : null;
  let w = null, g = null;
  v && Number.isFinite(v.lat) && Number.isFinite(v.lng) && (w = v.lat, g = v.lng);
  const b = ve(() => {
    var h, y, E, T, $;
    return {
      center: {
        lat: (h = w) != null ? h : 0,
        lng: (y = g) != null ? y : 0
      },
      zoom: (E = t.zoom) != null ? E : 0,
      heading: (T = t.heading) != null ? T : 0,
      tilt: ($ = t.tilt) != null ? $ : 0
    };
  }, [w, g, t.zoom, t.heading, t.tilt]);
  Ln(() => {
    if (!l || !C)
      return;
    l.moveCamera(b);
    const h = l.addListener("bounds_changed", () => {
      l.moveCamera(b);
    });
    return () => h.remove();
  }, [l, C, b]);
  const _ = ve(() => Nt({
    width: "100%",
    height: "100%",
    // when using deckgl, the map should be sent to the back
    zIndex: f ? -1 : 0
  }, i), [i, f]);
  return o === Ot.AUTH_FAILURE ? /* @__PURE__ */ W.createElement("div", {
    style: Nt({
      position: "relative"
    }, n ? {} : _),
    className: n
  }, /* @__PURE__ */ W.createElement(g6, null)) : /* @__PURE__ */ W.createElement("div", Nt({
    ref: c,
    "data-testid": "map",
    style: n ? void 0 : _,
    className: n
  }, r ? {
    id: r
  } : {}), l ? /* @__PURE__ */ W.createElement(di.Provider, {
    value: {
      map: l
    }
  }, e) : null);
};
Zo.deckGLViewProps = !0;
function S6(t) {
  const e = Jo(), r = Se(ui);
  return K(() => {
    !e || !r || r.importLibrary(t);
  }, [e, r, t]), (r == null ? void 0 : r.loadedLibraries[t]) || null;
}
const E6 = W.createContext(null);
function T6(t) {
  var e;
  const [r, n] = ae(null), [i, s] = ae(null), o = (e = Se(di)) == null ? void 0 : e.map, l = S6("marker"), {
    children: c,
    className: u,
    onClick: f,
    onDrag: C,
    onDragStart: v,
    onDragEnd: w,
    collisionBehavior: g,
    draggable: b,
    position: _,
    title: h,
    zIndex: y
  } = t, E = vl.count(c);
  return K(() => {
    if (!o || !l)
      return;
    const T = new l.AdvancedMarkerElement();
    if (T.map = o, n(T), E > 0) {
      const $ = document.createElement("div");
      u && ($.className = u), T.content = $, s($);
    }
    return () => {
      T.map = null, n(null), s(null);
    };
  }, [o, l, E]), K(() => {
    i && (i.className = u ?? "");
  }, [i, u]), K(() => {
    if (!r)
      return;
    const T = google.maps.event;
    f && T.addListener(r, "click", f), C && T.addListener(r, "drag", C), v && T.addListener(r, "dragstart", v), w && T.addListener(r, "dragend", w), (C || v || w) && !b && console.warn("You need to set the marker to draggable to listen to drag-events.");
    const $ = r;
    return () => {
      T.clearInstanceListeners($);
    };
  }, [r, b, f, v, C, w]), K(() => {
    r && (_ !== void 0 && (r.position = _), b !== void 0 && (r.gmpDraggable = b), g !== void 0 && (r.collisionBehavior = g), y !== void 0 && (r.zIndex = y), typeof h == "string" && (r.title = h));
  }, [r, _, b, g, y, h]), [r, i];
}
Lr((t, e) => {
  const {
    children: r
  } = t, [n, i] = T6(t);
  return Cs(e, () => n, [n]), n ? /* @__PURE__ */ W.createElement(E6.Provider, {
    value: {
      marker: n
    }
  }, i !== null && Q1(r, i)) : null;
});
const k6 = ["onClick", "onDrag", "onDragStart", "onDragEnd", "onMouseOver", "onMouseOut"];
function M6(t) {
  var e;
  const [r, n] = ae(null), i = (e = Se(di)) == null ? void 0 : e.map, {
    onClick: s,
    onDrag: o,
    onDragStart: l,
    onDragEnd: c,
    onMouseOver: u,
    onMouseOut: f
  } = t, C = $n(t, k6), {
    position: v,
    draggable: w
  } = C;
  return K(() => {
    if (!i) {
      i === void 0 && console.error("<Marker> has to be inside a Map component.");
      return;
    }
    const g = new google.maps.Marker(C);
    return g.setMap(i), n(g), () => {
      g.setMap(null), n(null);
    };
  }, [i]), K(() => {
    if (!r)
      return;
    const g = r, b = google.maps.event;
    return s && b.addListener(g, "click", s), o && b.addListener(g, "drag", o), l && b.addListener(g, "dragstart", l), c && b.addListener(g, "dragend", c), u && b.addListener(g, "mouseover", u), f && b.addListener(g, "mouseout", f), r.setDraggable(!!w), () => {
      b.clearInstanceListeners(g);
    };
  }, [r, w, s, o, l, c, u, f]), K(() => {
    r && C && r.setOptions(C);
  }, [r, C]), K(() => {
    w || !v || !r || r.setPosition(v);
  }, [w, v, r]), r;
}
const O6 = Lr((t, e) => {
  const r = M6(t);
  return Cs(e, () => r, [r]), /* @__PURE__ */ W.createElement(W.Fragment, null);
});
var Ko = {}, Xo = { exports: {} };
(function(t) {
  var e = function(r) {
    var n = Object.prototype, i = n.hasOwnProperty, s, o = typeof Symbol == "function" ? Symbol : {}, l = o.iterator || "@@iterator", c = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
    function f(F, O, k) {
      return Object.defineProperty(F, O, {
        value: k,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), F[O];
    }
    try {
      f({}, "");
    } catch {
      f = function(F, O, k) {
        return F[O] = k;
      };
    }
    function C(F, O, k, U) {
      var V = O && O.prototype instanceof y ? O : y, H = Object.create(V.prototype), le = new se(U || []);
      return H._invoke = N(F, k, le), H;
    }
    r.wrap = C;
    function v(F, O, k) {
      try {
        return { type: "normal", arg: F.call(O, k) };
      } catch (U) {
        return { type: "throw", arg: U };
      }
    }
    var w = "suspendedStart", g = "suspendedYield", b = "executing", _ = "completed", h = {};
    function y() {
    }
    function E() {
    }
    function T() {
    }
    var $ = {};
    $[l] = function() {
      return this;
    };
    var L = Object.getPrototypeOf, z = L && L(L(Y([])));
    z && z !== n && i.call(z, l) && ($ = z);
    var P = T.prototype = y.prototype = Object.create($);
    E.prototype = P.constructor = T, T.constructor = E, E.displayName = f(
      T,
      u,
      "GeneratorFunction"
    );
    function B(F) {
      ["next", "throw", "return"].forEach(function(O) {
        f(F, O, function(k) {
          return this._invoke(O, k);
        });
      });
    }
    r.isGeneratorFunction = function(F) {
      var O = typeof F == "function" && F.constructor;
      return O ? O === E || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (O.displayName || O.name) === "GeneratorFunction" : !1;
    }, r.mark = function(F) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(F, T) : (F.__proto__ = T, f(F, u, "GeneratorFunction")), F.prototype = Object.create(P), F;
    }, r.awrap = function(F) {
      return { __await: F };
    };
    function q(F, O) {
      function k(H, le, me, we) {
        var Pe = v(F[H], F, le);
        if (Pe.type === "throw")
          we(Pe.arg);
        else {
          var it = Pe.arg, ke = it.value;
          return ke && typeof ke == "object" && i.call(ke, "__await") ? O.resolve(ke.__await).then(function(Ae) {
            k("next", Ae, me, we);
          }, function(Ae) {
            k("throw", Ae, me, we);
          }) : O.resolve(ke).then(function(Ae) {
            it.value = Ae, me(it);
          }, function(Ae) {
            return k("throw", Ae, me, we);
          });
        }
      }
      var U;
      function V(H, le) {
        function me() {
          return new O(function(we, Pe) {
            k(H, le, we, Pe);
          });
        }
        return U = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        U ? U.then(
          me,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          me
        ) : me();
      }
      this._invoke = V;
    }
    B(q.prototype), q.prototype[c] = function() {
      return this;
    }, r.AsyncIterator = q, r.async = function(F, O, k, U, V) {
      V === void 0 && (V = Promise);
      var H = new q(
        C(F, O, k, U),
        V
      );
      return r.isGeneratorFunction(O) ? H : H.next().then(function(le) {
        return le.done ? le.value : H.next();
      });
    };
    function N(F, O, k) {
      var U = w;
      return function(V, H) {
        if (U === b)
          throw new Error("Generator is already running");
        if (U === _) {
          if (V === "throw")
            throw H;
          return ie();
        }
        for (k.method = V, k.arg = H; ; ) {
          var le = k.delegate;
          if (le) {
            var me = R(le, k);
            if (me) {
              if (me === h)
                continue;
              return me;
            }
          }
          if (k.method === "next")
            k.sent = k._sent = k.arg;
          else if (k.method === "throw") {
            if (U === w)
              throw U = _, k.arg;
            k.dispatchException(k.arg);
          } else
            k.method === "return" && k.abrupt("return", k.arg);
          U = b;
          var we = v(F, O, k);
          if (we.type === "normal") {
            if (U = k.done ? _ : g, we.arg === h)
              continue;
            return {
              value: we.arg,
              done: k.done
            };
          } else
            we.type === "throw" && (U = _, k.method = "throw", k.arg = we.arg);
        }
      };
    }
    function R(F, O) {
      var k = F.iterator[O.method];
      if (k === s) {
        if (O.delegate = null, O.method === "throw") {
          if (F.iterator.return && (O.method = "return", O.arg = s, R(F, O), O.method === "throw"))
            return h;
          O.method = "throw", O.arg = new TypeError(
            "The iterator does not provide a 'throw' method"
          );
        }
        return h;
      }
      var U = v(k, F.iterator, O.arg);
      if (U.type === "throw")
        return O.method = "throw", O.arg = U.arg, O.delegate = null, h;
      var V = U.arg;
      if (!V)
        return O.method = "throw", O.arg = new TypeError("iterator result is not an object"), O.delegate = null, h;
      if (V.done)
        O[F.resultName] = V.value, O.next = F.nextLoc, O.method !== "return" && (O.method = "next", O.arg = s);
      else
        return V;
      return O.delegate = null, h;
    }
    B(P), f(P, u, "Generator"), P[l] = function() {
      return this;
    }, P.toString = function() {
      return "[object Generator]";
    };
    function D(F) {
      var O = { tryLoc: F[0] };
      1 in F && (O.catchLoc = F[1]), 2 in F && (O.finallyLoc = F[2], O.afterLoc = F[3]), this.tryEntries.push(O);
    }
    function Q(F) {
      var O = F.completion || {};
      O.type = "normal", delete O.arg, F.completion = O;
    }
    function se(F) {
      this.tryEntries = [{ tryLoc: "root" }], F.forEach(D, this), this.reset(!0);
    }
    r.keys = function(F) {
      var O = [];
      for (var k in F)
        O.push(k);
      return O.reverse(), function U() {
        for (; O.length; ) {
          var V = O.pop();
          if (V in F)
            return U.value = V, U.done = !1, U;
        }
        return U.done = !0, U;
      };
    };
    function Y(F) {
      if (F) {
        var O = F[l];
        if (O)
          return O.call(F);
        if (typeof F.next == "function")
          return F;
        if (!isNaN(F.length)) {
          var k = -1, U = function V() {
            for (; ++k < F.length; )
              if (i.call(F, k))
                return V.value = F[k], V.done = !1, V;
            return V.value = s, V.done = !0, V;
          };
          return U.next = U;
        }
      }
      return { next: ie };
    }
    r.values = Y;
    function ie() {
      return { value: s, done: !0 };
    }
    return se.prototype = {
      constructor: se,
      reset: function(F) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = s, this.done = !1, this.delegate = null, this.method = "next", this.arg = s, this.tryEntries.forEach(Q), !F)
          for (var O in this)
            O.charAt(0) === "t" && i.call(this, O) && !isNaN(+O.slice(1)) && (this[O] = s);
      },
      stop: function() {
        this.done = !0;
        var F = this.tryEntries[0], O = F.completion;
        if (O.type === "throw")
          throw O.arg;
        return this.rval;
      },
      dispatchException: function(F) {
        if (this.done)
          throw F;
        var O = this;
        function k(we, Pe) {
          return H.type = "throw", H.arg = F, O.next = we, Pe && (O.method = "next", O.arg = s), !!Pe;
        }
        for (var U = this.tryEntries.length - 1; U >= 0; --U) {
          var V = this.tryEntries[U], H = V.completion;
          if (V.tryLoc === "root")
            return k("end");
          if (V.tryLoc <= this.prev) {
            var le = i.call(V, "catchLoc"), me = i.call(V, "finallyLoc");
            if (le && me) {
              if (this.prev < V.catchLoc)
                return k(V.catchLoc, !0);
              if (this.prev < V.finallyLoc)
                return k(V.finallyLoc);
            } else if (le) {
              if (this.prev < V.catchLoc)
                return k(V.catchLoc, !0);
            } else if (me) {
              if (this.prev < V.finallyLoc)
                return k(V.finallyLoc);
            } else
              throw new Error("try statement without catch or finally");
          }
        }
      },
      abrupt: function(F, O) {
        for (var k = this.tryEntries.length - 1; k >= 0; --k) {
          var U = this.tryEntries[k];
          if (U.tryLoc <= this.prev && i.call(U, "finallyLoc") && this.prev < U.finallyLoc) {
            var V = U;
            break;
          }
        }
        V && (F === "break" || F === "continue") && V.tryLoc <= O && O <= V.finallyLoc && (V = null);
        var H = V ? V.completion : {};
        return H.type = F, H.arg = O, V ? (this.method = "next", this.next = V.finallyLoc, h) : this.complete(H);
      },
      complete: function(F, O) {
        if (F.type === "throw")
          throw F.arg;
        return F.type === "break" || F.type === "continue" ? this.next = F.arg : F.type === "return" ? (this.rval = this.arg = F.arg, this.method = "return", this.next = "end") : F.type === "normal" && O && (this.next = O), h;
      },
      finish: function(F) {
        for (var O = this.tryEntries.length - 1; O >= 0; --O) {
          var k = this.tryEntries[O];
          if (k.finallyLoc === F)
            return this.complete(k.completion, k.afterLoc), Q(k), h;
        }
      },
      catch: function(F) {
        for (var O = this.tryEntries.length - 1; O >= 0; --O) {
          var k = this.tryEntries[O];
          if (k.tryLoc === F) {
            var U = k.completion;
            if (U.type === "throw") {
              var V = U.arg;
              Q(k);
            }
            return V;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(F, O, k) {
        return this.delegate = {
          iterator: Y(F),
          resultName: O,
          nextLoc: k
        }, this.method === "next" && (this.arg = s), h;
      }
    }, r;
  }(
    // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    t.exports
  );
  try {
    regeneratorRuntime = e;
  } catch {
    Function("r", "regeneratorRuntime = r")(e);
  }
})(Xo);
var L6 = Xo.exports;
(function(t) {
  var e = L6;
  function r(g, b, _, h, y, E, T) {
    try {
      var $ = g[E](T), L = $.value;
    } catch (z) {
      return void _(z);
    }
    $.done ? b(L) : Promise.resolve(L).then(h, y);
  }
  function n(g) {
    return function() {
      var b = this, _ = arguments;
      return new Promise(function(h, y) {
        var E = g.apply(b, _);
        function T(L) {
          r(E, h, y, T, $, "next", L);
        }
        function $(L) {
          r(E, h, y, T, $, "throw", L);
        }
        T(void 0);
      });
    };
  }
  Object.defineProperty(t, "__esModule", { value: !0 }), t.default = void 0;
  var i = !1, s = null, o = "en", l = null, c = null, u = "https://maps.googleapis.com/maps/api/geocode/json";
  function f(g) {
    var b = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    i && (b ? console.warn(g) : console.log(g));
  }
  function C(g) {
    return v.apply(this, arguments);
  }
  function v() {
    return (v = n(e.mark(function g(b) {
      var _, h;
      return e.wrap(function(y) {
        for (; ; )
          switch (y.prev = y.next) {
            case 0:
              return y.next = 2, fetch(b).catch(function() {
                return Promise.reject(new Error("Error fetching data"));
              });
            case 2:
              return _ = y.sent, y.next = 5, _.json().catch(function() {
                return f("Error parsing server response"), Promise.reject(new Error("Error parsing server response"));
              });
            case 5:
              if ((h = y.sent).status !== "OK") {
                y.next = 9;
                break;
              }
              return f(h), y.abrupt("return", h);
            case 9:
              return f("".concat(h.error_message, `.
Server returned status code `).concat(h.status), !0), y.abrupt("return", Promise.reject(new Error("".concat(h.error_message, `.
Server returned status code `).concat(h.status))));
            case 11:
            case "end":
              return y.stop();
          }
      }, g);
    }))).apply(this, arguments);
  }
  var w = { setApiKey: function(g) {
    s = g;
  }, setLanguage: function(g) {
    o = g;
  }, setRegion: function(g) {
    l = g;
  }, setLocationType: function(g) {
    c = g;
  }, enableDebug: function() {
    var g = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    i = g;
  }, fromLatLng: function(g, b, _, h, y, E) {
    return n(e.mark(function T() {
      var $, L;
      return e.wrap(function(z) {
        for (; ; )
          switch (z.prev = z.next) {
            case 0:
              if (g && b) {
                z.next = 3;
                break;
              }
              return f("Provided coordinates are invalid", !0), z.abrupt("return", Promise.reject(new Error("Provided coordinates are invalid")));
            case 3:
              return $ = "".concat(g, ",").concat(b), L = "".concat(u, "?latlng=").concat(encodeURIComponent($)), (_ || s) && (L += "&key=".concat(s = _ || s)), (h || o) && (L += "&language=".concat(o = h || o)), (y || l) && (l = y || l, L += "&region=".concat(encodeURIComponent(l))), (E || c) && (c = E || c, L += "&location_type=".concat(encodeURIComponent(c))), z.abrupt("return", C(L));
            case 9:
            case "end":
              return z.stop();
          }
      }, T);
    }))();
  }, fromAddress: function(g, b, _, h) {
    return n(e.mark(function y() {
      var E;
      return e.wrap(function(T) {
        for (; ; )
          switch (T.prev = T.next) {
            case 0:
              if (g) {
                T.next = 3;
                break;
              }
              return f("Provided address is invalid", !0), T.abrupt("return", Promise.reject(new Error("Provided address is invalid")));
            case 3:
              return E = "".concat(u, "?address=").concat(encodeURIComponent(g)), (b || s) && (E += "&key=".concat(s = b || s)), (_ || o) && (E += "&language=".concat(o = _ || o)), (h || l) && (l = h || l, E += "&region=".concat(encodeURIComponent(l))), T.abrupt("return", C(E));
            case 8:
            case "end":
              return T.stop();
          }
      }, y);
    }))();
  } };
  t.default = w;
})(Ko);
const w1 = /* @__PURE__ */ Uo(Ko);
function P6(t) {
  var e;
  const {
    onClick: r,
    onDrag: n,
    onDragStart: i,
    onDragEnd: s,
    onMouseOver: o,
    onMouseOut: l,
    onRadiusChanged: c,
    onCenterChanged: u,
    radius: f,
    center: C,
    ...v
  } = t, w = X({});
  Object.assign(w.current, {
    onClick: r,
    onDrag: n,
    onDragStart: i,
    onDragEnd: s,
    onMouseOver: o,
    onMouseOut: l,
    onRadiusChanged: c,
    onCenterChanged: u
  });
  const g = X(new google.maps.Circle()).current;
  g.setOptions(v), K(() => {
    C && (m6(C, g.getCenter()) || g.setCenter(C));
  }, [C]), K(() => {
    f != null && f !== g.getRadius() && g.setRadius(f);
  }, [f]);
  const b = (e = Se(di)) == null ? void 0 : e.map;
  return K(() => {
    if (!b) {
      b === void 0 && console.error("<Circle> has to be inside a Map component.");
      return;
    }
    return g.setMap(b), () => {
      g.setMap(null);
    };
  }, [b]), K(() => {
    if (!g)
      return;
    const _ = google.maps.event;
    return [
      ["click", "onClick"],
      ["drag", "onDrag"],
      ["dragstart", "onDragStart"],
      ["dragend", "onDragEnd"],
      ["mouseover", "onMouseOver"],
      ["mouseout", "onMouseOut"]
    ].forEach(([h, y]) => {
      _.addListener(g, h, (E) => {
        const T = w.current[y];
        T && T(E);
      });
    }), _.addListener(g, "radius_changed", () => {
      var h, y;
      const E = g.getRadius();
      (y = (h = w.current).onRadiusChanged) == null || y.call(h, E);
    }), _.addListener(g, "center_changed", () => {
      var h, y;
      const E = g.getCenter();
      (y = (h = w.current).onCenterChanged) == null || y.call(h, E);
    }), () => {
      _.clearInstanceListeners(g);
    };
  }, [g]), g;
}
const A6 = Lr((t, e) => {
  const r = P6(t);
  return Cs(e, () => r), null;
}), N6 = (t) => t * 1609.344, $6 = ({ containerStyle: t, locations: e, serviceArea: r, hideLocation: n, className: i }) => {
  const s = process.env.PUBLIC_GOOGLE_MAPS_API_KEY || "NO API KEY DETECTED", o = `w-full h-full overflow-hidden ${i}`, [l, c] = ae({
    center: { lat: 40.7, lng: -74 },
    zoom: 9.5
  }), [u, f] = ae({
    lat: 0,
    lng: 0
  }), C = (v) => c(v.detail);
  return K(() => {
    const v = e == null ? void 0 : e[0], w = (v == null ? void 0 : v.streetAddress) + "," + (v == null ? void 0 : v.city) + "," + (v == null ? void 0 : v.state) + "," + (v == null ? void 0 : v.postalCode);
    (w1.fromAddress || w1.default.fromAddress)(w, s).then((g) => {
      const { lat: b, lng: _ } = g.results[0].geometry.location;
      c({
        center: {
          lat: b,
          lng: _
        },
        zoom: 9.5
      }), f({
        lat: b,
        lng: _
      });
    });
  }, [s, e]), /* @__PURE__ */ d(
    "div",
    {
      style: {
        width: "64rem",
        maxWidth: "100%",
        height: "500px",
        borderRadius: "10px",
        ...t
      },
      children: /* @__PURE__ */ d(i6, { apiKey: s, children: /* @__PURE__ */ I(Zo, { ...l, onCameraChanged: C, className: o, children: [
        n && /* @__PURE__ */ d(O6, { position: { lat: u.lat, lng: u.lng } }),
        /* @__PURE__ */ d(
          A6,
          {
            radius: N6(Number.parseInt(r || "25")),
            center: {
              lat: u.lat,
              lng: u.lng
            },
            draggable: !1,
            strokeColor: "black",
            strokeOpacity: 1,
            strokeWeight: 3,
            fillColor: "black",
            fillOpacity: 0.3
          }
        )
      ] }) })
    }
  );
}, j6 = async (t, e, r) => {
  const n = {
    "x-api-key": (process.env.PUBLIC_SEND_EMAIL_LAMBDA_API_KEY ?? (r == null ? void 0 : r.email_lambda_api_key)) || "NO API KEY DETECTED"
  }, i = e, s = process.env.PUBLIC_SEND_EMAIL_URL ?? (r == null ? void 0 : r.email_url), o = {
    to: `${i}`,
    body: {
      name: t.name,
      phoneNumber: t.phoneNumber,
      businessName: t.businessName,
      to: "TO",
      website: t.website,
      email: t.email,
      message: t.message
    },
    subject: "Request Quote",
    templateName: "request_quote"
  };
  return await fetch(s || "NO URL DETECTED", {
    method: "POST",
    body: JSON.stringify(o),
    headers: n
  });
}, F6 = async (t, e, r) => j6(t, e, r), ur = (t) => {
  const e = ("" + t).replace(/\D/g, "").match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
  return e ? (e[1] ? "+1 " : "") + "(" + e[2] + ") " + e[3] + "-" + e[4] : t;
}, R6 = (t) => t.split(/\s+/).map((e) => e.charAt(0)).join(""), I6 = ({ text: t = "", position: e, className: r }) => {
  if (!t)
    return "";
  const n = t == null ? void 0 : t.split(" ").map(
    (i, s) => s === e ? /* @__PURE__ */ d("span", { className: r, children: i }, s) : i
  );
  return /* @__PURE__ */ d(a1, { children: n.reduce((i, s, o) => /* @__PURE__ */ I(a1, { children: [
    i,
    o !== 0 && " ",
    s
  ] })) });
};
function ea(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number")
    n += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (r = ea(t[e])) && (n && (n += " "), n += r);
    else
      for (e in t)
        t[e] && (n && (n += " "), n += e);
  return n;
}
const ge = (...t) => {
  for (var e = 0, r, n, i = ""; e < t.length; )
    (r = t[e++]) && (n = ea(r)) && (i && (i += " "), i += n);
  return i;
}, ta = ({ businessEmail: t, businessName: e }) => {
  const [r, n] = ae(!1), [i, s] = ae(!1), [o, l] = ae(!1), [c, u] = ae({
    name: "",
    phoneNumber: "",
    email: "",
    businessName: e,
    website: "",
    message: ""
  });
  K(() => {
    u((C) => ({ ...C, website: window.location.href }));
  }, []);
  const f = (C) => {
    u({ ...c, [C.target.name]: C.target.value });
  };
  return K(() => {
    i && setTimeout(() => {
      s(!1);
    }, 5e3);
  }, [i]), K(() => {
    o && setTimeout(() => {
      l(!1);
    }, 5e3);
  }, [o]), { form: c, handleChange: f, onSubmit: (C) => {
    C.preventDefault(), n(!0), F6(c, t).then((v) => {
      v.ok ? (s(!0), n(!1)) : (s(!1), n(!1), l(!0));
    });
  }, isLoading: r, isSuccess: i, isError: o };
}, D6 = {
  "facebook.com": "facebook",
  "instagram.com": "instagram",
  "x.com": "twitter",
  "twitter.com": "twitter",
  "yelp.com": "yelp",
  "linkedin.com": "linkedin",
  "tiktok.com": "tikTok",
  "youtube.com": "youTube",
  "google.com": "google",
  "pinterest.com": "pinterest",
  "tripadvisor.com": "tripAdvisor",
  "foursquare.com": "foursquare"
}, V6 = (t) => {
  for (const [e, r] of Object.entries(D6))
    if (t != null && t.includes(e))
      return r;
  return "default";
}, z6 = (t, e = "w-6 h-6") => {
  const r = V6(t == null ? void 0 : t.toLowerCase());
  return {
    facebook: /* @__PURE__ */ d("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d(
      "path",
      {
        d: "M14.9786 0.520508H3.02051C1.64551 0.520508 0.520508 1.64551 0.520508 3.02051V14.9799C0.520508 16.3549 1.64551 17.4799 3.02051 17.4799H14.9799C16.3549 17.4799 17.4799 16.3549 17.4799 14.9799V3.02051C17.4786 1.64551 16.3549 0.520508 14.9786 0.520508ZM14.818 9.57238H12.8055V16.8536H9.79426V9.57238H8.28801V7.06238H9.79426V5.55613C9.79426 3.50863 10.6443 2.29051 13.063 2.29051H15.0736V4.79988H13.8161C12.8761 4.79988 12.8136 5.15176 12.8136 5.80613L12.8055 7.06238H15.0836L14.818 9.57238Z",
        fill: "currentColor"
      }
    ) }),
    instagram: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d(
      "path",
      {
        d: "M10.8567 1.66753C11.4649 1.6652 12.073 1.67131 12.6809 1.68586L12.8426 1.6917C13.0292 1.69836 13.2134 1.7067 13.4359 1.7167C14.3226 1.75836 14.9276 1.89836 15.4584 2.1042C16.0084 2.31586 16.4717 2.60253 16.9351 3.06586C17.3587 3.4822 17.6866 3.98582 17.8959 4.5417C18.1017 5.07253 18.2417 5.67836 18.2834 6.56503C18.2934 6.7867 18.3017 6.9717 18.3084 7.15836L18.3134 7.32003C18.3282 7.92769 18.3346 8.53553 18.3326 9.14336L18.3334 9.76503V10.8567C18.3355 11.4648 18.3291 12.0729 18.3142 12.6809L18.3092 12.8425C18.3026 13.0292 18.2942 13.2134 18.2842 13.4359C18.2426 14.3225 18.1009 14.9275 17.8959 15.4584C17.6873 16.0148 17.3593 16.5189 16.9351 16.935C16.5184 17.3586 16.0145 17.6865 15.4584 17.8959C14.9276 18.1017 14.3226 18.2417 13.4359 18.2834C13.2134 18.2934 13.0292 18.3017 12.8426 18.3084L12.6809 18.3134C12.073 18.3282 11.4649 18.3346 10.8567 18.3325L10.2351 18.3334H9.14424C8.53612 18.3354 7.92801 18.329 7.32007 18.3142L7.15841 18.3092C6.96058 18.302 6.7628 18.2937 6.56507 18.2842C5.67841 18.2425 5.07341 18.1009 4.54174 17.8959C3.98564 17.687 3.48194 17.359 3.06591 16.935C2.64178 16.5186 2.31359 16.0147 2.10424 15.4584C1.89841 14.9275 1.75841 14.3225 1.71674 13.4359C1.70746 13.2381 1.69913 13.0403 1.69174 12.8425L1.68757 12.6809C1.67221 12.0729 1.66527 11.4648 1.66674 10.8567V9.14336C1.66441 8.53553 1.67053 7.92769 1.68507 7.32003L1.69091 7.15836C1.69757 6.9717 1.70591 6.7867 1.71591 6.56503C1.75757 5.67753 1.89757 5.07336 2.10341 4.5417C2.31288 3.98555 2.64171 3.48207 3.06674 3.0667C3.48249 2.64232 3.98587 2.31384 4.54174 2.1042C5.07341 1.89836 5.67757 1.75836 6.56507 1.7167L7.15841 1.6917L7.32007 1.68753C7.92773 1.67217 8.53556 1.66523 9.14341 1.6667L10.8567 1.66753ZM10.0001 5.8342C9.448 5.82639 8.89987 5.92838 8.38755 6.13425C7.87524 6.34012 7.40895 6.64576 7.01578 7.03341C6.62261 7.42106 6.31041 7.88298 6.09731 8.39233C5.88422 8.90169 5.77448 9.44831 5.77448 10.0004C5.77448 10.5526 5.88422 11.0992 6.09731 11.6086C6.31041 12.1179 6.62261 12.5798 7.01578 12.9675C7.40895 13.3551 7.87524 13.6608 8.38755 13.8666C8.89987 14.0725 9.448 14.1745 10.0001 14.1667C11.1051 14.1667 12.1649 13.7277 12.9464 12.9463C13.7278 12.1649 14.1667 11.1051 14.1667 10C14.1667 8.89496 13.7278 7.83515 12.9464 7.05375C12.1649 6.27235 11.1051 5.8342 10.0001 5.8342ZM10.0001 7.50086C10.3322 7.49474 10.6621 7.55486 10.9707 7.6777C11.2793 7.80054 11.5604 7.98365 11.7974 8.21632C12.0344 8.44899 12.2227 8.72656 12.3513 9.03281C12.4798 9.33907 12.5461 9.66788 12.5461 10C12.5462 10.3322 12.4801 10.661 12.3516 10.9673C12.2231 11.2736 12.0349 11.5512 11.798 11.784C11.561 12.0167 11.2801 12.1999 10.9715 12.3229C10.663 12.4458 10.333 12.506 10.0009 12.5C9.33787 12.5 8.70198 12.2366 8.23314 11.7678C7.7643 11.299 7.50091 10.6631 7.50091 10C7.50091 9.33699 7.7643 8.7011 8.23314 8.23226C8.70198 7.76342 9.33787 7.50003 10.0009 7.50003L10.0001 7.50086ZM14.3751 4.5842C14.1062 4.59496 13.852 4.70932 13.6656 4.90334C13.4792 5.09736 13.3751 5.35597 13.3751 5.62503C13.3751 5.89408 13.4792 6.1527 13.6656 6.34672C13.852 6.54074 14.1062 6.6551 14.3751 6.66586C14.6513 6.66586 14.9163 6.55612 15.1116 6.36077C15.307 6.16542 15.4167 5.90046 15.4167 5.6242C15.4167 5.34793 15.307 5.08298 15.1116 4.88763C14.9163 4.69228 14.6513 4.58253 14.3751 4.58253V4.5842Z",
        fill: "currentColor"
      }
    ) }),
    x: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d("g", { clipPath: "url(#clip0_1280_424)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M15.7508 0.960938H18.8175L12.1175 8.61927L20 19.0384H13.8283L8.995 12.7184L3.46333 19.0384H0.395L7.56167 10.8468L0 0.961771H6.32833L10.6975 6.73844L15.7508 0.960938ZM14.675 17.2034H16.3742L5.405 2.7001H3.58167L14.675 17.2034Z",
        fill: "currentColor"
      }
    ) }) }),
    twitter: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d("g", { clipPath: "url(#clip0_1280_426)", children: /* @__PURE__ */ d(
      "path",
      {
        d: "M3.82837 4.15334C3.97925 4.1358 4.13205 4.15984 4.27026 4.22285C4.40846 4.28585 4.52682 4.38544 4.61254 4.51084C5.84254 6.31 7.3192 7.05833 8.95837 7.22833C9.03837 6.5275 9.22754 5.835 9.58337 5.225C10.105 4.33 10.9534 3.67167 12.165 3.42833C13.84 3.09167 15.115 3.69833 15.8542 4.44083L17.3475 4.16167C17.5038 4.13239 17.6652 4.14842 17.8126 4.20787C17.9601 4.26733 18.0875 4.36772 18.1797 4.49721C18.272 4.62669 18.3252 4.77987 18.3333 4.93865C18.3413 5.09743 18.3038 5.2552 18.225 5.39334L16.7917 7.91167C16.9225 11.5458 15.9125 14.0825 13.7592 15.83C12.6175 16.7567 10.9825 17.2825 9.18837 17.445C7.38004 17.6083 5.33587 17.4108 3.3042 16.8175C3.13061 16.7669 2.9782 16.6611 2.86997 16.5163C2.76175 16.3714 2.70357 16.1953 2.70423 16.0145C2.70489 15.8336 2.76434 15.6579 2.87363 15.5139C2.98291 15.3698 3.13608 15.2652 3.31004 15.2158C4.3317 14.925 5.11004 14.6742 5.81254 14.235C4.81337 13.705 4.07754 13.0117 3.5567 12.2217C2.83337 11.1233 2.56504 9.89833 2.5117 8.79417C2.45837 7.69 2.61754 6.66667 2.78587 5.92917C2.8817 5.50833 2.99337 5.08667 3.14754 4.68333C3.20192 4.54116 3.2942 4.4166 3.41437 4.32316C3.53454 4.22973 3.67718 4.17099 3.82837 4.15334Z",
        fill: "currentColor"
      }
    ) }) }),
    yelp: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d(
      "path",
      {
        d: "M12.5381 12.471L17.0611 13.937C17.0611 13.937 17.7081 14.056 17.7011 14.489C17.6971 14.794 17.5041 15.141 17.5041 15.141L15.5941 17.897C15.5941 17.897 15.2531 18.183 14.9081 18.183C14.5641 18.183 14.1671 17.646 14.1671 17.646L11.7501 13.573C11.7501 13.573 11.4781 12.979 11.8001 12.652C12.0951 12.352 12.5381 12.471 12.5381 12.471ZM11.5701 10.6C11.8011 10.996 12.4401 10.881 12.4401 10.881L16.9531 9.55C16.9531 9.55 17.5681 9.297 17.6561 8.961C17.7421 8.624 17.5541 8.218 17.5541 8.218L15.3971 5.654C15.3971 5.654 15.2101 5.33 14.8221 5.297C14.3941 5.26 14.1311 5.783 14.1311 5.783L11.5811 9.833C11.5821 9.832 11.3571 10.235 11.5701 10.6ZM9.43809 9.021C9.96909 8.889 10.0541 8.11 10.0541 8.11L10.0181 1.625C10.0181 1.625 9.93809 0.824999 9.58209 0.607999C9.02309 0.265999 8.85809 0.443999 8.69809 0.467999L4.95109 1.873C4.95109 1.873 4.58409 1.996 4.39309 2.305C4.12009 2.742 4.67009 3.384 4.67009 3.384L8.56409 8.742C8.56409 8.742 8.94909 9.143 9.43809 9.021ZM8.51309 11.645C8.52609 11.145 7.91809 10.844 7.91809 10.844L3.89009 8.791C3.89009 8.791 3.29309 8.543 3.00309 8.716C2.78209 8.848 2.58509 9.088 2.56609 9.299L2.30409 12.558C2.30409 12.558 2.26509 13.123 2.41009 13.38C2.61509 13.744 3.29109 13.491 3.29109 13.491L7.99309 12.442C8.17509 12.318 8.49509 12.306 8.51309 11.645ZM9.68209 13.404C9.27809 13.195 8.79509 13.628 8.79509 13.628L5.64709 17.126C5.64709 17.126 5.25409 17.661 5.35409 17.989C5.44809 18.297 5.60409 18.45 5.82409 18.558L8.98609 19.565C8.98609 19.565 9.36909 19.645 9.66009 19.56C10.0721 19.439 9.99609 18.788 9.99609 18.788L10.0671 14.052C10.0671 14.053 10.0511 13.597 9.68209 13.404Z",
        fill: "currentColor"
      }
    ) }),
    linkedin: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d(
      "path",
      {
        d: "M15.8333 2.5C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333ZM15.4167 15.4167V11C15.4167 10.2795 15.1304 9.5885 14.621 9.07903C14.1115 8.56955 13.4205 8.28333 12.7 8.28333C11.9917 8.28333 11.1667 8.71667 10.7667 9.36667V8.44167H8.44167V15.4167H10.7667V11.3083C10.7667 10.6667 11.2833 10.1417 11.925 10.1417C12.2344 10.1417 12.5312 10.2646 12.75 10.4834C12.9688 10.7022 13.0917 10.9989 13.0917 11.3083V15.4167H15.4167ZM5.73333 7.13333C6.10464 7.13333 6.46073 6.98583 6.72328 6.72328C6.98583 6.46073 7.13333 6.10464 7.13333 5.73333C7.13333 4.95833 6.50833 4.325 5.73333 4.325C5.35982 4.325 5.0016 4.47338 4.73749 4.73749C4.47338 5.0016 4.325 5.35982 4.325 5.73333C4.325 6.50833 4.95833 7.13333 5.73333 7.13333ZM6.89167 15.4167V8.44167H4.58333V15.4167H6.89167Z",
        fill: "currentColor"
      }
    ) }),
    tiktok: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d(
      "path",
      {
        d: "M16.3251 5.57508C15.4944 5.39241 14.7429 4.95128 14.1785 4.31499C13.6141 3.67871 13.2657 2.87997 13.1835 2.03341V1.66675H10.3085V13.0584C10.309 13.5639 10.1506 14.0567 9.85549 14.4671C9.56041 14.8775 9.14368 15.1847 8.66434 15.3451C8.185 15.5055 7.66733 15.511 7.18469 15.3608C6.70204 15.2107 6.27887 14.9124 5.97512 14.5084C5.70299 14.1508 5.53636 13.7241 5.49406 13.2767C5.45176 12.8293 5.53549 12.379 5.73577 11.9767C5.93605 11.5745 6.2449 11.2362 6.62738 11.0003C7.00987 10.7644 7.45073 10.6402 7.90012 10.6417C8.14865 10.6403 8.39595 10.6769 8.63345 10.7501V7.83341C8.35707 7.79919 8.07854 7.78526 7.80012 7.79175C6.77455 7.81915 5.77922 8.14503 4.93602 8.72947C4.09283 9.31392 3.43836 10.1316 3.05277 11.0823C2.66717 12.033 2.56719 13.0755 2.76505 14.0822C2.96292 15.0889 3.45005 16.016 4.16679 16.7501C4.90136 17.4969 5.84136 18.0085 6.86737 18.2199C7.89337 18.4313 8.95905 18.3329 9.929 17.9372C10.899 17.5416 11.7294 16.8665 12.3148 15.9978C12.9002 15.1291 13.2142 14.106 13.2168 13.0584V7.22508C14.3763 8.05337 15.7668 8.49645 17.1918 8.49175V5.65841C16.9119 5.65957 16.6326 5.63164 16.3585 5.57508H16.3251Z",
        fill: "currentColor"
      }
    ) }),
    youtube: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d("g", { clipPath: "url(#clip0_1280_436)", children: /* @__PURE__ */ d(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.0001 3.33325C10.7126 3.33325 11.4434 3.35159 12.1517 3.38159L12.9884 3.42159L13.7892 3.46909L14.5392 3.51992L15.2242 3.57325C15.9676 3.63015 16.6671 3.94737 17.1997 4.46912C17.7323 4.99086 18.0638 5.6837 18.1359 6.42575L18.1692 6.77992L18.2317 7.53825C18.2901 8.32408 18.3334 9.18075 18.3334 9.99992C18.3334 10.8191 18.2901 11.6758 18.2317 12.4616L18.1692 13.2199C18.1584 13.3416 18.1476 13.4591 18.1359 13.5741C18.0637 14.3163 17.7321 15.0092 17.1994 15.531C16.6666 16.0527 15.9669 16.3699 15.2234 16.4266L14.5401 16.4791L13.7901 16.5308L12.9884 16.5783L12.1517 16.6183C11.4349 16.6494 10.7176 16.6655 10.0001 16.6666C9.2826 16.6655 8.56522 16.6494 7.84841 16.6183L7.01175 16.5783L6.21091 16.5308L5.46091 16.4791L4.77591 16.4266C4.03254 16.3697 3.33304 16.0525 2.80048 15.5307C2.26791 15.009 1.93639 14.3161 1.86425 13.5741L1.83091 13.2199L1.76841 12.4616C1.7047 11.6425 1.67078 10.8214 1.66675 9.99992C1.66675 9.18075 1.71008 8.32408 1.76841 7.53825L1.83091 6.77992C1.84175 6.65825 1.85258 6.54075 1.86425 6.42575C1.93637 5.68383 2.26776 4.9911 2.80016 4.46937C3.33255 3.94764 4.03186 3.63034 4.77508 3.57325L5.45925 3.51992L6.20925 3.46909L7.01091 3.42159L7.84758 3.38159C8.56466 3.35045 9.28232 3.33433 10.0001 3.33325ZM8.33341 7.97908V12.0208C8.33341 12.4058 8.75008 12.6458 9.08341 12.4541L12.5834 10.4333C12.6596 10.3894 12.7228 10.3263 12.7668 10.2502C12.8108 10.1741 12.834 10.0878 12.834 9.99992C12.834 9.91204 12.8108 9.82572 12.7668 9.74964C12.7228 9.67356 12.6596 9.61043 12.5834 9.56658L9.08341 7.54659C9.00738 7.50269 8.92113 7.47958 8.83333 7.4796C8.74554 7.47961 8.65929 7.50274 8.58328 7.54667C8.50726 7.59059 8.44414 7.65375 8.40028 7.72981C8.35642 7.80586 8.33336 7.89212 8.33341 7.97992V7.97908Z",
        fill: "currentColor"
      }
    ) }) }),
    google: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d(
      "path",
      {
        d: "M2.55342 6.25842C3.24676 4.87778 4.31039 3.71717 5.62544 2.90631C6.94049 2.09544 8.45513 1.66626 10.0001 1.66675C12.2459 1.66675 14.1326 2.49258 15.5751 3.83758L13.1859 6.22758C12.3217 5.40175 11.2234 4.98092 10.0001 4.98092C7.82925 4.98092 5.99175 6.44758 5.33758 8.41675C5.17092 8.91675 5.07592 9.45008 5.07592 10.0001C5.07592 10.5501 5.17092 11.0834 5.33758 11.5834C5.99258 13.5534 7.82925 15.0192 10.0001 15.0192C11.1209 15.0192 12.0751 14.7234 12.8217 14.2234C13.2546 13.9384 13.6252 13.5686 13.9111 13.1363C14.197 12.7041 14.3922 12.2183 14.4851 11.7084H10.0001V8.48508H17.8484C17.9467 9.03008 18.0001 9.59842 18.0001 10.1892C18.0001 12.7276 17.0917 14.8642 15.5151 16.3142C14.1367 17.5876 12.2501 18.3334 10.0001 18.3334C8.90561 18.3339 7.82178 18.1186 6.81054 17.7C5.79929 17.2813 4.88046 16.6675 4.10655 15.8936C3.33264 15.1197 2.71883 14.2009 2.30019 13.1896C1.88156 12.1784 1.66631 11.0946 1.66675 10.0001C1.66675 8.65508 1.98842 7.38342 2.55342 6.25842Z",
        fill: "currentColor"
      }
    ) }),
    pinterest: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d(
      "path",
      {
        d: "M7.53341 17.9501C8.33341 18.1917 9.14175 18.3334 10.0001 18.3334C12.2102 18.3334 14.3298 17.4554 15.8926 15.8926C17.4554 14.3298 18.3334 12.2102 18.3334 10.0001C18.3334 8.90573 18.1179 7.8221 17.6991 6.81105C17.2803 5.80001 16.6665 4.88135 15.8926 4.10752C15.1188 3.3337 14.2002 2.71987 13.1891 2.30109C12.1781 1.8823 11.0944 1.66675 10.0001 1.66675C8.90573 1.66675 7.8221 1.8823 6.81105 2.30109C5.80001 2.71987 4.88135 3.3337 4.10752 4.10752C2.54472 5.67033 1.66675 7.78994 1.66675 10.0001C1.66675 13.5417 3.89175 16.5834 7.03341 17.7834C6.95841 17.1334 6.88341 16.0584 7.03341 15.3167L7.99175 11.2001C7.99175 11.2001 7.75008 10.7167 7.75008 9.95008C7.75008 8.80008 8.46675 7.94175 9.28341 7.94175C10.0001 7.94175 10.3334 8.46675 10.3334 9.14175C10.3334 9.85841 9.85841 10.8834 9.61675 11.8667C9.47508 12.6834 10.0501 13.4001 10.8834 13.4001C12.3667 13.4001 13.5167 11.8167 13.5167 9.58341C13.5167 7.58341 12.0834 6.21675 10.0251 6.21675C7.67508 6.21675 6.29175 7.96675 6.29175 9.80841C6.29175 10.5251 6.52508 11.2501 6.90841 11.7251C6.98341 11.7751 6.98342 11.8417 6.95842 11.9667L6.71675 12.8751C6.71675 13.0167 6.62508 13.0667 6.48341 12.9667C5.41675 12.5001 4.80008 10.9834 4.80008 9.75841C4.80008 7.12508 6.66675 4.73341 10.2667 4.73341C13.1334 4.73341 15.3667 6.79175 15.3667 9.52508C15.3667 12.3917 13.5917 14.6917 11.0501 14.6917C10.2417 14.6917 9.45008 14.2584 9.16675 13.7501L8.60841 15.7251C8.41675 16.4417 7.89175 17.4001 7.53341 17.9751V17.9501Z",
        fill: "currentColor"
      }
    ) }),
    tripadvisor: /* @__PURE__ */ I("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: [
      /* @__PURE__ */ d(
        "path",
        {
          d: "M6.92511 8.56665C6.51272 8.56665 6.1096 8.68905 5.76681 8.91834C5.42403 9.14763 5.15702 9.4735 4.99958 9.85466C4.84215 10.2358 4.80138 10.6551 4.88244 11.0595C4.96351 11.4639 5.16275 11.835 5.45495 12.1261C5.74714 12.4171 6.11913 12.6149 6.52381 12.6943C6.92848 12.7737 7.34763 12.7313 7.72816 12.5723C8.10869 12.4134 8.43349 12.145 8.6614 11.8014C8.88932 11.4577 9.0101 11.054 9.00845 10.6417C9.00624 10.0906 8.78578 9.5628 8.39531 9.1739C8.00485 8.785 7.47621 8.56665 6.92511 8.56665ZM6.92511 11.7333C6.7743 11.7465 6.62239 11.7282 6.47902 11.6796C6.33566 11.6309 6.20398 11.553 6.09236 11.4507C5.98074 11.3485 5.8916 11.2241 5.83063 11.0855C5.76965 10.9469 5.73816 10.7972 5.73816 10.6458C5.73816 10.4944 5.76965 10.3447 5.83063 10.2061C5.8916 10.0676 5.98074 9.94318 6.09236 9.84091C6.20398 9.73864 6.33566 9.6607 6.47902 9.61205C6.62239 9.5634 6.7743 9.5451 6.92511 9.55832C7.07593 9.5451 7.22784 9.5634 7.37121 9.61205C7.51457 9.6607 7.64624 9.73864 7.75787 9.84091C7.86949 9.94318 7.95863 10.0676 8.0196 10.2061C8.08058 10.3447 8.11207 10.4944 8.11207 10.6458C8.11207 10.7972 8.08058 10.9469 8.0196 11.0855C7.95863 11.2241 7.86949 11.3485 7.75787 11.4507C7.64624 11.553 7.51457 11.6309 7.37121 11.6796C7.22784 11.7282 7.07593 11.7465 6.92511 11.7333ZM13.0751 8.56665C12.6627 8.56665 12.2596 8.68905 11.9168 8.91834C11.574 9.14763 11.307 9.4735 11.1496 9.85466C10.9921 10.2358 10.9514 10.6551 11.0324 11.0595C11.1135 11.4639 11.3128 11.835 11.6049 12.1261C11.8971 12.4171 12.2691 12.6149 12.6738 12.6943C13.0785 12.7737 13.4976 12.7313 13.8782 12.5723C14.2587 12.4134 14.5835 12.145 14.8114 11.8014C15.0393 11.4577 15.1601 11.054 15.1584 10.6417C15.1562 10.0906 14.9358 9.5628 14.5453 9.1739C14.1549 8.785 13.6262 8.56665 13.0751 8.56665ZM14.1668 10.6417C14.1684 10.8579 14.1058 11.0698 13.9869 11.2504C13.8679 11.431 13.698 11.5722 13.4987 11.6561C13.2994 11.74 13.0796 11.7629 12.8673 11.7217C12.655 11.6805 12.4597 11.5772 12.3062 11.4249C12.1527 11.2725 12.0479 11.078 12.0051 10.866C11.9623 10.6541 11.9834 10.4341 12.0658 10.2342C12.1481 10.0342 12.2881 9.86322 12.4678 9.74289C12.6475 9.62256 12.8588 9.55832 13.0751 9.55832C13.3632 9.55831 13.6396 9.67218 13.8441 9.87511C14.0486 10.078 14.1646 10.3536 14.1668 10.6417Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M10.0001 1.66675C8.35191 1.66675 6.74074 2.15549 5.37033 3.07117C3.99992 3.98685 2.93182 5.28834 2.30109 6.81105C1.67036 8.33377 1.50533 10.0093 1.82687 11.6258C2.14842 13.2423 2.94209 14.7272 4.10753 15.8926C5.27297 17.0581 6.75782 17.8517 8.37433 18.1733C9.99084 18.4948 11.6664 18.3298 13.1891 17.6991C14.7118 17.0683 16.0133 16.0002 16.929 14.6298C17.8447 13.2594 18.3334 11.6483 18.3334 10.0001C18.3334 8.90573 18.1179 7.8221 17.6991 6.81105C17.2803 5.80001 16.6665 4.88135 15.8926 4.10752C15.1188 3.3337 14.2002 2.71987 13.1891 2.30109C12.1781 1.8823 11.0944 1.66675 10.0001 1.66675ZM16.1501 10.6417C16.1509 11.2405 15.9769 11.8265 15.6495 12.3278C15.322 12.8291 14.8553 13.2239 14.3067 13.4637C13.758 13.7035 13.1513 13.7779 12.5609 13.6778C11.9706 13.5777 11.4223 13.3074 10.9834 12.9001L10.0001 13.9751L9.01675 12.9001C8.71909 13.1737 8.37045 13.3859 7.99075 13.5248C7.61105 13.6636 7.20772 13.7264 6.80378 13.7093C6.39985 13.6923 6.00322 13.5959 5.63655 13.4256C5.26988 13.2553 4.94034 13.0144 4.66675 12.7167C4.39316 12.4191 4.18089 12.0705 4.04203 11.6907C3.90318 11.311 3.84048 10.9077 3.8575 10.5038C3.87453 10.0998 3.97095 9.70322 4.14125 9.33655C4.31156 8.96987 4.55242 8.64034 4.85009 8.36675L3.85009 7.28341H6.08342C7.23819 6.49302 8.60489 6.07008 10.0043 6.07008C11.4036 6.07008 12.7703 6.49302 13.9251 7.28341H16.1501L15.1501 8.37508C15.4641 8.66353 15.715 9.01379 15.8871 9.40387C16.0591 9.79395 16.1487 10.2154 16.1501 10.6417Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M12.3083 7.5416C11.577 7.2363 10.7924 7.0791 9.99998 7.0791C9.20753 7.0791 8.42294 7.2363 7.69165 7.5416C8.33793 7.75724 8.90405 8.16296 9.31592 8.70568C9.72778 9.24839 9.96621 9.90281 9.99998 10.5833C10.036 9.90344 10.2753 9.25009 10.6868 8.70779C11.0984 8.1655 11.6633 7.75923 12.3083 7.5416Z",
          fill: "currentColor"
        }
      )
    ] }),
    foursquare: /* @__PURE__ */ d("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ d(
      "path",
      {
        d: "M14.7172 1.25H5.41172C4.12773 1.25 3.75 2.21875 3.75 2.82852V17.6582C3.75 18.3453 4.11797 18.6004 4.325 18.6844C4.53203 18.7684 5.10273 18.8406 5.44492 18.4434C5.44492 18.4434 9.83828 13.3305 9.91367 13.2547C10.0277 13.1402 10.0277 13.1402 10.1418 13.1402H12.9844C14.1789 13.1402 14.3707 12.2859 14.4957 11.7828C14.5992 11.3613 15.7645 5.37656 16.1539 3.47969C16.4508 2.03125 16.0836 1.25 14.7172 1.25ZM14.4957 11.7828C14.5992 11.3613 15.7645 5.37656 16.1539 3.47969L14.4957 11.7828ZM14.1676 3.77617L13.777 5.79688C13.7305 6.01758 13.4535 6.25 13.1965 6.25H9.44961C9.0418 6.25 8.75 6.48984 8.75 6.89844V7.42383C8.75 7.83281 9.04375 8.12266 9.45312 8.12266H12.6504C12.9387 8.12266 13.2211 8.43945 13.1582 8.74766C13.0953 9.05586 12.8031 10.5668 12.7676 10.7355C12.732 10.9043 12.5395 11.1934 12.1969 11.1934H9.6875C9.23047 11.1934 9.09219 11.2535 8.78633 11.6348C8.48047 12.016 5.7293 15.3297 5.7293 15.3297C5.70156 15.3617 5.67422 15.3523 5.67422 15.3176V3.74609C5.67422 3.48477 5.90078 3.17852 6.23984 3.17852H13.7063C13.7786 3.18009 13.8497 3.19785 13.9144 3.23048C13.979 3.26312 14.0355 3.3098 14.0797 3.36711C14.124 3.42442 14.1548 3.4909 14.17 3.56168C14.1852 3.63247 14.1844 3.70575 14.1676 3.77617Z",
        fill: "currentColor"
      }
    ) }),
    default: /* @__PURE__ */ d(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: "1.5",
        stroke: "currentColor",
        className: e,
        children: /* @__PURE__ */ d(
          "path",
          {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
          }
        )
      }
    )
  }[r];
};
var Bt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, is = { exports: {} };
(function(t, e) {
  var r = 200, n = "__lodash_hash_undefined__", i = 9007199254740991, s = "[object Arguments]", o = "[object Array]", l = "[object Boolean]", c = "[object Date]", u = "[object Error]", f = "[object Function]", C = "[object GeneratorFunction]", v = "[object Map]", w = "[object Number]", g = "[object Object]", b = "[object Promise]", _ = "[object RegExp]", h = "[object Set]", y = "[object String]", E = "[object Symbol]", T = "[object WeakMap]", $ = "[object ArrayBuffer]", L = "[object DataView]", z = "[object Float32Array]", P = "[object Float64Array]", B = "[object Int8Array]", q = "[object Int16Array]", N = "[object Int32Array]", R = "[object Uint8Array]", D = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", se = "[object Uint32Array]", Y = /[\\^$.*+?()[\]{}|]/g, ie = /\w*$/, F = /^\[object .+?Constructor\]$/, O = /^(?:0|[1-9]\d*)$/, k = {};
  k[s] = k[o] = k[$] = k[L] = k[l] = k[c] = k[z] = k[P] = k[B] = k[q] = k[N] = k[v] = k[w] = k[g] = k[_] = k[h] = k[y] = k[E] = k[R] = k[D] = k[Q] = k[se] = !0, k[u] = k[f] = k[T] = !1;
  var U = typeof Bt == "object" && Bt && Bt.Object === Object && Bt, V = typeof self == "object" && self && self.Object === Object && self, H = U || V || Function("return this")(), le = e && !e.nodeType && e, me = le && !0 && t && !t.nodeType && t, we = me && me.exports === le;
  function Pe(a, m) {
    return a.set(m[0], m[1]), a;
  }
  function it(a, m) {
    return a.add(m), a;
  }
  function ke(a, m) {
    for (var x = -1, A = a ? a.length : 0; ++x < A && m(a[x], x, a) !== !1; )
      ;
    return a;
  }
  function Ae(a, m) {
    for (var x = -1, A = m.length, ne = a.length; ++x < A; )
      a[ne + x] = m[x];
    return a;
  }
  function Yt(a, m, x, A) {
    var ne = -1, ce = a ? a.length : 0;
    for (A && ce && (x = a[++ne]); ++ne < ce; )
      x = m(x, a[ne], ne, a);
    return x;
  }
  function Jt(a, m) {
    for (var x = -1, A = Array(a); ++x < a; )
      A[x] = m(x);
    return A;
  }
  function Cr(a, m) {
    return a == null ? void 0 : a[m];
  }
  function yt(a) {
    var m = !1;
    if (a != null && typeof a.toString != "function")
      try {
        m = !!(a + "");
      } catch {
      }
    return m;
  }
  function xt(a) {
    var m = -1, x = Array(a.size);
    return a.forEach(function(A, ne) {
      x[++m] = [ne, A];
    }), x;
  }
  function wt(a, m) {
    return function(x) {
      return a(m(x));
    };
  }
  function ft(a) {
    var m = -1, x = Array(a.size);
    return a.forEach(function(A) {
      x[++m] = A;
    }), x;
  }
  var gr = Array.prototype, vr = Function.prototype, Ye = Object.prototype, st = H["__core-js_shared__"], Ft = function() {
    var a = /[^.]+$/.exec(st && st.keys && st.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }(), Rt = vr.toString, Ee = Ye.hasOwnProperty, ot = Ye.toString, $r = RegExp(
    "^" + Rt.call(Ee).replace(Y, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), bt = we ? H.Buffer : void 0, Zt = H.Symbol, Kt = H.Uint8Array, jr = wt(Object.getPrototypeOf, Object), pt = Object.create, yr = Ye.propertyIsEnumerable, Fr = gr.splice, Xt = Object.getOwnPropertySymbols, xr = bt ? bt.isBuffer : void 0, Rr = wt(Object.keys, Object), ht = Z(H, "DataView"), ze = Z(H, "Map"), Je = Z(H, "Promise"), mt = Z(H, "Set"), Ct = Z(H, "WeakMap"), Ne = Z(Object, "create"), er = Fe(ht), tr = Fe(ze), Ir = Fe(Je), Dr = Fe(mt), Vr = Fe(Ct), _t = Zt ? Zt.prototype : void 0, rr = _t ? _t.valueOf : void 0;
  function Me(a) {
    var m = -1, x = a ? a.length : 0;
    for (this.clear(); ++m < x; ) {
      var A = a[m];
      this.set(A[0], A[1]);
    }
  }
  function zr() {
    this.__data__ = Ne ? Ne(null) : {};
  }
  function Br(a) {
    return this.has(a) && delete this.__data__[a];
  }
  function Wr(a) {
    var m = this.__data__;
    if (Ne) {
      var x = m[a];
      return x === n ? void 0 : x;
    }
    return Ee.call(m, a) ? m[a] : void 0;
  }
  function Hr(a) {
    var m = this.__data__;
    return Ne ? m[a] !== void 0 : Ee.call(m, a);
  }
  function Gr(a, m) {
    var x = this.__data__;
    return x[a] = Ne && m === void 0 ? n : m, this;
  }
  Me.prototype.clear = zr, Me.prototype.delete = Br, Me.prototype.get = Wr, Me.prototype.has = Hr, Me.prototype.set = Gr;
  function be(a) {
    var m = -1, x = a ? a.length : 0;
    for (this.clear(); ++m < x; ) {
      var A = a[m];
      this.set(A[0], A[1]);
    }
  }
  function qr() {
    this.__data__ = [];
  }
  function Ie(a) {
    var m = this.__data__, x = Ze(m, a);
    if (x < 0)
      return !1;
    var A = m.length - 1;
    return x == A ? m.pop() : Fr.call(m, x, 1), !0;
  }
  function Ur(a) {
    var m = this.__data__, x = Ze(m, a);
    return x < 0 ? void 0 : m[x][1];
  }
  function Qr(a) {
    return Ze(this.__data__, a) > -1;
  }
  function Yr(a, m) {
    var x = this.__data__, A = Ze(x, a);
    return A < 0 ? x.push([a, m]) : x[A][1] = m, this;
  }
  be.prototype.clear = qr, be.prototype.delete = Ie, be.prototype.get = Ur, be.prototype.has = Qr, be.prototype.set = Yr;
  function $e(a) {
    var m = -1, x = a ? a.length : 0;
    for (this.clear(); ++m < x; ) {
      var A = a[m];
      this.set(A[0], A[1]);
    }
  }
  function Jr() {
    this.__data__ = {
      hash: new Me(),
      map: new (ze || be)(),
      string: new Me()
    };
  }
  function Zr(a) {
    return J(this, a).delete(a);
  }
  function Kr(a) {
    return J(this, a).get(a);
  }
  function Xr(a) {
    return J(this, a).has(a);
  }
  function en(a, m) {
    return J(this, a).set(a, m), this;
  }
  $e.prototype.clear = Jr, $e.prototype.delete = Zr, $e.prototype.get = Kr, $e.prototype.has = Xr, $e.prototype.set = en;
  function je(a) {
    this.__data__ = new be(a);
  }
  function nr() {
    this.__data__ = new be();
  }
  function wr(a) {
    return this.__data__.delete(a);
  }
  function tn(a) {
    return this.__data__.get(a);
  }
  function rn(a) {
    return this.__data__.has(a);
  }
  function br(a, m) {
    var x = this.__data__;
    if (x instanceof be) {
      var A = x.__data__;
      if (!ze || A.length < r - 1)
        return A.push([a, m]), this;
      x = this.__data__ = new $e(A);
    }
    return x.set(a, m), this;
  }
  je.prototype.clear = nr, je.prototype.delete = wr, je.prototype.get = tn, je.prototype.has = rn, je.prototype.set = br;
  function nn(a, m) {
    var x = ir(a) || Oi(a) ? Jt(a.length, String) : [], A = x.length, ne = !!A;
    for (var ce in a)
      (m || Ee.call(a, ce)) && !(ne && (ce == "length" || De(ce, A))) && x.push(ce);
    return x;
  }
  function It(a, m, x) {
    var A = a[m];
    (!(Ee.call(a, m) && pn(A, x)) || x === void 0 && !(m in a)) && (a[m] = x);
  }
  function Ze(a, m) {
    for (var x = a.length; x--; )
      if (pn(a[x][0], m))
        return x;
    return -1;
  }
  function _r(a, m) {
    return a && j(m, sr(m), a);
  }
  function St(a, m, x, A, ne, ce, he) {
    var de;
    if (A && (de = ce ? A(a, ne, ce, he) : A(a)), de !== void 0)
      return de;
    if (!Tt(a))
      return a;
    var Cn = ir(a);
    if (Cn) {
      if (de = Le(a), !m)
        return M(a, de);
    } else {
      var Be = ue(a), gn = Be == f || Be == C;
      if (Pi(a))
        return an(a, m);
      if (Be == g || Be == s || gn && !ce) {
        if (yt(a))
          return ce ? a : {};
        if (de = Oe(gn ? {} : a), !m)
          return G(a, _r(de, a));
      } else {
        if (!k[Be])
          return ce ? a : {};
        de = at(a, Be, St, m);
      }
    }
    he || (he = new je());
    var vn = he.get(a);
    if (vn)
      return vn;
    if (he.set(a, de), !Cn)
      var yn = x ? re(a) : sr(a);
    return ke(yn || a, function(or, kt) {
      yn && (kt = or, or = a[kt]), It(de, kt, St(or, m, x, A, kt, a, he));
    }), de;
  }
  function Sr(a) {
    return Tt(a) ? pt(a) : {};
  }
  function Er(a, m, x) {
    var A = m(a);
    return ir(a) ? A : Ae(A, x(a));
  }
  function sn(a) {
    return ot.call(a);
  }
  function on(a) {
    if (!Tt(a) || kr(a))
      return !1;
    var m = mn(a) || yt(a) ? $r : F;
    return m.test(Fe(a));
  }
  function Tr(a) {
    if (!Dt(a))
      return Rr(a);
    var m = [];
    for (var x in Object(a))
      Ee.call(a, x) && x != "constructor" && m.push(x);
    return m;
  }
  function an(a, m) {
    if (m)
      return a.slice();
    var x = new a.constructor(a.length);
    return a.copy(x), x;
  }
  function Et(a) {
    var m = new a.constructor(a.byteLength);
    return new Kt(m).set(new Kt(a)), m;
  }
  function ln(a, m) {
    var x = m ? Et(a.buffer) : a.buffer;
    return new a.constructor(x, a.byteOffset, a.byteLength);
  }
  function cn(a, m, x) {
    var A = m ? x(xt(a), !0) : xt(a);
    return Yt(A, Pe, new a.constructor());
  }
  function un(a) {
    var m = new a.constructor(a.source, ie.exec(a));
    return m.lastIndex = a.lastIndex, m;
  }
  function dn(a, m, x) {
    var A = m ? x(ft(a), !0) : ft(a);
    return Yt(A, it, new a.constructor());
  }
  function p(a) {
    return rr ? Object(rr.call(a)) : {};
  }
  function S(a, m) {
    var x = m ? Et(a.buffer) : a.buffer;
    return new a.constructor(x, a.byteOffset, a.length);
  }
  function M(a, m) {
    var x = -1, A = a.length;
    for (m || (m = Array(A)); ++x < A; )
      m[x] = a[x];
    return m;
  }
  function j(a, m, x, A) {
    x || (x = {});
    for (var ne = -1, ce = m.length; ++ne < ce; ) {
      var he = m[ne], de = A ? A(x[he], a[he], he, x, a) : void 0;
      It(x, he, de === void 0 ? a[he] : de);
    }
    return x;
  }
  function G(a, m) {
    return j(a, Ce(a), m);
  }
  function re(a) {
    return Er(a, sr, Ce);
  }
  function J(a, m) {
    var x = a.__data__;
    return fn(m) ? x[typeof m == "string" ? "string" : "hash"] : x.map;
  }
  function Z(a, m) {
    var x = Cr(a, m);
    return on(x) ? x : void 0;
  }
  var Ce = Xt ? wt(Xt, Object) : $i, ue = sn;
  (ht && ue(new ht(new ArrayBuffer(1))) != L || ze && ue(new ze()) != v || Je && ue(Je.resolve()) != b || mt && ue(new mt()) != h || Ct && ue(new Ct()) != T) && (ue = function(a) {
    var m = ot.call(a), x = m == g ? a.constructor : void 0, A = x ? Fe(x) : void 0;
    if (A)
      switch (A) {
        case er:
          return L;
        case tr:
          return v;
        case Ir:
          return b;
        case Dr:
          return h;
        case Vr:
          return T;
      }
    return m;
  });
  function Le(a) {
    var m = a.length, x = a.constructor(m);
    return m && typeof a[0] == "string" && Ee.call(a, "index") && (x.index = a.index, x.input = a.input), x;
  }
  function Oe(a) {
    return typeof a.constructor == "function" && !Dt(a) ? Sr(jr(a)) : {};
  }
  function at(a, m, x, A) {
    var ne = a.constructor;
    switch (m) {
      case $:
        return Et(a);
      case l:
      case c:
        return new ne(+a);
      case L:
        return ln(a, A);
      case z:
      case P:
      case B:
      case q:
      case N:
      case R:
      case D:
      case Q:
      case se:
        return S(a, A);
      case v:
        return cn(a, A, x);
      case w:
      case y:
        return new ne(a);
      case _:
        return un(a);
      case h:
        return dn(a, A, x);
      case E:
        return p(a);
    }
  }
  function De(a, m) {
    return m = m ?? i, !!m && (typeof a == "number" || O.test(a)) && a > -1 && a % 1 == 0 && a < m;
  }
  function fn(a) {
    var m = typeof a;
    return m == "string" || m == "number" || m == "symbol" || m == "boolean" ? a !== "__proto__" : a === null;
  }
  function kr(a) {
    return !!Ft && Ft in a;
  }
  function Dt(a) {
    var m = a && a.constructor, x = typeof m == "function" && m.prototype || Ye;
    return a === x;
  }
  function Fe(a) {
    if (a != null) {
      try {
        return Rt.call(a);
      } catch {
      }
      try {
        return a + "";
      } catch {
      }
    }
    return "";
  }
  function Mi(a) {
    return St(a, !0, !0);
  }
  function pn(a, m) {
    return a === m || a !== a && m !== m;
  }
  function Oi(a) {
    return Li(a) && Ee.call(a, "callee") && (!yr.call(a, "callee") || ot.call(a) == s);
  }
  var ir = Array.isArray;
  function hn(a) {
    return a != null && Ai(a.length) && !mn(a);
  }
  function Li(a) {
    return Ni(a) && hn(a);
  }
  var Pi = xr || ji;
  function mn(a) {
    var m = Tt(a) ? ot.call(a) : "";
    return m == f || m == C;
  }
  function Ai(a) {
    return typeof a == "number" && a > -1 && a % 1 == 0 && a <= i;
  }
  function Tt(a) {
    var m = typeof a;
    return !!a && (m == "object" || m == "function");
  }
  function Ni(a) {
    return !!a && typeof a == "object";
  }
  function sr(a) {
    return hn(a) ? nn(a) : Tr(a);
  }
  function $i() {
    return [];
  }
  function ji() {
    return !1;
  }
  t.exports = Mi;
})(is, is.exports);
var ss = is.exports, os = function() {
  return os = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, os.apply(this, arguments);
};
function B6(t, e, r, n) {
  function i(s) {
    return s instanceof r ? s : new r(function(o) {
      o(s);
    });
  }
  return new (r || (r = Promise))(function(s, o) {
    function l(f) {
      try {
        u(n.next(f));
      } catch (C) {
        o(C);
      }
    }
    function c(f) {
      try {
        u(n.throw(f));
      } catch (C) {
        o(C);
      }
    }
    function u(f) {
      f.done ? s(f.value) : i(f.value).then(l, c);
    }
    u((n = n.apply(t, e || [])).next());
  });
}
function W6(t, e) {
  var r = { label: 0, sent: function() {
    if (s[0] & 1)
      throw s[1];
    return s[1];
  }, trys: [], ops: [] }, n, i, s, o;
  return o = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function l(u) {
    return function(f) {
      return c([u, f]);
    };
  }
  function c(u) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (r = 0)), r; )
      try {
        if (n = 1, i && (s = u[0] & 2 ? i.return : u[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, u[1])).done)
          return s;
        switch (i = 0, s && (u = [u[0] & 2, s.value]), u[0]) {
          case 0:
          case 1:
            s = u;
            break;
          case 4:
            return r.label++, { value: u[1], done: !1 };
          case 5:
            r.label++, i = u[1], u = [0];
            continue;
          case 7:
            u = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (s = r.trys, !(s = s.length > 0 && s[s.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              r = 0;
              continue;
            }
            if (u[0] === 3 && (!s || u[1] > s[0] && u[1] < s[3])) {
              r.label = u[1];
              break;
            }
            if (u[0] === 6 && r.label < s[1]) {
              r.label = s[1], s = u;
              break;
            }
            if (s && r.label < s[2]) {
              r.label = s[2], r.ops.push(u);
              break;
            }
            s[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        u = e.call(t, r);
      } catch (f) {
        u = [6, f], i = 0;
      } finally {
        n = s = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function b1(t, e, r, n, i) {
  return B6(this, void 0, void 0, function() {
    var s, o;
    return W6(this, function(l) {
      switch (l.label) {
        case 0:
          if (r === void 0)
            return [
              2
              /*return*/
            ];
          o = 0, l.label = 1;
        case 1:
          return o < r.length ? [4, r[o](t, e, n, i, r)] : [3, 4];
        case 2:
          if (s = l.sent(), s === "canceled")
            return [3, 4];
          l.label = 3;
        case 3:
          return o++, [3, 1];
        case 4:
          return s !== "canceled" ? [2, s] : [
            2
            /*return*/
          ];
      }
    });
  });
}
var _1 = function(t, e) {
  return e === void 0 && (e = {}), t ? {
    trackedAnalytics: os({ sdkCode: t.sdkCode, sdkSemver: t.sdkSemver, techVersion: t.techVersion }, e)
  } : null;
}, H6 = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      var s = this;
      this.isMounted = !0, this.imgElement = e, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var o = ss(r);
      b1(e, o, n, this.htmlPluginState, i).then(function(l) {
        if (s.isMounted) {
          s.htmlPluginState.pluginEventSubscription.forEach(function(u) {
            u();
          });
          var c = _1(i, l);
          s.imgElement.setAttribute("src", o.toURL(c));
        }
      });
    }
    return t.prototype.update = function(e, r, n) {
      var i = this, s = ss(e);
      b1(this.imgElement, s, r, this.htmlPluginState).then(function(o) {
        if (i.isMounted) {
          var l = _1(n, o);
          i.imgElement.setAttribute("src", s.toURL(l));
        }
      });
    }, t.prototype.unmount = function() {
      this.isMounted = !1;
    }, t;
  }()
);
let xe = class {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(e) {
    this.values = [], this.delimiter = ":", this.hasValue(e) && this.addValue(e);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(e) {
    return typeof e < "u" && e !== null && e !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(e) {
    return Array.isArray(e) ? this.values = this.values.concat(e) : this.values.push(e), this.values = this.values.filter((r) => this.hasValue(r)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(e) {
    return this.delimiter = e, this;
  }
}, G6 = class extends Error {
  constructor(t = "Unsupported") {
    super(t);
  }
};
function Ps(t) {
  return new G6(t);
}
function q6() {
  return this._qualifierModel || { error: Ps(`unsupported qualifier ${this.constructor.name}`) };
}
let U6 = class {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return q6.apply(this);
  }
}, te = class extends U6 {
  constructor(e, r) {
    super(), this.delimiter = "_", this.key = e, r instanceof xe ? this.qualifierValue = r : (this.qualifierValue = new xe(), this.qualifierValue.addValue(r));
  }
  toString() {
    const { key: e, delimiter: r, qualifierValue: n } = this;
    return `${e}${r}${n.toString()}`;
  }
  addValue(e) {
    return this.qualifierValue.addValue(e), this;
  }
}, et = class extends te {
  constructor(e, r) {
    let n;
    r ? n = new xe([e, `${r}`]).setDelimiter(":") : n = e, super("fl", n), this.flagValue = r;
  }
  toString() {
    return super.toString().replace(/\./, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
};
function Q6(t, e) {
  const r = Array.from(t.entries());
  return e.forEach((n) => {
    r.push(["fl", n]);
  }), r.sort().map((n) => n[1]);
}
function Y6() {
  var t, e, r;
  const n = this._actionModel && Object.keys(this._actionModel).length, i = (r = (e = (t = this._actionModel) === null || t === void 0 ? void 0 : t.source) === null || e === void 0 ? void 0 : e.transformation) === null || r === void 0 ? void 0 : r.error;
  return i && i instanceof Error ? { error: i } : n ? this._actionModel : { error: Ps(`unsupported action ${this.constructor.name}`) };
}
let J6 = class {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return Y6.apply(this);
  }
}, vt = class extends J6 {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(t) {
    return this.actionTag = t, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), Q6(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(t) {
    if (typeof t == "string") {
      const [e, r] = t.toLowerCase().split("_");
      e === "fl" ? this.flags.push(new et(r)) : this.qualifiers.set(e, new te(e, r));
    } else
      this.qualifiers.set(t.key, t);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(t) {
    return typeof t == "string" ? this.flags.push(new et(t)) : t instanceof et && this.flags.push(t), this;
  }
  addValueToQualifier(t, e) {
    return this.qualifiers.get(t).addValue(e), this;
  }
};
class As extends vt {
  constructor(e) {
    super(), this.regionType = e, this._actionModel.regionType = e;
  }
}
class fi extends As {
  constructor() {
    super("custom");
  }
  /**
   * @description The x position in pixels.
   * @param {number | string} x
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new te("x", e)), this;
  }
  /**
   * @description The y position in pixels.
   * @param {number | string} y
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new te("y", e)), this;
  }
  /**
   * @description The width of the region in pixels.
   * @param {number | string} width
   */
  width(e) {
    return this._actionModel.width = e, this.addQualifier(new te("w", e)), this;
  }
  /**
   * @description The height of the region in pixels.
   * @param {number | string} height
   */
  height(e) {
    return this._actionModel.height = e, this.addQualifier(new te("h", e)), this;
  }
  static fromJson(e) {
    const r = new fi();
    return e.width && r.width(e.width), e.height && r.height(e.height), e.x && r.x(e.x), e.y && r.y(e.y), r;
  }
}
function Z6() {
  return new fi();
}
function ra() {
  return new As("faces");
}
function K6() {
  return new As("ocr_text");
}
class X6 extends vt {
  constructor(e) {
    super(), this._actionModel = {}, this._strength = e, this._actionModel.actionType = "blur", this._actionModel.strength = e;
  }
  /**
   * @description Specifies the region to blur.
   * @param {NamedRegion} blurRegion
   */
  region(e) {
    return this._region = e, this._actionModel.region = e.toJson(), this;
  }
  /**
   * @description Sets the strength of the blur effect.
   * @param {number | string} strength
   */
  strength(e) {
    return this._strength = e, this._actionModel.strength = e, this;
  }
  prepareQualifiers() {
    const e = this._strength ? `:${this._strength}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((r) => this.addQualifier(r)), this._region.regionType === "custom" && this.addQualifier(new te("e", `blur_region${e}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new te("e", `blur_region${e}`)), this.addQualifier(new te("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new te("e", `blur_faces${e}`))) : this.addQualifier(new te("e", `blur${e}`));
  }
  static fromJson(e) {
    const { strength: r, region: n } = e, i = new this(r);
    return r && i.strength(r), n && n.regionType === "faces" && i.region(ra()), n && n.regionType === "ocr_text" && i.region(K6()), n && n.regionType === "custom" && i.region(fi.fromJson(n)), i;
  }
}
function pr(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    e[t[r]] = r;
  }), e;
}
const na = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad"
}, e5 = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, ia = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, sa = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, t5 = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, oa = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, r5 = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
}, n5 = pr(oa);
pr(r5);
const i5 = pr(na), s5 = pr(e5), aa = pr(ia);
pr(sa);
pr(t5);
class la extends vt {
  constructor(e, r) {
    super(), this._actionModel = {}, this._actionModel.actionType = aa[e] || e;
    const n = this.createEffectQualifier(e, r);
    this.addQualifier(n);
  }
  createEffectQualifier(e, r) {
    let n;
    return r ? n = new xe([e, `${r}`]).setDelimiter(":") : n = new xe(e), new te("e", n);
  }
  static fromJson(e) {
    const { actionType: r, level: n, strength: i } = e, s = ia[r] || r;
    return new this(s, n || i);
  }
}
class o5 extends la {
  constructor(e, r) {
    super(e, r), this.LEVEL_NAME = "level", this._actionModel = {}, this.effectType = e, this._actionModel.actionType = aa[e] || e, r && this.setLevel(r);
  }
  /**
   *
   * @description Sets the effect level for the action
   * @param {string | number} level - The strength of the effect
   * @protected
   */
  setLevel(e) {
    this._actionModel[this.LEVEL_NAME] = e;
    const r = this.createEffectQualifier(this.effectType, e);
    return this.addQualifier(r), this;
  }
}
function pi(t) {
  return t && (t.match(/^#/) ? `rgb:${t.substr(1)}` : t);
}
class a5 extends vt {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "vectorize";
  }
  /**
   * @description The number of colors. (Range: 2 to 30, Server default: 10)
   * @param {number | string} num
   * @return {this}
   */
  numOfColors(e) {
    return this._actionModel.numOfColors = e, this._numOfColors = e, this;
  }
  /**
   * @description The level of detail. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 1000). (Server default: 300)
   * @param {number | string} num
   * @return {this}
   */
  detailsLevel(e) {
    return this._actionModel.detailLevel = e, this._detailsLevel = e, this;
  }
  /**
   * @description The size of speckles to suppress. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 100, Server default: 2)
   * @param {number | string} num
   * @return {this}
   */
  despeckleLevel(e) {
    return this._actionModel.despeckleLevel = e, this._despeckleLevel = e, this;
  }
  /**
   * @description The corner threshold. Specify 100 for no smoothing (polygon corners), 0 for completely smooth corners. (Range: 0 to 100, Default: 25)
   * @param {number | string} num
   * @return {this}
   */
  cornersLevel(e) {
    return this._actionModel.cornersLevel = e, this._cornersLevel = e, this;
  }
  /**
   * @description The optimization value. Specify 100 for least optimization and the largest file. (Range: 0 to 100, Server default: 100).
   * @param {number} num
   * @return {this}
   */
  paths(e) {
    return this._actionModel.paths = e, this._paths = e, this;
  }
  prepareQualifiers() {
    let e = "vectorize";
    this._numOfColors && (e += `:${new xe(`colors:${this._numOfColors}`).toString()}`), this._detailsLevel && (e += `:${new xe(`detail:${this._detailsLevel}`).toString()}`), this._despeckleLevel && (e += `:${new xe(`despeckle:${this._despeckleLevel}`).toString()}`), this._paths && (e += `:${new xe(`paths:${this._paths}`).toString()}`), this._cornersLevel && (e += `:${new xe(`corners:${this._cornersLevel}`).toString()}`), this.addQualifier(new te("e", e));
  }
  static fromJson(e) {
    const { actionType: r, paths: n, cornersLevel: i, despeckleLevel: s, detailLevel: o, numOfColors: l } = e, c = new this();
    return n && c.paths(n), i && c.cornersLevel(i), s && c.despeckleLevel(s), o && c.detailsLevel(o), l && c.numOfColors(l), c;
  }
}
class l5 extends o5 {
  level(e) {
    return this._actionModel.level = e, this.setLevel(e);
  }
}
class c5 extends vt {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "assistColorblind", this.addQualifier(new te("e", new xe("assist_colorblind")));
  }
  /**
   * @description Replaces problematic colors with colors that are easier to differentiate.
   * @return {this}
   */
  xray() {
    return this._actionModel.type = "xray", this.addQualifier(new te("e", new xe(["assist_colorblind", "xray"]).setDelimiter(":")));
  }
  /**
   * @description Applies stripes of the specified intensity to help people with common color blind conditions to differentiate between colors that are similar for them.
   * @param {number | string} strength The intensity of the stripes. (Range: 1 to 100, Server default: 10)
   * @return {this}
   */
  stripesStrength(e) {
    return this._actionModel.type = "stripes", this._actionModel.stripesStrength = e, this.addQualifier(new te("e", new xe(["assist_colorblind", e]).setDelimiter(":")));
  }
  static fromJson(e) {
    const { actionType: r, type: n, stripesStrength: i } = e, s = new this();
    return n === "xray" && s.xray(), n === "stripes" && i && s.stripesStrength(i), s;
  }
}
class u5 extends l5 {
  /**
   * @description The color to use for colorization. Specify HTML name or RGB hex code. (Server default: gray)
   * @param {string} color HTML name(red, green, etc.) or RGB hex code. (Server default: gray)
   * @return {this}
   */
  color(e) {
    return this._actionModel.color = e, this.addQualifier(new te("co", new xe(pi(e))));
  }
  static fromJson(e) {
    const { actionType: r, level: n, color: i } = e, s = new this(r, n);
    return i && s.color(i), s;
  }
}
class d5 extends vt {
  constructor(e) {
    super(), this._actionModel = {}, this._squareSize = e, this._actionModel.actionType = "pixelate", this._actionModel.squareSize = e;
  }
  /**
   * @description Specifies the region to piexlate.
   * @param {NamedRegion} pixelateRegion
   */
  region(e) {
    return this._region = e, this._actionModel.region = { regionType: this._region.regionType }, this;
  }
  /**
   * @description Sets the squareSize of the pixelate effect.
   * @param {number | string} squareSize
   */
  squareSize(e) {
    return this._squareSize = e, this._actionModel.squareSize = e, this;
  }
  prepareQualifiers() {
    const e = this._squareSize ? `:${this._squareSize}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((r) => this.addQualifier(r)), this._region.regionType === "custom" && this.addQualifier(new te("e", `pixelate_region${e}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new te("e", `pixelate_region${e}`)), this.addQualifier(new te("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new te("e", `pixelate_faces${e}`))) : this.addQualifier(new te("e", `pixelate${e}`));
  }
  static fromJson(e) {
    const { region: r, squareSize: n } = e, i = new this(n);
    return n && i.squareSize(n), r && r.regionType === "faces" && i.region(ra()), r && r.regionType === "custom" && i.region(Z6()), i;
  }
}
function f5(t) {
  return new X6(t);
}
function p5() {
  return new la("grayscale");
}
function S1(t) {
  return new u5("colorize", t);
}
function h5() {
  return new a5();
}
function m5() {
  return new c5();
}
function C5(t) {
  return new d5(t);
}
let g5 = class extends vt {
  constructor(t) {
    super(), this._actionModel = {}, this.addQualifier(new te("b", new xe(pi(t)).setDelimiter("_"))), this._actionModel.color = t, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(t) {
    const { color: e } = t;
    return new this(e);
  }
}, E1 = class {
  constructor(t) {
    this.raw = t;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: Ps(`unsupported action ${this.constructor.name}`) };
  }
};
function v5(t) {
  const e = t;
  return "error" in e && !!e.error;
}
function y5() {
  return new et("ignore_aspect_ratio");
}
function x5() {
  return new et("lossy");
}
function w5() {
  return new et("preserve_transparency");
}
function b5(t) {
  return new et("progressive", t);
}
function _5() {
  return new et("region_relative");
}
function S5() {
  return new et("relative");
}
let Ns = class extends xe {
  constructor(e) {
    super(e), this.val = e;
  }
  getValue() {
    return this.val;
  }
}, ca = class extends vt {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(t, e, r) {
    super(), this._actionModel = {};
    let n;
    e instanceof Ns ? n = e.getValue() : n = e, this._actionModel.actionType = s5[t], this._actionModel[r] = n, this.addQualifier(new te(t, e));
  }
}, E5 = class extends et {
  constructor(t) {
    super("progressive", t);
  }
}, as = class extends ca {
  constructor(e, r) {
    super(e, r, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(x5()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(e) {
    return e instanceof E5 ? (this._actionModel.progressive = { mode: e.getFlagValue() }, this.addFlag(e)) : (this._actionModel.progressive = { mode: e }, this.addFlag(b5(e))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(w5()), this;
  }
  static fromJson(e) {
    const { formatType: r, lossy: n, progressive: i, preserveTransparency: s } = e;
    let o;
    return r ? o = new this("f", r) : o = new this("f"), i && (i.mode ? o.progressive(i.mode) : o.progressive()), n && o.lossy(), s && o.preserveTransparency(), o;
  }
}, hi = class ua {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(e) {
    let r;
    if (typeof e == "string") {
      if (e.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      r = new E1(e);
    } else
      r = e;
    return this.actions.push(r), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(e) {
    return e instanceof ua ? this.actions = this.actions.concat(e.actions) : this.actions.push(new E1(e)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((e) => e.toString()).filter((e) => e).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(e) {
    return this.addAction(e);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(e) {
    return this.addAction(e);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(e) {
    return this.addAction(e);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(e) {
    return this.addAction(new as("q", e)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(e) {
    return this.addAction(new as("f", e)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(e) {
    return e.setLayerType("u"), this.addAction(e);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(e) {
    return this.addAction(e);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(e) {
    return this.addAction(e);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(e) {
    return this.addAction(e);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(e) {
    return this.addAction(new g5(e));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(e) {
    return this.addAction(e);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(e) {
    const r = new vt();
    let n = e;
    return typeof e == "string" && (n = new et(e)), r.addQualifier(n), this.addAction(r);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(e) {
    return this.addAction(e);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(e) {
    return this.addAction(e);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(e) {
    return this.addAction(e);
  }
  toJson() {
    const e = [];
    for (const r of this.actions) {
      const n = r.toJson();
      if (v5(n))
        return n;
      e.push(n);
    }
    return { actions: e };
  }
};
function T1(t) {
  const e = t.toString();
  return e.match(/[A-Z]/gi) || e.length > 1 && e[0] === "0" ? e : !isNaN(parseFloat(e)) && e.indexOf(":") === -1 && e.indexOf(".") === -1 ? `${e}.0` : e;
}
class T5 extends xe {
}
class k5 extends vt {
  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  constructor(e, r, n) {
    super(), this._actionModel = { dimensions: {} }, this._actionModel.actionType = i5[e] || e, this.addQualifier(new te("c", e)), r && this.width(r), n && this.height(n);
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  height(e) {
    return this._actionModel.dimensions.height = e, this.addQualifier(new te("h", e));
  }
  /**
   * @description Sets the width of the resize
   * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  width(e) {
    return this._actionModel.dimensions.width = e, this.addQualifier(new te("w", e));
  }
  /**
   * @description Sets the aspect ratio of the asset.
   * For a list of supported types see {@link Qualifiers.AspectRatio|
    * AspectRatio values}
   * @param {AspectRatioType|number|string} ratio The new aspect ratio, specified as a percentage or ratio.
   * @return {this}
   */
  aspectRatio(e) {
    if (e instanceof T5)
      return this._actionModel.dimensions.aspectRatio = `${e}`, this.addQualifier(new te("ar", e));
    if (typeof e == "number" || typeof e == "string")
      return this._actionModel.dimensions.aspectRatio = T1(e), this.addQualifier(new te("ar", T1(e)));
    if (e instanceof et)
      return this._actionModel.dimensions.aspectRatio = `${e.qualifierValue}`, this.addFlag(e);
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
   * @return {this}
   */
  relative() {
    return this._actionModel.relative = !0, this.addFlag(S5());
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
   * @return {this}
   */
  regionRelative() {
    return this._actionModel.regionRelative = !0, this.addFlag(_5());
  }
  static fromJson(e) {
    const { actionType: r, dimensions: n, relative: i, regionRelative: s } = e, { aspectRatio: o, width: l, height: c } = n, u = na[r] || r, f = new this(u, l, c);
    return o && f.aspectRatio(o === "ignore_aspect_ratio" ? y5() : o), i && f.relative(), s && f.regionRelative(), f;
  }
}
let $s = class extends te {
  /**
   * @param value, an array containing (GravityObject | AutoGravity | string) or a string;
   */
  constructor(e) {
    super("g", new xe(e));
  }
};
class da extends $s {
  constructor() {
    super("auto");
  }
  /**
   * @description Autofocuses on objects, allowing their priority within the algorithm to be configured.
   * @param {AutoFocus} AutoFocusObjects
   */
  autoFocus(...e) {
    return this.addValue(e), this;
  }
}
class fa extends $s {
  constructor(e) {
    super(e);
  }
  /**
   * @description Specifies the gravity to use if none of the other gravity objects are found.
   * @param {Qualifiers.Gravity.AutoGravity} val
   */
  fallbackGravity(e) {
    return this.addValue(e.qualifierValue), this;
  }
}
class pa extends $s {
  constructor(e) {
    super(e);
  }
}
function M5(t) {
  return new pa(t);
}
function ha(...t) {
  const e = [...t];
  return new fa(e);
}
function ma() {
  return new da();
}
class mi extends xe {
  constructor(e) {
    super(), this.name = e;
  }
  toString() {
    return this.name;
  }
}
function O5() {
  return new mi("ocr_text");
}
function L5(t) {
  return t && `${t}`.split(":")[0] === "auto";
}
function P5(t) {
  const e = js(t);
  return ["north", "center", "east", "west", "south", "north_west", "south_east", "south_west", "north_east"].includes(e);
}
function js(t) {
  return `${t}`.replace("g_", "");
}
function A5(t) {
  return {
    compass: js(t),
    gravityType: "direction"
  };
}
function N5(t) {
  return js(t) === "ocr_text";
}
function $5() {
  return {
    gravityType: "ocr"
  };
}
function j5(t) {
  return `${t.qualifierValue}`.split(":")[0] === "auto";
}
function F5(t) {
  const e = t.toString().split("_"), r = {
    object: e[0]
  };
  return e.length > 1 && (e[1] === "avoid" ? r.avoid = !0 : r.weight = +e[1]), r;
}
function Ca(t) {
  let e;
  const r = t === "auto" ? new da() : t;
  return `${t}`.startsWith("auto:") ? e = `${t}`.split(":").filter((n) => n !== "auto") : e = r.qualifierValue.values.filter((n) => n !== "auto"), {
    gravityType: "auto",
    autoFocus: e.map(F5)
  };
}
function R5(t) {
  const e = `${t}`.split(":").includes("auto"), r = t.qualifierValue.values, n = {
    gravityType: "object",
    focusOnObjects: (e ? r.slice(0, r.length - 1) : r).map((i) => `${i}`)
  };
  if (e) {
    const i = r[r.length - 1].values.slice(1), s = ma().autoFocus(...i);
    n.fallbackGravity = Ca(s);
  }
  return n;
}
function I5(t) {
  const e = t.split(":").map((r) => new mi(r));
  return new fa(e);
}
function D5(t) {
  return P5(t) ? A5(t) : N5(t) ? $5() : L5(t) || j5(t) ? Ca(t) : R5(typeof t == "string" ? I5(t) : t);
}
class Fs extends xe {
  constructor(e, r) {
    super(), this._weight = r, this.focusOn = e, this.shouldAvoid = !1;
  }
  /**
   * @summary qualifier
   * @description Specifies the object to focus on automatically
   * Accepts an AutoFocusObject (which is just a wrapper for a FocusOn object, but with extra method: avoid, weight)
   * @param {Qualifiers.FocusOn} obj The object to focus on.
   * @param {number} weight
   */
  static focusOn(e, r) {
    return new Fs(e, r);
  }
  shouldAddWeight() {
    return typeof this._weight == "number" || typeof this._weight == "string" || this.shouldAvoid;
  }
  /**
   * @summary qualifier
   * @desc Get the name of the of the object
   */
  getName() {
    return this.focusOn.name;
  }
  /**
   * @summary qualifier
   * @desc Get the weight for the object
   */
  getWeight() {
    return this.shouldAvoid ? "avoid" : this._weight;
  }
  /**
   * @summary qualifier
   * @desc Return the string representation of this QualifierValue
   */
  toString() {
    return this.shouldAddWeight() ? `${this.getName()}_${this.getWeight()}` : `${this.getName()}`;
  }
  /**
   * @summary qualifier
   * @description Sets the importance level of the object within the automatic gravity algorithm
   * @param {numebr} w The focus weight for the object
   * @return {this}
   */
  weight(e) {
    return this._weight = e, this;
  }
  /**
   * @summary qualifier
   * @description Attempts to avoid the detected object in the image
   * @return {this}
   */
  avoid() {
    return this.shouldAvoid = !0, this;
  }
}
class ga extends xe {
  constructor(e) {
    super(), this.val = e;
  }
  toString() {
    return this.val;
  }
}
function V5(t) {
  return t.gravityType === "direction";
}
function z5(t) {
  return t.gravityType === "ocr";
}
function B5(t) {
  return t.gravityType === "auto";
}
function W5(t) {
  const { object: e, weight: r, avoid: n } = t, i = new Fs(new mi(e));
  return (r || r === 0) && i.weight(r), n && i.avoid(), i;
}
function va(t) {
  const e = (t.autoFocus || []).map(W5);
  return ma().autoFocus(...e);
}
function H5(t) {
  const e = (t.focusOnObjects || []).map((n) => new mi(n)), r = ha(...e);
  if (t.fallbackGravity) {
    const n = va(t.fallbackGravity);
    r.fallbackGravity(n);
  }
  return r;
}
function G5(t) {
  return V5(t) ? new pa(new ga(t.compass)) : z5(t) ? ha(O5()) : B5(t) ? va(t) : H5(t);
}
let Rs = class extends k5 {
  /**
   * @description Which part of the original image to include.
   * @param {Qualifiers.Gravity} gravity
   */
  gravity(e) {
    this._actionModel.gravity = D5(e);
    const r = typeof e == "string" ? new te("g", e) : e;
    return this.addQualifier(r);
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.gravity && r.gravity(G5(e.gravity)), r;
  }
};
class jn extends te {
  constructor(e) {
    super("b"), e && this.addValue(e);
  }
}
const ya = 100, q5 = 0;
class U5 extends jn {
  /**
   * @description Sets the intensity of the blur.
   * @param {number} value - The intensity of the blur.
   */
  intensity(e) {
    return this.intensityLevel = e, this;
  }
  /**
   * @description Sets the brightness of the background.
   * @param {number} value - The brightness of the background.
   */
  brightness(e) {
    return this.brightnessLevel = e, this;
  }
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function
   */
  toString() {
    const e = this.intensityLevel !== void 0 ? `:${this.intensityLevel}` : "", r = this.brightnessLevel !== void 0 ? this.intensityLevel !== void 0 ? `:${this.brightnessLevel}` : `:${ya}:${this.brightnessLevel}` : "";
    return `b_blurred${e}${r}`;
  }
}
var xa = U5;
let Is = class extends jn {
  constructor() {
    super(), this._palette = [];
  }
  /**
   * @description Selects the strongest contrasting color to use for padding.
   * @return {this}
   */
  contrast() {
    return this._contrast = !0, this;
  }
  /**
   * @description Defines the custom colors to use when resizing using content-aware padding.
   * @param {...string} colors One or more colors - Example: palette('green', 'red', blue')
   * @return {this}
   */
  palette(...e) {
    return this._palette = e.map((r) => pi(r)), this;
  }
};
class wa extends Is {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class ba extends Is {
  /**
   *
   * @description Sets the number of predominant colors to use (2 or 4).
   * @param {number} num
   * @return {this}
   */
  gradientColors(e) {
    return this._gradientColors = e, this;
  }
  /**
   * @description Sets the direction for a background gradient fade effect.
   * @param {Qualifiers.GradientDirection | GradientDirectionType | string} direction Use one of these functions
   * provided by {@link Qualifiers.GradientDirection|GradientDirection}
   * @return {this}
   */
  gradientDirection(e) {
    return this._gradientDirection = e, this;
  }
}
class _a extends ba {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Sa extends ba {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Ea extends Is {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Ta extends jn {
  constructor() {
    super("gen_fill"), this._backgroundType = "generativeFill";
  }
  prompt(e) {
    return this._prompt = e, this;
  }
  getPrompt() {
    return this._prompt;
  }
  getBackgroundType() {
    return this._backgroundType;
  }
  /**
   * @description
   * Override the toString() function to explicitly stringify the qualifier.
   */
  toString() {
    return `b_gen_fill${this._prompt ? `:prompt_${this._prompt}` : ""}`;
  }
}
function ka(t) {
  return `${t}`.replace("b_", "");
}
function Q5() {
  return { backgroundType: "auto" };
}
function Y5(t) {
  const { intensityLevel: e, brightnessLevel: r } = t, n = {
    backgroundType: "blurred"
  };
  return (e || e === 0) && (n.intensity = e), (r || r === 0) && (n.brightness = r), n;
}
function Ds(t) {
  const e = t._contrast, r = t._palette, n = {
    backgroundType: ""
  };
  return e && (n.contrast = !0), r && (n.palette = r), n;
}
function J5(t) {
  return Object.assign(Object.assign({}, Ds(t)), { backgroundType: "border" });
}
function Ma(t) {
  const e = t._gradientColors, r = `${t._gradientDirection}`, n = Ds(t);
  return e && (n.gradientColors = e), r && (n.gradientDirection = r), n;
}
function Z5(t) {
  return Object.assign(Object.assign({}, Ma(t)), { backgroundType: "borderGradient" });
}
function K5(t) {
  return {
    backgroundType: "color",
    color: ka(t)
  };
}
function X5(t) {
  return Object.assign(Object.assign({}, Ds(t)), { backgroundType: "predominant" });
}
function e4(t) {
  return Object.assign(Object.assign({}, Ma(t)), { backgroundType: "predominantGradient" });
}
function t4(t) {
  return Object.assign({ backgroundType: t.getBackgroundType() }, t.getPrompt() ? { prompt: t.getPrompt() } : {});
}
function r4(t) {
  return ka(t) === "auto" ? Q5() : t instanceof xa ? Y5(t) : t instanceof wa ? J5(t) : t instanceof _a ? Z5(t) : t instanceof Ea ? X5(t) : t instanceof Sa ? e4(t) : t instanceof Ta ? t4(t) : K5(t);
}
function n4() {
  return new Ns("svg");
}
function Vs() {
  return new Ns("auto");
}
function Oa() {
  return new wa();
}
function La() {
  return new jn("auto");
}
function Pa() {
  return new _a();
}
function Aa() {
  return new Sa();
}
function Na() {
  return new Ea();
}
function $a(t) {
  return new jn(pi(t));
}
function i4() {
  return new xa();
}
function ja() {
  return new Ta();
}
const Fa = {
  auto: La,
  border: Oa,
  borderGradient: Pa,
  predominantGradient: Aa,
  predominant: Na,
  color: $a,
  blurred: i4,
  generativeFill: ja
};
function s4(t) {
  const { brightness: e, intensity: r } = t, n = Fa.blurred();
  return n.brightness(e ?? q5), n.intensity(r ?? ya), n;
}
function k1(t, e) {
  const { gradientColors: r, gradientDirection: n, contrast: i, palette: s } = e;
  return i && t.contrast(), s && t.palette(...s), r && t.gradientColors(+r), n && t.gradientDirection(n), t;
}
function M1(t, e) {
  const { contrast: r, palette: n } = e;
  return r && t.contrast(), n && t.palette(...n), t;
}
function o4(t, e) {
  const { prompt: r } = e;
  return r && t.prompt(r), t;
}
function a4(t) {
  const { backgroundType: e } = t;
  switch (e) {
    case "auto":
      return La();
    case "blurred":
      return s4(t);
    case "border":
      return M1(Oa(), t);
    case "borderGradient":
      return k1(Pa(), t);
    case "predominant":
      return M1(Na(), t);
    case "predominantGradient":
      return k1(Aa(), t);
    case "generativeFill":
      return o4(ja(), t);
    default:
      return $a(t.color);
  }
}
class l4 extends Rs {
  /**
   * @description Sets the background.
   * @param {Qualifiers.Background} backgroundQualifier Defines the background color to use instead of
   * transparent background areas or when resizing with padding.
   */
  background(e) {
    return this._actionModel.background = r4(e), this.addQualifier(e);
  }
  /**
   * @description Horizontal position for custom-coordinates based padding.
   * @param {number} x The x position.
   */
  offsetX(e) {
    return this._actionModel.x = e, this.addQualifier(new te("x", e));
  }
  /**
   * @description Vertical position for custom-coordinates based padding
   * @param {number} y The y position.
   */
  offsetY(e) {
    return this._actionModel.y = e, this.addQualifier(new te("y", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.background && r.background(a4(e.background)), e.x && r.offsetX(e.x), e.y && r.offsetY(e.y), e.zoom && r.zoom(e.zoom), r;
  }
}
class c4 extends Rs {
  /**
   * @description Horizontal position for custom-coordinates based cropping.
   * @param {number} x The x position.
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new te("x", e));
  }
  /**
   * @description Vertical position for custom-coordinates based cropping
   * @param {number} y The y position.
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new te("y", e));
  }
  /**
   * @description Controls how much of the original image surrounding the face to keep when using either the 'crop' or 'thumb' cropping modes with face detection.
   * @param {number | string} z The zoom factor. (Default: 1.0)
   */
  zoom(e) {
    return this._actionModel.zoom = e, this.addQualifier(new te("z", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.x && r.x(e.x), e.y && r.y(e.y), e.zoom && r.zoom(e.zoom), r;
  }
}
class u4 extends Rs {
  /**
   * @description Absolute X position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} x The x position.
   */
  x(e) {
    return this._actionModel.x = e, this.addQualifier(new te("x", e));
  }
  /**
   * @description Absolute Y position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} y The y position.
   */
  y(e) {
    return this._actionModel.y = e, this.addQualifier(new te("y", e));
  }
  static fromJson(e) {
    const r = super.fromJson.apply(this, [e]);
    return e.x && r.x(e.x), e.y && r.y(e.y), r;
  }
}
function d4(t, e) {
  return new c4("crop", t, e);
}
function f4(t, e) {
  return new u4("fill", t, e);
}
function p4(t, e) {
  return new l4("pad", t, e);
}
class h4 extends ca {
  /**
   * @param {Qualifiers.Quality} qualityValue a Quality value
   */
  constructor(e) {
    super("q", e.toString(), "level");
  }
  /**
   * Selet the Chroma sub sampling</br>
   * <b>Learn more</b>: {@link https://cloudinary.com/documentation/image_optimization#toggle_chroma_subsampling|Toggling chroma subsampling}
   * @param {420 | 444 | number} type The chroma sub sampling type
   */
  chromaSubSampling(e) {
    this._actionModel.chromaSubSampling = oa[e];
    const r = new xe([this._actionModel.level, e]);
    return r.setDelimiter(":"), this.addQualifier(new te("q", r));
  }
  /**
   * Controls the final quality by setting a maximum quantization percentage
   * @param {number} val
   */
  quantization(e) {
    this._actionModel.quantization = e;
    const r = new xe([this._actionModel.level, `qmax_${e}`]).setDelimiter(":");
    return this.addQualifier(new te("q", r));
  }
  static fromJson(e) {
    const { level: r, chromaSubSampling: n, quantization: i } = e, s = sa[r] || r, o = new this(s);
    if (n) {
      const l = n5[n.toUpperCase()];
      l && o.chromaSubSampling(+l);
    }
    return i && o.quantization(i), o;
  }
}
function Ci(t) {
  return new as("f", t);
}
function gi(t) {
  return new h4(t);
}
function m4() {
  return new ga("north_east");
}
S1(70).color("black"), S1(40).color("white"), p5(), m5();
new hi().effect(h5()).delivery(gi("auto")).delivery(Ci(n4()));
new hi().effect(C5()).delivery(gi("auto")).delivery(Ci(Vs()));
new hi().effect(f5(2e3)).delivery(gi("auto")).delivery(Ci(Vs()));
new hi().resize(p4("iw_div_2").aspectRatio(1).background(Fa.auto())).resize(d4(1, 1).gravity(M5(m4()))).resize(f4().height("ih").width("iw")).delivery(gi("auto")).delivery(Ci(Vs()));
var C4 = typeof Bt == "object" && Bt && Bt.Object === Object && Bt, g4 = typeof self == "object" && self && self.Object === Object && self;
C4 || g4 || Function("return this")();
function v4() {
  return typeof window < "u";
}
function y4(t, e, r) {
  var n = ss(e);
  if (t)
    for (var i = 0; i < t.length; i++) {
      var s = t[i](null, n);
      if (!s)
        break;
    }
  return n.toURL(r ? { trackedAnalytics: r } : null);
}
function O1(t) {
  t.cleanupCallbacks.forEach(function(e) {
    e();
  });
}
const tt = ({ cldImg: t, plugins: e, src: r, ...n }) => {
  const i = X(null), s = X(null);
  if (K(() => (i.current && (s.current = new H6(i.current, t, e)), () => {
    s.current && (O1(s.current.htmlPluginState), s.current.unmount());
  }), [t, e]), K(() => {
    s.current && (O1(s.current.htmlPluginState), s.current.update(t, e));
  }, [t, e]), v4())
    return /* @__PURE__ */ d("img", { suppressHydrationWarning: !0, ...n, src: r == null ? void 0 : r.toURL(), ref: i });
  {
    const o = y4(e, t);
    return /* @__PURE__ */ d("img", { ...n, src: o });
  }
};
function x4(t) {
  return !(typeof t != "object" || t instanceof Array);
}
class w4 {
  filterOutNonSupportedKeys(e, r) {
    const n = /* @__PURE__ */ Object.create({});
    return x4(e) ? (Object.keys(e).forEach((i) => {
      r.indexOf(i) >= 0 ? n[i] = e[i] : console.warn("Warning - unsupported key provided to configuration: ", i);
    }), n) : /* @__PURE__ */ Object.create({});
  }
}
const b4 = w4, L1 = [
  "cname",
  "secureDistribution",
  "privateCdn",
  "signUrl",
  "longUrlSignature",
  "shorten",
  "useRootPath",
  "secure",
  "forceVersion",
  "analytics",
  "queryParams"
];
class zs extends b4 {
  /**
   * @param {IURLConfig} userURLConfig
   */
  constructor(e) {
    super();
    const r = this.filterOutNonSupportedKeys(e, L1);
    Object.assign(this, {
      secure: !0
    }, r);
  }
  extend(e) {
    const r = this.filterOutNonSupportedKeys(e, L1);
    return new zs(Object.assign({}, this, r));
  }
  /**
   * @param {string} value Sets the cname
   */
  setCname(e) {
    return this.cname = e, this;
  }
  /**
   * @param {string} value Sets the secureDistribution
   */
  setSecureDistribution(e) {
    return this.secureDistribution = e, this;
  }
  /**
   * @param {boolean} value Sets whether to use a private CDN (Removes cloudName from URL)
   */
  setPrivateCdn(e) {
    return this.privateCdn = e, this;
  }
  /**
   * @param value Sets whether or not to sign the URL
   */
  setSignUrl(e) {
    return this.signUrl = e, this;
  }
  /**
   * @param value Sets whether or not to use a long signature
   */
  setLongUrlSignature(e) {
    return this.longUrlSignature = e, this;
  }
  /**
   * @param value Sets whether or not to shorten the URL
   */
  setShorten(e) {
    return this.shorten = e, this;
  }
  /**
   * @param value Sets whether or not to use a root path
   */
  setUseRootPath(e) {
    return this.useRootPath = e, this;
  }
  /**
   * @param value Sets whether or not to deliver the asset through https
   */
  setSecure(e) {
    return this.secure = e, this;
  }
  /**
   * @param value Sets whether to force a version in the URL
   */
  setForceVersion(e) {
    return this.forceVersion = e, this;
  }
  /**
   * @param params Sets additional params
   */
  setQueryParams(e) {
    return this.queryParams = e, this;
  }
}
const _4 = zs;
class kn {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(e) {
    this.values = [], this.delimiter = ":", this.hasValue(e) && this.addValue(e);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(e) {
    return typeof e < "u" && e !== null && e !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(e) {
    return Array.isArray(e) ? this.values = this.values.concat(e) : this.values.push(e), this.values = this.values.filter((r) => this.hasValue(r)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(e) {
    return this.delimiter = e, this;
  }
}
class S4 extends Error {
  constructor(e = "Unsupported") {
    super(e);
  }
}
function Bs(t) {
  return new S4(t);
}
function E4() {
  return this._qualifierModel || { error: Bs(`unsupported qualifier ${this.constructor.name}`) };
}
class T4 {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return E4.apply(this);
  }
}
class vi extends T4 {
  constructor(e, r) {
    super(), this.delimiter = "_", this.key = e, r instanceof kn ? this.qualifierValue = r : (this.qualifierValue = new kn(), this.qualifierValue.addValue(r));
  }
  toString() {
    const { key: e, delimiter: r, qualifierValue: n } = this;
    return `${e}${r}${n.toString()}`;
  }
  addValue(e) {
    return this.qualifierValue.addValue(e), this;
  }
}
class qt extends vi {
  constructor(e, r) {
    let n;
    r ? n = new kn([e, `${r}`]).setDelimiter(":") : n = e, super("fl", n), this.flagValue = r;
  }
  toString() {
    return super.toString().replace(/\./g, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
}
function k4(t, e) {
  const r = Array.from(t.entries());
  return e.forEach((n) => {
    r.push(["fl", n]);
  }), r.sort().map((n) => n[1]);
}
function M4() {
  var t, e, r;
  const n = this._actionModel && Object.keys(this._actionModel).length, i = (r = (e = (t = this._actionModel) === null || t === void 0 ? void 0 : t.source) === null || e === void 0 ? void 0 : e.transformation) === null || r === void 0 ? void 0 : r.error;
  return i && i instanceof Error ? { error: i } : n ? this._actionModel : { error: Bs(`unsupported action ${this.constructor.name}`) };
}
class O4 {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return M4.apply(this);
  }
}
let Ws = class extends O4 {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(e) {
    return this.actionTag = e, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), k4(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(e) {
    if (typeof e == "string") {
      const [r, n] = e.toLowerCase().split("_");
      r === "fl" ? this.flags.push(new qt(n)) : this.qualifiers.set(r, new vi(r, n));
    } else
      this.qualifiers.set(e.key, e);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(e) {
    return typeof e == "string" ? this.flags.push(new qt(e)) : e instanceof qt && this.flags.push(e), this;
  }
  addValueToQualifier(e, r) {
    return this.qualifiers.get(e).addValue(r), this;
  }
};
function L4(t) {
  return t && (t.match(/^#/) ? `rgb:${t.substr(1)}` : t);
}
class P4 extends Ws {
  constructor(e) {
    super(), this._actionModel = {}, this.addQualifier(new vi("b", new kn(L4(e)).setDelimiter("_"))), this._actionModel.color = e, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(e) {
    const { color: r } = e;
    return new this(r);
  }
}
class P1 {
  constructor(e) {
    this.raw = e;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: Bs(`unsupported action ${this.constructor.name}`) };
  }
}
function A4(t) {
  const e = t;
  return "error" in e && !!e.error;
}
function N4() {
  return new qt("lossy");
}
function $4() {
  return new qt("preserve_transparency");
}
function j4(t) {
  return new qt("progressive", t);
}
class F4 extends kn {
  constructor(e) {
    super(e), this.val = e;
  }
  getValue() {
    return this.val;
  }
}
function hr(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    e[t[r]] = r;
  }), e;
}
const R4 = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad",
  autoPad: "auto_pad"
}, I4 = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, D4 = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, V4 = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, z4 = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, B4 = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, W4 = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
};
hr(B4);
hr(W4);
hr(R4);
const H4 = hr(I4);
hr(D4);
hr(V4);
hr(z4);
class G4 extends Ws {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(e, r, n) {
    super(), this._actionModel = {};
    let i;
    r instanceof F4 ? i = r.getValue() : i = r, this._actionModel.actionType = H4[e], this._actionModel[n] = i, this.addQualifier(new vi(e, r));
  }
}
class q4 extends qt {
  constructor(e) {
    super("progressive", e);
  }
}
class Yn extends G4 {
  constructor(e, r) {
    super(e, r, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(N4()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(e) {
    return e instanceof q4 ? (this._actionModel.progressive = { mode: e.getFlagValue() }, this.addFlag(e)) : (this._actionModel.progressive = { mode: e }, this.addFlag(j4(e))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag($4()), this;
  }
  static fromJson(e) {
    const { formatType: r, lossy: n, progressive: i, preserveTransparency: s } = e;
    let o;
    return r ? o = new this("f", r) : o = new this("f"), i && (i.mode ? o.progressive(i.mode) : o.progressive()), n && o.lossy(), s && o.preserveTransparency(), o;
  }
}
class yi {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(e) {
    let r;
    if (typeof e == "string") {
      if (e.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      r = new P1(e);
    } else
      r = e;
    return this.actions.push(r), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(e) {
    return e instanceof yi ? this.actions = this.actions.concat(e.actions) : this.actions.push(new P1(e)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((e) => e.toString()).filter((e) => e).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(e) {
    return this.addAction(e);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(e) {
    return this.addAction(e);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(e) {
    return this.addAction(e);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(e) {
    return this.addAction(new Yn("q", e)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(e) {
    return this.addAction(new Yn("f", e)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(e) {
    return e.setLayerType("u"), this.addAction(e);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(e) {
    return this.addAction(e);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(e) {
    return this.addAction(e);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(e) {
    return this.addAction(e);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(e) {
    return this.addAction(e);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(e) {
    return this.addAction(new P4(e));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(e) {
    return this.addAction(e);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(e) {
    return this.addAction(e);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(e) {
    const r = new Ws();
    let n = e;
    return typeof e == "string" && (n = new qt(e)), r.addQualifier(n), this.addAction(r);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(e) {
    return this.addAction(e);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(e) {
    return this.addAction(e);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(e) {
    return this.addAction(e);
  }
  toJson() {
    const e = [];
    for (const r of this.actions) {
      const n = r.toJson();
      if (A4(n))
        return n;
      e.push(n);
    }
    return { actions: e };
  }
}
class U4 extends yi {
}
class Q4 extends yi {
}
function Y4(t) {
  return t.match(/^https?:\//);
}
function J4(t) {
  return t.indexOf("/") < 0;
}
function Z4(t) {
  return t.match(/^v[0-9]+/);
}
function K4(t, e) {
  const r = e.secure, n = e.privateCdn, i = e.cname, s = e.secureDistribution;
  return !r && !i ? `http://res.cloudinary.com/${t}` : r && !s && n ? `https://${t}-res.cloudinary.com` : r && !s ? `https://res.cloudinary.com/${t}` : r && s && n ? `https://${s}` : r && s ? `https://${s}/${t}` : !r && i ? `http://${i}/${t}` : "ERROR";
}
function X4(t) {
  return t || "image";
}
function e7(t) {
  return t || "upload";
}
function t7(t, e, r) {
  const n = r !== !1;
  return e ? `v${e}` : Z4(t) || Y4(t) || J4(t) ? "" : n ? "v1" : "";
}
function Hs(t, e, r) {
  let n = e >> 0, i = String(typeof r < "u" ? r : " ");
  return t.length > n ? String(t) : (n = n - t.length, n > i.length && (i += r7(i, n / i.length)), i.slice(0, n) + String(t));
}
function r7(t, e) {
  let r = e, n = "";
  for (; r > 0; )
    n += t, r--;
  return n;
}
const n7 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Jn = {};
let A1 = 0;
n7.split("").forEach((t) => {
  let e = A1.toString(2);
  e = Hs(e, 6, "0"), Jn[e] = t, A1++;
});
function i7(t) {
  if (t.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return t.split(".").reverse().join(".");
}
function s7(t) {
  if (t.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return t.split(".").map((e) => {
    const r = +e;
    if (isNaN(r) || r < 0)
      throw "Invalid version number provided";
    return Hs(e, 2, "0");
  }).join(".");
}
function N1(t) {
  let e = "";
  const r = t.split(".").length * 6, n = i7(t), i = s7(n);
  let s = parseInt(i.split(".").join("")).toString(2);
  if (s = Hs(s, r, "0"), s.length % 6 !== 0)
    throw "Version must be smaller than 43.21.26)";
  return s.match(/.{1,6}/g).forEach((o) => {
    e += Jn[o];
  }), e;
}
function o7(t) {
  const e = {
    sdkSemver: t.sdkSemver,
    techVersion: t.techVersion,
    sdkCode: t.sdkCode,
    product: t.product,
    feature: "0",
    osType: t.osType,
    osVersion: t.osVersion
  };
  return t.accessibility && (e.feature = "D"), t.lazyload && (e.feature = "C"), t.responsive && (e.feature = "A"), t.placeholder && (e.feature = "B"), e;
}
const a7 = "1.16.1";
function l7(t) {
  const [e, r] = t.split("."), n = parseInt(e).toString(2), i = parseInt(r).toString(2), s = n.padStart(6, "0"), o = i.padStart(6, "0");
  return Jn[s] + Jn[o];
}
function c7() {
  const t = "0.0.0";
  if (typeof window < "u")
    return t;
  try {
    return process.versions.node || t;
  } catch {
    return t;
  }
}
function u7(t) {
  const e = {
    techVersion: c7(),
    sdkCode: "T",
    sdkSemver: a7.split("-")[0],
    product: "A",
    osType: "Z",
    osVersion: "0.0",
    responsive: !1,
    placeholder: !1,
    lazyload: !1,
    accessibility: !1
  };
  return t ? Object.assign(Object.assign({}, e), t) : e;
}
function $1(t) {
  const e = u7(t), r = o7(e);
  try {
    const n = d7(r.techVersion), i = N1(r.sdkSemver), s = N1(n), o = l7(r.osVersion), l = r.feature, c = r.sdkCode, { product: u, osType: f } = r;
    return `D${u}${c}${i}${s}${f}${o}${l}`;
  } catch {
    return "E";
  }
}
function d7(t) {
  const e = t.split(".");
  return `${e[0]}.${e[1]}`;
}
const j1 = {
  "image/upload": "images",
  "image/private": "private_images",
  "image/authenticated": "authenticated_images",
  "raw/upload": "files",
  "video/upload": "videos"
};
class f7 {
  constructor(e, r = {}, n) {
    this.setPublicID(e), this.setCloudConfig(r), this.setURLConfig(n);
  }
  /**
   * @description Sets the URL Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setURLConfig(e) {
    return this.urlConfig = new _4(e), this;
  }
  /**
   * @description Sets the Cloud Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setCloudConfig(e) {
    return this.cloudName = e.cloudName, this.apiKey = e.apiKey, this.apiSecret = e.apiSecret, this.authToken = e.authToken, this;
  }
  /**
   * @description Sets the public ID of the asset.
   * @param {string} publicID The public ID of the asset.
   * @return {this}
   */
  setPublicID(e) {
    return this.publicID = e ? e.toString() : "", this;
  }
  /**
   * @description Sets the delivery type of the asset.
   * @param {DELIVERY_TYPE | string} newType The type of the asset.
   * @return {this}
   */
  setDeliveryType(e) {
    return this.deliveryType = e, this;
  }
  /**
   * @description Sets the URL SEO suffix of the asset.
   * @param {string} newSuffix The SEO suffix.
   * @return {this}
   */
  setSuffix(e) {
    return this.suffix = e, this;
  }
  /**
   * @description Sets the signature of the asset.
   * @param {string} signature The signature.
   * @return {this}
   */
  setSignature(e) {
    return this.signature = e, this;
  }
  /**
   * @description Sets the version of the asset.
   * @param {string} newVersion The version of the asset.
   * @return {this}
   */
  setVersion(e) {
    return e && (this.version = e), this;
  }
  /**
   * @description Sets the asset type.
   * @param {string} newType The type of the asset.
   * @return {this}
   */
  setAssetType(e) {
    return e && (this.assetType = e), this;
  }
  sign() {
    return this;
  }
  /**
   * @description Serializes to URL string
   * @param overwriteOptions
   */
  toURL(e = {}) {
    return this.createCloudinaryURL(null, e.trackedAnalytics);
  }
  /**
   * @description Validate various options before attempting to create a URL
   * The function will throw in case a violation
   * @throws Validation errors
   */
  validateAssetForURLCreation() {
    if (typeof this.cloudName > "u")
      throw "You must supply a cloudName when initializing the asset";
    const e = this.suffix && this.suffix.indexOf(".") >= 0, r = this.suffix && this.suffix.indexOf("/") >= 0;
    if (e || r)
      throw "`suffix`` should not include . or /";
  }
  /**
   * @description return an SEO friendly name for a combination of asset/delivery, some examples:
   * * image/upload -> images
   * * video/upload -> videos
   * If no match is found, return `{asset}/{delivery}`
   */
  getResourceType() {
    const e = X4(this.assetType), r = e7(this.deliveryType), n = !!this.suffix, i = `${e}/${r}`, s = j1[`${e}/${r}`], o = this.urlConfig.useRootPath, l = this.urlConfig.shorten;
    if (o) {
      if (i === "image/upload")
        return "";
      throw new Error(`useRootPath can only be used with assetType: 'image' and deliveryType: 'upload'. Provided: ${i} instead`);
    }
    if (l && i === "image/upload")
      return "iu";
    if (n) {
      if (s)
        return s;
      throw new Error(`URL Suffix only supported for ${Object.keys(j1).join(", ")}, Provided: ${i} instead`);
    }
    return i;
  }
  getSignature() {
    return this.signature ? `s--${this.signature}--` : "";
  }
  /**
   *
   * @description Creates a fully qualified CloudinaryURL
   * @return {string} CloudinaryURL
   * @throws Validation Errors
   */
  createCloudinaryURL(e, r) {
    if (!this.publicID)
      return "";
    this.validateAssetForURLCreation();
    const n = K4(this.cloudName, this.urlConfig), i = e ? e.toString() : "", s = t7(this.publicID, this.version, this.urlConfig.forceVersion), o = this.publicID;
    if (typeof e == "string")
      return [n, this.getResourceType(), this.getSignature(), i, s, o.replace(/,/g, "%2C"), this.suffix].filter((l) => l).join("/");
    {
      const l = [
        encodeURI(n),
        this.getResourceType(),
        this.getSignature(),
        encodeURI(i),
        s,
        encodeURI(o).replace(/,/g, "%2C"),
        this.suffix && encodeURI(this.suffix)
      ].filter((f) => f).join("/").replace(/\?/g, "%3F").replace(/=/g, "%3D"), c = this.urlConfig.analytics !== !1 && !o.includes("?");
      let u = "";
      if (typeof this.urlConfig.queryParams == "object")
        try {
          const f = new URLSearchParams(this.urlConfig.queryParams);
          c && f.set("_a", $1(r)), u = f.toString();
        } catch {
          console.error("Error: URLSearchParams is not available so the queryParams object cannot be parsed, please try passing as an already parsed string");
        }
      else
        u = this.urlConfig.queryParams || "", c && (u += `${u.length > 0 ? "&" : ""}_a=${$1(r)}`);
      return u ? `${l}?${u}` : l;
    }
  }
}
class Ra extends f7 {
  constructor(e, r, n, i) {
    super(e, r, n), this.transformation = i;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Animated} animated
   * @return {this}
   */
  animated(e) {
    return this.transformation.animated(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Border} border
   * @return {this}
   */
  border(e) {
    return this.transformation.border(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Reshape} reshape
   * @return {this}
   */
  reshape(e) {
    return this.transformation.reshape(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Resize} resize
   * @return {this}
   */
  resize(e) {
    return this.transformation.resize(e), this;
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(e) {
    return this.addAction(new Yn("q", e)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(e) {
    return this.addAction(new Yn("f", e)), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.RoundCorners} roundCorners
   * @return {this}
   */
  roundCorners(e) {
    return this.transformation.roundCorners(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  overlay(e) {
    return this.transformation.overlay(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Variable} variableAction
   * @return {this}
   */
  addVariable(e) {
    return this.transformation.addVariable(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Condition} conditionalAction
   * @return {this}
   */
  conditional(e) {
    return this.transformation.conditional(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Effect} effect
   * @return {this}
   */
  effect(e) {
    return this.transformation.effect(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Adjust} action
   * @return {this}
   */
  adjust(e) {
    return this.transformation.adjust(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Rotate} rotate
   * @return {this}
   */
  rotate(e) {
    return this.transformation.rotate(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(e) {
    return this.transformation.namedTransformation(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Delivery} deliveryAction
   * @return {this}
   */
  delivery(e) {
    return this.transformation.delivery(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.color} color
   * @return {this}
   */
  backgroundColor(e) {
    return this.transformation.backgroundColor(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.PSDTools} action
   * @return {this}
   */
  psdTools(e) {
    return this.transformation.psdTools(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Extract} action
   * @return {this}
   */
  extract(e) {
    return this.transformation.extract(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(e) {
    return this.transformation.addFlag(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.CustomFunction} customFunction
   * @return {this}
   */
  customFunction(e) {
    return this.transformation.customFunction(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(e) {
    return this.transformation.addAction(e), this;
  }
  /**
   * @description Extend your transformation with another transformation
   * @param { string | SDK.Transformation } tx
   */
  addTransformation(e) {
    return this.transformation.addTransformation(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {string}
   */
  toString() {
    return this.transformation.toString();
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  underlay(e) {
    return this.transformation.underlay(e), this;
  }
  toURL(e = {}) {
    return this.createCloudinaryURL(this.transformation, e == null ? void 0 : e.trackedAnalytics);
  }
}
class p7 extends Ra {
  constructor(e, r, n) {
    super(e, r, n, new U4());
  }
}
class h7 extends Ra {
  constructor(e, r, n) {
    super(e, r, n, new Q4()), this.assetType = "video";
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Transcode} action
   * @return {this}
   */
  transcode(e) {
    return this.transformation.transcode(e), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.VideoEdit} action
   * @return {this}
   */
  videoEdit(e) {
    return this.transformation.videoEdit(e), this;
  }
}
class Ia {
  constructor(e) {
    e && (this.cloudinaryConfig = e);
  }
  image(e) {
    return new p7(e, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
  }
  video(e) {
    return new h7(e, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
  }
  setConfig(e) {
    return this.cloudinaryConfig = e, this;
  }
  getConfig() {
    return this.cloudinaryConfig;
  }
  extendConfig() {
  }
}
const rt = (t) => {
  const e = new Ia({ cloud: { cloudName: "trades-org" } }), r = "w_500,c_auto,g_auto,f_auto,q_auto:low,e_blur:1000/e_art:audrey", n = t;
  return e.image(n).addTransformation(r).setDeliveryType("fetch");
}, Ge = (t) => {
  const e = new Ia({ cloud: { cloudName: "trades-org" } }), r = "c_auto,g_auto,f_auto,q_auto", n = t;
  return e.image(n).addTransformation(r).setDeliveryType("fetch");
}, Da = ({ state: t, city: e, postalCode: r, streetAddress: n }) => {
  const i = [n, e, t, r].filter(Boolean).join("+");
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(i)}`;
}, Va = ({ state: t, city: e, postalCode: r, streetAddress: n }) => [n, e, t, r].filter(Boolean).join(", "), $c = ({
  sectionHeader: t = "About Us",
  sectionTagline: e = "What We Do",
  shortDescription: r,
  longDescription: n,
  images: i
}) => {
  const [s, o] = ae(!1), l = !!(n && (n == null ? void 0 : n.length) > 1200);
  return /* @__PURE__ */ d("div", { "data-testid": "about-us", id: "about-us", className: "bg-neutral-400", children: /* @__PURE__ */ d("div", { className: "flex-col flex items-start gap-10 py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px] 2xl:max-w-8xl w-full 2xl:mx-auto", children: /* @__PURE__ */ I("div", { className: "w-full flex flex-col md:flex-row gap-10", children: [
    /* @__PURE__ */ I("div", { className: "flex-col w-full flex items-start max-w-2xl", children: [
      /* @__PURE__ */ d("h1", { className: "text-heading3 mb-6 md:mb-8 xl:mb-10 md:text-heading2 xl:text-heading1  text-white font-Tomorrow", children: t }),
      /* @__PURE__ */ d("span", { className: "text-lg mb-6 md:mb-8 xl:mb-10  text-white font-lato ", children: r }),
      /* @__PURE__ */ d("span", { className: "text-lg text-white font-lato", children: l && !s ? n == null ? void 0 : n.slice(0, 1200) : n }),
      l && /* @__PURE__ */ d(
        "button",
        {
          className: "uppercase px-4 py-2 bg-primary-300 active:bg-white hover:bg-neutral-100 mt-10 font-medium text-neutral-400 text-button",
          onClick: () => o(!s),
          children: s ? "Read Less" : "Read More"
        }
      )
    ] }),
    /* @__PURE__ */ I("div", { className: "flex flex-col w-full gap-4", children: [
      /* @__PURE__ */ d(
        "div",
        {
          className: ge(
            "flex-row gap-10 relative w-full h-full",
            i && i.length === 3 ? "grid grid-cols-2 xl:grid-cols-2" : "grid grid-cols-1"
          ),
          children: i && (i.length === 3 ? i == null ? void 0 : i.slice(0, 3).map((c, u) => /* @__PURE__ */ d(
            tt,
            {
              className: ge(
                u === 2 ? "relative left-0 right-0 -top-32 translate-x-1/2  z-20 h-[20rem] w-full" : "w-full",
                "object-cover h-[20rem]"
              ),
              alt: c.title,
              src: rt(c.url),
              cldImg: Ge(c.url),
              plugins: [Xe()]
            },
            `image-aboutus-${u}`
          )) : /* @__PURE__ */ d(
            tt,
            {
              className: "object-cover w-full max-h-96",
              alt: i == null ? void 0 : i[0].title,
              src: rt(i == null ? void 0 : i[0].url),
              cldImg: Ge(i == null ? void 0 : i[0].url),
              plugins: [Xe()]
            }
          ))
        }
      ),
      /* @__PURE__ */ d("div", { className: "flex-row grid grid-cols-2 xl:grid-cols-3 gap-10  w-full h-full", children: i == null ? void 0 : i.slice(i.length === 3 ? 3 : i.length === 2 || i.length === 1 ? 1 : 0, i.length).map((c, u) => /* @__PURE__ */ d(
        tt,
        {
          className: ge("object-cover h-[10rem] w-full"),
          alt: c.title,
          src: rt(c.url),
          cldImg: Ge(c.url),
          plugins: [Xe()]
        },
        `image-aboutus-${u}`
      )) })
    ] })
  ] }) }) });
}, jc = ({
  sectionHeader: t = "Create a your future best project with us!",
  sectionDescription: e = "Be prepared to be amazed to take the next steps towards your next project.",
  promotionTitle: r,
  promotionDescription: n,
  actionButtonText: i = "Call Us",
  phoneNumber: s
}) => /* @__PURE__ */ d("div", { "data-testid": "cta", id: "cta", className: "bg-neutral-400", children: /* @__PURE__ */ I("div", { className: "flex-col  flex items-center gap-6 md:gap-8 xl:gap-10 py-14 md:py-16 xl:py-20 2xl:max-w-8xl 2xl:mx-auto px-5 md:px-10 xl:px-[100px]", children: [
  /* @__PURE__ */ I("div", { className: "w-full max-w-4xl flex-col flex items-center gap-3 xl:gap-5 text-6xl text-center text-white", children: [
    /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1 text-center", children: /* @__PURE__ */ d(I6, { text: r ?? t, className: "text-primary-300", position: 1 }) }),
    /* @__PURE__ */ d("svg", { width: "100", height: "3", viewBox: "0 0 100 3", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { x1: "100", y1: "1.5", y2: "1.5", stroke: "#B8FF51", strokeWidth: "3" }) })
  ] }),
  /* @__PURE__ */ d("span", { className: "text-heading6 md:text-heading5 xl:text-heading4 font-medium font-lato text-center text-white", children: n ?? e }),
  /* @__PURE__ */ d("div", { className: "w-full flex-col flex items-center gap-5", children: /* @__PURE__ */ d(
    "a",
    {
      href: `tel:${ur(s)}`,
      className: "flex uppercase text-button justify-center border transition-all border-neutral-400 active:bg-white hover:bg-neutral-100 items-center gap-2.5 px-4 py-2 h-fit   font-medium  bg-primary-300 text-neutral-400",
      children: i
    }
  ) })
] }) });
var m7 = Object.defineProperty, C7 = (t, e, r) => e in t ? m7(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Di = (t, e, r) => (C7(t, typeof e != "symbol" ? e + "" : e, r), r);
let g7 = class {
  constructor() {
    Di(this, "current", this.detect()), Di(this, "handoffState", "pending"), Di(this, "currentId", 0);
  }
  set(e) {
    this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, $t = new g7(), ut = (t, e) => {
  $t.isServer ? K(t, e) : Ln(t, e);
};
function ct(t) {
  let e = X(t);
  return ut(() => {
    e.current = t;
  }, [t]), e;
}
let oe = function(t) {
  let e = ct(t);
  return W.useCallback((...r) => e.current(...r), [e]);
};
function za(t) {
  typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function Fn() {
  let t = [], e = { addEventListener(r, n, i, s) {
    return r.addEventListener(n, i, s), e.add(() => r.removeEventListener(n, i, s));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return e.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return e.requestAnimationFrame(() => e.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return e.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return za(() => {
      n.current && r[0]();
    }), e.add(() => {
      n.current = !1;
    });
  }, style(r, n, i) {
    let s = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: i }), this.add(() => {
      Object.assign(r.style, { [n]: s });
    });
  }, group(r) {
    let n = Fn();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return t.push(r), () => {
      let n = t.indexOf(r);
      if (n >= 0)
        for (let i of t.splice(n, 1))
          i();
    };
  }, dispose() {
    for (let r of t.splice(0))
      r();
  } };
  return e;
}
function Ba() {
  let [t] = ae(Fn);
  return K(() => () => t.dispose(), [t]), t;
}
function v7() {
  let t = typeof document > "u";
  return "useSyncExternalStore" in At ? ((e) => e.useSyncExternalStore)(At)(() => () => {
  }, () => !1, () => !t) : !1;
}
function xi() {
  let t = v7(), [e, r] = At.useState($t.isHandoffComplete);
  return e && $t.isHandoffComplete === !1 && r(!1), At.useEffect(() => {
    e !== !0 && r(!0);
  }, [e]), At.useEffect(() => $t.handoff(), []), t ? !1 : e;
}
var F1;
let Ut = (F1 = W.useId) != null ? F1 : function() {
  let t = xi(), [e, r] = W.useState(t ? () => $t.nextId() : null);
  return ut(() => {
    e === null && r($t.nextId());
  }, [e]), e != null ? "" + e : void 0;
};
function _e(t, e, ...r) {
  if (t in e) {
    let i = e[t];
    return typeof i == "function" ? i(...r) : i;
  }
  let n = new Error(`Tried to handle "${t}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, _e), n;
}
function wi(t) {
  return $t.isServer ? null : t instanceof Node ? t.ownerDocument : t != null && t.hasOwnProperty("current") && t.current instanceof Node ? t.current.ownerDocument : document;
}
let ls = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((t) => `${t}:not([tabindex='-1'])`).join(",");
var Lt = ((t) => (t[t.First = 1] = "First", t[t.Previous = 2] = "Previous", t[t.Next = 4] = "Next", t[t.Last = 8] = "Last", t[t.WrapAround = 16] = "WrapAround", t[t.NoScroll = 32] = "NoScroll", t))(Lt || {}), Zn = ((t) => (t[t.Error = 0] = "Error", t[t.Overflow = 1] = "Overflow", t[t.Success = 2] = "Success", t[t.Underflow = 3] = "Underflow", t))(Zn || {}), y7 = ((t) => (t[t.Previous = -1] = "Previous", t[t.Next = 1] = "Next", t))(y7 || {});
function bi(t = document.body) {
  return t == null ? [] : Array.from(t.querySelectorAll(ls)).sort((e, r) => Math.sign((e.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Gs = ((t) => (t[t.Strict = 0] = "Strict", t[t.Loose = 1] = "Loose", t))(Gs || {});
function Wa(t, e = 0) {
  var r;
  return t === ((r = wi(t)) == null ? void 0 : r.body) ? !1 : _e(e, { [0]() {
    return t.matches(ls);
  }, [1]() {
    let n = t;
    for (; n !== null; ) {
      if (n.matches(ls))
        return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
var x7 = ((t) => (t[t.Keyboard = 0] = "Keyboard", t[t.Mouse = 1] = "Mouse", t))(x7 || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (t) => {
  t.metaKey || t.altKey || t.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (t) => {
  t.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : t.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
let w7 = ["textarea", "input"].join(",");
function b7(t) {
  var e, r;
  return (r = (e = t == null ? void 0 : t.matches) == null ? void 0 : e.call(t, w7)) != null ? r : !1;
}
function _7(t, e = (r) => r) {
  return t.slice().sort((r, n) => {
    let i = e(r), s = e(n);
    if (i === null || s === null)
      return 0;
    let o = i.compareDocumentPosition(s);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function cr(t, e, { sorted: r = !0, relativeTo: n = null, skipElements: i = [] } = {}) {
  let s = Array.isArray(t) ? t.length > 0 ? t[0].ownerDocument : document : t.ownerDocument, o = Array.isArray(t) ? r ? _7(t) : t : bi(t);
  i.length > 0 && o.length > 1 && (o = o.filter((w) => !i.includes(w))), n = n ?? s.activeElement;
  let l = (() => {
    if (e & 5)
      return 1;
    if (e & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (e & 1)
      return 0;
    if (e & 2)
      return Math.max(0, o.indexOf(n)) - 1;
    if (e & 4)
      return Math.max(0, o.indexOf(n)) + 1;
    if (e & 8)
      return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = e & 32 ? { preventScroll: !0 } : {}, f = 0, C = o.length, v;
  do {
    if (f >= C || f + C <= 0)
      return 0;
    let w = c + f;
    if (e & 16)
      w = (w + C) % C;
    else {
      if (w < 0)
        return 3;
      if (w >= C)
        return 1;
    }
    v = o[w], v == null || v.focus(u), f += l;
  } while (v !== s.activeElement);
  return e & 6 && b7(v) && v.select(), 2;
}
function S7() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function E7() {
  return /Android/gi.test(window.navigator.userAgent);
}
function T7() {
  return S7() || E7();
}
function In(t, e, r) {
  let n = ct(e);
  K(() => {
    function i(s) {
      n.current(s);
    }
    return document.addEventListener(t, i, r), () => document.removeEventListener(t, i, r);
  }, [t, r]);
}
function Ha(t, e, r) {
  let n = ct(e);
  K(() => {
    function i(s) {
      n.current(s);
    }
    return window.addEventListener(t, i, r), () => window.removeEventListener(t, i, r);
  }, [t, r]);
}
function k7(t, e, r = !0) {
  let n = X(!1);
  K(() => {
    requestAnimationFrame(() => {
      n.current = r;
    });
  }, [r]);
  function i(o, l) {
    if (!n.current || o.defaultPrevented)
      return;
    let c = l(o);
    if (c === null || !c.getRootNode().contains(c) || !c.isConnected)
      return;
    let u = function f(C) {
      return typeof C == "function" ? f(C()) : Array.isArray(C) || C instanceof Set ? C : [C];
    }(t);
    for (let f of u) {
      if (f === null)
        continue;
      let C = f instanceof HTMLElement ? f : f.current;
      if (C != null && C.contains(c) || o.composed && o.composedPath().includes(C))
        return;
    }
    return !Wa(c, Gs.Loose) && c.tabIndex !== -1 && o.preventDefault(), e(o, c);
  }
  let s = X(null);
  In("pointerdown", (o) => {
    var l, c;
    n.current && (s.current = ((c = (l = o.composedPath) == null ? void 0 : l.call(o)) == null ? void 0 : c[0]) || o.target);
  }, !0), In("mousedown", (o) => {
    var l, c;
    n.current && (s.current = ((c = (l = o.composedPath) == null ? void 0 : l.call(o)) == null ? void 0 : c[0]) || o.target);
  }, !0), In("click", (o) => {
    T7() || s.current && (i(o, () => s.current), s.current = null);
  }, !0), In("touchend", (o) => i(o, () => o.target instanceof HTMLElement ? o.target : null), !0), Ha("blur", (o) => i(o, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Nr(...t) {
  return ve(() => wi(...t), [...t]);
}
function R1(t) {
  var e;
  if (t.type)
    return t.type;
  let r = (e = t.as) != null ? e : "button";
  if (typeof r == "string" && r.toLowerCase() === "button")
    return "button";
}
function Ga(t, e) {
  let [r, n] = ae(() => R1(t));
  return ut(() => {
    n(R1(t));
  }, [t.type, t.as]), ut(() => {
    r || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && n("button");
  }, [r, e]), r;
}
let qa = Symbol();
function qs(t, e = !0) {
  return Object.assign(t, { [qa]: e });
}
function qe(...t) {
  let e = X(t);
  K(() => {
    e.current = t;
  }, [t]);
  let r = oe((n) => {
    for (let i of e.current)
      i != null && (typeof i == "function" ? i(n) : i.current = n);
  });
  return t.every((n) => n == null || (n == null ? void 0 : n[qa])) ? void 0 : r;
}
function Kn(...t) {
  return Array.from(new Set(t.flatMap((e) => typeof e == "string" ? e.split(" ") : []))).filter(Boolean).join(" ");
}
var Qt = ((t) => (t[t.None = 0] = "None", t[t.RenderStrategy = 1] = "RenderStrategy", t[t.Static = 2] = "Static", t))(Qt || {}), Wt = ((t) => (t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden", t))(Wt || {});
function Ue({ ourProps: t, theirProps: e, slot: r, defaultTag: n, features: i, visible: s = !0, name: o, mergeRefs: l }) {
  l = l ?? M7;
  let c = Ua(e, t);
  if (s)
    return Dn(c, r, n, o, l);
  let u = i ?? 0;
  if (u & 2) {
    let { static: f = !1, ...C } = c;
    if (f)
      return Dn(C, r, n, o, l);
  }
  if (u & 1) {
    let { unmount: f = !0, ...C } = c;
    return _e(f ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return Dn({ ...C, hidden: !0, style: { display: "none" } }, r, n, o, l);
    } });
  }
  return Dn(c, r, n, o, l);
}
function Dn(t, e = {}, r, n, i) {
  let { as: s = r, children: o, refName: l = "ref", ...c } = Vi(t, ["unmount", "static"]), u = t.ref !== void 0 ? { [l]: t.ref } : {}, f = typeof o == "function" ? o(e) : o;
  "className" in c && c.className && typeof c.className == "function" && (c.className = c.className(e));
  let C = {};
  if (e) {
    let v = !1, w = [];
    for (let [g, b] of Object.entries(e))
      typeof b == "boolean" && (v = !0), b === !0 && w.push(g);
    v && (C["data-headlessui-state"] = w.join(" "));
  }
  if (s === lt && Object.keys(I1(c)).length > 0) {
    if (!yl(f) || Array.isArray(f) && f.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(c).map((b) => `  - ${b}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((b) => `  - ${b}`).join(`
`)].join(`
`));
    let v = f.props, w = typeof (v == null ? void 0 : v.className) == "function" ? (...b) => Kn(v == null ? void 0 : v.className(...b), c.className) : Kn(v == null ? void 0 : v.className, c.className), g = w ? { className: w } : {};
    return xl(f, Object.assign({}, Ua(f.props, I1(Vi(c, ["ref"]))), C, u, { ref: i(f.ref, u.ref) }, g));
  }
  return wl(s, Object.assign({}, Vi(c, ["ref"]), s !== lt && u, s !== lt && C), f);
}
function Us() {
  let t = X([]), e = ar((r) => {
    for (let n of t.current)
      n != null && (typeof n == "function" ? n(r) : n.current = r);
  }, []);
  return (...r) => {
    if (!r.every((n) => n == null))
      return t.current = r, e;
  };
}
function M7(...t) {
  return t.every((e) => e == null) ? void 0 : (e) => {
    for (let r of t)
      r != null && (typeof r == "function" ? r(e) : r.current = e);
  };
}
function Ua(...t) {
  if (t.length === 0)
    return {};
  if (t.length === 1)
    return t[0];
  let e = {}, r = {};
  for (let n of t)
    for (let i in n)
      i.startsWith("on") && typeof n[i] == "function" ? (r[i] != null || (r[i] = []), r[i].push(n[i])) : e[i] = n[i];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r)
    Object.assign(e, { [n](i, ...s) {
      let o = r[n];
      for (let l of o) {
        if ((i instanceof Event || (i == null ? void 0 : i.nativeEvent) instanceof Event) && i.defaultPrevented)
          return;
        l(i, ...s);
      }
    } });
  return e;
}
function Ve(t) {
  var e;
  return Object.assign(Lr(t), { displayName: (e = t.displayName) != null ? e : t.name });
}
function I1(t) {
  let e = Object.assign({}, t);
  for (let r in e)
    e[r] === void 0 && delete e[r];
  return e;
}
function Vi(t, e = []) {
  let r = Object.assign({}, t);
  for (let n of e)
    n in r && delete r[n];
  return r;
}
let O7 = "div";
var Or = ((t) => (t[t.None = 1] = "None", t[t.Focusable = 2] = "Focusable", t[t.Hidden = 4] = "Hidden", t))(Or || {});
function L7(t, e) {
  var r;
  let { features: n = 1, ...i } = t, s = { ref: e, "aria-hidden": (n & 2) === 2 ? !0 : (r = i["aria-hidden"]) != null ? r : void 0, hidden: (n & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
  return Ue({ ourProps: s, theirProps: i, slot: {}, defaultTag: O7, name: "Hidden" });
}
let Mn = Ve(L7), Qs = Re(null);
Qs.displayName = "OpenClosedContext";
var Te = ((t) => (t[t.Open = 1] = "Open", t[t.Closed = 2] = "Closed", t[t.Closing = 4] = "Closing", t[t.Opening = 8] = "Opening", t))(Te || {});
function Rn() {
  return Se(Qs);
}
function Ys({ value: t, children: e }) {
  return W.createElement(Qs.Provider, { value: t }, e);
}
function Js(t) {
  let e = t.parentElement, r = null;
  for (; e && !(e instanceof HTMLFieldSetElement); )
    e instanceof HTMLLegendElement && (r = e), e = e.parentElement;
  let n = (e == null ? void 0 : e.getAttribute("disabled")) === "";
  return n && P7(r) ? !1 : n;
}
function P7(t) {
  if (!t)
    return !1;
  let e = t.previousElementSibling;
  for (; e !== null; ) {
    if (e instanceof HTMLLegendElement)
      return !1;
    e = e.previousElementSibling;
  }
  return !0;
}
var He = ((t) => (t.Space = " ", t.Enter = "Enter", t.Escape = "Escape", t.Backspace = "Backspace", t.Delete = "Delete", t.ArrowLeft = "ArrowLeft", t.ArrowUp = "ArrowUp", t.ArrowRight = "ArrowRight", t.ArrowDown = "ArrowDown", t.Home = "Home", t.End = "End", t.PageUp = "PageUp", t.PageDown = "PageDown", t.Tab = "Tab", t))(He || {});
function A7(t, e, r, n) {
  let i = ct(r);
  K(() => {
    t = t ?? window;
    function s(o) {
      i.current(o);
    }
    return t.addEventListener(e, s, n), () => t.removeEventListener(e, s, n);
  }, [t, e, n]);
}
function Zs() {
  let t = X(!1);
  return ut(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
function N7(t) {
  let e = oe(t), r = X(!1);
  K(() => (r.current = !1, () => {
    r.current = !0, za(() => {
      r.current && e();
    });
  }), [e]);
}
var Pt = ((t) => (t[t.Forwards = 0] = "Forwards", t[t.Backwards = 1] = "Backwards", t))(Pt || {});
function Qa() {
  let t = X(0);
  return Ha("keydown", (e) => {
    e.key === "Tab" && (t.current = e.shiftKey ? 1 : 0);
  }, !0), t;
}
let $7 = Re(!1);
function j7() {
  return Se($7);
}
function F7(t) {
  let e = j7(), r = Se(Ya), n = Nr(t), [i, s] = ae(() => {
    if (!e && r !== null || $t.isServer)
      return null;
    let o = n == null ? void 0 : n.getElementById("headlessui-portal-root");
    if (o)
      return o;
    if (n === null)
      return null;
    let l = n.createElement("div");
    return l.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(l);
  });
  return K(() => {
    i !== null && (n != null && n.body.contains(i) || n == null || n.body.appendChild(i));
  }, [i, n]), K(() => {
    e || r !== null && s(r.current);
  }, [r, s, e]), i;
}
let R7 = lt;
function I7(t, e) {
  let r = t, n = X(null), i = qe(qs((f) => {
    n.current = f;
  }), e), s = Nr(n), o = F7(n), [l] = ae(() => {
    var f;
    return $t.isServer ? null : (f = s == null ? void 0 : s.createElement("div")) != null ? f : null;
  }), c = Se(cs), u = xi();
  return ut(() => {
    !o || !l || o.contains(l) || (l.setAttribute("data-headlessui-portal", ""), o.appendChild(l));
  }, [o, l]), ut(() => {
    if (l && c)
      return c.register(l);
  }, [c, l]), N7(() => {
    var f;
    !o || !l || (l instanceof Node && o.contains(l) && o.removeChild(l), o.childNodes.length <= 0 && ((f = o.parentElement) == null || f.removeChild(o)));
  }), u ? !o || !l ? null : Q1(Ue({ ourProps: { ref: i }, theirProps: r, defaultTag: R7, name: "Portal" }), l) : null;
}
let D7 = lt, Ya = Re(null);
function V7(t, e) {
  let { target: r, ...n } = t, i = { ref: qe(e) };
  return W.createElement(Ya.Provider, { value: r }, Ue({ ourProps: i, theirProps: n, defaultTag: D7, name: "Popover.Group" }));
}
let cs = Re(null);
function z7() {
  let t = Se(cs), e = X([]), r = oe((s) => (e.current.push(s), t && t.register(s), () => n(s))), n = oe((s) => {
    let o = e.current.indexOf(s);
    o !== -1 && e.current.splice(o, 1), t && t.unregister(s);
  }), i = ve(() => ({ register: r, unregister: n, portals: e }), [r, n, e]);
  return [e, ve(() => function({ children: s }) {
    return W.createElement(cs.Provider, { value: i }, s);
  }, [i])];
}
let B7 = Ve(I7), W7 = Ve(V7);
Object.assign(B7, { Group: W7 });
function H7({ defaultContainers: t = [], portals: e, mainTreeNodeRef: r } = {}) {
  var n;
  let i = X((n = r == null ? void 0 : r.current) != null ? n : null), s = Nr(i), o = oe(() => {
    var l, c, u;
    let f = [];
    for (let C of t)
      C !== null && (C instanceof HTMLElement ? f.push(C) : "current" in C && C.current instanceof HTMLElement && f.push(C.current));
    if (e != null && e.current)
      for (let C of e.current)
        f.push(C);
    for (let C of (l = s == null ? void 0 : s.querySelectorAll("html > *, body > *")) != null ? l : [])
      C !== document.body && C !== document.head && C instanceof HTMLElement && C.id !== "headlessui-portal-root" && (C.contains(i.current) || C.contains((u = (c = i.current) == null ? void 0 : c.getRootNode()) == null ? void 0 : u.host) || f.some((v) => C.contains(v)) || f.push(C));
    return f;
  });
  return { resolveContainers: o, contains: oe((l) => o().some((c) => c.contains(l))), mainTreeNodeRef: i, MainTreeNode: ve(() => function() {
    return r != null ? null : W.createElement(Mn, { features: Or.Hidden, ref: i });
  }, [i, r]) };
}
function G7() {
  let t = X(null);
  return { mainTreeNodeRef: t, MainTreeNode: ve(() => function() {
    return W.createElement(Mn, { features: Or.Hidden, ref: t });
  }, [t]) };
}
var D1;
let q7 = (D1 = W.startTransition) != null ? D1 : function(t) {
  t();
};
var U7 = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(U7 || {}), Q7 = ((t) => (t[t.ToggleDisclosure = 0] = "ToggleDisclosure", t[t.CloseDisclosure = 1] = "CloseDisclosure", t[t.SetButtonId = 2] = "SetButtonId", t[t.SetPanelId = 3] = "SetPanelId", t[t.LinkPanel = 4] = "LinkPanel", t[t.UnlinkPanel = 5] = "UnlinkPanel", t))(Q7 || {});
let Y7 = { [0]: (t) => ({ ...t, disclosureState: _e(t.disclosureState, { [0]: 1, [1]: 0 }) }), [1]: (t) => t.disclosureState === 1 ? t : { ...t, disclosureState: 1 }, [4](t) {
  return t.linkedPanel === !0 ? t : { ...t, linkedPanel: !0 };
}, [5](t) {
  return t.linkedPanel === !1 ? t : { ...t, linkedPanel: !1 };
}, [2](t, e) {
  return t.buttonId === e.buttonId ? t : { ...t, buttonId: e.buttonId };
}, [3](t, e) {
  return t.panelId === e.panelId ? t : { ...t, panelId: e.panelId };
} }, Ks = Re(null);
Ks.displayName = "DisclosureContext";
function Xs(t) {
  let e = Se(Ks);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Xs), r;
  }
  return e;
}
let e1 = Re(null);
e1.displayName = "DisclosureAPIContext";
function Ja(t) {
  let e = Se(e1);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ja), r;
  }
  return e;
}
let t1 = Re(null);
t1.displayName = "DisclosurePanelContext";
function J7() {
  return Se(t1);
}
function Z7(t, e) {
  return _e(e.type, Y7, t, e);
}
let K7 = lt;
function X7(t, e) {
  let { defaultOpen: r = !1, ...n } = t, i = X(null), s = qe(e, qs((_) => {
    i.current = _;
  }, t.as === void 0 || t.as === lt)), o = X(null), l = X(null), c = ni(Z7, { disclosureState: r ? 0 : 1, linkedPanel: !1, buttonRef: l, panelRef: o, buttonId: null, panelId: null }), [{ disclosureState: u, buttonId: f }, C] = c, v = oe((_) => {
    C({ type: 1 });
    let h = wi(i);
    if (!h || !f)
      return;
    let y = (() => _ ? _ instanceof HTMLElement ? _ : _.current instanceof HTMLElement ? _.current : h.getElementById(f) : h.getElementById(f))();
    y == null || y.focus();
  }), w = ve(() => ({ close: v }), [v]), g = ve(() => ({ open: u === 0, close: v }), [u, v]), b = { ref: s };
  return W.createElement(Ks.Provider, { value: c }, W.createElement(e1.Provider, { value: w }, W.createElement(Ys, { value: _e(u, { [0]: Te.Open, [1]: Te.Closed }) }, Ue({ ourProps: b, theirProps: n, slot: g, defaultTag: K7, name: "Disclosure" }))));
}
let e0 = "button";
function t0(t, e) {
  let r = Ut(), { id: n = `headlessui-disclosure-button-${r}`, ...i } = t, [s, o] = Xs("Disclosure.Button"), l = J7(), c = l === null ? !1 : l === s.panelId, u = X(null), f = qe(u, e, c ? null : s.buttonRef), C = Us();
  K(() => {
    if (!c)
      return o({ type: 2, buttonId: n }), () => {
        o({ type: 2, buttonId: null });
      };
  }, [n, o, c]);
  let v = oe((y) => {
    var E;
    if (c) {
      if (s.disclosureState === 1)
        return;
      switch (y.key) {
        case He.Space:
        case He.Enter:
          y.preventDefault(), y.stopPropagation(), o({ type: 0 }), (E = s.buttonRef.current) == null || E.focus();
          break;
      }
    } else
      switch (y.key) {
        case He.Space:
        case He.Enter:
          y.preventDefault(), y.stopPropagation(), o({ type: 0 });
          break;
      }
  }), w = oe((y) => {
    switch (y.key) {
      case He.Space:
        y.preventDefault();
        break;
    }
  }), g = oe((y) => {
    var E;
    Js(y.currentTarget) || t.disabled || (c ? (o({ type: 0 }), (E = s.buttonRef.current) == null || E.focus()) : o({ type: 0 }));
  }), b = ve(() => ({ open: s.disclosureState === 0 }), [s]), _ = Ga(t, u), h = c ? { ref: f, type: _, onKeyDown: v, onClick: g } : { ref: f, id: n, type: _, "aria-expanded": s.disclosureState === 0, "aria-controls": s.linkedPanel ? s.panelId : void 0, onKeyDown: v, onKeyUp: w, onClick: g };
  return Ue({ mergeRefs: C, ourProps: h, theirProps: i, slot: b, defaultTag: e0, name: "Disclosure.Button" });
}
let r0 = "div", n0 = Qt.RenderStrategy | Qt.Static;
function i0(t, e) {
  let r = Ut(), { id: n = `headlessui-disclosure-panel-${r}`, ...i } = t, [s, o] = Xs("Disclosure.Panel"), { close: l } = Ja("Disclosure.Panel"), c = Us(), u = qe(e, s.panelRef, (g) => {
    q7(() => o({ type: g ? 4 : 5 }));
  });
  K(() => (o({ type: 3, panelId: n }), () => {
    o({ type: 3, panelId: null });
  }), [n, o]);
  let f = Rn(), C = (() => f !== null ? (f & Te.Open) === Te.Open : s.disclosureState === 0)(), v = ve(() => ({ open: s.disclosureState === 0, close: l }), [s, l]), w = { ref: u, id: n };
  return W.createElement(t1.Provider, { value: s.panelId }, Ue({ mergeRefs: c, ourProps: w, theirProps: i, slot: v, defaultTag: r0, features: n0, visible: C, name: "Disclosure.Panel" }));
}
let s0 = Ve(X7), o0 = Ve(t0), a0 = Ve(i0), bn = Object.assign(s0, { Button: o0, Panel: a0 });
var l0 = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(l0 || {}), c0 = ((t) => (t[t.TogglePopover = 0] = "TogglePopover", t[t.ClosePopover = 1] = "ClosePopover", t[t.SetButton = 2] = "SetButton", t[t.SetButtonId = 3] = "SetButtonId", t[t.SetPanel = 4] = "SetPanel", t[t.SetPanelId = 5] = "SetPanelId", t))(c0 || {});
let u0 = { [0]: (t) => {
  let e = { ...t, popoverState: _e(t.popoverState, { [0]: 1, [1]: 0 }) };
  return e.popoverState === 0 && (e.__demoMode = !1), e;
}, [1](t) {
  return t.popoverState === 1 ? t : { ...t, popoverState: 1 };
}, [2](t, e) {
  return t.button === e.button ? t : { ...t, button: e.button };
}, [3](t, e) {
  return t.buttonId === e.buttonId ? t : { ...t, buttonId: e.buttonId };
}, [4](t, e) {
  return t.panel === e.panel ? t : { ...t, panel: e.panel };
}, [5](t, e) {
  return t.panelId === e.panelId ? t : { ...t, panelId: e.panelId };
} }, r1 = Re(null);
r1.displayName = "PopoverContext";
function _i(t) {
  let e = Se(r1);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, _i), r;
  }
  return e;
}
let n1 = Re(null);
n1.displayName = "PopoverAPIContext";
function i1(t) {
  let e = Se(n1);
  if (e === null) {
    let r = new Error(`<${t} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, i1), r;
  }
  return e;
}
let s1 = Re(null);
s1.displayName = "PopoverGroupContext";
function Za() {
  return Se(s1);
}
let Si = Re(null);
Si.displayName = "PopoverPanelContext";
function d0() {
  return Se(Si);
}
function f0(t, e) {
  return _e(e.type, u0, t, e);
}
let p0 = "div";
function h0(t, e) {
  var r;
  let { __demoMode: n = !1, ...i } = t, s = X(null), o = qe(e, qs((Y) => {
    s.current = Y;
  })), l = X([]), c = ni(f0, { __demoMode: n, popoverState: n ? 0 : 1, buttons: l, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: l1(), afterPanelSentinel: l1() }), [{ popoverState: u, button: f, buttonId: C, panel: v, panelId: w, beforePanelSentinel: g, afterPanelSentinel: b }, _] = c, h = Nr((r = s.current) != null ? r : f), y = ve(() => {
    if (!f || !v)
      return !1;
    for (let V of document.querySelectorAll("body > *"))
      if (Number(V == null ? void 0 : V.contains(f)) ^ Number(V == null ? void 0 : V.contains(v)))
        return !0;
    let Y = bi(), ie = Y.indexOf(f), F = (ie + Y.length - 1) % Y.length, O = (ie + 1) % Y.length, k = Y[F], U = Y[O];
    return !v.contains(k) && !v.contains(U);
  }, [f, v]), E = ct(C), T = ct(w), $ = ve(() => ({ buttonId: E, panelId: T, close: () => _({ type: 1 }) }), [E, T, _]), L = Za(), z = L == null ? void 0 : L.registerPopover, P = oe(() => {
    var Y;
    return (Y = L == null ? void 0 : L.isFocusWithinPopoverGroup()) != null ? Y : (h == null ? void 0 : h.activeElement) && ((f == null ? void 0 : f.contains(h.activeElement)) || (v == null ? void 0 : v.contains(h.activeElement)));
  });
  K(() => z == null ? void 0 : z($), [z, $]);
  let [B, q] = z7(), N = H7({ mainTreeNodeRef: L == null ? void 0 : L.mainTreeNodeRef, portals: B, defaultContainers: [f, v] });
  A7(h == null ? void 0 : h.defaultView, "focus", (Y) => {
    var ie, F, O, k;
    Y.target !== window && Y.target instanceof HTMLElement && u === 0 && (P() || f && v && (N.contains(Y.target) || (F = (ie = g.current) == null ? void 0 : ie.contains) != null && F.call(ie, Y.target) || (k = (O = b.current) == null ? void 0 : O.contains) != null && k.call(O, Y.target) || _({ type: 1 })));
  }, !0), k7(N.resolveContainers, (Y, ie) => {
    _({ type: 1 }), Wa(ie, Gs.Loose) || (Y.preventDefault(), f == null || f.focus());
  }, u === 0);
  let R = oe((Y) => {
    _({ type: 1 });
    let ie = (() => Y ? Y instanceof HTMLElement ? Y : "current" in Y && Y.current instanceof HTMLElement ? Y.current : f : f)();
    ie == null || ie.focus();
  }), D = ve(() => ({ close: R, isPortalled: y }), [R, y]), Q = ve(() => ({ open: u === 0, close: R }), [u, R]), se = { ref: o };
  return W.createElement(Si.Provider, { value: null }, W.createElement(r1.Provider, { value: c }, W.createElement(n1.Provider, { value: D }, W.createElement(Ys, { value: _e(u, { [0]: Te.Open, [1]: Te.Closed }) }, W.createElement(q, null, Ue({ ourProps: se, theirProps: i, slot: Q, defaultTag: p0, name: "Popover" }), W.createElement(N.MainTreeNode, null))))));
}
let m0 = "button";
function C0(t, e) {
  let r = Ut(), { id: n = `headlessui-popover-button-${r}`, ...i } = t, [s, o] = _i("Popover.Button"), { isPortalled: l } = i1("Popover.Button"), c = X(null), u = `headlessui-focus-sentinel-${Ut()}`, f = Za(), C = f == null ? void 0 : f.closeOthers, v = d0() !== null;
  K(() => {
    if (!v)
      return o({ type: 3, buttonId: n }), () => {
        o({ type: 3, buttonId: null });
      };
  }, [v, n, o]);
  let [w] = ae(() => Symbol()), g = qe(c, e, v ? null : (N) => {
    if (N)
      s.buttons.current.push(w);
    else {
      let R = s.buttons.current.indexOf(w);
      R !== -1 && s.buttons.current.splice(R, 1);
    }
    s.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), N && o({ type: 2, button: N });
  }), b = qe(c, e), _ = Nr(c), h = oe((N) => {
    var R, D, Q;
    if (v) {
      if (s.popoverState === 1)
        return;
      switch (N.key) {
        case He.Space:
        case He.Enter:
          N.preventDefault(), (D = (R = N.target).click) == null || D.call(R), o({ type: 1 }), (Q = s.button) == null || Q.focus();
          break;
      }
    } else
      switch (N.key) {
        case He.Space:
        case He.Enter:
          N.preventDefault(), N.stopPropagation(), s.popoverState === 1 && (C == null || C(s.buttonId)), o({ type: 0 });
          break;
        case He.Escape:
          if (s.popoverState !== 0)
            return C == null ? void 0 : C(s.buttonId);
          if (!c.current || _ != null && _.activeElement && !c.current.contains(_.activeElement))
            return;
          N.preventDefault(), N.stopPropagation(), o({ type: 1 });
          break;
      }
  }), y = oe((N) => {
    v || N.key === He.Space && N.preventDefault();
  }), E = oe((N) => {
    var R, D;
    Js(N.currentTarget) || t.disabled || (v ? (o({ type: 1 }), (R = s.button) == null || R.focus()) : (N.preventDefault(), N.stopPropagation(), s.popoverState === 1 && (C == null || C(s.buttonId)), o({ type: 0 }), (D = s.button) == null || D.focus()));
  }), T = oe((N) => {
    N.preventDefault(), N.stopPropagation();
  }), $ = s.popoverState === 0, L = ve(() => ({ open: $ }), [$]), z = Ga(t, c), P = v ? { ref: b, type: z, onKeyDown: h, onClick: E } : { ref: g, id: s.buttonId, type: z, "aria-expanded": s.popoverState === 0, "aria-controls": s.panel ? s.panelId : void 0, onKeyDown: h, onKeyUp: y, onClick: E, onMouseDown: T }, B = Qa(), q = oe(() => {
    let N = s.panel;
    if (!N)
      return;
    function R() {
      _e(B.current, { [Pt.Forwards]: () => cr(N, Lt.First), [Pt.Backwards]: () => cr(N, Lt.Last) }) === Zn.Error && cr(bi().filter((D) => D.dataset.headlessuiFocusGuard !== "true"), _e(B.current, { [Pt.Forwards]: Lt.Next, [Pt.Backwards]: Lt.Previous }), { relativeTo: s.button });
    }
    R();
  });
  return W.createElement(W.Fragment, null, Ue({ ourProps: P, theirProps: i, slot: L, defaultTag: m0, name: "Popover.Button" }), $ && !v && l && W.createElement(Mn, { id: u, features: Or.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: q }));
}
let g0 = "div", v0 = Qt.RenderStrategy | Qt.Static;
function y0(t, e) {
  let r = Ut(), { id: n = `headlessui-popover-overlay-${r}`, ...i } = t, [{ popoverState: s }, o] = _i("Popover.Overlay"), l = qe(e), c = Rn(), u = (() => c !== null ? (c & Te.Open) === Te.Open : s === 0)(), f = oe((v) => {
    if (Js(v.currentTarget))
      return v.preventDefault();
    o({ type: 1 });
  }), C = ve(() => ({ open: s === 0 }), [s]);
  return Ue({ ourProps: { ref: l, id: n, "aria-hidden": !0, onClick: f }, theirProps: i, slot: C, defaultTag: g0, features: v0, visible: u, name: "Popover.Overlay" });
}
let x0 = "div", w0 = Qt.RenderStrategy | Qt.Static;
function b0(t, e) {
  let r = Ut(), { id: n = `headlessui-popover-panel-${r}`, focus: i = !1, ...s } = t, [o, l] = _i("Popover.Panel"), { close: c, isPortalled: u } = i1("Popover.Panel"), f = `headlessui-focus-sentinel-before-${Ut()}`, C = `headlessui-focus-sentinel-after-${Ut()}`, v = X(null), w = qe(v, e, (P) => {
    l({ type: 4, panel: P });
  }), g = Nr(v), b = Us();
  ut(() => (l({ type: 5, panelId: n }), () => {
    l({ type: 5, panelId: null });
  }), [n, l]);
  let _ = Rn(), h = (() => _ !== null ? (_ & Te.Open) === Te.Open : o.popoverState === 0)(), y = oe((P) => {
    var B;
    switch (P.key) {
      case He.Escape:
        if (o.popoverState !== 0 || !v.current || g != null && g.activeElement && !v.current.contains(g.activeElement))
          return;
        P.preventDefault(), P.stopPropagation(), l({ type: 1 }), (B = o.button) == null || B.focus();
        break;
    }
  });
  K(() => {
    var P;
    t.static || o.popoverState === 1 && ((P = t.unmount) == null || P) && l({ type: 4, panel: null });
  }, [o.popoverState, t.unmount, t.static, l]), K(() => {
    if (o.__demoMode || !i || o.popoverState !== 0 || !v.current)
      return;
    let P = g == null ? void 0 : g.activeElement;
    v.current.contains(P) || cr(v.current, Lt.First);
  }, [o.__demoMode, i, v, o.popoverState]);
  let E = ve(() => ({ open: o.popoverState === 0, close: c }), [o, c]), T = { ref: w, id: n, onKeyDown: y, onBlur: i && o.popoverState === 0 ? (P) => {
    var B, q, N, R, D;
    let Q = P.relatedTarget;
    Q && v.current && ((B = v.current) != null && B.contains(Q) || (l({ type: 1 }), ((N = (q = o.beforePanelSentinel.current) == null ? void 0 : q.contains) != null && N.call(q, Q) || (D = (R = o.afterPanelSentinel.current) == null ? void 0 : R.contains) != null && D.call(R, Q)) && Q.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1 }, $ = Qa(), L = oe(() => {
    let P = v.current;
    if (!P)
      return;
    function B() {
      _e($.current, { [Pt.Forwards]: () => {
        var q;
        cr(P, Lt.First) === Zn.Error && ((q = o.afterPanelSentinel.current) == null || q.focus());
      }, [Pt.Backwards]: () => {
        var q;
        (q = o.button) == null || q.focus({ preventScroll: !0 });
      } });
    }
    B();
  }), z = oe(() => {
    let P = v.current;
    if (!P)
      return;
    function B() {
      _e($.current, { [Pt.Forwards]: () => {
        var q;
        if (!o.button)
          return;
        let N = bi(), R = N.indexOf(o.button), D = N.slice(0, R + 1), Q = [...N.slice(R + 1), ...D];
        for (let se of Q.slice())
          if (se.dataset.headlessuiFocusGuard === "true" || (q = o.panel) != null && q.contains(se)) {
            let Y = Q.indexOf(se);
            Y !== -1 && Q.splice(Y, 1);
          }
        cr(Q, Lt.First, { sorted: !1 });
      }, [Pt.Backwards]: () => {
        var q;
        cr(P, Lt.Previous) === Zn.Error && ((q = o.button) == null || q.focus());
      } });
    }
    B();
  });
  return W.createElement(Si.Provider, { value: n }, h && u && W.createElement(Mn, { id: f, ref: o.beforePanelSentinel, features: Or.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: L }), Ue({ mergeRefs: b, ourProps: T, theirProps: s, slot: E, defaultTag: x0, features: w0, visible: h, name: "Popover.Panel" }), h && u && W.createElement(Mn, { id: C, ref: o.afterPanelSentinel, features: Or.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: z }));
}
let _0 = "div";
function S0(t, e) {
  let r = X(null), n = qe(r, e), [i, s] = ae([]), o = G7(), l = oe((b) => {
    s((_) => {
      let h = _.indexOf(b);
      if (h !== -1) {
        let y = _.slice();
        return y.splice(h, 1), y;
      }
      return _;
    });
  }), c = oe((b) => (s((_) => [..._, b]), () => l(b))), u = oe(() => {
    var b;
    let _ = wi(r);
    if (!_)
      return !1;
    let h = _.activeElement;
    return (b = r.current) != null && b.contains(h) ? !0 : i.some((y) => {
      var E, T;
      return ((E = _.getElementById(y.buttonId.current)) == null ? void 0 : E.contains(h)) || ((T = _.getElementById(y.panelId.current)) == null ? void 0 : T.contains(h));
    });
  }), f = oe((b) => {
    for (let _ of i)
      _.buttonId.current !== b && _.close();
  }), C = ve(() => ({ registerPopover: c, unregisterPopover: l, isFocusWithinPopoverGroup: u, closeOthers: f, mainTreeNodeRef: o.mainTreeNodeRef }), [c, l, u, f, o.mainTreeNodeRef]), v = ve(() => ({}), []), w = t, g = { ref: n };
  return W.createElement(s1.Provider, { value: C }, Ue({ ourProps: g, theirProps: w, slot: v, defaultTag: _0, name: "Popover.Group" }), W.createElement(o.MainTreeNode, null));
}
let E0 = Ve(h0), T0 = Ve(C0), k0 = Ve(y0), M0 = Ve(b0), O0 = Ve(S0), xn = Object.assign(E0, { Button: T0, Overlay: k0, Panel: M0, Group: O0 });
function L0(t = 0) {
  let [e, r] = ae(t), n = Zs(), i = ar((c) => {
    n.current && r((u) => u | c);
  }, [e, n]), s = ar((c) => !!(e & c), [e]), o = ar((c) => {
    n.current && r((u) => u & ~c);
  }, [r, n]), l = ar((c) => {
    n.current && r((u) => u ^ c);
  }, [r]);
  return { flags: e, addFlag: i, hasFlag: s, removeFlag: o, toggleFlag: l };
}
function P0(t) {
  let e = { called: !1 };
  return (...r) => {
    if (!e.called)
      return e.called = !0, t(...r);
  };
}
function zi(t, ...e) {
  t && e.length > 0 && t.classList.add(...e);
}
function Bi(t, ...e) {
  t && e.length > 0 && t.classList.remove(...e);
}
function A0(t, e) {
  let r = Fn();
  if (!t)
    return r.dispose;
  let { transitionDuration: n, transitionDelay: i } = getComputedStyle(t), [s, o] = [n, i].map((c) => {
    let [u = 0] = c.split(",").filter(Boolean).map((f) => f.includes("ms") ? parseFloat(f) : parseFloat(f) * 1e3).sort((f, C) => C - f);
    return u;
  }), l = s + o;
  if (l !== 0) {
    r.group((u) => {
      u.setTimeout(() => {
        e(), u.dispose();
      }, l), u.addEventListener(t, "transitionrun", (f) => {
        f.target === f.currentTarget && u.dispose();
      });
    });
    let c = r.addEventListener(t, "transitionend", (u) => {
      u.target === u.currentTarget && (e(), c());
    });
  } else
    e();
  return r.add(() => e()), r.dispose;
}
function N0(t, e, r, n) {
  let i = r ? "enter" : "leave", s = Fn(), o = n !== void 0 ? P0(n) : () => {
  };
  i === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
  let l = _e(i, { enter: () => e.enter, leave: () => e.leave }), c = _e(i, { enter: () => e.enterTo, leave: () => e.leaveTo }), u = _e(i, { enter: () => e.enterFrom, leave: () => e.leaveFrom });
  return Bi(t, ...e.base, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), zi(t, ...e.base, ...l, ...u), s.nextFrame(() => {
    Bi(t, ...e.base, ...l, ...u), zi(t, ...e.base, ...l, ...c), A0(t, () => (Bi(t, ...e.base, ...l), zi(t, ...e.base, ...e.entered), o()));
  }), s.dispose;
}
function $0({ immediate: t, container: e, direction: r, classes: n, onStart: i, onStop: s }) {
  let o = Zs(), l = Ba(), c = ct(r);
  ut(() => {
    t && (c.current = "enter");
  }, [t]), ut(() => {
    let u = Fn();
    l.add(u.dispose);
    let f = e.current;
    if (f && c.current !== "idle" && o.current)
      return u.dispose(), i.current(c.current), u.add(N0(f, n.current, c.current === "enter", () => {
        u.dispose(), s.current(c.current);
      })), u.dispose;
  }, [r]);
}
function Vt(t = "") {
  return t.split(/\s+/).filter((e) => e.length > 1);
}
let Ei = Re(null);
Ei.displayName = "TransitionContext";
var j0 = ((t) => (t.Visible = "visible", t.Hidden = "hidden", t))(j0 || {});
function F0() {
  let t = Se(Ei);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function R0() {
  let t = Se(Ti);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
let Ti = Re(null);
Ti.displayName = "NestingContext";
function ki(t) {
  return "children" in t ? ki(t.children) : t.current.filter(({ el: e }) => e.current !== null).filter(({ state: e }) => e === "visible").length > 0;
}
function Ka(t, e) {
  let r = ct(t), n = X([]), i = Zs(), s = Ba(), o = oe((w, g = Wt.Hidden) => {
    let b = n.current.findIndex(({ el: _ }) => _ === w);
    b !== -1 && (_e(g, { [Wt.Unmount]() {
      n.current.splice(b, 1);
    }, [Wt.Hidden]() {
      n.current[b].state = "hidden";
    } }), s.microTask(() => {
      var _;
      !ki(n) && i.current && ((_ = r.current) == null || _.call(r));
    }));
  }), l = oe((w) => {
    let g = n.current.find(({ el: b }) => b === w);
    return g ? g.state !== "visible" && (g.state = "visible") : n.current.push({ el: w, state: "visible" }), () => o(w, Wt.Unmount);
  }), c = X([]), u = X(Promise.resolve()), f = X({ enter: [], leave: [], idle: [] }), C = oe((w, g, b) => {
    c.current.splice(0), e && (e.chains.current[g] = e.chains.current[g].filter(([_]) => _ !== w)), e == null || e.chains.current[g].push([w, new Promise((_) => {
      c.current.push(_);
    })]), e == null || e.chains.current[g].push([w, new Promise((_) => {
      Promise.all(f.current[g].map(([h, y]) => y)).then(() => _());
    })]), g === "enter" ? u.current = u.current.then(() => e == null ? void 0 : e.wait.current).then(() => b(g)) : b(g);
  }), v = oe((w, g, b) => {
    Promise.all(f.current[g].splice(0).map(([_, h]) => h)).then(() => {
      var _;
      (_ = c.current.shift()) == null || _();
    }).then(() => b(g));
  });
  return ve(() => ({ children: n, register: l, unregister: o, onStart: C, onStop: v, wait: u, chains: f }), [l, o, n, C, v, f, u]);
}
function I0() {
}
let D0 = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function V1(t) {
  var e;
  let r = {};
  for (let n of D0)
    r[n] = (e = t[n]) != null ? e : I0;
  return r;
}
function V0(t) {
  let e = X(V1(t));
  return K(() => {
    e.current = V1(t);
  }, [t]), e;
}
let z0 = "div", Xa = Qt.RenderStrategy;
function B0(t, e) {
  var r, n;
  let { beforeEnter: i, afterEnter: s, beforeLeave: o, afterLeave: l, enter: c, enterFrom: u, enterTo: f, entered: C, leave: v, leaveFrom: w, leaveTo: g, ...b } = t, _ = X(null), h = qe(_, e), y = (r = b.unmount) == null || r ? Wt.Unmount : Wt.Hidden, { show: E, appear: T, initial: $ } = F0(), [L, z] = ae(E ? "visible" : "hidden"), P = R0(), { register: B, unregister: q } = P;
  K(() => B(_), [B, _]), K(() => {
    if (y === Wt.Hidden && _.current) {
      if (E && L !== "visible") {
        z("visible");
        return;
      }
      return _e(L, { hidden: () => q(_), visible: () => B(_) });
    }
  }, [L, _, B, q, E, y]);
  let N = ct({ base: Vt(b.className), enter: Vt(c), enterFrom: Vt(u), enterTo: Vt(f), entered: Vt(C), leave: Vt(v), leaveFrom: Vt(w), leaveTo: Vt(g) }), R = V0({ beforeEnter: i, afterEnter: s, beforeLeave: o, afterLeave: l }), D = xi();
  K(() => {
    if (D && L === "visible" && _.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [_, L, D]);
  let Q = $ && !T, se = T && E && $, Y = (() => !D || Q ? "idle" : E ? "enter" : "leave")(), ie = L0(0), F = oe((le) => _e(le, { enter: () => {
    ie.addFlag(Te.Opening), R.current.beforeEnter();
  }, leave: () => {
    ie.addFlag(Te.Closing), R.current.beforeLeave();
  }, idle: () => {
  } })), O = oe((le) => _e(le, { enter: () => {
    ie.removeFlag(Te.Opening), R.current.afterEnter();
  }, leave: () => {
    ie.removeFlag(Te.Closing), R.current.afterLeave();
  }, idle: () => {
  } })), k = Ka(() => {
    z("hidden"), q(_);
  }, P), U = X(!1);
  $0({ immediate: se, container: _, classes: N, direction: Y, onStart: ct((le) => {
    U.current = !0, k.onStart(_, le, F);
  }), onStop: ct((le) => {
    U.current = !1, k.onStop(_, le, O), le === "leave" && !ki(k) && (z("hidden"), q(_));
  }) });
  let V = b, H = { ref: h };
  return se ? V = { ...V, className: Kn(b.className, ...N.current.enter, ...N.current.enterFrom) } : U.current && (V.className = Kn(b.className, (n = _.current) == null ? void 0 : n.className), V.className === "" && delete V.className), W.createElement(Ti.Provider, { value: k }, W.createElement(Ys, { value: _e(L, { visible: Te.Open, hidden: Te.Closed }) | ie.flags }, Ue({ ourProps: H, theirProps: V, defaultTag: z0, features: Xa, visible: L === "visible", name: "Transition.Child" })));
}
function W0(t, e) {
  let { show: r, appear: n = !1, unmount: i = !0, ...s } = t, o = X(null), l = qe(o, e);
  xi();
  let c = Rn();
  if (r === void 0 && c !== null && (r = (c & Te.Open) === Te.Open), ![!0, !1].includes(r))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [u, f] = ae(r ? "visible" : "hidden"), C = Ka(() => {
    f("hidden");
  }), [v, w] = ae(!0), g = X([r]);
  ut(() => {
    v !== !1 && g.current[g.current.length - 1] !== r && (g.current.push(r), w(!1));
  }, [g, r]);
  let b = ve(() => ({ show: r, appear: n, initial: v }), [r, n, v]);
  K(() => {
    if (r)
      f("visible");
    else if (!ki(C))
      f("hidden");
    else {
      let E = o.current;
      if (!E)
        return;
      let T = E.getBoundingClientRect();
      T.x === 0 && T.y === 0 && T.width === 0 && T.height === 0 && f("hidden");
    }
  }, [r, C]);
  let _ = { unmount: i }, h = oe(() => {
    var E;
    v && w(!1), (E = t.beforeEnter) == null || E.call(t);
  }), y = oe(() => {
    var E;
    v && w(!1), (E = t.beforeLeave) == null || E.call(t);
  });
  return W.createElement(Ti.Provider, { value: C }, W.createElement(Ei.Provider, { value: b }, Ue({ ourProps: { ..._, as: lt, children: W.createElement(el, { ref: l, ..._, ...s, beforeEnter: h, beforeLeave: y }) }, theirProps: {}, defaultTag: lt, features: Xa, visible: u === "visible", name: "Transition" })));
}
function H0(t, e) {
  let r = Se(Ei) !== null, n = Rn() !== null;
  return W.createElement(W.Fragment, null, !r && n ? W.createElement(us, { ref: e, ...t }) : W.createElement(el, { ref: e, ...t }));
}
let us = Ve(W0), el = Ve(B0), G0 = Ve(H0), Bn = Object.assign(us, { Child: G0, Root: us });
const Rc = ({
  sectionHeader: t = "Frequently Asked Questions",
  sectionDescription: e = "We’ve compiled a list of frequently asked questions to help you get the most out of our products and services. If you have a question that’s not listed here, please don’t hesitate to contact us.",
  sectionImage: r,
  faqs: n
}) => {
  if (!n || n.length === 0)
    return null;
  const i = !!(r != null && r.url);
  return /* @__PURE__ */ d("div", { "data-testid": "faq", id: "faq", className: "bg-white", children: /* @__PURE__ */ I("div", { className: " flex-col  flex items-center gap-6 md:gap-8 xl:gap-10 2xl:max-w-8xl 2xl:mx-auto py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px]", children: [
    /* @__PURE__ */ I("div", { className: "w-full flex-col flex items-center gap-3 xl:gap-5 text-center text-neutral-400 ", children: [
      /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1", children: t }),
      /* @__PURE__ */ d("svg", { width: "100", height: "3", viewBox: "0 0 100 3", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { y1: "1.5", x2: "100", y2: "1.5", stroke: "#282931", strokeWidth: "3" }) })
    ] }),
    /* @__PURE__ */ d("div", { className: "text-heading6 max-w-6xl md:text-heading5 xl:text-heading4  font-medium text-center text-neutral-400 font-lato ", children: e }),
    i && /* @__PURE__ */ d(
      tt,
      {
        className: "object-cover h-[21rem] w-full",
        alt: r == null ? void 0 : r.title,
        src: rt(r == null ? void 0 : r.url),
        cldImg: Ge(r == null ? void 0 : r.url),
        plugins: [Xe()]
      }
    ),
    /* @__PURE__ */ d("div", { className: "w-full grid grid-cols-1  xl:grid-cols-2 gap-4 md:gap-5 xl:gap-8 items-start after:", children: n.map((s, o) => /* @__PURE__ */ d(bn, { children: ({ open: l }) => /* @__PURE__ */ I("div", { className: "flex flex-col bg-neutral-100 px-5 py-3 h-fit items-start [grid-auto-cols:min-content]", children: [
      /* @__PURE__ */ I(bn.Button, { className: ge("flex w-full gap-4"), children: [
        /* @__PURE__ */ d("div", { className: "bg-neutral-400 flex  gap-2.5 p-2", children: /* @__PURE__ */ d("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d(
          "path",
          {
            d: "M9.33301 15.3333V18.6667M9.33301 15.3333V7.33333C9.33301 6.22876 10.2284 5.33333 11.333 5.33333C12.4376 5.33333 13.333 6.22876 13.333 7.33333M9.33301 15.3333C9.33301 14.2288 8.43758 13.3333 7.33301 13.3333C6.22844 13.3333 5.33301 14.2288 5.33301 15.3333V18C5.33301 23.5228 9.81016 28 15.333 28C20.8559 28 25.333 23.5228 25.333 18V11.3333C25.333 10.2288 24.4376 9.33333 23.333 9.33333C22.2284 9.33333 21.333 10.2288 21.333 11.3333M13.333 7.33333V14.6667M13.333 7.33333V6C13.333 4.89543 14.2284 4 15.333 4C16.4376 4 17.333 4.89543 17.333 6V7.33333M17.333 7.33333V14.6667M17.333 7.33333C17.333 6.22876 18.2284 5.33333 19.333 5.33333C20.4376 5.33333 21.333 6.22876 21.333 7.33333V11.3333M21.333 11.3333V14.6667",
            stroke: "#B8FF51",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ) }) }),
        /* @__PURE__ */ I("div", { className: "flex-row flex w-full justify-between self-center  gap-2", children: [
          /* @__PURE__ */ d("span", { className: "text-heading5 text-left  font-medium font-lato text-neutral-400", children: s.question }),
          /* @__PURE__ */ d(
            "div",
            {
              className: ge(
                "flex justify-center items-center  transition-all",
                l ? "transform rotate-90" : "transform rotate-0"
              ),
              children: /* @__PURE__ */ d(
                "svg",
                {
                  width: "32",
                  height: "32",
                  viewBox: "0 0 32 32",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: /* @__PURE__ */ d(
                    "path",
                    {
                      d: "M12 6.66683L21.3333 16.0002L12 25.3335",
                      stroke: "#282931",
                      strokeWidth: "2",
                      strokeLinecap: "round",
                      strokeLinejoin: "round"
                    }
                  )
                }
              )
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ d(
        Bn,
        {
          enter: "transition duration-100 ease-out",
          enterFrom: "transform scale-95 opacity-0",
          enterTo: "transform scale-100 opacity-100",
          leave: "transition duration-75 ease-out",
          leaveFrom: "transform scale-100 opacity-100",
          leaveTo: "transform scale-95 opacity-0",
          children: /* @__PURE__ */ d(bn.Panel, { className: ge("w-full px-16 pb-5 mt-1 rounded-b-xl"), children: /* @__PURE__ */ d("p", { className: " flex-col flex items-center gap-2 text-neutral-400 text-body1 font-lato", children: s.answer }) })
        }
      )
    ] }) }, `faq-${o}`)) })
  ] }) });
}, Ic = ({
  orgLinks: t,
  logoImage: e,
  businessName: r,
  shortDescription: n,
  businessLinks: i,
  phones: s,
  emails: o,
  locations: l,
  hideLocation: c = !1
}) => {
  const u = !c && l && (l == null ? void 0 : l.length) > 0;
  return /* @__PURE__ */ d("div", { "data-testid": "footer", id: "footer", children: /* @__PURE__ */ I("div", { className: "bg-neutral-400 flex-col  flex items-center gap-6 md:gap-8 xl:gap-10  py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px]", children: [
    /* @__PURE__ */ I("div", { className: "max-w-[77.5rem] w-full   flex justify-between gap-16 items-start flex-wrap", children: [
      /* @__PURE__ */ I("div", { className: "flex-col flex items-start gap-5", children: [
        /* @__PURE__ */ d("h2", { className: "flex-col flex items-start gap-5  text-heading2 xl:text-heading1  text-primary-300 font-Tomorrow", children: r }),
        /* @__PURE__ */ d("span", { className: "text-white text-body1", children: n }),
        /* @__PURE__ */ d("div", { className: "flex justify-center items-start gap-6", children: i == null ? void 0 : i.map((f, C) => /* @__PURE__ */ d("a", { href: f.url, target: "_blank", rel: "noreferrer", children: z6(f.url, "w-6 h-6 text-white") }, `footer-link-${C}`)) })
      ] }),
      /* @__PURE__ */ I("div", { className: "flex-col flex items-start gap-5 text-lg  text-white", children: [
        s && (s == null ? void 0 : s.length) > 0 && /* @__PURE__ */ I("div", { className: "flex justify-center items-center gap-2.5 ", children: [
          /* @__PURE__ */ d("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d(
            "path",
            {
              d: "M25.6401 20.3465L22.2534 19.9599C21.8552 19.9131 21.4515 19.9572 21.0728 20.0888C20.6941 20.2204 20.3501 20.4362 20.0667 20.7199L17.6134 23.1732C13.8283 21.2481 10.7518 18.1716 8.82672 14.3865L11.2934 11.9199C11.8667 11.3465 12.1467 10.5465 12.0534 9.73319L11.6667 6.37319C11.5911 5.72275 11.279 5.12283 10.7897 4.68765C10.3004 4.25246 9.6682 4.01241 9.01339 4.01319H6.70672C5.20005 4.01319 3.94672 5.26652 4.04005 6.77319C4.74672 18.1599 13.8534 27.2532 25.2267 27.9599C26.7334 28.0532 27.9867 26.7999 27.9867 25.2932V22.9865C28.0001 21.6399 26.9867 20.5065 25.6401 20.3465Z",
              fill: "#98F215"
            }
          ) }),
          /* @__PURE__ */ d("div", { className: "flex gap-2 flex-col", children: s == null ? void 0 : s.map((f, C) => /* @__PURE__ */ d(
            "a",
            {
              className: "font-lato text-body1",
              href: `tel:${ur(f.phoneNumber)}`,
              children: ur(f.phoneNumber)
            },
            `phone-${C}`
          )) })
        ] }),
        u && /* @__PURE__ */ I("div", { className: "flex justify-center items-center gap-2.5", children: [
          /* @__PURE__ */ d("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d(
            "path",
            {
              d: "M16 3.21436C11.5808 3.21436 8 6.78076 8 11.1984C8 18.8368 16 28.7984 16 28.7984C16 28.7984 24 18.8352 24 11.1984C24 6.78236 20.4192 3.21436 16 3.21436ZM16 15.616C14.8543 15.616 13.7555 15.1608 12.9453 14.3507C12.1351 13.5405 11.68 12.4417 11.68 11.296C11.68 10.1502 12.1351 9.05141 12.9453 8.24125C13.7555 7.4311 14.8543 6.97596 16 6.97596C17.1457 6.97596 18.2445 7.4311 19.0547 8.24125C19.8649 9.05141 20.32 10.1502 20.32 11.296C20.32 12.4417 19.8649 13.5405 19.0547 14.3507C18.2445 15.1608 17.1457 15.616 16 15.616Z",
              fill: "#98F215"
            }
          ) }),
          /* @__PURE__ */ d("div", { className: "flex gap-2 flex-col", children: l == null ? void 0 : l.map(({ streetAddress: f, city: C, state: v, postalCode: w }, g) => /* @__PURE__ */ d(
            "a",
            {
              target: "_blank",
              className: "font-lato text-body1",
              href: Da({ streetAddress: f, city: C, state: v, postalCode: w }),
              rel: "noreferrer",
              children: Va({ streetAddress: f, city: C, state: v, postalCode: w })
            },
            `location-${g}`
          )) })
        ] }),
        o && (o == null ? void 0 : o.length) > 0 && /* @__PURE__ */ I("div", { className: "flex justify-center items-center gap-2.5 ", children: [
          /* @__PURE__ */ d("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d(
            "path",
            {
              d: "M26.667 5.3335H5.33366C3.86699 5.3335 2.68033 6.5335 2.68033 8.00016L2.66699 24.0002C2.66699 25.4668 3.86699 26.6668 5.33366 26.6668H26.667C28.1337 26.6668 29.3337 25.4668 29.3337 24.0002V8.00016C29.3337 6.5335 28.1337 5.3335 26.667 5.3335ZM26.667 10.6668L16.0003 17.3335L5.33366 10.6668V8.00016L16.0003 14.6668L26.667 8.00016V10.6668Z",
              fill: "#98F215"
            }
          ) }),
          /* @__PURE__ */ d("div", { className: "flex gap-2 flex-col", children: o == null ? void 0 : o.map((f, C) => /* @__PURE__ */ d("a", { className: "font-lato text-body1", href: `mailto:${f.email}`, children: f.email }, `email-${C}`)) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ I("div", { className: "flex-col  w-full mx-auto flex items-center gap-10 text-lg  text-center  font-lato", children: [
      /* @__PURE__ */ d("svg", { width: "1240", height: "3", viewBox: "0 0 1240 3", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "w-full", children: /* @__PURE__ */ d("line", { y1: "1.5", x2: "1240", y2: "1.5", stroke: "#98F215", strokeWidth: "3", className: "w-full" }) }),
      /* @__PURE__ */ I("div", { className: "flex justify-center items-start gap-5  max-sm:flex-wrap w-full", children: [
        /* @__PURE__ */ d(
          "a",
          {
            href: "https://www.trades.org/trade-pro/privacy",
            rel: "noreferrer",
            target: "_blank",
            className: "max-w-xs w-full font-lato text-body1 text-white",
            children: "Privacy Policy"
          }
        ),
        /* @__PURE__ */ d(
          "a",
          {
            href: "https://www.trades.org/trade-pro/terms",
            rel: "noreferrer",
            target: "_blank",
            className: "max-w-xs w-full font-lato text-body1 text-white",
            children: "Terms"
          }
        ),
        /* @__PURE__ */ d(
          "a",
          {
            href: "https://www.trades.org/",
            rel: "noreferrer",
            target: "_blank",
            className: "max-w-xs w-full font-lato text-body1 text-white",
            children: "powered by trades.org"
          }
        )
      ] })
    ] })
  ] }) });
}, Dc = ({ sectionHeader: t = "Our Guarantees", sectionImage: e, guarantees: r }) => {
  var i;
  if (!r || ((i = r == null ? void 0 : r.guaranteeDescriptions) == null ? void 0 : i.length) === 0)
    return null;
  const n = !!(e != null && e.url);
  return /* @__PURE__ */ I("div", { "data-testid": "guarantees", id: "guarantees", className: "bg-neutral-400 relative", children: [
    n && /* @__PURE__ */ I("div", { className: "h-full w-full absolute", children: [
      /* @__PURE__ */ d(
        tt,
        {
          src: rt(e == null ? void 0 : e.url),
          cldImg: Ge(e == null ? void 0 : e.url),
          plugins: [Xe()],
          alt: e == null ? void 0 : e.title,
          className: "object-cover w-full h-full absolute inset-0"
        }
      ),
      /* @__PURE__ */ d("div", { className: "w-full h-full flex  justify-center items-center backdrop-brightness-50" })
    ] }),
    /* @__PURE__ */ I("div", { className: "2xl:max-w-8xl relative 2xl:mx-auto w-full flex-col py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px] flex items-start gap-6 md:gap-8 xl:gap-10", children: [
      /* @__PURE__ */ I("div", { className: "flex-col flex items-center gap-6 md:gap-8 xl:gap-10 w-full", children: [
        /* @__PURE__ */ I("div", { className: "flex-col flex items-center gap-3 xl:gap-5", children: [
          /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1 text-center text-white", children: t }),
          /* @__PURE__ */ d("svg", { width: "101", height: "4", viewBox: "0 0 101 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("path", { d: "M0.5 1.7998H100.5", stroke: "#B8FF51", strokeWidth: "3" }) })
        ] }),
        /* @__PURE__ */ d("p", { className: "text-heading6 md:text-heading4 font-medium font-lato text-white max-lg:max-w-3xl text-center", children: r.title })
      ] }),
      /* @__PURE__ */ d("div", { className: "grid grid-cols-1 xl:grid-cols-3 w-full justify-center items-center gap-10", children: r.guaranteeDescriptions.map((s, o) => /* @__PURE__ */ d("div", { className: "max-w-xs w-full mx-auto", children: /* @__PURE__ */ I("div", { className: "flex items-start gap-3 font-medium text-white font-lato justify-center", children: [
        /* @__PURE__ */ I("svg", { width: "33", height: "33", viewBox: "0 0 33 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
          /* @__PURE__ */ d(
            "path",
            {
              d: "M32.8154 16.7998C32.8154 7.96325 25.652 0.799805 16.8154 0.799805C7.97887 0.799805 0.81543 7.96325 0.81543 16.7998C0.81543 25.6364 7.97887 32.7998 16.8154 32.7998C25.652 32.7998 32.8154 25.6364 32.8154 16.7998Z",
              fill: "#B8FF51"
            }
          ),
          /* @__PURE__ */ d("path", { d: "M11.7881 17.856L14.063 19.9343", stroke: "#282931", strokeWidth: "2", strokeLinecap: "round" }),
          /* @__PURE__ */ d("path", { d: "M21.4287 12.9829L14.3176 20.094", stroke: "#282931", strokeWidth: "2", strokeLinecap: "round" })
        ] }),
        /* @__PURE__ */ I("div", { className: "", children: [
          /* @__PURE__ */ d("span", { className: "text-heading5  font-lato", children: s.title }),
          /* @__PURE__ */ d("p", { className: "font-lato text-body2", children: s.description })
        ] })
      ] }) }, `guarantee-${o}`)) })
    ] })
  ] });
};
function q0({
  title: t,
  titleId: e,
  ...r
}, n) {
  return /* @__PURE__ */ At.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: n,
    "aria-labelledby": e
  }, r), t ? /* @__PURE__ */ At.createElement("title", {
    id: e
  }, t) : null, /* @__PURE__ */ At.createElement("path", {
    fillRule: "evenodd",
    d: "M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z",
    clipRule: "evenodd"
  }));
}
const U0 = At.forwardRef(q0), Q0 = U0, Vc = ({ logoImage: t, actionButtonText: e = "Contact Us", phoneNumber: r }) => {
  const n = !!(t != null && t.url), [i, s] = ae(!1), [o, l] = ae(!0);
  return K(() => {
    let c = 0;
    const u = () => {
      const f = window.scrollY;
      f > 60 ? s(!0) : s(!1), f > c ? l(!1) : f < c && l(!0), c = f;
    };
    return window.addEventListener("scroll", u), () => {
      window.removeEventListener("scroll", u);
    };
  }, []), /* @__PURE__ */ d("div", { "data-testid": "header", id: "header", children: /* @__PURE__ */ d(
    "div",
    {
      className: ge(
        i && " bg-neutral-400 ",
        o ? " flex " : "md:hidden",
        "`flex-row justify-between items-center px-5 py-5 md:px-10 xl:px-24 w-full fixed z-50 gap-20 transition-all"
      ),
      children: /* @__PURE__ */ I("div", { className: "w-full flex justify-between items-center px-5", children: [
        /* @__PURE__ */ I("div", { className: "flex items-start gap-10 font-bold text-white max-md:hidden", children: [
          /* @__PURE__ */ d("a", { href: "/", className: "font-lato", children: "Home" }),
          /* @__PURE__ */ d("a", { href: "#about-us", className: "font-lato", children: "About Us" }),
          /* @__PURE__ */ d("a", { href: "#services", className: "font-lato", children: "Services" })
        ] }),
        n ? /* @__PURE__ */ d(
          tt,
          {
            plugins: [Xe()],
            src: rt(t == null ? void 0 : t.url),
            cldImg: Ge(t == null ? void 0 : t.url),
            className: "h-6 w-6",
            alt: ""
          }
        ) : /* @__PURE__ */ d("div", { className: "h-6 w-6 rounded-full bg-neutral-700" }),
        /* @__PURE__ */ d(
          "a",
          {
            href: `tel:${ur(r)}`,
            className: "flex uppercase max-md:hidden text-button justify-center border transition-all border-neutral-400 active:bg-white hover:bg-neutral-100 items-center gap-2.5 px-4 py-2 h-fit   font-medium font-Tomorrow bg-primary-300 text-neutral-400",
            children: e
          }
        ),
        /* @__PURE__ */ I(xn, { className: "md:hidden flex ", children: [
          /* @__PURE__ */ d(xn.Button, { children: /* @__PURE__ */ I("svg", { width: "22", height: "16", viewBox: "0 0 22 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
            /* @__PURE__ */ d("path", { d: "M0.5 0.299805H21.5V3.2998H0.5V0.299805Z", fill: "white" }),
            /* @__PURE__ */ d("path", { d: "M0.5 6.2998H21.5V9.2998H0.5V6.2998Z", fill: "white" }),
            /* @__PURE__ */ d("path", { d: "M0.5 12.2998H21.5V15.2998H0.5V12.2998Z", fill: "white" })
          ] }) }),
          /* @__PURE__ */ I(Bn.Root, { children: [
            /* @__PURE__ */ d(
              Bn.Child,
              {
                as: lt,
                enter: "duration-150 ease-out",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "duration-150 ease-in",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /* @__PURE__ */ d(xn.Overlay, { className: "fixed inset-0 z-30 bg-black opacity-30 lg:hidden" })
              }
            ),
            /* @__PURE__ */ d(
              Bn.Child,
              {
                as: lt,
                enter: "duration-150 ease-out",
                enterFrom: "opacity-0 scale-95",
                enterTo: "opacity-100 scale-100",
                leave: "duration-150 ease-in",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-95",
                children: /* @__PURE__ */ d(xn.Panel, { className: "fixed z-[9999] bg-green-400 inset-x-0 h-full top-0 origin-top-right transform transition lg:hidden", children: /* @__PURE__ */ d("div", { className: "divide-y-2 divide-gray-50  bg-neutral-400 shadow-lg ring-1 ring-black ring-opacity-5 w-full h-full", children: /* @__PURE__ */ I("div", { className: "px-5 pt-3 pb-6 max-h-[calc(85vh-1px)] h-full", children: [
                  /* @__PURE__ */ I("div", { className: "flex items-center justify-between py-2", children: [
                    n ? /* @__PURE__ */ d(
                      tt,
                      {
                        src: rt(t == null ? void 0 : t.url),
                        cldImg: Ge(t == null ? void 0 : t.url),
                        plugins: [Xe()],
                        className: "h-6 w-6",
                        alt: ""
                      }
                    ) : /* @__PURE__ */ d("div", { className: "h-6 w-6 rounded-full bg-neutral-700" }),
                    /* @__PURE__ */ d("div", { className: "-mr-1 mt-1", children: /* @__PURE__ */ d(xn.Button, { className: "inline-flex items-center rounded-md justify-center  p-1 text-gray-100 hover:text-gray-300 focus:outline-none ", children: /* @__PURE__ */ d(Q0, { className: "h-7 w-7", "aria-hidden": "true" }) }) })
                  ] }),
                  /* @__PURE__ */ d("div", { className: "flex flex-col h-full justify-between", children: /* @__PURE__ */ I("div", { className: "flex gap-8 flex-col py-6 items-center", children: [
                    /* @__PURE__ */ d("a", { href: "/", className: "flex  items-center  text-white font-medium text-heading6", children: "Home" }),
                    /* @__PURE__ */ d(
                      "a",
                      {
                        href: "#about-us",
                        className: "flex  items-center  text-white  font-medium text-heading6",
                        children: "About us"
                      }
                    ),
                    /* @__PURE__ */ d(
                      "a",
                      {
                        href: "#services",
                        className: "flex  items-center  text-white  font-medium text-heading6",
                        children: "Services"
                      }
                    ),
                    /* @__PURE__ */ d(
                      "a",
                      {
                        href: "#our-work",
                        className: "flex  items-center  text-white  font-medium text-heading6",
                        children: "Projects"
                      }
                    ),
                    /* @__PURE__ */ d("a", { href: "#faq", className: "flex  items-center   text-white font-medium text-heading6", children: "FAQs" }),
                    /* @__PURE__ */ d(
                      "a",
                      {
                        href: `tel:${ur(r)}`,
                        className: "flex uppercase  text-button justify-center border transition-all border-neutral-400 active:bg-white hover:bg-neutral-100 items-center gap-2.5 px-4 py-2 h-fit font-medium font-Tomorrow bg-primary-300 text-neutral-400",
                        children: e
                      }
                    )
                  ] }) })
                ] }) }) })
              }
            )
          ] })
        ] })
      ] })
    }
  ) });
}, zc = ({
  headline: t,
  subHeadline: e,
  businessName: r,
  coverImage: n,
  requestQuote: i = {
    actionButtonText: "Request a Quote Now!",
    sectionDescription: "With our passion for creativity and industry-leading technologies, we're ready to help you unleash the power of innovation and achieve great results!",
    sectionHeader: "Elevate Your Experience, Start Your Project With Us."
  },
  businessEmail: s
}) => {
  const { isHorizontal: o } = n, { isLoading: l, isSuccess: c, handleChange: u, onSubmit: f, isError: C } = ta({
    businessEmail: s,
    businessName: r
  });
  return /* @__PURE__ */ d("div", { "data-testid": "hero", id: "hero", children: /* @__PURE__ */ I(
    "div",
    {
      style: {
        backgroundImage: `url(${Ge(n == null ? void 0 : n.url).toURL()})`
      },
      className: "bg-cover bg-center  relative flex-col min-h-[45rem] justify-center flex items-start gap-10 pb-6 md:pb-10 xl:pb-12 pt-24 md:pt-36",
      children: [
        /* @__PURE__ */ d("div", { className: "w-full h-full inset-0 flex absolute z-10 justify-center items-center backdrop-brightness-[0.40]" }),
        /* @__PURE__ */ I(
          "div",
          {
            className: ge(
              o ? "max-w-3xl mx-auto gap-6 md:gap-8 xl:gap-10" : "max-w-4xl  gap-10 md:gap-12",
              "flex-col  flex items-start w-full relative z-20 px-5 md:px-10 xl:px-[100px]"
            ),
            children: [
              /* @__PURE__ */ I("div", { className: ge("flex-col  flex items-start gap-10", o && "gap-5 md:gap-8 xl:gap-10"), children: [
                /* @__PURE__ */ I("div", { className: ge("w-full flex-col flex items-start ", o ? "gap-6 md:gap-8 xl:gap-10" : "gap-5"), children: [
                  /* @__PURE__ */ d(
                    "span",
                    {
                      className: ge(
                        o && "text-center w-full",
                        "text-heading6  font-medium text-primary-300 font-lato "
                      ),
                      children: r
                    }
                  ),
                  /* @__PURE__ */ d(
                    "h1",
                    {
                      className: ge(
                        o && "text-center",
                        "text-heading3 md:text-heading2 xl:text-heading1  text-white "
                      ),
                      children: t
                    }
                  )
                ] }),
                /* @__PURE__ */ d(
                  "div",
                  {
                    className: ge(
                      o && "text-center",
                      "xl:text-heading4 md:text-heading5 text-heading6 font-medium text-white font-lato "
                    ),
                    children: e
                  }
                )
              ] }),
              /* @__PURE__ */ I("form", { onSubmit: f, className: ge(!o && "max-w-xl", "flex-col flex items-start gap-4 w-full"), children: [
                c && /* @__PURE__ */ d("div", { className: "flex items-center w-full justify-center p-4 text-sm font-medium text-primary-500 bg-primary-100 rounded-md", children: "Message sent successfully" }),
                C && /* @__PURE__ */ d("div", { className: "flex items-center w-full  justify-center p-4 text-sm font-medium text-error-200 bg-error-50 rounded-md", children: "Error sending message" }),
                /* @__PURE__ */ I("div", { className: ge(o ? "flex-row gap-6" : "flex-col gap-10 ", "flex items-center  w-full"), children: [
                  /* @__PURE__ */ d(
                    "input",
                    {
                      name: "name",
                      id: "name",
                      type: "text",
                      placeholder: "First Name",
                      onChange: u,
                      required: !0,
                      className: "bg-white w-full flex-col flex items-start outline-none border border-primary-200 gap-2.5 px-4 py-1.5 text-lg  text-neutral-400 font-lato"
                    }
                  ),
                  /* @__PURE__ */ d(
                    "input",
                    {
                      name: "email",
                      id: "email",
                      onChange: u,
                      required: !0,
                      placeholder: "Email",
                      className: "bg-white w-full flex-col flex outline-none border border-primary-200 items-start gap-2.5 px-4 py-1.5 text-lg  text-neutral-400 font-lato"
                    }
                  ),
                  /* @__PURE__ */ d(
                    "button",
                    {
                      disabled: l,
                      type: "submit",
                      className: " w-full flex uppercase text-button justify-center border transition-all border-neutral-400 active:bg-white hover:bg-neutral-100 items-center gap-2.5 px-4 py-2 h-fit   font-medium  bg-primary-300 text-neutral-400",
                      children: i == null ? void 0 : i.actionButtonText
                    }
                  )
                ] }),
                /* @__PURE__ */ d("span", { className: "text-primary-300 w-full justify-end flex", children: s.toUpperCase() })
              ] })
            ]
          }
        )
      ]
    }
  ) });
}, Bc = ({
  sectionHeader: t = "Our Standout Features",
  sectionDescription: e = "Discover how these features work in harmony to create projects that inspire and exceed expectations.",
  sectionImage: r,
  highlightedFeatures: n
}) => {
  if (!n || n.length === 0)
    return null;
  const i = !!(r != null && r.url);
  return /* @__PURE__ */ d("div", { "data-testid": "features", id: "features", children: /* @__PURE__ */ I("div", { className: ge(i && "md:flex-row", "w-full flex flex-col px-10 pb-12 md:px-10 md:pb-16 xl:px-24 bg-neutral-400"), children: [
    /* @__PURE__ */ d("div", { className: ge(i ? "md:w-1/2 xl:w-2/3 md:mb-0" : "mb-4 md:mb-10", "w-full bg-black mb-6"), children: /* @__PURE__ */ I("div", { className: "relative w-full h-full flex flex-col justify-center", children: [
      /* @__PURE__ */ I("div", { className: ge(i ? "xl:hidden" : "", "flex flex-col bg-neutral-400"), children: [
        /* @__PURE__ */ d("h2", { className: "w-full text-center text-heading3 md:text-heading2 xl:text-heading1 mb-4 text-white", children: t }),
        /* @__PURE__ */ d(
          "svg",
          {
            width: "100",
            height: "4",
            viewBox: "0 0 100 4",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "w-full self-center mb-10",
            children: /* @__PURE__ */ d("line", { y1: "2.2998", x2: "100", y2: "2.2998", stroke: "#98F215", strokeWidth: "3" })
          }
        ),
        /* @__PURE__ */ d("p", { className: "text-heading6 md:text-heading5 xl:text-heading4 font-medium font-lato max-lg:text-center text-center text-white mb-8 xl:mb-0", children: e })
      ] }),
      /* @__PURE__ */ d(
        tt,
        {
          className: ge(
            i ? "block" : "hidden",
            "object-cover object-center w-full md:h-full h-[12.5rem] md:min-h-[37.5rem] xl:min-h-[50rem] opacity-40"
          ),
          src: rt(r == null ? void 0 : r.url),
          cldImg: Ge(r == null ? void 0 : r.url),
          plugins: [Xe()]
        }
      ),
      /* @__PURE__ */ I(
        "div",
        {
          className: ge(
            i && "xl:flex",
            "absolute inset w-2/3 flex-col items-center bg-black bg-opacity-40 ml-5 p-5 hidden"
          ),
          children: [
            /* @__PURE__ */ d("h2", { className: "w-full text-center text-heading3 md:text-heading2 xl:text-heading1 mb-4 text-white", children: t }),
            /* @__PURE__ */ d(
              "svg",
              {
                width: "100",
                height: "4",
                viewBox: "0 0 100 4",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: "w-full self-center mb-10",
                children: /* @__PURE__ */ d("line", { y1: "2.2998", x2: "100", y2: "2.2998", stroke: "#98F215", strokeWidth: "3" })
              }
            ),
            /* @__PURE__ */ d("p", { className: "text-heading6 md:text-heading5 xl:text-heading4 font-medium font-lato max-lg:text-center text-center text-white", children: e })
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ d(
      "div",
      {
        className: ge(
          i ? "md:w-1/2 xl:w-1/3 gap-6 md:gap-8" : "xl:grid-cols-3",
          "w-full grid grid-cols-1 gap-y-10 gap-x-24"
        ),
        children: n.map((s, o) => /* @__PURE__ */ I("div", { className: "w-full flex flex-col gap-5 my-5", children: [
          /* @__PURE__ */ I("div", { className: "flex flex-row gap-2 items-center justify-center px-2 py-4 border-y-[3px] border-primary-300", children: [
            /* @__PURE__ */ d("svg", { xmlns: "http://www.w3.org/2000/svg", width: "33", height: "32", viewBox: "0 0 33 32", fill: "none", children: /* @__PURE__ */ d(
              "path",
              {
                d: "M11.1667 16.4445L14.4487 20.0001L21.8334 12.0001M3.16675 16.0001L9.83341 4.45312H23.1667L29.8334 16.0001L23.1667 27.5472H9.83341L3.16675 16.0001Z",
                stroke: "#B8FF51",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
              }
            ) }),
            /* @__PURE__ */ d("h4", { className: "text-heading6 font-lato font-semibold text-white", children: s.title })
          ] }),
          /* @__PURE__ */ d("p", { className: "text-body1 font-lato px-5 text-white", children: s.description })
        ] }, `feature-${o}`))
      }
    )
  ] }) });
}, Wc = ({
  sectionHeader: t = "Our Specialized Services",
  sectionDescription: e = "Explore our specialized services that make dreams come.",
  highlightedServices: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ d("div", { "data-testid": "services", id: "services", className: "bg-neutral-400", children: /* @__PURE__ */ I("div", { className: "2xl:max-w-8xl mx-auto flex-col  flex items-center gap-6 md:gap-8 xl:gap-10  py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px]", children: [
  /* @__PURE__ */ I("div", { className: "flex-col flex items-center gap-6 md:gap-8 xl:gap-10 text-white", children: [
    /* @__PURE__ */ I("div", { className: "flex-col flex items-center gap-3 md:gap-5 text-6xl  text-center ", children: [
      /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1", children: t }),
      /* @__PURE__ */ d("svg", { width: "100", height: "4", viewBox: "0 0 100 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { y1: "2.2998", x2: "100", y2: "2.2998", stroke: "#98F215", strokeWidth: "3" }) })
    ] }),
    /* @__PURE__ */ d("span", { className: "text-heading6 md:text-heading5 xl:text-heading4 font-medium font-lato text-center", children: e })
  ] }),
  /* @__PURE__ */ d("div", { className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10 xl:gap-20  justify-between items-start text-white ", children: r.map((n, i) => /* @__PURE__ */ I("div", { className: "bg-neutral-400 flex-col flex items-start gap-10", children: [
    /* @__PURE__ */ I("div", { className: "flex-col flex items-start text-xl w-full font-medium", children: [
      n.image && /* @__PURE__ */ d(
        tt,
        {
          className: "object-cover max-h-[20rem]   w-full h-[20rem]",
          src: rt(n.image.url),
          cldImg: Ge(n.image.url),
          plugins: [Xe()]
        }
      ),
      /* @__PURE__ */ d("span", { className: "w-full text-heading6 font-lato  flex justify-center items-center gap-2.5 px-2.5 py-5 border-y-[3px] border-primary-300", children: n.name })
    ] }),
    /* @__PURE__ */ d("div", { className: "text-body1  font-lato ", children: n.description })
  ] }, `service-${i}`)) })
] }) }), Hc = ({ sectionHeader: t = "Our Process", sectionImages: e, ourProcess: r }) => !r || (r == null ? void 0 : r.ourProcessSteps.length) === 0 ? null : /* @__PURE__ */ d("div", { "data-testid": "our-process", id: "our-process", className: "bg-neutral-100", children: /* @__PURE__ */ I("div", { className: "2xl:max-w-8xl w-full 2xl:mx-auto py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px] flex flex-col  items-start justify-start gap-6 md:gap-8 xl:gap-10 text-center", children: [
  /* @__PURE__ */ I("div", { className: "flex flex-col items-center justify-start gap-3 xl:gap-5 w-full ", children: [
    /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1 w-full text-center", children: t }),
    /* @__PURE__ */ d("svg", { width: "100", height: "4", viewBox: "0 0 100 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { y1: "2.30078", x2: "100", y2: "2.30078", stroke: "#282931", strokeWidth: "3" }) })
  ] }),
  /* @__PURE__ */ d("p", { className: "font-medium font-lato text-heading6 md:text-heading5 xl:text-heading4 2xl:max-w-8xl 2xl:mx-auto", children: r.title }),
  /* @__PURE__ */ d("div", { className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 items-start justify-start gap-6 md:gap-10 xl:gap-12 text-background-primary", children: r == null ? void 0 : r.ourProcessSteps.map((n) => /* @__PURE__ */ I(
    "div",
    {
      className: "bg-neutral-400 flex flex-col p-5 md:p-6 items-center justify-center gap-5",
      children: [
        !e && /* @__PURE__ */ d("svg", { width: "61", height: "60", viewBox: "0 0 61 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d(
          "path",
          {
            d: "M27.8333 10C27.8333 7.23858 30.0719 5 32.8333 5C35.5947 5 37.8333 7.23858 37.8333 10V12.5C37.8333 13.8807 38.9526 15 40.3333 15H47.8333C49.214 15 50.3333 16.1193 50.3333 17.5V25C50.3333 26.3807 49.214 27.5 47.8333 27.5H45.3333C42.5719 27.5 40.3333 29.7386 40.3333 32.5C40.3333 35.2614 42.5719 37.5 45.3333 37.5H47.8333C49.214 37.5 50.3333 38.6193 50.3333 40V47.5C50.3333 48.8807 49.214 50 47.8333 50H40.3333C38.9526 50 37.8333 48.8807 37.8333 47.5V45C37.8333 42.2386 35.5947 40 32.8333 40C30.0719 40 27.8333 42.2386 27.8333 45V47.5C27.8333 48.8807 26.714 50 25.3333 50H17.8333C16.4526 50 15.3333 48.8807 15.3333 47.5V40C15.3333 38.6193 14.214 37.5 12.8333 37.5H10.3333C7.57189 37.5 5.33331 35.2614 5.33331 32.5C5.33331 29.7386 7.57189 27.5 10.3333 27.5H12.8333C14.214 27.5 15.3333 26.3807 15.3333 25V17.5C15.3333 16.1193 16.4526 15 17.8333 15H25.3333C26.714 15 27.8333 13.8807 27.8333 12.5V10Z",
            stroke: "white",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ) }),
        /* @__PURE__ */ I("span", { className: "font-medium text-heading6 md:text-heading5 xl:text-heading4 text-white font-lato", children: [
          "Step ",
          n.stepOrder,
          ":"
        ] }),
        /* @__PURE__ */ d("div", { className: "font-medium  text-heading6 md:text-heading5 xl:text-heading4  text-primary-300 font-lato", children: n.title }),
        /* @__PURE__ */ d("p", { className: "text-body2 xl:text-body1 text-white font-lato", children: n.description })
      ]
    },
    `step-${n.stepOrder}`
  )) }),
  e && (e == null ? void 0 : e.length) > 0 && /* @__PURE__ */ d("div", { className: "grid grid-cols-2 w-full gap-8", children: e == null ? void 0 : e.map((n, i) => /* @__PURE__ */ d("div", { className: "flex flex-col items-center justify-center gap-5", children: /* @__PURE__ */ d(
    tt,
    {
      className: "w-full max-h-72 h-full object-cover",
      src: rt(n.url),
      cldImg: Ge(n.url),
      plugins: [Xe()],
      alt: n.title
    }
  ) }, `image-process-${i}`)) })
] }) }), Gc = ({
  sectionHeader: t = "Our Team",
  sectionDescription: e = "Meet our team of experts",
  ourPros: r
}) => {
  if (!r || r.length === 0)
    return null;
  const n = (i) => {
    const [s, o] = ae(!1), l = !!(i.bio && i.bio.length > 200);
    return /* @__PURE__ */ d(bn, { as: "div", className: "w-full", children: ({ open: c }) => {
      var u, f, C, v;
      return /* @__PURE__ */ I("div", { className: "w-full flex flex-col bg-white p-7 group transition duration-300", children: [
        /* @__PURE__ */ I(bn.Button, { className: "w-full flex flex-col gap-9", children: [
          (u = i.image) != null && u.url ? /* @__PURE__ */ d(
            tt,
            {
              src: rt((f = i.image) == null ? void 0 : f.url),
              cldImg: Ge((C = i.image) == null ? void 0 : C.url),
              plugins: [Xe()],
              alt: "",
              className: "w-full h-[330px] object-cover object-center"
            }
          ) : /* @__PURE__ */ d("div", { className: "w-full h-[330px] flex flex-col items-center justify-center bg-neutral-400", children: /* @__PURE__ */ d("span", { className: "text-heading5 text-white", children: R6(i.name) }) }),
          /* @__PURE__ */ I("div", { className: "w-full flex flex-col gap-2 items-center", children: [
            /* @__PURE__ */ d("span", { className: "font-lato text-heading4 text-center text-neutral-400 font-medium", children: i.name }),
            /* @__PURE__ */ d("span", { className: "font-lato text-heading6 text-center text-neutral-400 font-medium", children: i.title })
          ] }),
          /* @__PURE__ */ d(
            "p",
            {
              className: ge(
                c ? "flex" : "hidden",
                "text-body1 font-lato xl:hidden group-hover:xl:flex font-normal transition-all"
              ),
              children: l && !s ? (v = i.bio) == null ? void 0 : v.slice(0, 200) : i.bio
            }
          )
        ] }),
        l && /* @__PURE__ */ d("div", { className: ge(c ? "flex" : "hidden", "w-full flex-row justify-end xl:hidden group-hover:xl:flex"), children: /* @__PURE__ */ d(
          "button",
          {
            className: "underline font-lato text-button font-semibold text-neutral-400",
            onClick: () => o(!s),
            children: s ? "Read Less" : "Read More"
          }
        ) })
      ] });
    } });
  };
  return /* @__PURE__ */ d("div", { "data-testid": "our-team", id: "our-team", className: "bg-neutral-400", children: /* @__PURE__ */ d("div", { className: "flex justify-center items-center py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px] 2xl:max-w-8xl w-full 2xl:mx-auto", children: /* @__PURE__ */ I("div", { className: "flex w-full flex-col justify-start items-center gap-6 md:gap-8 xl:gap-10 ", children: [
    /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-center gap-6 md:gap-8 xl:gap-10 ", children: [
      /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-center gap-3 xl:gap-5", children: [
        /* @__PURE__ */ d("div", { className: "text-heading3 md:text-heading2 xl:text-heading1 text-center  text-white", children: t }),
        /* @__PURE__ */ d("svg", { width: "100", height: "4", viewBox: "0 0 100 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { y1: "2.30078", x2: "100", y2: "2.30078", stroke: "#98F215", strokeWidth: "3" }) })
      ] }),
      /* @__PURE__ */ d("div", { className: "flex flex-col justify-start items-center gap-9 ", children: /* @__PURE__ */ d("p", { className: "font-lato text-heading6 md:text-heading5 xl:text-heading4 text-center  text-white font-medium", children: e }) })
    ] }),
    /* @__PURE__ */ d(
      "div",
      {
        className: ge(
          "grid grid-cols-1  gap-10 xl:gap-20 justify-items-center",
          r.length === 2 && "md:grid-cols-2 xl:grid-cols-2",
          r.length >= 3 && "w-full md:grid-cols-2 xl:grid-cols-3"
        ),
        children: r.map((i, s) => /* @__PURE__ */ d("div", { className: "w-full", children: n(i) }, `our-team-${s}`))
      }
    )
  ] }) }) });
};
function z1(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function o1(t = {}, e = {}) {
  Object.keys(e).forEach((r) => {
    typeof t[r] > "u" ? t[r] = e[r] : z1(e[r]) && z1(t[r]) && Object.keys(e[r]).length > 0 && o1(t[r], e[r]);
  });
}
const tl = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function mr() {
  const t = typeof document < "u" ? document : {};
  return o1(t, tl), t;
}
const Y0 = {
  document: tl,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function Qe() {
  const t = typeof window < "u" ? window : {};
  return o1(t, Y0), t;
}
function J0(t) {
  const e = t;
  Object.keys(e).forEach((r) => {
    try {
      e[r] = null;
    } catch {
    }
    try {
      delete e[r];
    } catch {
    }
  });
}
function ds(t, e = 0) {
  return setTimeout(t, e);
}
function Xn() {
  return Date.now();
}
function Z0(t) {
  const e = Qe();
  let r;
  return e.getComputedStyle && (r = e.getComputedStyle(t, null)), !r && t.currentStyle && (r = t.currentStyle), r || (r = t.style), r;
}
function K0(t, e = "x") {
  const r = Qe();
  let n, i, s;
  const o = Z0(t);
  return r.WebKitCSSMatrix ? (i = o.transform || o.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map((l) => l.replace(",", ".")).join(", ")), s = new r.WebKitCSSMatrix(i === "none" ? "" : i)) : (s = o.MozTransform || o.OTransform || o.MsTransform || o.msTransform || o.transform || o.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = s.toString().split(",")), e === "x" && (r.WebKitCSSMatrix ? i = s.m41 : n.length === 16 ? i = parseFloat(n[12]) : i = parseFloat(n[4])), e === "y" && (r.WebKitCSSMatrix ? i = s.m42 : n.length === 16 ? i = parseFloat(n[13]) : i = parseFloat(n[5])), i || 0;
}
function Vn(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function X0(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function We(...t) {
  const e = Object(t[0]), r = ["__proto__", "constructor", "prototype"];
  for (let n = 1; n < t.length; n += 1) {
    const i = t[n];
    if (i != null && !X0(i)) {
      const s = Object.keys(Object(i)).filter((o) => r.indexOf(o) < 0);
      for (let o = 0, l = s.length; o < l; o += 1) {
        const c = s[o], u = Object.getOwnPropertyDescriptor(i, c);
        u !== void 0 && u.enumerable && (Vn(e[c]) && Vn(i[c]) ? i[c].__swiper__ ? e[c] = i[c] : We(e[c], i[c]) : !Vn(e[c]) && Vn(i[c]) ? (e[c] = {}, i[c].__swiper__ ? e[c] = i[c] : We(e[c], i[c])) : e[c] = i[c]);
      }
    }
  }
  return e;
}
function zn(t, e, r) {
  t.style.setProperty(e, r);
}
function rl({
  swiper: t,
  targetPosition: e,
  side: r
}) {
  const n = Qe(), i = -t.translate;
  let s = null, o;
  const l = t.params.speed;
  t.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(t.cssModeFrameID);
  const c = e > i ? "next" : "prev", u = (C, v) => c === "next" && C >= v || c === "prev" && C <= v, f = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), s === null && (s = o);
    const C = Math.max(Math.min((o - s) / l, 1), 0), v = 0.5 - Math.cos(C * Math.PI) / 2;
    let w = i + v * (e - i);
    if (u(w, e) && (w = e), t.wrapperEl.scrollTo({
      [r]: w
    }), u(w, e)) {
      t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
          [r]: w
        });
      }), n.cancelAnimationFrame(t.cssModeFrameID);
      return;
    }
    t.cssModeFrameID = n.requestAnimationFrame(f);
  };
  f();
}
function gt(t, e = "") {
  return [...t.children].filter((r) => r.matches(e));
}
function nl(t, e = []) {
  const r = document.createElement(t);
  return r.classList.add(...Array.isArray(e) ? e : [e]), r;
}
function e8(t, e) {
  const r = [];
  for (; t.previousElementSibling; ) {
    const n = t.previousElementSibling;
    e ? n.matches(e) && r.push(n) : r.push(n), t = n;
  }
  return r;
}
function t8(t, e) {
  const r = [];
  for (; t.nextElementSibling; ) {
    const n = t.nextElementSibling;
    e ? n.matches(e) && r.push(n) : r.push(n), t = n;
  }
  return r;
}
function Ht(t, e) {
  return Qe().getComputedStyle(t, null).getPropertyValue(e);
}
function ei(t) {
  let e = t, r;
  if (e) {
    for (r = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (r += 1);
    return r;
  }
}
function il(t, e) {
  const r = [];
  let n = t.parentElement;
  for (; n; )
    e ? n.matches(e) && r.push(n) : r.push(n), n = n.parentElement;
  return r;
}
function fs(t, e, r) {
  const n = Qe();
  return r ? t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom")) : t.offsetWidth;
}
let Wi;
function r8() {
  const t = Qe(), e = mr();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function sl() {
  return Wi || (Wi = r8()), Wi;
}
let Hi;
function n8({
  userAgent: t
} = {}) {
  const e = sl(), r = Qe(), n = r.navigator.platform, i = t || r.navigator.userAgent, s = {
    ios: !1,
    android: !1
  }, o = r.screen.width, l = r.screen.height, c = i.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = i.match(/(iPad).*OS\s([\d_]+)/);
  const f = i.match(/(iPod)(.*OS\s([\d_]+))?/), C = !u && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/), v = n === "Win32";
  let w = n === "MacIntel";
  const g = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && w && e.touch && g.indexOf(`${o}x${l}`) >= 0 && (u = i.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), w = !1), c && !v && (s.os = "android", s.android = !0), (u || C || f) && (s.os = "ios", s.ios = !0), s;
}
function i8(t = {}) {
  return Hi || (Hi = n8(t)), Hi;
}
let Gi;
function s8() {
  const t = Qe();
  let e = !1;
  function r() {
    const n = t.navigator.userAgent.toLowerCase();
    return n.indexOf("safari") >= 0 && n.indexOf("chrome") < 0 && n.indexOf("android") < 0;
  }
  if (r()) {
    const n = String(t.navigator.userAgent);
    if (n.includes("Version/")) {
      const [i, s] = n.split("Version/")[1].split(" ")[0].split(".").map((o) => Number(o));
      e = i < 16 || i === 16 && s < 2;
    }
  }
  return {
    isSafari: e || r(),
    needPerspectiveFix: e,
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
  };
}
function o8() {
  return Gi || (Gi = s8()), Gi;
}
function a8({
  swiper: t,
  on: e,
  emit: r
}) {
  const n = Qe();
  let i = null, s = null;
  const o = () => {
    !t || t.destroyed || !t.initialized || (r("beforeResize"), r("resize"));
  }, l = () => {
    !t || t.destroyed || !t.initialized || (i = new ResizeObserver((f) => {
      s = n.requestAnimationFrame(() => {
        const {
          width: C,
          height: v
        } = t;
        let w = C, g = v;
        f.forEach(({
          contentBoxSize: b,
          contentRect: _,
          target: h
        }) => {
          h && h !== t.el || (w = _ ? _.width : (b[0] || b).inlineSize, g = _ ? _.height : (b[0] || b).blockSize);
        }), (w !== C || g !== v) && o();
      });
    }), i.observe(t.el));
  }, c = () => {
    s && n.cancelAnimationFrame(s), i && i.unobserve && t.el && (i.unobserve(t.el), i = null);
  }, u = () => {
    !t || t.destroyed || !t.initialized || r("orientationchange");
  };
  e("init", () => {
    if (t.params.resizeObserver && typeof n.ResizeObserver < "u") {
      l();
      return;
    }
    n.addEventListener("resize", o), n.addEventListener("orientationchange", u);
  }), e("destroy", () => {
    c(), n.removeEventListener("resize", o), n.removeEventListener("orientationchange", u);
  });
}
function l8({
  swiper: t,
  extendParams: e,
  on: r,
  emit: n
}) {
  const i = [], s = Qe(), o = (u, f = {}) => {
    const C = s.MutationObserver || s.WebkitMutationObserver, v = new C((w) => {
      if (t.__preventObserver__)
        return;
      if (w.length === 1) {
        n("observerUpdate", w[0]);
        return;
      }
      const g = function() {
        n("observerUpdate", w[0]);
      };
      s.requestAnimationFrame ? s.requestAnimationFrame(g) : s.setTimeout(g, 0);
    });
    v.observe(u, {
      attributes: typeof f.attributes > "u" ? !0 : f.attributes,
      childList: typeof f.childList > "u" ? !0 : f.childList,
      characterData: typeof f.characterData > "u" ? !0 : f.characterData
    }), i.push(v);
  }, l = () => {
    if (t.params.observer) {
      if (t.params.observeParents) {
        const u = il(t.el);
        for (let f = 0; f < u.length; f += 1)
          o(u[f]);
      }
      o(t.el, {
        childList: t.params.observeSlideChildren
      }), o(t.wrapperEl, {
        attributes: !1
      });
    }
  }, c = () => {
    i.forEach((u) => {
      u.disconnect();
    }), i.splice(0, i.length);
  };
  e({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), r("init", l), r("destroy", c);
}
const c8 = {
  on(t, e, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    const i = r ? "unshift" : "push";
    return t.split(" ").forEach((s) => {
      n.eventsListeners[s] || (n.eventsListeners[s] = []), n.eventsListeners[s][i](e);
    }), n;
  },
  once(t, e, r) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function")
      return n;
    function i(...s) {
      n.off(t, i), i.__emitterProxy && delete i.__emitterProxy, e.apply(n, s);
    }
    return i.__emitterProxy = e, n.on(t, i, r);
  },
  onAny(t, e) {
    const r = this;
    if (!r.eventsListeners || r.destroyed || typeof t != "function")
      return r;
    const n = e ? "unshift" : "push";
    return r.eventsAnyListeners.indexOf(t) < 0 && r.eventsAnyListeners[n](t), r;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners)
      return e;
    const r = e.eventsAnyListeners.indexOf(t);
    return r >= 0 && e.eventsAnyListeners.splice(r, 1), e;
  },
  off(t, e) {
    const r = this;
    return !r.eventsListeners || r.destroyed || !r.eventsListeners || t.split(" ").forEach((n) => {
      typeof e > "u" ? r.eventsListeners[n] = [] : r.eventsListeners[n] && r.eventsListeners[n].forEach((i, s) => {
        (i === e || i.__emitterProxy && i.__emitterProxy === e) && r.eventsListeners[n].splice(s, 1);
      });
    }), r;
  },
  emit(...t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsListeners)
      return e;
    let r, n, i;
    return typeof t[0] == "string" || Array.isArray(t[0]) ? (r = t[0], n = t.slice(1, t.length), i = e) : (r = t[0].events, n = t[0].data, i = t[0].context || e), n.unshift(i), (Array.isArray(r) ? r : r.split(" ")).forEach((o) => {
      e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach((l) => {
        l.apply(i, [o, ...n]);
      }), e.eventsListeners && e.eventsListeners[o] && e.eventsListeners[o].forEach((l) => {
        l.apply(i, n);
      });
    }), e;
  }
};
function u8() {
  const t = this;
  let e, r;
  const n = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = n.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? r = t.params.height : r = n.clientHeight, !(e === 0 && t.isHorizontal() || r === 0 && t.isVertical()) && (e = e - parseInt(Ht(n, "padding-left") || 0, 10) - parseInt(Ht(n, "padding-right") || 0, 10), r = r - parseInt(Ht(n, "padding-top") || 0, 10) - parseInt(Ht(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(r) && (r = 0), Object.assign(t, {
    width: e,
    height: r,
    size: t.isHorizontal() ? e : r
  }));
}
function d8() {
  const t = this;
  function e(N) {
    return t.isHorizontal() ? N : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[N];
  }
  function r(N, R) {
    return parseFloat(N.getPropertyValue(e(R)) || 0);
  }
  const n = t.params, {
    wrapperEl: i,
    slidesEl: s,
    size: o,
    rtlTranslate: l,
    wrongRTL: c
  } = t, u = t.virtual && n.virtual.enabled, f = u ? t.virtual.slides.length : t.slides.length, C = gt(s, `.${t.params.slideClass}, swiper-slide`), v = u ? t.virtual.slides.length : C.length;
  let w = [];
  const g = [], b = [];
  let _ = n.slidesOffsetBefore;
  typeof _ == "function" && (_ = n.slidesOffsetBefore.call(t));
  let h = n.slidesOffsetAfter;
  typeof h == "function" && (h = n.slidesOffsetAfter.call(t));
  const y = t.snapGrid.length, E = t.slidesGrid.length;
  let T = n.spaceBetween, $ = -_, L = 0, z = 0;
  if (typeof o > "u")
    return;
  typeof T == "string" && T.indexOf("%") >= 0 ? T = parseFloat(T.replace("%", "")) / 100 * o : typeof T == "string" && (T = parseFloat(T)), t.virtualSize = -T, C.forEach((N) => {
    l ? N.style.marginLeft = "" : N.style.marginRight = "", N.style.marginBottom = "", N.style.marginTop = "";
  }), n.centeredSlides && n.cssMode && (zn(i, "--swiper-centered-offset-before", ""), zn(i, "--swiper-centered-offset-after", ""));
  const P = n.grid && n.grid.rows > 1 && t.grid;
  P && t.grid.initSlides(v);
  let B;
  const q = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((N) => typeof n.breakpoints[N].slidesPerView < "u").length > 0;
  for (let N = 0; N < v; N += 1) {
    B = 0;
    let R;
    if (C[N] && (R = C[N]), P && t.grid.updateSlide(N, R, v, e), !(C[N] && Ht(R, "display") === "none")) {
      if (n.slidesPerView === "auto") {
        q && (C[N].style[e("width")] = "");
        const D = getComputedStyle(R), Q = R.style.transform, se = R.style.webkitTransform;
        if (Q && (R.style.transform = "none"), se && (R.style.webkitTransform = "none"), n.roundLengths)
          B = t.isHorizontal() ? fs(R, "width", !0) : fs(R, "height", !0);
        else {
          const Y = r(D, "width"), ie = r(D, "padding-left"), F = r(D, "padding-right"), O = r(D, "margin-left"), k = r(D, "margin-right"), U = D.getPropertyValue("box-sizing");
          if (U && U === "border-box")
            B = Y + O + k;
          else {
            const {
              clientWidth: V,
              offsetWidth: H
            } = R;
            B = Y + ie + F + O + k + (H - V);
          }
        }
        Q && (R.style.transform = Q), se && (R.style.webkitTransform = se), n.roundLengths && (B = Math.floor(B));
      } else
        B = (o - (n.slidesPerView - 1) * T) / n.slidesPerView, n.roundLengths && (B = Math.floor(B)), C[N] && (C[N].style[e("width")] = `${B}px`);
      C[N] && (C[N].swiperSlideSize = B), b.push(B), n.centeredSlides ? ($ = $ + B / 2 + L / 2 + T, L === 0 && N !== 0 && ($ = $ - o / 2 - T), N === 0 && ($ = $ - o / 2 - T), Math.abs($) < 1 / 1e3 && ($ = 0), n.roundLengths && ($ = Math.floor($)), z % n.slidesPerGroup === 0 && w.push($), g.push($)) : (n.roundLengths && ($ = Math.floor($)), (z - Math.min(t.params.slidesPerGroupSkip, z)) % t.params.slidesPerGroup === 0 && w.push($), g.push($), $ = $ + B + T), t.virtualSize += B + T, L = B, z += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, o) + h, l && c && (n.effect === "slide" || n.effect === "coverflow") && (i.style.width = `${t.virtualSize + T}px`), n.setWrapperSize && (i.style[e("width")] = `${t.virtualSize + T}px`), P && t.grid.updateWrapperSize(B, w, e), !n.centeredSlides) {
    const N = [];
    for (let R = 0; R < w.length; R += 1) {
      let D = w[R];
      n.roundLengths && (D = Math.floor(D)), w[R] <= t.virtualSize - o && N.push(D);
    }
    w = N, Math.floor(t.virtualSize - o) - Math.floor(w[w.length - 1]) > 1 && w.push(t.virtualSize - o);
  }
  if (u && n.loop) {
    const N = b[0] + T;
    if (n.slidesPerGroup > 1) {
      const R = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / n.slidesPerGroup), D = N * n.slidesPerGroup;
      for (let Q = 0; Q < R; Q += 1)
        w.push(w[w.length - 1] + D);
    }
    for (let R = 0; R < t.virtual.slidesBefore + t.virtual.slidesAfter; R += 1)
      n.slidesPerGroup === 1 && w.push(w[w.length - 1] + N), g.push(g[g.length - 1] + N), t.virtualSize += N;
  }
  if (w.length === 0 && (w = [0]), T !== 0) {
    const N = t.isHorizontal() && l ? "marginLeft" : e("marginRight");
    C.filter((R, D) => !n.cssMode || n.loop ? !0 : D !== C.length - 1).forEach((R) => {
      R.style[N] = `${T}px`;
    });
  }
  if (n.centeredSlides && n.centeredSlidesBounds) {
    let N = 0;
    b.forEach((D) => {
      N += D + (T || 0);
    }), N -= T;
    const R = N - o;
    w = w.map((D) => D < 0 ? -_ : D > R ? R + h : D);
  }
  if (n.centerInsufficientSlides) {
    let N = 0;
    if (b.forEach((R) => {
      N += R + (T || 0);
    }), N -= T, N < o) {
      const R = (o - N) / 2;
      w.forEach((D, Q) => {
        w[Q] = D - R;
      }), g.forEach((D, Q) => {
        g[Q] = D + R;
      });
    }
  }
  if (Object.assign(t, {
    slides: C,
    snapGrid: w,
    slidesGrid: g,
    slidesSizesGrid: b
  }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
    zn(i, "--swiper-centered-offset-before", `${-w[0]}px`), zn(i, "--swiper-centered-offset-after", `${t.size / 2 - b[b.length - 1] / 2}px`);
    const N = -t.snapGrid[0], R = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((D) => D + N), t.slidesGrid = t.slidesGrid.map((D) => D + R);
  }
  if (v !== f && t.emit("slidesLengthChange"), w.length !== y && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), g.length !== E && t.emit("slidesGridLengthChange"), n.watchSlidesProgress && t.updateSlidesOffset(), !u && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
    const N = `${n.containerModifierClass}backface-hidden`, R = t.el.classList.contains(N);
    v <= n.maxBackfaceHiddenSlides ? R || t.el.classList.add(N) : R && t.el.classList.remove(N);
  }
}
function f8(t) {
  const e = this, r = [], n = e.virtual && e.params.virtual.enabled;
  let i = 0, s;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const o = (l) => n ? e.slides[e.getSlideIndexByData(l)] : e.slides[l];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((l) => {
        r.push(l);
      });
    else
      for (s = 0; s < Math.ceil(e.params.slidesPerView); s += 1) {
        const l = e.activeIndex + s;
        if (l > e.slides.length && !n)
          break;
        r.push(o(l));
      }
  else
    r.push(o(e.activeIndex));
  for (s = 0; s < r.length; s += 1)
    if (typeof r[s] < "u") {
      const l = r[s].offsetHeight;
      i = l > i ? l : i;
    }
  (i || i === 0) && (e.wrapperEl.style.height = `${i}px`);
}
function p8() {
  const t = this, e = t.slides, r = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let n = 0; n < e.length; n += 1)
    e[n].swiperSlideOffset = (t.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - r - t.cssOverflowAdjustment();
}
function h8(t = this && this.translate || 0) {
  const e = this, r = e.params, {
    slides: n,
    rtlTranslate: i,
    snapGrid: s
  } = e;
  if (n.length === 0)
    return;
  typeof n[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let o = -t;
  i && (o = t), n.forEach((c) => {
    c.classList.remove(r.slideVisibleClass);
  }), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let l = r.spaceBetween;
  typeof l == "string" && l.indexOf("%") >= 0 ? l = parseFloat(l.replace("%", "")) / 100 * e.size : typeof l == "string" && (l = parseFloat(l));
  for (let c = 0; c < n.length; c += 1) {
    const u = n[c];
    let f = u.swiperSlideOffset;
    r.cssMode && r.centeredSlides && (f -= n[0].swiperSlideOffset);
    const C = (o + (r.centeredSlides ? e.minTranslate() : 0) - f) / (u.swiperSlideSize + l), v = (o - s[0] + (r.centeredSlides ? e.minTranslate() : 0) - f) / (u.swiperSlideSize + l), w = -(o - f), g = w + e.slidesSizesGrid[c];
    (w >= 0 && w < e.size - 1 || g > 1 && g <= e.size || w <= 0 && g >= e.size) && (e.visibleSlides.push(u), e.visibleSlidesIndexes.push(c), n[c].classList.add(r.slideVisibleClass)), u.progress = i ? -C : C, u.originalProgress = i ? -v : v;
  }
}
function m8(t) {
  const e = this;
  if (typeof t > "u") {
    const f = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * f || 0;
  }
  const r = e.params, n = e.maxTranslate() - e.minTranslate();
  let {
    progress: i,
    isBeginning: s,
    isEnd: o,
    progressLoop: l
  } = e;
  const c = s, u = o;
  if (n === 0)
    i = 0, s = !0, o = !0;
  else {
    i = (t - e.minTranslate()) / n;
    const f = Math.abs(t - e.minTranslate()) < 1, C = Math.abs(t - e.maxTranslate()) < 1;
    s = f || i <= 0, o = C || i >= 1, f && (i = 0), C && (i = 1);
  }
  if (r.loop) {
    const f = e.getSlideIndexByData(0), C = e.getSlideIndexByData(e.slides.length - 1), v = e.slidesGrid[f], w = e.slidesGrid[C], g = e.slidesGrid[e.slidesGrid.length - 1], b = Math.abs(t);
    b >= v ? l = (b - v) / g : l = (b + g - w) / g, l > 1 && (l -= 1);
  }
  Object.assign(e, {
    progress: i,
    progressLoop: l,
    isBeginning: s,
    isEnd: o
  }), (r.watchSlidesProgress || r.centeredSlides && r.autoHeight) && e.updateSlidesProgress(t), s && !c && e.emit("reachBeginning toEdge"), o && !u && e.emit("reachEnd toEdge"), (c && !s || u && !o) && e.emit("fromEdge"), e.emit("progress", i);
}
function C8() {
  const t = this, {
    slides: e,
    params: r,
    slidesEl: n,
    activeIndex: i
  } = t, s = t.virtual && r.virtual.enabled, o = (c) => gt(n, `.${r.slideClass}${c}, swiper-slide${c}`)[0];
  e.forEach((c) => {
    c.classList.remove(r.slideActiveClass, r.slideNextClass, r.slidePrevClass);
  });
  let l;
  if (s)
    if (r.loop) {
      let c = i - t.virtual.slidesBefore;
      c < 0 && (c = t.virtual.slides.length + c), c >= t.virtual.slides.length && (c -= t.virtual.slides.length), l = o(`[data-swiper-slide-index="${c}"]`);
    } else
      l = o(`[data-swiper-slide-index="${i}"]`);
  else
    l = e[i];
  if (l) {
    l.classList.add(r.slideActiveClass);
    let c = t8(l, `.${r.slideClass}, swiper-slide`)[0];
    r.loop && !c && (c = e[0]), c && c.classList.add(r.slideNextClass);
    let u = e8(l, `.${r.slideClass}, swiper-slide`)[0];
    r.loop && !u === 0 && (u = e[e.length - 1]), u && u.classList.add(r.slidePrevClass);
  }
  t.emitSlidesClasses();
}
const Wn = (t, e) => {
  if (!t || t.destroyed || !t.params)
    return;
  const r = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, n = e.closest(r());
  if (n) {
    const i = n.querySelector(`.${t.params.lazyPreloaderClass}`);
    i && i.remove();
  }
}, B1 = (t, e) => {
  if (!t.slides[e])
    return;
  const r = t.slides[e].querySelector('[loading="lazy"]');
  r && r.removeAttribute("loading");
}, ps = (t) => {
  if (!t || t.destroyed || !t.params)
    return;
  let e = t.params.lazyPreloadPrevNext;
  const r = t.slides.length;
  if (!r || !e || e < 0)
    return;
  e = Math.min(e, r);
  const n = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), i = t.activeIndex, s = i + n - 1;
  if (t.params.rewind)
    for (let o = i - e; o <= s + e; o += 1) {
      const l = (o % r + r) % r;
      l !== i && l > s && B1(t, l);
    }
  else
    for (let o = Math.max(s - e, 0); o <= Math.min(s + e, r - 1); o += 1)
      o !== i && o > s && B1(t, o);
};
function g8(t) {
  const {
    slidesGrid: e,
    params: r
  } = t, n = t.rtlTranslate ? t.translate : -t.translate;
  let i;
  for (let s = 0; s < e.length; s += 1)
    typeof e[s + 1] < "u" ? n >= e[s] && n < e[s + 1] - (e[s + 1] - e[s]) / 2 ? i = s : n >= e[s] && n < e[s + 1] && (i = s + 1) : n >= e[s] && (i = s);
  return r.normalizeSlideIndex && (i < 0 || typeof i > "u") && (i = 0), i;
}
function v8(t) {
  const e = this, r = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: n,
    params: i,
    activeIndex: s,
    realIndex: o,
    snapIndex: l
  } = e;
  let c = t, u;
  const f = (v) => {
    let w = v - e.virtual.slidesBefore;
    return w < 0 && (w = e.virtual.slides.length + w), w >= e.virtual.slides.length && (w -= e.virtual.slides.length), w;
  };
  if (typeof c > "u" && (c = g8(e)), n.indexOf(r) >= 0)
    u = n.indexOf(r);
  else {
    const v = Math.min(i.slidesPerGroupSkip, c);
    u = v + Math.floor((c - v) / i.slidesPerGroup);
  }
  if (u >= n.length && (u = n.length - 1), c === s) {
    u !== l && (e.snapIndex = u, e.emit("snapIndexChange")), e.params.loop && e.virtual && e.params.virtual.enabled && (e.realIndex = f(c));
    return;
  }
  let C;
  e.virtual && i.virtual.enabled && i.loop ? C = f(c) : e.slides[c] ? C = parseInt(e.slides[c].getAttribute("data-swiper-slide-index") || c, 10) : C = c, Object.assign(e, {
    previousSnapIndex: l,
    snapIndex: u,
    previousRealIndex: o,
    realIndex: C,
    previousIndex: s,
    activeIndex: c
  }), e.initialized && ps(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), o !== C && e.emit("realIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && e.emit("slideChange");
}
function y8(t) {
  const e = this, r = e.params, n = t.closest(`.${r.slideClass}, swiper-slide`);
  let i = !1, s;
  if (n) {
    for (let o = 0; o < e.slides.length; o += 1)
      if (e.slides[o] === n) {
        i = !0, s = o;
        break;
      }
  }
  if (n && i)
    e.clickedSlide = n, e.virtual && e.params.virtual.enabled ? e.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : e.clickedIndex = s;
  else {
    e.clickedSlide = void 0, e.clickedIndex = void 0;
    return;
  }
  r.slideToClickedSlide && e.clickedIndex !== void 0 && e.clickedIndex !== e.activeIndex && e.slideToClickedSlide();
}
const x8 = {
  updateSize: u8,
  updateSlides: d8,
  updateAutoHeight: f8,
  updateSlidesOffset: p8,
  updateSlidesProgress: h8,
  updateProgress: m8,
  updateSlidesClasses: C8,
  updateActiveIndex: v8,
  updateClickedSlide: y8
};
function w8(t = this.isHorizontal() ? "x" : "y") {
  const e = this, {
    params: r,
    rtlTranslate: n,
    translate: i,
    wrapperEl: s
  } = e;
  if (r.virtualTranslate)
    return n ? -i : i;
  if (r.cssMode)
    return i;
  let o = K0(s, t);
  return o += e.cssOverflowAdjustment(), n && (o = -o), o || 0;
}
function b8(t, e) {
  const r = this, {
    rtlTranslate: n,
    params: i,
    wrapperEl: s,
    progress: o
  } = r;
  let l = 0, c = 0;
  const u = 0;
  r.isHorizontal() ? l = n ? -t : t : c = t, i.roundLengths && (l = Math.floor(l), c = Math.floor(c)), r.previousTranslate = r.translate, r.translate = r.isHorizontal() ? l : c, i.cssMode ? s[r.isHorizontal() ? "scrollLeft" : "scrollTop"] = r.isHorizontal() ? -l : -c : i.virtualTranslate || (r.isHorizontal() ? l -= r.cssOverflowAdjustment() : c -= r.cssOverflowAdjustment(), s.style.transform = `translate3d(${l}px, ${c}px, ${u}px)`);
  let f;
  const C = r.maxTranslate() - r.minTranslate();
  C === 0 ? f = 0 : f = (t - r.minTranslate()) / C, f !== o && r.updateProgress(t), r.emit("setTranslate", r.translate, e);
}
function _8() {
  return -this.snapGrid[0];
}
function S8() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function E8(t = 0, e = this.params.speed, r = !0, n = !0, i) {
  const s = this, {
    params: o,
    wrapperEl: l
  } = s;
  if (s.animating && o.preventInteractionOnTransition)
    return !1;
  const c = s.minTranslate(), u = s.maxTranslate();
  let f;
  if (n && t > c ? f = c : n && t < u ? f = u : f = t, s.updateProgress(f), o.cssMode) {
    const C = s.isHorizontal();
    if (e === 0)
      l[C ? "scrollLeft" : "scrollTop"] = -f;
    else {
      if (!s.support.smoothScroll)
        return rl({
          swiper: s,
          targetPosition: -f,
          side: C ? "left" : "top"
        }), !0;
      l.scrollTo({
        [C ? "left" : "top"]: -f,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (s.setTransition(0), s.setTranslate(f), r && (s.emit("beforeTransitionStart", e, i), s.emit("transitionEnd"))) : (s.setTransition(e), s.setTranslate(f), r && (s.emit("beforeTransitionStart", e, i), s.emit("transitionStart")), s.animating || (s.animating = !0, s.onTranslateToWrapperTransitionEnd || (s.onTranslateToWrapperTransitionEnd = function(v) {
    !s || s.destroyed || v.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd), s.onTranslateToWrapperTransitionEnd = null, delete s.onTranslateToWrapperTransitionEnd, r && s.emit("transitionEnd"));
  }), s.wrapperEl.addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd))), !0;
}
const T8 = {
  getTranslate: w8,
  setTranslate: b8,
  minTranslate: _8,
  maxTranslate: S8,
  translateTo: E8
};
function k8(t, e) {
  const r = this;
  r.params.cssMode || (r.wrapperEl.style.transitionDuration = `${t}ms`), r.emit("setTransition", t, e);
}
function ol({
  swiper: t,
  runCallbacks: e,
  direction: r,
  step: n
}) {
  const {
    activeIndex: i,
    previousIndex: s
  } = t;
  let o = r;
  if (o || (i > s ? o = "next" : i < s ? o = "prev" : o = "reset"), t.emit(`transition${n}`), e && i !== s) {
    if (o === "reset") {
      t.emit(`slideResetTransition${n}`);
      return;
    }
    t.emit(`slideChangeTransition${n}`), o === "next" ? t.emit(`slideNextTransition${n}`) : t.emit(`slidePrevTransition${n}`);
  }
}
function M8(t = !0, e) {
  const r = this, {
    params: n
  } = r;
  n.cssMode || (n.autoHeight && r.updateAutoHeight(), ol({
    swiper: r,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function O8(t = !0, e) {
  const r = this, {
    params: n
  } = r;
  r.animating = !1, !n.cssMode && (r.setTransition(0), ol({
    swiper: r,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
const L8 = {
  setTransition: k8,
  transitionStart: M8,
  transitionEnd: O8
};
function P8(t = 0, e = this.params.speed, r = !0, n, i) {
  typeof t == "string" && (t = parseInt(t, 10));
  const s = this;
  let o = t;
  o < 0 && (o = 0);
  const {
    params: l,
    snapGrid: c,
    slidesGrid: u,
    previousIndex: f,
    activeIndex: C,
    rtlTranslate: v,
    wrapperEl: w,
    enabled: g
  } = s;
  if (s.animating && l.preventInteractionOnTransition || !g && !n && !i)
    return !1;
  const b = Math.min(s.params.slidesPerGroupSkip, o);
  let _ = b + Math.floor((o - b) / s.params.slidesPerGroup);
  _ >= c.length && (_ = c.length - 1);
  const h = -c[_];
  if (l.normalizeSlideIndex)
    for (let E = 0; E < u.length; E += 1) {
      const T = -Math.floor(h * 100), $ = Math.floor(u[E] * 100), L = Math.floor(u[E + 1] * 100);
      typeof u[E + 1] < "u" ? T >= $ && T < L - (L - $) / 2 ? o = E : T >= $ && T < L && (o = E + 1) : T >= $ && (o = E);
    }
  if (s.initialized && o !== C && (!s.allowSlideNext && h < s.translate && h < s.minTranslate() || !s.allowSlidePrev && h > s.translate && h > s.maxTranslate() && (C || 0) !== o))
    return !1;
  o !== (f || 0) && r && s.emit("beforeSlideChangeStart"), s.updateProgress(h);
  let y;
  if (o > C ? y = "next" : o < C ? y = "prev" : y = "reset", v && -h === s.translate || !v && h === s.translate)
    return s.updateActiveIndex(o), l.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), l.effect !== "slide" && s.setTranslate(h), y !== "reset" && (s.transitionStart(r, y), s.transitionEnd(r, y)), !1;
  if (l.cssMode) {
    const E = s.isHorizontal(), T = v ? h : -h;
    if (e === 0) {
      const $ = s.virtual && s.params.virtual.enabled;
      $ && (s.wrapperEl.style.scrollSnapType = "none", s._immediateVirtual = !0), $ && !s._cssModeVirtualInitialSet && s.params.initialSlide > 0 ? (s._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        w[E ? "scrollLeft" : "scrollTop"] = T;
      })) : w[E ? "scrollLeft" : "scrollTop"] = T, $ && requestAnimationFrame(() => {
        s.wrapperEl.style.scrollSnapType = "", s._immediateVirtual = !1;
      });
    } else {
      if (!s.support.smoothScroll)
        return rl({
          swiper: s,
          targetPosition: T,
          side: E ? "left" : "top"
        }), !0;
      w.scrollTo({
        [E ? "left" : "top"]: T,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return s.setTransition(e), s.setTranslate(h), s.updateActiveIndex(o), s.updateSlidesClasses(), s.emit("beforeTransitionStart", e, n), s.transitionStart(r, y), e === 0 ? s.transitionEnd(r, y) : s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function(T) {
    !s || s.destroyed || T.target === this && (s.wrapperEl.removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(r, y));
  }), s.wrapperEl.addEventListener("transitionend", s.onSlideToWrapperTransitionEnd)), !0;
}
function A8(t = 0, e = this.params.speed, r = !0, n) {
  typeof t == "string" && (t = parseInt(t, 10));
  const i = this;
  let s = t;
  return i.params.loop && (i.virtual && i.params.virtual.enabled ? s = s + i.virtual.slidesBefore : s = i.getSlideIndexByData(s)), i.slideTo(s, e, r, n);
}
function N8(t = this.params.speed, e = !0, r) {
  const n = this, {
    enabled: i,
    params: s,
    animating: o
  } = n;
  if (!i)
    return n;
  let l = s.slidesPerGroup;
  s.slidesPerView === "auto" && s.slidesPerGroup === 1 && s.slidesPerGroupAuto && (l = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const c = n.activeIndex < s.slidesPerGroupSkip ? 1 : l, u = n.virtual && s.virtual.enabled;
  if (s.loop) {
    if (o && !u && s.loopPreventsSliding)
      return !1;
    n.loopFix({
      direction: "next"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  return s.rewind && n.isEnd ? n.slideTo(0, t, e, r) : n.slideTo(n.activeIndex + c, t, e, r);
}
function $8(t = this.params.speed, e = !0, r) {
  const n = this, {
    params: i,
    snapGrid: s,
    slidesGrid: o,
    rtlTranslate: l,
    enabled: c,
    animating: u
  } = n;
  if (!c)
    return n;
  const f = n.virtual && i.virtual.enabled;
  if (i.loop) {
    if (u && !f && i.loopPreventsSliding)
      return !1;
    n.loopFix({
      direction: "prev"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  const C = l ? n.translate : -n.translate;
  function v(h) {
    return h < 0 ? -Math.floor(Math.abs(h)) : Math.floor(h);
  }
  const w = v(C), g = s.map((h) => v(h));
  let b = s[g.indexOf(w) - 1];
  if (typeof b > "u" && i.cssMode) {
    let h;
    s.forEach((y, E) => {
      w >= y && (h = E);
    }), typeof h < "u" && (b = s[h > 0 ? h - 1 : h]);
  }
  let _ = 0;
  if (typeof b < "u" && (_ = o.indexOf(b), _ < 0 && (_ = n.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (_ = _ - n.slidesPerViewDynamic("previous", !0) + 1, _ = Math.max(_, 0))), i.rewind && n.isBeginning) {
    const h = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(h, t, e, r);
  }
  return n.slideTo(_, t, e, r);
}
function j8(t = this.params.speed, e = !0, r) {
  const n = this;
  return n.slideTo(n.activeIndex, t, e, r);
}
function F8(t = this.params.speed, e = !0, r, n = 0.5) {
  const i = this;
  let s = i.activeIndex;
  const o = Math.min(i.params.slidesPerGroupSkip, s), l = o + Math.floor((s - o) / i.params.slidesPerGroup), c = i.rtlTranslate ? i.translate : -i.translate;
  if (c >= i.snapGrid[l]) {
    const u = i.snapGrid[l], f = i.snapGrid[l + 1];
    c - u > (f - u) * n && (s += i.params.slidesPerGroup);
  } else {
    const u = i.snapGrid[l - 1], f = i.snapGrid[l];
    c - u <= (f - u) * n && (s -= i.params.slidesPerGroup);
  }
  return s = Math.max(s, 0), s = Math.min(s, i.slidesGrid.length - 1), i.slideTo(s, t, e, r);
}
function R8() {
  const t = this, {
    params: e,
    slidesEl: r
  } = t, n = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let i = t.clickedIndex, s;
  const o = t.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (t.animating)
      return;
    s = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? i < t.loopedSlides - n / 2 || i > t.slides.length - t.loopedSlides + n / 2 ? (t.loopFix(), i = t.getSlideIndex(gt(r, `${o}[data-swiper-slide-index="${s}"]`)[0]), ds(() => {
      t.slideTo(i);
    })) : t.slideTo(i) : i > t.slides.length - n ? (t.loopFix(), i = t.getSlideIndex(gt(r, `${o}[data-swiper-slide-index="${s}"]`)[0]), ds(() => {
      t.slideTo(i);
    })) : t.slideTo(i);
  } else
    t.slideTo(i);
}
const I8 = {
  slideTo: P8,
  slideToLoop: A8,
  slideNext: N8,
  slidePrev: $8,
  slideReset: j8,
  slideToClosest: F8,
  slideToClickedSlide: R8
};
function D8(t) {
  const e = this, {
    params: r,
    slidesEl: n
  } = e;
  if (!r.loop || e.virtual && e.params.virtual.enabled)
    return;
  gt(n, `.${r.slideClass}, swiper-slide`).forEach((s, o) => {
    s.setAttribute("data-swiper-slide-index", o);
  }), e.loopFix({
    slideRealIndex: t,
    direction: r.centeredSlides ? void 0 : "next"
  });
}
function V8({
  slideRealIndex: t,
  slideTo: e = !0,
  direction: r,
  setTranslate: n,
  activeSlideIndex: i,
  byController: s,
  byMousewheel: o
} = {}) {
  const l = this;
  if (!l.params.loop)
    return;
  l.emit("beforeLoopFix");
  const {
    slides: c,
    allowSlidePrev: u,
    allowSlideNext: f,
    slidesEl: C,
    params: v
  } = l;
  if (l.allowSlidePrev = !0, l.allowSlideNext = !0, l.virtual && v.virtual.enabled) {
    e && (!v.centeredSlides && l.snapIndex === 0 ? l.slideTo(l.virtual.slides.length, 0, !1, !0) : v.centeredSlides && l.snapIndex < v.slidesPerView ? l.slideTo(l.virtual.slides.length + l.snapIndex, 0, !1, !0) : l.snapIndex === l.snapGrid.length - 1 && l.slideTo(l.virtual.slidesBefore, 0, !1, !0)), l.allowSlidePrev = u, l.allowSlideNext = f, l.emit("loopFix");
    return;
  }
  const w = v.slidesPerView === "auto" ? l.slidesPerViewDynamic() : Math.ceil(parseFloat(v.slidesPerView, 10));
  let g = v.loopedSlides || w;
  g % v.slidesPerGroup !== 0 && (g += v.slidesPerGroup - g % v.slidesPerGroup), l.loopedSlides = g;
  const b = [], _ = [];
  let h = l.activeIndex;
  typeof i > "u" ? i = l.getSlideIndex(l.slides.filter((L) => L.classList.contains(v.slideActiveClass))[0]) : h = i;
  const y = r === "next" || !r, E = r === "prev" || !r;
  let T = 0, $ = 0;
  if (i < g) {
    T = Math.max(g - i, v.slidesPerGroup);
    for (let L = 0; L < g - i; L += 1) {
      const z = L - Math.floor(L / c.length) * c.length;
      b.push(c.length - z - 1);
    }
  } else if (i > l.slides.length - g * 2) {
    $ = Math.max(i - (l.slides.length - g * 2), v.slidesPerGroup);
    for (let L = 0; L < $; L += 1) {
      const z = L - Math.floor(L / c.length) * c.length;
      _.push(z);
    }
  }
  if (E && b.forEach((L) => {
    l.slides[L].swiperLoopMoveDOM = !0, C.prepend(l.slides[L]), l.slides[L].swiperLoopMoveDOM = !1;
  }), y && _.forEach((L) => {
    l.slides[L].swiperLoopMoveDOM = !0, C.append(l.slides[L]), l.slides[L].swiperLoopMoveDOM = !1;
  }), l.recalcSlides(), v.slidesPerView === "auto" && l.updateSlides(), v.watchSlidesProgress && l.updateSlidesOffset(), e) {
    if (b.length > 0 && E)
      if (typeof t > "u") {
        const L = l.slidesGrid[h], P = l.slidesGrid[h + T] - L;
        o ? l.setTranslate(l.translate - P) : (l.slideTo(h + T, 0, !1, !0), n && (l.touches[l.isHorizontal() ? "startX" : "startY"] += P));
      } else
        n && l.slideToLoop(t, 0, !1, !0);
    else if (_.length > 0 && y)
      if (typeof t > "u") {
        const L = l.slidesGrid[h], P = l.slidesGrid[h - $] - L;
        o ? l.setTranslate(l.translate - P) : (l.slideTo(h - $, 0, !1, !0), n && (l.touches[l.isHorizontal() ? "startX" : "startY"] += P));
      } else
        l.slideToLoop(t, 0, !1, !0);
  }
  if (l.allowSlidePrev = u, l.allowSlideNext = f, l.controller && l.controller.control && !s) {
    const L = {
      slideRealIndex: t,
      slideTo: !1,
      direction: r,
      setTranslate: n,
      activeSlideIndex: i,
      byController: !0
    };
    Array.isArray(l.controller.control) ? l.controller.control.forEach((z) => {
      !z.destroyed && z.params.loop && z.loopFix(L);
    }) : l.controller.control instanceof l.constructor && l.controller.control.params.loop && l.controller.control.loopFix(L);
  }
  l.emit("loopFix");
}
function z8() {
  const t = this, {
    params: e,
    slidesEl: r
  } = t;
  if (!e.loop || t.virtual && t.params.virtual.enabled)
    return;
  t.recalcSlides();
  const n = [];
  t.slides.forEach((i) => {
    const s = typeof i.swiperSlideIndex > "u" ? i.getAttribute("data-swiper-slide-index") * 1 : i.swiperSlideIndex;
    n[s] = i;
  }), t.slides.forEach((i) => {
    i.removeAttribute("data-swiper-slide-index");
  }), n.forEach((i) => {
    r.append(i);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
const B8 = {
  loopCreate: D8,
  loopFix: V8,
  loopDestroy: z8
};
function W8(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode)
    return;
  const r = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), r.style.cursor = "move", r.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function H8() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
const G8 = {
  setGrabCursor: W8,
  unsetGrabCursor: H8
};
function q8(t, e = this) {
  function r(n) {
    if (!n || n === mr() || n === Qe())
      return null;
    n.assignedSlot && (n = n.assignedSlot);
    const i = n.closest(t);
    return !i && !n.getRootNode ? null : i || r(n.getRootNode().host);
  }
  return r(e);
}
function U8(t) {
  const e = this, r = mr(), n = Qe(), i = e.touchEventsData;
  i.evCache.push(t);
  const {
    params: s,
    touches: o,
    enabled: l
  } = e;
  if (!l || !s.simulateTouch && t.pointerType === "mouse" || e.animating && s.preventInteractionOnTransition)
    return;
  !e.animating && s.cssMode && s.loop && e.loopFix();
  let c = t;
  c.originalEvent && (c = c.originalEvent);
  let u = c.target;
  if (s.touchEventsTarget === "wrapper" && !e.wrapperEl.contains(u) || "which" in c && c.which === 3 || "button" in c && c.button > 0 || i.isTouched && i.isMoved)
    return;
  const f = !!s.noSwipingClass && s.noSwipingClass !== "", C = t.composedPath ? t.composedPath() : t.path;
  f && c.target && c.target.shadowRoot && C && (u = C[0]);
  const v = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`, w = !!(c.target && c.target.shadowRoot);
  if (s.noSwiping && (w ? q8(v, u) : u.closest(v))) {
    e.allowClick = !0;
    return;
  }
  if (s.swipeHandler && !u.closest(s.swipeHandler))
    return;
  o.currentX = c.pageX, o.currentY = c.pageY;
  const g = o.currentX, b = o.currentY, _ = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection, h = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
  if (_ && (g <= h || g >= n.innerWidth - h))
    if (_ === "prevent")
      t.preventDefault();
    else
      return;
  Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), o.startX = g, o.startY = b, i.touchStartTime = Xn(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, s.threshold > 0 && (i.allowThresholdMove = !1);
  let y = !0;
  u.matches(i.focusableElements) && (y = !1, u.nodeName === "SELECT" && (i.isTouched = !1)), r.activeElement && r.activeElement.matches(i.focusableElements) && r.activeElement !== u && r.activeElement.blur();
  const E = y && e.allowTouchMove && s.touchStartPreventDefault;
  (s.touchStartForcePreventDefault || E) && !u.isContentEditable && c.preventDefault(), e.params.freeMode && e.params.freeMode.enabled && e.freeMode && e.animating && !s.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", c);
}
function Q8(t) {
  const e = mr(), r = this, n = r.touchEventsData, {
    params: i,
    touches: s,
    rtlTranslate: o,
    enabled: l
  } = r;
  if (!l || !i.simulateTouch && t.pointerType === "mouse")
    return;
  let c = t;
  if (c.originalEvent && (c = c.originalEvent), !n.isTouched) {
    n.startMoving && n.isScrolling && r.emit("touchMoveOpposite", c);
    return;
  }
  const u = n.evCache.findIndex((L) => L.pointerId === c.pointerId);
  u >= 0 && (n.evCache[u] = c);
  const f = n.evCache.length > 1 ? n.evCache[0] : c, C = f.pageX, v = f.pageY;
  if (c.preventedByNestedSwiper) {
    s.startX = C, s.startY = v;
    return;
  }
  if (!r.allowTouchMove) {
    c.target.matches(n.focusableElements) || (r.allowClick = !1), n.isTouched && (Object.assign(s, {
      startX: C,
      startY: v,
      prevX: r.touches.currentX,
      prevY: r.touches.currentY,
      currentX: C,
      currentY: v
    }), n.touchStartTime = Xn());
    return;
  }
  if (i.touchReleaseOnEdges && !i.loop) {
    if (r.isVertical()) {
      if (v < s.startY && r.translate <= r.maxTranslate() || v > s.startY && r.translate >= r.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else if (C < s.startX && r.translate <= r.maxTranslate() || C > s.startX && r.translate >= r.minTranslate())
      return;
  }
  if (e.activeElement && c.target === e.activeElement && c.target.matches(n.focusableElements)) {
    n.isMoved = !0, r.allowClick = !1;
    return;
  }
  if (n.allowTouchCallbacks && r.emit("touchMove", c), c.targetTouches && c.targetTouches.length > 1)
    return;
  s.currentX = C, s.currentY = v;
  const w = s.currentX - s.startX, g = s.currentY - s.startY;
  if (r.params.threshold && Math.sqrt(w ** 2 + g ** 2) < r.params.threshold)
    return;
  if (typeof n.isScrolling > "u") {
    let L;
    r.isHorizontal() && s.currentY === s.startY || r.isVertical() && s.currentX === s.startX ? n.isScrolling = !1 : w * w + g * g >= 25 && (L = Math.atan2(Math.abs(g), Math.abs(w)) * 180 / Math.PI, n.isScrolling = r.isHorizontal() ? L > i.touchAngle : 90 - L > i.touchAngle);
  }
  if (n.isScrolling && r.emit("touchMoveOpposite", c), typeof n.startMoving > "u" && (s.currentX !== s.startX || s.currentY !== s.startY) && (n.startMoving = !0), n.isScrolling || r.zoom && r.params.zoom && r.params.zoom.enabled && n.evCache.length > 1) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  r.allowClick = !1, !i.cssMode && c.cancelable && c.preventDefault(), i.touchMoveStopPropagation && !i.nested && c.stopPropagation();
  let b = r.isHorizontal() ? w : g, _ = r.isHorizontal() ? s.currentX - s.previousX : s.currentY - s.previousY;
  i.oneWayMovement && (b = Math.abs(b) * (o ? 1 : -1), _ = Math.abs(_) * (o ? 1 : -1)), s.diff = b, b *= i.touchRatio, o && (b = -b, _ = -_);
  const h = r.touchesDirection;
  r.swipeDirection = b > 0 ? "prev" : "next", r.touchesDirection = _ > 0 ? "prev" : "next";
  const y = r.params.loop && !i.cssMode;
  if (!n.isMoved) {
    if (y && r.loopFix({
      direction: r.swipeDirection
    }), n.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
      const L = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0
      });
      r.wrapperEl.dispatchEvent(L);
    }
    n.allowMomentumBounce = !1, i.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", c);
  }
  let E;
  n.isMoved && h !== r.touchesDirection && y && Math.abs(b) >= 1 && (r.loopFix({
    direction: r.swipeDirection,
    setTranslate: !0
  }), E = !0), r.emit("sliderMove", c), n.isMoved = !0, n.currentTranslate = b + n.startTranslate;
  let T = !0, $ = i.resistanceRatio;
  if (i.touchReleaseOnEdges && ($ = 0), b > 0 ? (y && !E && n.currentTranslate > (i.centeredSlides ? r.minTranslate() - r.size / 2 : r.minTranslate()) && r.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > r.minTranslate() && (T = !1, i.resistance && (n.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + n.startTranslate + b) ** $))) : b < 0 && (y && !E && n.currentTranslate < (i.centeredSlides ? r.maxTranslate() + r.size / 2 : r.maxTranslate()) && r.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: r.slides.length - (i.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
  }), n.currentTranslate < r.maxTranslate() && (T = !1, i.resistance && (n.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - n.startTranslate - b) ** $))), T && (c.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (n.currentTranslate = n.startTranslate), i.threshold > 0)
    if (Math.abs(b) > i.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, n.currentTranslate = n.startTranslate, s.diff = r.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !i.followFinger || i.cssMode || ((i.freeMode && i.freeMode.enabled && r.freeMode || i.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), r.params.freeMode && i.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(n.currentTranslate), r.setTranslate(n.currentTranslate));
}
function Y8(t) {
  const e = this, r = e.touchEventsData, n = r.evCache.findIndex((E) => E.pointerId === t.pointerId);
  if (n >= 0 && r.evCache.splice(n, 1), ["pointercancel", "pointerout", "pointerleave"].includes(t.type) && !(t.type === "pointercancel" && (e.browser.isSafari || e.browser.isWebView)))
    return;
  const {
    params: i,
    touches: s,
    rtlTranslate: o,
    slidesGrid: l,
    enabled: c
  } = e;
  if (!c || !i.simulateTouch && t.pointerType === "mouse")
    return;
  let u = t;
  if (u.originalEvent && (u = u.originalEvent), r.allowTouchCallbacks && e.emit("touchEnd", u), r.allowTouchCallbacks = !1, !r.isTouched) {
    r.isMoved && i.grabCursor && e.setGrabCursor(!1), r.isMoved = !1, r.startMoving = !1;
    return;
  }
  i.grabCursor && r.isMoved && r.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const f = Xn(), C = f - r.touchStartTime;
  if (e.allowClick) {
    const E = u.path || u.composedPath && u.composedPath();
    e.updateClickedSlide(E && E[0] || u.target), e.emit("tap click", u), C < 300 && f - r.lastClickTime < 300 && e.emit("doubleTap doubleClick", u);
  }
  if (r.lastClickTime = Xn(), ds(() => {
    e.destroyed || (e.allowClick = !0);
  }), !r.isTouched || !r.isMoved || !e.swipeDirection || s.diff === 0 || r.currentTranslate === r.startTranslate) {
    r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
    return;
  }
  r.isTouched = !1, r.isMoved = !1, r.startMoving = !1;
  let v;
  if (i.followFinger ? v = o ? e.translate : -e.translate : v = -r.currentTranslate, i.cssMode)
    return;
  if (e.params.freeMode && i.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: v
    });
    return;
  }
  let w = 0, g = e.slidesSizesGrid[0];
  for (let E = 0; E < l.length; E += E < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
    const T = E < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
    typeof l[E + T] < "u" ? v >= l[E] && v < l[E + T] && (w = E, g = l[E + T] - l[E]) : v >= l[E] && (w = E, g = l[l.length - 1] - l[l.length - 2]);
  }
  let b = null, _ = null;
  i.rewind && (e.isBeginning ? _ = e.params.virtual && e.params.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (b = 0));
  const h = (v - l[w]) / g, y = w < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
  if (C > i.longSwipesMs) {
    if (!i.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (h >= i.longSwipesRatio ? e.slideTo(i.rewind && e.isEnd ? b : w + y) : e.slideTo(w)), e.swipeDirection === "prev" && (h > 1 - i.longSwipesRatio ? e.slideTo(w + y) : _ !== null && h < 0 && Math.abs(h) > i.longSwipesRatio ? e.slideTo(_) : e.slideTo(w));
  } else {
    if (!i.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (u.target === e.navigation.nextEl || u.target === e.navigation.prevEl) ? u.target === e.navigation.nextEl ? e.slideTo(w + y) : e.slideTo(w) : (e.swipeDirection === "next" && e.slideTo(b !== null ? b : w + y), e.swipeDirection === "prev" && e.slideTo(_ !== null ? _ : w));
  }
}
function W1() {
  const t = this, {
    params: e,
    el: r
  } = t;
  if (r && r.offsetWidth === 0)
    return;
  e.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: i,
    snapGrid: s
  } = t, o = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const l = o && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !l ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !o ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = i, t.allowSlideNext = n, t.params.watchOverflow && s !== t.snapGrid && t.checkOverflow();
}
function J8(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function Z8() {
  const t = this, {
    wrapperEl: e,
    rtlTranslate: r,
    enabled: n
  } = t;
  if (!n)
    return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let i;
  const s = t.maxTranslate() - t.minTranslate();
  s === 0 ? i = 0 : i = (t.translate - t.minTranslate()) / s, i !== t.progress && t.updateProgress(r ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function K8(t) {
  const e = this;
  Wn(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
let H1 = !1;
function X8() {
}
const al = (t, e) => {
  const r = mr(), {
    params: n,
    el: i,
    wrapperEl: s,
    device: o
  } = t, l = !!n.nested, c = e === "on" ? "addEventListener" : "removeEventListener", u = e;
  i[c]("pointerdown", t.onTouchStart, {
    passive: !1
  }), r[c]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: l
  }), r[c]("pointerup", t.onTouchEnd, {
    passive: !0
  }), r[c]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), r[c]("pointerout", t.onTouchEnd, {
    passive: !0
  }), r[c]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && i[c]("click", t.onClick, !0), n.cssMode && s[c]("scroll", t.onScroll), n.updateOnWindowResize ? t[u](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", W1, !0) : t[u]("observerUpdate", W1, !0), i[c]("load", t.onLoad, {
    capture: !0
  });
};
function ec() {
  const t = this, e = mr(), {
    params: r
  } = t;
  t.onTouchStart = U8.bind(t), t.onTouchMove = Q8.bind(t), t.onTouchEnd = Y8.bind(t), r.cssMode && (t.onScroll = Z8.bind(t)), t.onClick = J8.bind(t), t.onLoad = K8.bind(t), H1 || (e.addEventListener("touchstart", X8), H1 = !0), al(t, "on");
}
function tc() {
  al(this, "off");
}
const rc = {
  attachEvents: ec,
  detachEvents: tc
}, G1 = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function nc() {
  const t = this, {
    realIndex: e,
    initialized: r,
    params: n,
    el: i
  } = t, s = n.breakpoints;
  if (!s || s && Object.keys(s).length === 0)
    return;
  const o = t.getBreakpoint(s, t.params.breakpointsBase, t.el);
  if (!o || t.currentBreakpoint === o)
    return;
  const c = (o in s ? s[o] : void 0) || t.originalParams, u = G1(t, n), f = G1(t, c), C = n.enabled;
  u && !f ? (i.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), t.emitContainerClasses()) : !u && f && (i.classList.add(`${n.containerModifierClass}grid`), (c.grid.fill && c.grid.fill === "column" || !c.grid.fill && n.grid.fill === "column") && i.classList.add(`${n.containerModifierClass}grid-column`), t.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((b) => {
    const _ = n[b] && n[b].enabled, h = c[b] && c[b].enabled;
    _ && !h && t[b].disable(), !_ && h && t[b].enable();
  });
  const v = c.direction && c.direction !== n.direction, w = n.loop && (c.slidesPerView !== n.slidesPerView || v);
  v && r && t.changeDirection(), We(t.params, c);
  const g = t.params.enabled;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), C && !g ? t.disable() : !C && g && t.enable(), t.currentBreakpoint = o, t.emit("_beforeBreakpoint", c), w && r && (t.loopDestroy(), t.loopCreate(e), t.updateSlides()), t.emit("breakpoint", c);
}
function ic(t, e = "window", r) {
  if (!t || e === "container" && !r)
    return;
  let n = !1;
  const i = Qe(), s = e === "window" ? i.innerHeight : r.clientHeight, o = Object.keys(t).map((l) => {
    if (typeof l == "string" && l.indexOf("@") === 0) {
      const c = parseFloat(l.substr(1));
      return {
        value: s * c,
        point: l
      };
    }
    return {
      value: l,
      point: l
    };
  });
  o.sort((l, c) => parseInt(l.value, 10) - parseInt(c.value, 10));
  for (let l = 0; l < o.length; l += 1) {
    const {
      point: c,
      value: u
    } = o[l];
    e === "window" ? i.matchMedia(`(min-width: ${u}px)`).matches && (n = c) : u <= r.clientWidth && (n = c);
  }
  return n || "max";
}
const sc = {
  setBreakpoint: nc,
  getBreakpoint: ic
};
function oc(t, e) {
  const r = [];
  return t.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((i) => {
      n[i] && r.push(e + i);
    }) : typeof n == "string" && r.push(e + n);
  }), r;
}
function ac() {
  const t = this, {
    classNames: e,
    params: r,
    rtl: n,
    el: i,
    device: s
  } = t, o = oc(["initialized", r.direction, {
    "free-mode": t.params.freeMode && r.freeMode.enabled
  }, {
    autoheight: r.autoHeight
  }, {
    rtl: n
  }, {
    grid: r.grid && r.grid.rows > 1
  }, {
    "grid-column": r.grid && r.grid.rows > 1 && r.grid.fill === "column"
  }, {
    android: s.android
  }, {
    ios: s.ios
  }, {
    "css-mode": r.cssMode
  }, {
    centered: r.cssMode && r.centeredSlides
  }, {
    "watch-progress": r.watchSlidesProgress
  }], r.containerModifierClass);
  e.push(...o), i.classList.add(...e), t.emitContainerClasses();
}
function lc() {
  const t = this, {
    el: e,
    classNames: r
  } = t;
  e.classList.remove(...r), t.emitContainerClasses();
}
const cc = {
  addClasses: ac,
  removeClasses: lc
};
function uc() {
  const t = this, {
    isLocked: e,
    params: r
  } = t, {
    slidesOffsetBefore: n
  } = r;
  if (n) {
    const i = t.slides.length - 1, s = t.slidesGrid[i] + t.slidesSizesGrid[i] + n * 2;
    t.isLocked = t.size > s;
  } else
    t.isLocked = t.snapGrid.length === 1;
  r.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), r.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
const dc = {
  checkOverflow: uc
}, q1 = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopedSlides: null,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function fc(t, e) {
  return function(n = {}) {
    const i = Object.keys(n)[0], s = n[i];
    if (typeof s != "object" || s === null) {
      We(e, n);
      return;
    }
    if (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 && t[i] === !0 && (t[i] = {
      auto: !0
    }), !(i in t && "enabled" in s)) {
      We(e, n);
      return;
    }
    t[i] === !0 && (t[i] = {
      enabled: !0
    }), typeof t[i] == "object" && !("enabled" in t[i]) && (t[i].enabled = !0), t[i] || (t[i] = {
      enabled: !1
    }), We(e, n);
  };
}
const qi = {
  eventsEmitter: c8,
  update: x8,
  translate: T8,
  transition: L8,
  slide: I8,
  loop: B8,
  grabCursor: G8,
  events: rc,
  breakpoints: sc,
  checkOverflow: dc,
  classes: cc
}, Ui = {};
let On = class Mt {
  constructor(...e) {
    let r, n;
    e.length === 1 && e[0].constructor && Object.prototype.toString.call(e[0]).slice(8, -1) === "Object" ? n = e[0] : [r, n] = e, n || (n = {}), n = We({}, n), r && !n.el && (n.el = r);
    const i = mr();
    if (n.el && typeof n.el == "string" && i.querySelectorAll(n.el).length > 1) {
      const c = [];
      return i.querySelectorAll(n.el).forEach((u) => {
        const f = We({}, n, {
          el: u
        });
        c.push(new Mt(f));
      }), c;
    }
    const s = this;
    s.__swiper__ = !0, s.support = sl(), s.device = i8({
      userAgent: n.userAgent
    }), s.browser = o8(), s.eventsListeners = {}, s.eventsAnyListeners = [], s.modules = [...s.__modules__], n.modules && Array.isArray(n.modules) && s.modules.push(...n.modules);
    const o = {};
    s.modules.forEach((c) => {
      c({
        params: n,
        swiper: s,
        extendParams: fc(n, o),
        on: s.on.bind(s),
        once: s.once.bind(s),
        off: s.off.bind(s),
        emit: s.emit.bind(s)
      });
    });
    const l = We({}, q1, o);
    return s.params = We({}, l, Ui, n), s.originalParams = We({}, s.params), s.passedParams = We({}, n), s.params && s.params.on && Object.keys(s.params.on).forEach((c) => {
      s.on(c, s.params.on[c]);
    }), s.params && s.params.onAny && s.onAny(s.params.onAny), Object.assign(s, {
      enabled: s.params.enabled,
      el: r,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return s.params.direction === "horizontal";
      },
      isVertical() {
        return s.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: s.params.allowSlideNext,
      allowSlidePrev: s.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: s.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        evCache: []
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: s.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), s.emit("_swiper"), s.params.init && s.init(), s;
  }
  getSlideIndex(e) {
    const {
      slidesEl: r,
      params: n
    } = this, i = gt(r, `.${n.slideClass}, swiper-slide`), s = ei(i[0]);
    return ei(e) - s;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.filter((r) => r.getAttribute("data-swiper-slide-index") * 1 === e)[0]);
  }
  recalcSlides() {
    const e = this, {
      slidesEl: r,
      params: n
    } = e;
    e.slides = gt(r, `.${n.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, r) {
    const n = this;
    e = Math.min(Math.max(e, 0), 1);
    const i = n.minTranslate(), o = (n.maxTranslate() - i) * e + i;
    n.translateTo(o, typeof r > "u" ? 0 : r), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const r = e.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", r.join(" "));
  }
  getSlideClasses(e) {
    const r = this;
    return r.destroyed ? "" : e.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(r.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el)
      return;
    const r = [];
    e.slides.forEach((n) => {
      const i = e.getSlideClasses(n);
      r.push({
        slideEl: n,
        classNames: i
      }), e.emit("_slideClass", n, i);
    }), e.emit("_slideClasses", r);
  }
  slidesPerViewDynamic(e = "current", r = !1) {
    const n = this, {
      params: i,
      slides: s,
      slidesGrid: o,
      slidesSizesGrid: l,
      size: c,
      activeIndex: u
    } = n;
    let f = 1;
    if (i.centeredSlides) {
      let C = s[u].swiperSlideSize, v;
      for (let w = u + 1; w < s.length; w += 1)
        s[w] && !v && (C += s[w].swiperSlideSize, f += 1, C > c && (v = !0));
      for (let w = u - 1; w >= 0; w -= 1)
        s[w] && !v && (C += s[w].swiperSlideSize, f += 1, C > c && (v = !0));
    } else if (e === "current")
      for (let C = u + 1; C < s.length; C += 1)
        (r ? o[C] + l[C] - o[u] < c : o[C] - o[u] < c) && (f += 1);
    else
      for (let C = u - 1; C >= 0; C -= 1)
        o[u] - o[C] < c && (f += 1);
    return f;
  }
  update() {
    const e = this;
    if (!e || e.destroyed)
      return;
    const {
      snapGrid: r,
      params: n
    } = e;
    n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((o) => {
      o.complete && Wn(e, o);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function i() {
      const o = e.rtlTranslate ? e.translate * -1 : e.translate, l = Math.min(Math.max(o, e.maxTranslate()), e.minTranslate());
      e.setTranslate(l), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let s;
    if (e.params.freeMode && e.params.freeMode.enabled)
      i(), e.params.autoHeight && e.updateAutoHeight();
    else {
      if ((e.params.slidesPerView === "auto" || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides) {
        const o = e.virtual && e.params.virtual.enabled ? e.virtual.slides : e.slides;
        s = e.slideTo(o.length - 1, 0, !1, !0);
      } else
        s = e.slideTo(e.activeIndex, 0, !1, !0);
      s || i();
    }
    n.watchOverflow && r !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, r = !0) {
    const n = this, i = n.params.direction;
    return e || (e = i === "horizontal" ? "vertical" : "horizontal"), e === i || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${i}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((s) => {
      e === "vertical" ? s.style.width = "" : s.style.height = "";
    }), n.emit("changeDirection"), r && n.update()), n;
  }
  changeLanguageDirection(e) {
    const r = this;
    r.rtl && e === "rtl" || !r.rtl && e === "ltr" || (r.rtl = e === "rtl", r.rtlTranslate = r.params.direction === "horizontal" && r.rtl, r.rtl ? (r.el.classList.add(`${r.params.containerModifierClass}rtl`), r.el.dir = "rtl") : (r.el.classList.remove(`${r.params.containerModifierClass}rtl`), r.el.dir = "ltr"), r.update());
  }
  mount(e) {
    const r = this;
    if (r.mounted)
      return !0;
    let n = e || r.params.el;
    if (typeof n == "string" && (n = document.querySelector(n)), !n)
      return !1;
    n.swiper = r, n.shadowEl && (r.isElement = !0);
    const i = () => `.${(r.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let o = (() => n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(i()) : gt(n, i())[0])();
    return !o && r.params.createElements && (o = nl("div", r.params.wrapperClass), n.append(o), gt(n, `.${r.params.slideClass}`).forEach((l) => {
      o.append(l);
    })), Object.assign(r, {
      el: n,
      wrapperEl: o,
      slidesEl: r.isElement ? n : o,
      mounted: !0,
      // RTL
      rtl: n.dir.toLowerCase() === "rtl" || Ht(n, "direction") === "rtl",
      rtlTranslate: r.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || Ht(n, "direction") === "rtl"),
      wrongRTL: Ht(o, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const r = this;
    return r.initialized || r.mount(e) === !1 || (r.emit("beforeInit"), r.params.breakpoints && r.setBreakpoint(), r.addClasses(), r.updateSize(), r.updateSlides(), r.params.watchOverflow && r.checkOverflow(), r.params.grabCursor && r.enabled && r.setGrabCursor(), r.params.loop && r.virtual && r.params.virtual.enabled ? r.slideTo(r.params.initialSlide + r.virtual.slidesBefore, 0, r.params.runCallbacksOnInit, !1, !0) : r.slideTo(r.params.initialSlide, 0, r.params.runCallbacksOnInit, !1, !0), r.params.loop && r.loopCreate(), r.attachEvents(), [...r.el.querySelectorAll('[loading="lazy"]')].forEach((i) => {
      i.complete ? Wn(r, i) : i.addEventListener("load", (s) => {
        Wn(r, s.target);
      });
    }), ps(r), r.initialized = !0, ps(r), r.emit("init"), r.emit("afterInit")), r;
  }
  destroy(e = !0, r = !0) {
    const n = this, {
      params: i,
      el: s,
      wrapperEl: o,
      slides: l
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), i.loop && n.loopDestroy(), r && (n.removeClasses(), s.removeAttribute("style"), o.removeAttribute("style"), l && l.length && l.forEach((c) => {
      c.classList.remove(i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass), c.removeAttribute("style"), c.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((c) => {
      n.off(c);
    }), e !== !1 && (n.el.swiper = null, J0(n)), n.destroyed = !0), null;
  }
  static extendDefaults(e) {
    We(Ui, e);
  }
  static get extendedDefaults() {
    return Ui;
  }
  static get defaults() {
    return q1;
  }
  static installModule(e) {
    Mt.prototype.__modules__ || (Mt.prototype.__modules__ = []);
    const r = Mt.prototype.__modules__;
    typeof e == "function" && r.indexOf(e) < 0 && r.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((r) => Mt.installModule(r)), Mt) : (Mt.installModule(e), Mt);
  }
};
Object.keys(qi).forEach((t) => {
  Object.keys(qi[t]).forEach((e) => {
    On.prototype[e] = qi[t][e];
  });
});
On.use([a8, l8]);
function ll(t, e, r, n) {
  return t.params.createElements && Object.keys(n).forEach((i) => {
    if (!r[i] && r.auto === !0) {
      let s = gt(t.el, `.${n[i]}`)[0];
      s || (s = nl("div", n[i]), s.className = n[i], t.el.append(s)), r[i] = s, e[i] = s;
    }
  }), r;
}
function cl({
  swiper: t,
  extendParams: e,
  on: r,
  emit: n
}) {
  e({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), t.navigation = {
    nextEl: null,
    prevEl: null
  };
  const i = (g) => (Array.isArray(g) || (g = [g].filter((b) => !!b)), g);
  function s(g) {
    let b;
    return g && typeof g == "string" && t.isElement && (b = t.el.shadowRoot.querySelector(g), b) ? b : (g && (typeof g == "string" && (b = [...document.querySelectorAll(g)]), t.params.uniqueNavElements && typeof g == "string" && b.length > 1 && t.el.querySelectorAll(g).length === 1 && (b = t.el.querySelector(g))), g && !b ? g : b);
  }
  function o(g, b) {
    const _ = t.params.navigation;
    g = i(g), g.forEach((h) => {
      h && (h.classList[b ? "add" : "remove"](..._.disabledClass.split(" ")), h.tagName === "BUTTON" && (h.disabled = b), t.params.watchOverflow && t.enabled && h.classList[t.isLocked ? "add" : "remove"](_.lockClass));
    });
  }
  function l() {
    const {
      nextEl: g,
      prevEl: b
    } = t.navigation;
    if (t.params.loop) {
      o(b, !1), o(g, !1);
      return;
    }
    o(b, t.isBeginning && !t.params.rewind), o(g, t.isEnd && !t.params.rewind);
  }
  function c(g) {
    g.preventDefault(), !(t.isBeginning && !t.params.loop && !t.params.rewind) && (t.slidePrev(), n("navigationPrev"));
  }
  function u(g) {
    g.preventDefault(), !(t.isEnd && !t.params.loop && !t.params.rewind) && (t.slideNext(), n("navigationNext"));
  }
  function f() {
    const g = t.params.navigation;
    if (t.params.navigation = ll(t, t.originalParams.navigation, t.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(g.nextEl || g.prevEl))
      return;
    let b = s(g.nextEl), _ = s(g.prevEl);
    Object.assign(t.navigation, {
      nextEl: b,
      prevEl: _
    }), b = i(b), _ = i(_);
    const h = (y, E) => {
      y && y.addEventListener("click", E === "next" ? u : c), !t.enabled && y && y.classList.add(...g.lockClass.split(" "));
    };
    b.forEach((y) => h(y, "next")), _.forEach((y) => h(y, "prev"));
  }
  function C() {
    let {
      nextEl: g,
      prevEl: b
    } = t.navigation;
    g = i(g), b = i(b);
    const _ = (h, y) => {
      h.removeEventListener("click", y === "next" ? u : c), h.classList.remove(...t.params.navigation.disabledClass.split(" "));
    };
    g.forEach((h) => _(h, "next")), b.forEach((h) => _(h, "prev"));
  }
  r("init", () => {
    t.params.navigation.enabled === !1 ? w() : (f(), l());
  }), r("toEdge fromEdge lock unlock", () => {
    l();
  }), r("destroy", () => {
    C();
  }), r("enable disable", () => {
    let {
      nextEl: g,
      prevEl: b
    } = t.navigation;
    g = i(g), b = i(b), [...g, ...b].filter((_) => !!_).forEach((_) => _.classList[t.enabled ? "remove" : "add"](t.params.navigation.lockClass));
  }), r("click", (g, b) => {
    let {
      nextEl: _,
      prevEl: h
    } = t.navigation;
    _ = i(_), h = i(h);
    const y = b.target;
    if (t.params.navigation.hideOnClick && !h.includes(y) && !_.includes(y)) {
      if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === y || t.pagination.el.contains(y)))
        return;
      let E;
      _.length ? E = _[0].classList.contains(t.params.navigation.hiddenClass) : h.length && (E = h[0].classList.contains(t.params.navigation.hiddenClass)), n(E === !0 ? "navigationShow" : "navigationHide"), [..._, ...h].filter((T) => !!T).forEach((T) => T.classList.toggle(t.params.navigation.hiddenClass));
    }
  });
  const v = () => {
    t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")), f(), l();
  }, w = () => {
    t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")), C();
  };
  Object.assign(t.navigation, {
    enable: v,
    disable: w,
    update: l,
    init: f,
    destroy: C
  });
}
function wn(t = "") {
  return `.${t.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function ul({
  swiper: t,
  extendParams: e,
  on: r,
  emit: n
}) {
  const i = "swiper-pagination";
  e({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (h) => h,
      formatFractionTotal: (h) => h,
      bulletClass: `${i}-bullet`,
      bulletActiveClass: `${i}-bullet-active`,
      modifierClass: `${i}-`,
      currentClass: `${i}-current`,
      totalClass: `${i}-total`,
      hiddenClass: `${i}-hidden`,
      progressbarFillClass: `${i}-progressbar-fill`,
      progressbarOppositeClass: `${i}-progressbar-opposite`,
      clickableClass: `${i}-clickable`,
      lockClass: `${i}-lock`,
      horizontalClass: `${i}-horizontal`,
      verticalClass: `${i}-vertical`,
      paginationDisabledClass: `${i}-disabled`
    }
  }), t.pagination = {
    el: null,
    bullets: []
  };
  let s, o = 0;
  const l = (h) => (Array.isArray(h) || (h = [h].filter((y) => !!y)), h);
  function c() {
    return !t.params.pagination.el || !t.pagination.el || Array.isArray(t.pagination.el) && t.pagination.el.length === 0;
  }
  function u(h, y) {
    const {
      bulletActiveClass: E
    } = t.params.pagination;
    h && (h = h[`${y === "prev" ? "previous" : "next"}ElementSibling`], h && (h.classList.add(`${E}-${y}`), h = h[`${y === "prev" ? "previous" : "next"}ElementSibling`], h && h.classList.add(`${E}-${y}-${y}`)));
  }
  function f(h) {
    const y = h.target.closest(wn(t.params.pagination.bulletClass));
    if (!y)
      return;
    h.preventDefault();
    const E = ei(y) * t.params.slidesPerGroup;
    if (t.params.loop) {
      if (t.realIndex === E)
        return;
      const T = t.getSlideIndexByData(E), $ = t.getSlideIndexByData(t.realIndex);
      T > t.slides.length - t.loopedSlides && t.loopFix({
        direction: T > $ ? "next" : "prev",
        activeSlideIndex: T,
        slideTo: !1
      }), t.slideToLoop(E);
    } else
      t.slideTo(E);
  }
  function C() {
    const h = t.rtl, y = t.params.pagination;
    if (c())
      return;
    let E = t.pagination.el;
    E = l(E);
    let T, $;
    const L = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length, z = t.params.loop ? Math.ceil(L / t.params.slidesPerGroup) : t.snapGrid.length;
    if (t.params.loop ? ($ = t.previousRealIndex || 0, T = t.params.slidesPerGroup > 1 ? Math.floor(t.realIndex / t.params.slidesPerGroup) : t.realIndex) : typeof t.snapIndex < "u" ? (T = t.snapIndex, $ = t.previousSnapIndex) : ($ = t.previousIndex || 0, T = t.activeIndex || 0), y.type === "bullets" && t.pagination.bullets && t.pagination.bullets.length > 0) {
      const P = t.pagination.bullets;
      let B, q, N;
      if (y.dynamicBullets && (s = fs(P[0], t.isHorizontal() ? "width" : "height", !0), E.forEach((R) => {
        R.style[t.isHorizontal() ? "width" : "height"] = `${s * (y.dynamicMainBullets + 4)}px`;
      }), y.dynamicMainBullets > 1 && $ !== void 0 && (o += T - ($ || 0), o > y.dynamicMainBullets - 1 ? o = y.dynamicMainBullets - 1 : o < 0 && (o = 0)), B = Math.max(T - o, 0), q = B + (Math.min(P.length, y.dynamicMainBullets) - 1), N = (q + B) / 2), P.forEach((R) => {
        const D = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((Q) => `${y.bulletActiveClass}${Q}`)].map((Q) => typeof Q == "string" && Q.includes(" ") ? Q.split(" ") : Q).flat();
        R.classList.remove(...D);
      }), E.length > 1)
        P.forEach((R) => {
          const D = ei(R);
          D === T && R.classList.add(...y.bulletActiveClass.split(" ")), y.dynamicBullets && (D >= B && D <= q && R.classList.add(...`${y.bulletActiveClass}-main`.split(" ")), D === B && u(R, "prev"), D === q && u(R, "next"));
        });
      else {
        const R = P[T];
        if (R && R.classList.add(...y.bulletActiveClass.split(" ")), y.dynamicBullets) {
          const D = P[B], Q = P[q];
          for (let se = B; se <= q; se += 1)
            P[se] && P[se].classList.add(...`${y.bulletActiveClass}-main`.split(" "));
          u(D, "prev"), u(Q, "next");
        }
      }
      if (y.dynamicBullets) {
        const R = Math.min(P.length, y.dynamicMainBullets + 4), D = (s * R - s) / 2 - N * s, Q = h ? "right" : "left";
        P.forEach((se) => {
          se.style[t.isHorizontal() ? Q : "top"] = `${D}px`;
        });
      }
    }
    E.forEach((P, B) => {
      if (y.type === "fraction" && (P.querySelectorAll(wn(y.currentClass)).forEach((q) => {
        q.textContent = y.formatFractionCurrent(T + 1);
      }), P.querySelectorAll(wn(y.totalClass)).forEach((q) => {
        q.textContent = y.formatFractionTotal(z);
      })), y.type === "progressbar") {
        let q;
        y.progressbarOpposite ? q = t.isHorizontal() ? "vertical" : "horizontal" : q = t.isHorizontal() ? "horizontal" : "vertical";
        const N = (T + 1) / z;
        let R = 1, D = 1;
        q === "horizontal" ? R = N : D = N, P.querySelectorAll(wn(y.progressbarFillClass)).forEach((Q) => {
          Q.style.transform = `translate3d(0,0,0) scaleX(${R}) scaleY(${D})`, Q.style.transitionDuration = `${t.params.speed}ms`;
        });
      }
      y.type === "custom" && y.renderCustom ? (P.innerHTML = y.renderCustom(t, T + 1, z), B === 0 && n("paginationRender", P)) : (B === 0 && n("paginationRender", P), n("paginationUpdate", P)), t.params.watchOverflow && t.enabled && P.classList[t.isLocked ? "add" : "remove"](y.lockClass);
    });
  }
  function v() {
    const h = t.params.pagination;
    if (c())
      return;
    const y = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length;
    let E = t.pagination.el;
    E = l(E);
    let T = "";
    if (h.type === "bullets") {
      let $ = t.params.loop ? Math.ceil(y / t.params.slidesPerGroup) : t.snapGrid.length;
      t.params.freeMode && t.params.freeMode.enabled && $ > y && ($ = y);
      for (let L = 0; L < $; L += 1)
        h.renderBullet ? T += h.renderBullet.call(t, L, h.bulletClass) : T += `<${h.bulletElement} class="${h.bulletClass}"></${h.bulletElement}>`;
    }
    h.type === "fraction" && (h.renderFraction ? T = h.renderFraction.call(t, h.currentClass, h.totalClass) : T = `<span class="${h.currentClass}"></span> / <span class="${h.totalClass}"></span>`), h.type === "progressbar" && (h.renderProgressbar ? T = h.renderProgressbar.call(t, h.progressbarFillClass) : T = `<span class="${h.progressbarFillClass}"></span>`), t.pagination.bullets = [], E.forEach(($) => {
      h.type !== "custom" && ($.innerHTML = T || ""), h.type === "bullets" && t.pagination.bullets.push(...$.querySelectorAll(wn(h.bulletClass)));
    }), h.type !== "custom" && n("paginationRender", E[0]);
  }
  function w() {
    t.params.pagination = ll(t, t.originalParams.pagination, t.params.pagination, {
      el: "swiper-pagination"
    });
    const h = t.params.pagination;
    if (!h.el)
      return;
    let y;
    typeof h.el == "string" && t.isElement && (y = t.el.shadowRoot.querySelector(h.el)), !y && typeof h.el == "string" && (y = [...document.querySelectorAll(h.el)]), y || (y = h.el), !(!y || y.length === 0) && (t.params.uniqueNavElements && typeof h.el == "string" && Array.isArray(y) && y.length > 1 && (y = [...t.el.querySelectorAll(h.el)], y.length > 1 && (y = y.filter((E) => il(E, ".swiper")[0] === t.el)[0])), Array.isArray(y) && y.length === 1 && (y = y[0]), Object.assign(t.pagination, {
      el: y
    }), y = l(y), y.forEach((E) => {
      h.type === "bullets" && h.clickable && E.classList.add(h.clickableClass), E.classList.add(h.modifierClass + h.type), E.classList.add(t.isHorizontal() ? h.horizontalClass : h.verticalClass), h.type === "bullets" && h.dynamicBullets && (E.classList.add(`${h.modifierClass}${h.type}-dynamic`), o = 0, h.dynamicMainBullets < 1 && (h.dynamicMainBullets = 1)), h.type === "progressbar" && h.progressbarOpposite && E.classList.add(h.progressbarOppositeClass), h.clickable && E.addEventListener("click", f), t.enabled || E.classList.add(h.lockClass);
    }));
  }
  function g() {
    const h = t.params.pagination;
    if (c())
      return;
    let y = t.pagination.el;
    y && (y = l(y), y.forEach((E) => {
      E.classList.remove(h.hiddenClass), E.classList.remove(h.modifierClass + h.type), E.classList.remove(t.isHorizontal() ? h.horizontalClass : h.verticalClass), h.clickable && E.removeEventListener("click", f);
    })), t.pagination.bullets && t.pagination.bullets.forEach((E) => E.classList.remove(...h.bulletActiveClass.split(" ")));
  }
  r("changeDirection", () => {
    if (!t.pagination || !t.pagination.el)
      return;
    const h = t.params.pagination;
    let {
      el: y
    } = t.pagination;
    y = l(y), y.forEach((E) => {
      E.classList.remove(h.horizontalClass, h.verticalClass), E.classList.add(t.isHorizontal() ? h.horizontalClass : h.verticalClass);
    });
  }), r("init", () => {
    t.params.pagination.enabled === !1 ? _() : (w(), v(), C());
  }), r("activeIndexChange", () => {
    typeof t.snapIndex > "u" && C();
  }), r("snapIndexChange", () => {
    C();
  }), r("snapGridLengthChange", () => {
    v(), C();
  }), r("destroy", () => {
    g();
  }), r("enable disable", () => {
    let {
      el: h
    } = t.pagination;
    h && (h = l(h), h.forEach((y) => y.classList[t.enabled ? "remove" : "add"](t.params.pagination.lockClass)));
  }), r("lock unlock", () => {
    C();
  }), r("click", (h, y) => {
    const E = y.target;
    let {
      el: T
    } = t.pagination;
    if (Array.isArray(T) || (T = [T].filter(($) => !!$)), t.params.pagination.el && t.params.pagination.hideOnClick && T && T.length > 0 && !E.classList.contains(t.params.pagination.bulletClass)) {
      if (t.navigation && (t.navigation.nextEl && E === t.navigation.nextEl || t.navigation.prevEl && E === t.navigation.prevEl))
        return;
      const $ = T[0].classList.contains(t.params.pagination.hiddenClass);
      n($ === !0 ? "paginationShow" : "paginationHide"), T.forEach((L) => L.classList.toggle(t.params.pagination.hiddenClass));
    }
  });
  const b = () => {
    t.el.classList.remove(t.params.pagination.paginationDisabledClass);
    let {
      el: h
    } = t.pagination;
    h && (h = l(h), h.forEach((y) => y.classList.remove(t.params.pagination.paginationDisabledClass))), w(), v(), C();
  }, _ = () => {
    t.el.classList.add(t.params.pagination.paginationDisabledClass);
    let {
      el: h
    } = t.pagination;
    h && (h = l(h), h.forEach((y) => y.classList.add(t.params.pagination.paginationDisabledClass))), g();
  };
  Object.assign(t.pagination, {
    enable: b,
    disable: _,
    render: v,
    update: C,
    init: w,
    destroy: g
  });
}
function dr(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function Gt(t, e) {
  const r = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => r.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : dr(e[n]) && dr(t[n]) && Object.keys(e[n]).length > 0 ? e[n].__swiper__ ? t[n] = e[n] : Gt(t[n], e[n]) : t[n] = e[n];
  });
}
function dl(t = {}) {
  return t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function fl(t = {}) {
  return t.pagination && typeof t.pagination.el > "u";
}
function pl(t = {}) {
  return t.scrollbar && typeof t.scrollbar.el > "u";
}
function hl(t = "") {
  const e = t.split(" ").map((n) => n.trim()).filter((n) => !!n), r = [];
  return e.forEach((n) => {
    r.indexOf(n) < 0 && r.push(n);
  }), r.join(" ");
}
function pc(t = "") {
  return t ? t.includes("swiper-wrapper") ? t : `swiper-wrapper ${t}` : "swiper-wrapper";
}
const ml = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopedSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function hc(t = {}, e = !0) {
  const r = {
    on: {}
  }, n = {}, i = {};
  Gt(r, On.defaults), Gt(r, On.extendedDefaults), r._emitClasses = !0, r.init = !1;
  const s = {}, o = ml.map((c) => c.replace(/_/, "")), l = Object.assign({}, t);
  return Object.keys(l).forEach((c) => {
    typeof t[c] > "u" || (o.indexOf(c) >= 0 ? dr(t[c]) ? (r[c] = {}, i[c] = {}, Gt(r[c], t[c]), Gt(i[c], t[c])) : (r[c] = t[c], i[c] = t[c]) : c.search(/on[A-Z]/) === 0 && typeof t[c] == "function" ? e ? n[`${c[2].toLowerCase()}${c.substr(3)}`] = t[c] : r.on[`${c[2].toLowerCase()}${c.substr(3)}`] = t[c] : s[c] = t[c]);
  }), ["navigation", "pagination", "scrollbar"].forEach((c) => {
    r[c] === !0 && (r[c] = {}), r[c] === !1 && delete r[c];
  }), {
    params: r,
    passedParams: i,
    rest: s,
    events: n
  };
}
function mc({
  el: t,
  nextEl: e,
  prevEl: r,
  paginationEl: n,
  scrollbarEl: i,
  swiper: s
}, o) {
  dl(o) && e && r && (s.params.navigation.nextEl = e, s.originalParams.navigation.nextEl = e, s.params.navigation.prevEl = r, s.originalParams.navigation.prevEl = r), fl(o) && n && (s.params.pagination.el = n, s.originalParams.pagination.el = n), pl(o) && i && (s.params.scrollbar.el = i, s.originalParams.scrollbar.el = i), s.init(t);
}
function Cc(t, e, r, n, i) {
  const s = [];
  if (!e)
    return s;
  const o = (c) => {
    s.indexOf(c) < 0 && s.push(c);
  };
  if (r && n) {
    const c = n.map(i), u = r.map(i);
    c.join("") !== u.join("") && o("children"), n.length !== r.length && o("children");
  }
  return ml.filter((c) => c[0] === "_").map((c) => c.replace(/_/, "")).forEach((c) => {
    if (c in t && c in e)
      if (dr(t[c]) && dr(e[c])) {
        const u = Object.keys(t[c]), f = Object.keys(e[c]);
        u.length !== f.length ? o(c) : (u.forEach((C) => {
          t[c][C] !== e[c][C] && o(c);
        }), f.forEach((C) => {
          t[c][C] !== e[c][C] && o(c);
        }));
      } else
        t[c] !== e[c] && o(c);
  }), s;
}
function Cl(t) {
  return t.type && t.type.displayName && t.type.displayName.includes("SwiperSlide");
}
function gl(t) {
  const e = [];
  return W.Children.toArray(t).forEach((r) => {
    Cl(r) ? e.push(r) : r.props && r.props.children && gl(r.props.children).forEach((n) => e.push(n));
  }), e;
}
function gc(t) {
  const e = [], r = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return W.Children.toArray(t).forEach((n) => {
    if (Cl(n))
      e.push(n);
    else if (n.props && n.props.slot && r[n.props.slot])
      r[n.props.slot].push(n);
    else if (n.props && n.props.children) {
      const i = gl(n.props.children);
      i.length > 0 ? i.forEach((s) => e.push(s)) : r["container-end"].push(n);
    } else
      r["container-end"].push(n);
  }), {
    slides: e,
    slots: r
  };
}
function vc({
  swiper: t,
  slides: e,
  passedParams: r,
  changedParams: n,
  nextEl: i,
  prevEl: s,
  scrollbarEl: o,
  paginationEl: l
}) {
  const c = n.filter((P) => P !== "children" && P !== "direction" && P !== "wrapperClass"), {
    params: u,
    pagination: f,
    navigation: C,
    scrollbar: v,
    virtual: w,
    thumbs: g
  } = t;
  let b, _, h, y, E, T, $, L;
  n.includes("thumbs") && r.thumbs && r.thumbs.swiper && u.thumbs && !u.thumbs.swiper && (b = !0), n.includes("controller") && r.controller && r.controller.control && u.controller && !u.controller.control && (_ = !0), n.includes("pagination") && r.pagination && (r.pagination.el || l) && (u.pagination || u.pagination === !1) && f && !f.el && (h = !0), n.includes("scrollbar") && r.scrollbar && (r.scrollbar.el || o) && (u.scrollbar || u.scrollbar === !1) && v && !v.el && (y = !0), n.includes("navigation") && r.navigation && (r.navigation.prevEl || s) && (r.navigation.nextEl || i) && (u.navigation || u.navigation === !1) && C && !C.prevEl && !C.nextEl && (E = !0);
  const z = (P) => {
    t[P] && (t[P].destroy(), P === "navigation" ? (t.isElement && (t[P].prevEl.remove(), t[P].nextEl.remove()), u[P].prevEl = void 0, u[P].nextEl = void 0, t[P].prevEl = void 0, t[P].nextEl = void 0) : (t.isElement && t[P].el.remove(), u[P].el = void 0, t[P].el = void 0));
  };
  n.includes("loop") && t.isElement && (u.loop && !r.loop ? T = !0 : !u.loop && r.loop ? $ = !0 : L = !0), c.forEach((P) => {
    if (dr(u[P]) && dr(r[P]))
      Gt(u[P], r[P]), (P === "navigation" || P === "pagination" || P === "scrollbar") && "enabled" in r[P] && !r[P].enabled && z(P);
    else {
      const B = r[P];
      (B === !0 || B === !1) && (P === "navigation" || P === "pagination" || P === "scrollbar") ? B === !1 && z(P) : u[P] = r[P];
    }
  }), c.includes("controller") && !_ && t.controller && t.controller.control && u.controller && u.controller.control && (t.controller.control = u.controller.control), n.includes("children") && e && w && u.virtual.enabled && (w.slides = e, w.update(!0)), n.includes("children") && e && u.loop && (L = !0), b && g.init() && g.update(!0), _ && (t.controller.control = u.controller.control), h && (t.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-pagination"), t.el.shadowEl.appendChild(l)), l && (u.pagination.el = l), f.init(), f.render(), f.update()), y && (t.isElement && (!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-scrollbar"), t.el.shadowEl.appendChild(o)), o && (u.scrollbar.el = o), v.init(), v.updateSize(), v.setTranslate()), E && (t.isElement && ((!i || typeof i == "string") && (i = document.createElement("div"), i.classList.add("swiper-button-next"), t.el.shadowEl.appendChild(i)), (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-prev"), t.el.shadowEl.appendChild(s))), i && (u.navigation.nextEl = i), s && (u.navigation.prevEl = s), C.init(), C.update()), n.includes("allowSlideNext") && (t.allowSlideNext = r.allowSlideNext), n.includes("allowSlidePrev") && (t.allowSlidePrev = r.allowSlidePrev), n.includes("direction") && t.changeDirection(r.direction, !1), (T || L) && t.loopDestroy(), ($ || L) && t.loopCreate(), t.update();
}
function yc(t, e, r) {
  if (!r)
    return null;
  const n = (f) => {
    let C = f;
    return f < 0 ? C = e.length + f : C >= e.length && (C = C - e.length), C;
  }, i = t.isHorizontal() ? {
    [t.rtlTranslate ? "right" : "left"]: `${r.offset}px`
  } : {
    top: `${r.offset}px`
  }, {
    from: s,
    to: o
  } = r, l = t.params.loop ? -e.length : 0, c = t.params.loop ? e.length * 2 : e.length, u = [];
  for (let f = l; f < c; f += 1)
    f >= s && f <= o && u.push(e[n(f)]);
  return u.map((f, C) => /* @__PURE__ */ W.cloneElement(f, {
    swiper: t,
    style: i,
    key: `slide-${C}`
  }));
}
const xc = (t) => {
  !t || t.destroyed || !t.params.virtual || t.params.virtual && !t.params.virtual.enabled || (t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.parallax && t.params.parallax && t.params.parallax.enabled && t.parallax.setTranslate());
};
function _n(t, e) {
  return typeof window > "u" ? K(t, e) : Ln(t, e);
}
const U1 = /* @__PURE__ */ Re(null), wc = /* @__PURE__ */ Re(null);
function hs() {
  return hs = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, hs.apply(this, arguments);
}
const ti = /* @__PURE__ */ Lr(function(t, e) {
  let {
    className: r,
    tag: n = "div",
    wrapperTag: i = "div",
    children: s,
    onSwiper: o,
    ...l
  } = t === void 0 ? {} : t, c = !1;
  const [u, f] = ae("swiper"), [C, v] = ae(null), [w, g] = ae(!1), b = X(!1), _ = X(null), h = X(null), y = X(null), E = X(null), T = X(null), $ = X(null), L = X(null), z = X(null), {
    params: P,
    passedParams: B,
    rest: q,
    events: N
  } = hc(l), {
    slides: R,
    slots: D
  } = gc(s), Q = () => {
    g(!w);
  };
  Object.assign(P.on, {
    _containerClasses(O, k) {
      f(k);
    }
  });
  const se = () => {
    Object.assign(P.on, N), c = !0;
    const O = {
      ...P
    };
    if (delete O.wrapperClass, h.current = new On(O), h.current.virtual && h.current.params.virtual.enabled) {
      h.current.virtual.slides = R;
      const k = {
        cache: !1,
        slides: R,
        renderExternal: v,
        renderExternalUpdate: !1
      };
      Gt(h.current.params.virtual, k), Gt(h.current.originalParams.virtual, k);
    }
  };
  _.current || se(), h.current && h.current.on("_beforeBreakpoint", Q);
  const Y = () => {
    c || !N || !h.current || Object.keys(N).forEach((O) => {
      h.current.on(O, N[O]);
    });
  }, ie = () => {
    !N || !h.current || Object.keys(N).forEach((O) => {
      h.current.off(O, N[O]);
    });
  };
  K(() => () => {
    h.current && h.current.off("_beforeBreakpoint", Q);
  }), K(() => {
    !b.current && h.current && (h.current.emitSlidesClasses(), b.current = !0);
  }), _n(() => {
    if (e && (e.current = _.current), !!_.current)
      return h.current.destroyed && se(), mc({
        el: _.current,
        nextEl: T.current,
        prevEl: $.current,
        paginationEl: L.current,
        scrollbarEl: z.current,
        swiper: h.current
      }, P), o && o(h.current), () => {
        h.current && !h.current.destroyed && h.current.destroy(!0, !1);
      };
  }, []), _n(() => {
    Y();
    const O = Cc(B, y.current, R, E.current, (k) => k.key);
    return y.current = B, E.current = R, O.length && h.current && !h.current.destroyed && vc({
      swiper: h.current,
      slides: R,
      passedParams: B,
      changedParams: O,
      nextEl: T.current,
      prevEl: $.current,
      scrollbarEl: z.current,
      paginationEl: L.current
    }), () => {
      ie();
    };
  }), _n(() => {
    xc(h.current);
  }, [C]);
  function F() {
    return P.virtual ? yc(h.current, R, C) : R.map((O, k) => /* @__PURE__ */ W.cloneElement(O, {
      swiper: h.current,
      swiperSlideIndex: k
    }));
  }
  return /* @__PURE__ */ W.createElement(n, hs({
    ref: _,
    className: hl(`${u}${r ? ` ${r}` : ""}`)
  }, q), /* @__PURE__ */ W.createElement(wc.Provider, {
    value: h.current
  }, D["container-start"], /* @__PURE__ */ W.createElement(i, {
    className: pc(P.wrapperClass)
  }, D["wrapper-start"], F(), D["wrapper-end"]), dl(P) && /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement("div", {
    ref: $,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ W.createElement("div", {
    ref: T,
    className: "swiper-button-next"
  })), pl(P) && /* @__PURE__ */ W.createElement("div", {
    ref: z,
    className: "swiper-scrollbar"
  }), fl(P) && /* @__PURE__ */ W.createElement("div", {
    ref: L,
    className: "swiper-pagination"
  }), D["container-end"]));
});
ti.displayName = "Swiper";
function ms() {
  return ms = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ms.apply(this, arguments);
}
const ri = /* @__PURE__ */ Lr(function(t, e) {
  let {
    tag: r = "div",
    children: n,
    className: i = "",
    swiper: s,
    zoom: o,
    lazy: l,
    virtualIndex: c,
    swiperSlideIndex: u,
    ...f
  } = t === void 0 ? {} : t;
  const C = X(null), [v, w] = ae("swiper-slide"), [g, b] = ae(!1);
  function _(T, $, L) {
    $ === C.current && w(L);
  }
  _n(() => {
    if (typeof u < "u" && (C.current.swiperSlideIndex = u), e && (e.current = C.current), !(!C.current || !s)) {
      if (s.destroyed) {
        v !== "swiper-slide" && w("swiper-slide");
        return;
      }
      return s.on("_slideClass", _), () => {
        s && s.off("_slideClass", _);
      };
    }
  }), _n(() => {
    s && C.current && !s.destroyed && w(s.getSlideClasses(C.current));
  }, [s]);
  const h = {
    isActive: v.indexOf("swiper-slide-active") >= 0,
    isVisible: v.indexOf("swiper-slide-visible") >= 0,
    isPrev: v.indexOf("swiper-slide-prev") >= 0,
    isNext: v.indexOf("swiper-slide-next") >= 0
  }, y = () => typeof n == "function" ? n(h) : n, E = () => {
    b(!0);
  };
  return /* @__PURE__ */ W.createElement(r, ms({
    ref: C,
    className: hl(`${v}${i ? ` ${i}` : ""}`),
    "data-swiper-slide-index": c,
    onLoad: E
  }, f), o && /* @__PURE__ */ W.createElement(U1.Provider, {
    value: h
  }, /* @__PURE__ */ W.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof o == "number" ? o : void 0
  }, y(), l && !g && /* @__PURE__ */ W.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !o && /* @__PURE__ */ W.createElement(U1.Provider, {
    value: h
  }, y(), l && !g && /* @__PURE__ */ W.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
ri.displayName = "SwiperSlide";
const qc = ({ sectionHeader: t = "Our Projects", ourProjects: e }) => {
  if (!e || e.length === 0)
    return null;
  const [r, n] = ae(0), i = e.length === 1;
  return /* @__PURE__ */ d("div", { "data-testid": "our-work", id: "our-work", children: /* @__PURE__ */ d("div", { className: "w-full px-10 py-12 md:px-10 md:py-16 xl:px-24 bg-white", children: /* @__PURE__ */ I("div", { className: "w-full flex flex-col gap-10", children: [
    /* @__PURE__ */ I("div", { className: "flex flex-col items-center gap-3 xl:gap-5", children: [
      /* @__PURE__ */ d("h2", { className: " text-heading3 md:text-heading2 xl:text-heading1 text-center  text-neutral-400 ", children: i ? e[r].name : t }),
      /* @__PURE__ */ d("svg", { width: "100", height: "4", viewBox: "0 0 100 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { y1: "2.30078", x2: "100", y2: "2.30078", stroke: "#282931", strokeWidth: "3" }) })
    ] }),
    i ? /* @__PURE__ */ d("p", { className: "text-neutral-400 text-body2 md:text-body1 text-center", children: e[0].description }) : /* @__PURE__ */ I("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ d("span", { className: " text-neutral-400 text-center font-medium text-heading6 sm:text-heading5 xl:text-heading4", children: e[r].name }),
      /* @__PURE__ */ d("p", { className: "text-neutral-400  text-body2 md:text-body1 text-center", children: e[r].description })
    ] }),
    /* @__PURE__ */ I("div", { className: "w-full flex flex-row gap-8", children: [
      /* @__PURE__ */ d("div", { className: "hidden md:flex items-center justify-center", children: /* @__PURE__ */ d("button", { className: "w-16 h-16 bg-neutral-400 project-prev", children: /* @__PURE__ */ d("svg", { xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60", fill: "none", children: /* @__PURE__ */ d(
        "path",
        {
          d: "M37.5 47.5L20 30L37.5 12.5",
          stroke: "#B8FF51",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ) }) }) }),
      /* @__PURE__ */ d("div", { className: "w-full md:w-9/12 xl:w-full bg-neutral-100 p-6", children: /* @__PURE__ */ d(
        ti,
        {
          slidesPerView: 1,
          onSlideChange: (s) => n(s.activeIndex),
          modules: [cl],
          pagination: {
            clickable: !0
          },
          navigation: {
            prevEl: ".project-prev",
            nextEl: ".project-next",
            disabledClass: "opacity-50"
          },
          className: "w-full h-full",
          children: e == null ? void 0 : e.map((s, o) => /* @__PURE__ */ d(ri, { className: "!w-full", children: /* @__PURE__ */ d("div", { className: "w-full h-full", children: s.completedProjectImages.length === 0 ? /* @__PURE__ */ d("div", { className: "w-full h-full bg-neutral-400" }) : /* @__PURE__ */ d(
            ti,
            {
              slidesPerView: 1,
              modules: [ul],
              pagination: {
                clickable: !0
              },
              className: "w-full h-full  [--swiper-pagination-color:#98F217] [--swiper-pagination-bullet-inactive-color:#DDDDDE] [--swiper-pagination-bullet-inactive-opacity:1] [--swiper-pagination-bullet-size:12px] [--swiper-pagination-bullet-horizontal-gap:6px] [--swiper-pagination-top:308px] md:[--swiper-pagination-top:376px] xl:[--swiper-pagination-top:394px]",
              children: /* @__PURE__ */ d("div", { className: "w-full h-full", children: s.completedProjectImages.map((l, c) => /* @__PURE__ */ d(ri, { className: "!w-full", children: /* @__PURE__ */ I("div", { className: "w-full flex flex-col", children: [
                /* @__PURE__ */ d("div", { className: "w-full h-[358px] md:h-[424px] xl:h-[446px] bg-neutral-400 mb-6", children: /* @__PURE__ */ d(
                  tt,
                  {
                    src: rt(l.image.url),
                    cldImg: Ge(l.image.url),
                    plugins: [Xe()],
                    alt: "",
                    className: "w-full object-cover object-center h-full"
                  }
                ) }),
                l.image.caption && /* @__PURE__ */ d("span", { className: "font-lato text-heading6 md:text-heading5 xl:text-heading4  text-neutral-400 font-medium", children: l.image.caption }),
                l.image.description && /* @__PURE__ */ d("p", { className: "font-lato text-body2 md:text-body1 text-neutral-400 mt-6", children: l.image.description })
              ] }) }, `complProj-${c}-${l}`)) })
            }
          ) }) }, `ourProject-${o}`))
        }
      ) }),
      /* @__PURE__ */ d("div", { className: "hidden md:flex items-center justify-center", children: /* @__PURE__ */ d("button", { className: "w-16 h-16 bg-neutral-400 project-next", children: /* @__PURE__ */ d("svg", { xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60", fill: "none", children: /* @__PURE__ */ d(
        "path",
        {
          d: "M22.5 12.5L40 30L22.5 47.5",
          stroke: "#B8FF51",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ) }) }) })
    ] }),
    /* @__PURE__ */ I("div", { className: "flex md:hidden flex-row justify-center gap-10", children: [
      /* @__PURE__ */ d("button", { className: "w-16 h-16 bg-neutral-400 project-prev", children: /* @__PURE__ */ d("svg", { xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60", fill: "none", children: /* @__PURE__ */ d(
        "path",
        {
          d: "M37.5 47.5L20 30L37.5 12.5",
          stroke: "#B8FF51",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ) }) }),
      /* @__PURE__ */ d("button", { className: "w-16 h-16 bg-neutral-400 project-next", children: /* @__PURE__ */ d("svg", { xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60", fill: "none", children: /* @__PURE__ */ d(
        "path",
        {
          d: "M22.5 12.5L40 30L22.5 47.5",
          stroke: "#B8FF51",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ) }) })
    ] })
  ] }) }) });
}, Uc = ({
  sectionHeader: t = "Certified Expertise",
  sectionDescription: e = "Explore our qualifications and discover why we're the trusted choice for your project needs",
  qualifications: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ d("div", { "data-testid": "qualifications", id: "qualifications", className: "bg-neutral-100", children: /* @__PURE__ */ I("div", { className: "flex flex-col justify-between 2xl:max-w-8xl w-full 2xl:mx-auto py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px] gap-6 md:gap-8 xl:gap-10   ", children: [
  /* @__PURE__ */ I("div", { className: "flex flex-col  items-center gap-3 xl:gap-5 ", children: [
    /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1 text-center  text-neutral-400", children: t }),
    /* @__PURE__ */ d("svg", { width: "100", height: "4", viewBox: "0 0 100 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { y1: "2.30078", x2: "100", y2: "2.30078", stroke: "#282931", strokeWidth: "3" }) })
  ] }),
  /* @__PURE__ */ d("div", { className: "font-lato text-heading6 md:text-heading5 xl:text-heading4 text-center  text-neutral-400 font-medium", children: e }),
  /* @__PURE__ */ d("div", { className: "flex flex-wrap flex-row  items-start gap-6 md:gap-8 xl:gap-10 justify-center", children: r.map((n, i) => /* @__PURE__ */ I(
    "div",
    {
      className: "flex flex-col justify-center items-center gap-5 pt-8 pr-10 pb-8 pl-10  bg-neutral-400 max-w-md w-full",
      children: [
        /* @__PURE__ */ d("div", { className: "flex justify-center items-center ", children: /* @__PURE__ */ d("svg", { width: "61", height: "61", viewBox: "0 0 61 61", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d(
          "path",
          {
            d: "M50.333 18.3008L30.333 8.30078L10.333 18.3008M50.333 18.3008L30.333 28.3008M50.333 18.3008V43.3008L30.333 53.3008M30.333 28.3008L10.333 18.3008M30.333 28.3008V53.3008M10.333 18.3008V43.3008L30.333 53.3008",
            stroke: "white",
            strokeWidth: "2",
            strokeLinejoin: "round"
          }
        ) }) }),
        /* @__PURE__ */ I("div", { className: "flex flex-col items-center justify-center gap-4 ", children: [
          /* @__PURE__ */ d("span", { className: "font-lato text-heading6 md:text-heading5 xl:text-heading4 text-center   text-primary-400 font-medium", children: n.title }),
          /* @__PURE__ */ d("span", { className: "font-lato text-body2 md:text-body1  text-center  text-white ", children: n.description })
        ] })
      ]
    },
    `qualification-${i}`
  )) })
] }) }), Qc = ({
  sectionHeader: t = "Get Your Project Started!",
  headline: e,
  actionButtonText: r = "Request a Quote",
  businessEmail: n,
  businessName: i
}) => {
  const { isLoading: s, isSuccess: o, handleChange: l, onSubmit: c, isError: u } = ta({
    businessEmail: n,
    businessName: i
  });
  return /* @__PURE__ */ d("div", { "data-testid": "request-quote", id: "request-quote", children: /* @__PURE__ */ I("div", { className: "flex flex-col md:flex-row justify-between items-center 2xl:max-w-8xl w-full 2xl:mx-auto gap-6 md:gap-8 xl:gap-10 bg-white py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px]", children: [
    /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-start gap-6 md:gap-8 xl:gap-10 ", children: [
      /* @__PURE__ */ I("div", { className: "flex flex-col justify-start md:items-start items-center gap-3 xl:gap-5  max-md:w-full", children: [
        /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1  text-neutral-400 max-md:w-full  max-md:text-center font-normal", children: t }),
        /* @__PURE__ */ d("svg", { width: "100", height: "4", viewBox: "0 0 100 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { y1: "1.80078", x2: "100", y2: "1.80078", stroke: "#282931", strokeWidth: "3" }) })
      ] }),
      /* @__PURE__ */ d("div", { className: "font-lato xl:text-heading4 md:text-heading5 text-heading6 max-md:w-full  max-md:text-center text-neutral-400 font-medium", children: e })
    ] }),
    /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-center gap-10 pt-8 pr-10 pb-8 pl-10  bg-neutral-400 md:max-w-md w-full", children: [
      /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-center gap-3 xl:gap-5 ", children: [
        /* @__PURE__ */ d("span", { className: "font-lato xl:text-heading4 md:text-heading5 text-heading6 text-center  text-white font-medium", children: "Request a Quote" }),
        /* @__PURE__ */ d("svg", { width: "100", height: "4", viewBox: "0 0 100 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { x1: "100", y1: "2.30078", y2: "2.30078", stroke: "#B8FF51", strokeWidth: "3" }) })
      ] }),
      /* @__PURE__ */ I("form", { onSubmit: c, className: "flex flex-col justify-start items-center gap-5 w-full", children: [
        o && /* @__PURE__ */ d("div", { className: "flex items-center w-full justify-center p-4 text-sm font-medium text-primary-500 bg-primary-100 rounded-md", children: "Message sent successfully" }),
        u && /* @__PURE__ */ d("div", { className: "flex items-center w-full  justify-center p-4 text-sm font-medium text-error-200 bg-error-50 rounded-md", children: "Error sending message" }),
        /* @__PURE__ */ d(
          "input",
          {
            name: "name",
            id: "name",
            type: "text",
            placeholder: "Name",
            onChange: l,
            required: !0,
            className: "bg-white w-full flex-col flex items-start outline-none border border-primary-200 gap-2.5 px-4 py-1.5 text-lg  text-neutral-400 font-lato"
          }
        ),
        /* @__PURE__ */ d(
          "input",
          {
            name: "phoneNumber",
            id: "phoneNumber",
            onChange: l,
            required: !0,
            placeholder: "Phone Number",
            className: "bg-white w-full flex-col flex outline-none border border-primary-200 items-start gap-2.5 px-4 py-1.5 text-lg  text-neutral-400 font-lato"
          }
        ),
        /* @__PURE__ */ d(
          "button",
          {
            disabled: s,
            type: "submit",
            className: " w-full flex uppercase text-button justify-center border transition-all border-neutral-400 active:bg-white hover:bg-neutral-100 items-center gap-2.5 px-4 py-2 h-fit   font-medium  bg-primary-300 text-neutral-400",
            children: r
          }
        )
      ] })
    ] })
  ] }) });
}, Yc = ({
  sectionHeader: t = "Our Service Area",
  phones: e,
  emails: r,
  locations: n,
  hideLocation: i,
  serviceArea: s
}) => n && n.length === 0 ? null : /* @__PURE__ */ d("div", { "data-testid": "service-area", id: "service-area", className: "bg-neutral-400", children: /* @__PURE__ */ d("div", { className: "flex mx-auto 2xl:max-w-8xl w-full py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px]", children: /* @__PURE__ */ I("div", { className: "flex flex-col justify-start gap-10 w-full", children: [
  /* @__PURE__ */ I("div", { className: "grid grid-cols-1 md:grid-cols-2  xl:grid-cols-3  items-start  gap-8 ", children: [
    e && e.length > 0 && /* @__PURE__ */ I("div", { className: "flex flex-col  gap-2.5 max-w-xs", children: [
      /* @__PURE__ */ d("div", { className: "flex flex-row justify-start items-start gap-2.5 pt-4 pr-4 pb-4 pl-4  overflow-hidden", children: /* @__PURE__ */ d("svg", { width: "30", height: "31", viewBox: "0 0 30 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d(
        "path",
        {
          d: "M5 0.800781C2.23858 0.800781 0 3.03936 0 5.80078V9.80078C0 21.3988 9.40202 30.8008 21 30.8008H25C27.7614 30.8008 30 28.5622 30 25.8008V23.0368C30 21.9005 29.358 20.8617 28.3416 20.3536L23.5098 17.9376C21.8769 17.1212 19.8994 17.9403 19.3221 19.6722L18.7266 21.4588C18.5003 22.1377 17.8039 22.5418 17.1023 22.4014C12.7106 21.5231 9.27769 18.0902 8.39935 13.6985C8.25902 12.9968 8.66312 12.3005 9.34195 12.0742L11.5592 11.3351C13.0464 10.8394 13.9012 9.28229 13.521 7.76148L12.3489 3.07317C12.015 1.73767 10.815 0.800781 9.43845 0.800781H5Z",
          fill: "#98F215"
        }
      ) }) }),
      /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-start gap-3  ", children: [
        /* @__PURE__ */ d("span", { className: "font-lato text-heading6 xl:text-heading4  text-white font-medium", children: "Customer Support" }),
        e.map((o, l) => /* @__PURE__ */ d(
          "a",
          {
            href: `tel:${ur(o.phoneNumber)}`,
            className: "font-lato text-body1 xl:text-heading5 text-white font-medium",
            children: ur(o.phoneNumber)
          },
          `service-area-phone-${l}`
        ))
      ] })
    ] }),
    e && e.length > 0 && /* @__PURE__ */ I("div", { className: "flex flex-col  gap-2.5 ", children: [
      /* @__PURE__ */ d("div", { className: "flex flex-row justify-start items-start gap-2.5 pt-4 pr-4 pb-4 pl-4  overflow-hidden", children: /* @__PURE__ */ I("svg", { width: "31", height: "31", viewBox: "0 0 31 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
        /* @__PURE__ */ d(
          "path",
          {
            d: "M0.333008 5.80078C0.333008 4.14393 1.67615 2.80078 3.33301 2.80078H27.333C28.9899 2.80078 30.333 4.14393 30.333 5.80078V8.21594L15.333 16.6534L0.333008 8.21591V5.80078Z",
            fill: "#98F215"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M0.333008 10.5106V25.8008C0.333008 27.4576 1.67615 28.8008 3.33301 28.8008H27.333C28.9899 28.8008 30.333 27.4576 30.333 25.8008V10.5106L15.333 18.9481L0.333008 10.5106Z",
            fill: "#98F215"
          }
        )
      ] }) }),
      /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-start gap-3  ", children: [
        /* @__PURE__ */ d("span", { className: "font-lato text-heading6 xl:text-heading4  text-white font-medium", children: "General Questions" }),
        r == null ? void 0 : r.map((o, l) => /* @__PURE__ */ d(
          "a",
          {
            href: `mailto:${o.email}`,
            className: "font-lato text-body1 xl:text-heading5 text-white font-medium",
            children: o.email
          },
          `service-area-email-${l}`
        ))
      ] })
    ] }),
    !i && n && n.length > 0 && /* @__PURE__ */ I("div", { className: "flex flex-col  gap-2.5 ", children: [
      /* @__PURE__ */ d("div", { className: "flex flex-row justify-start items-start gap-2.5 pt-4 pr-4 pb-4 pl-4  overflow-hidden", children: /* @__PURE__ */ I("svg", { width: "31", height: "31", viewBox: "0 0 31 31", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
        /* @__PURE__ */ d(
          "path",
          {
            d: "M12.667 13.7929C12.667 12.1393 14.0107 10.7955 15.667 10.7955C17.3233 10.7955 18.667 12.1393 18.667 13.7929C18.667 15.4466 17.3233 16.7903 15.667 16.7903C14.0107 16.7903 12.667 15.4466 12.667 13.7929Z",
            fill: "#98F215"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.66699 13.7929C2.66699 6.61832 8.48933 0.800781 15.667 0.800781C22.8447 0.800781 28.667 6.61832 28.667 13.7929C28.667 19.141 25.9904 23.3779 23.1239 26.2426C21.6873 27.6782 20.1824 28.7913 18.8935 29.551C18.2493 29.9306 17.6473 30.229 17.124 30.4355C16.6299 30.6306 16.1112 30.7825 15.667 30.7825C15.2228 30.7825 14.7041 30.6306 14.21 30.4355C13.6867 30.229 13.0846 29.9306 12.4405 29.551C11.1515 28.7913 9.64667 27.6782 8.21011 26.2426C5.34357 23.3779 2.66699 19.141 2.66699 13.7929ZM15.667 8.79553C12.9073 8.79553 10.667 11.0334 10.667 13.7929C10.667 16.5524 12.9073 18.7903 15.667 18.7903C18.4267 18.7903 20.667 16.5524 20.667 13.7929C20.667 11.0334 18.4267 8.79553 15.667 8.79553Z",
            fill: "#98F215"
          }
        )
      ] }) }),
      /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-start gap-3  ", children: [
        /* @__PURE__ */ d("span", { className: "font-lato text-heading6 xl:text-heading4  text-white font-medium", children: "Address" }),
        n == null ? void 0 : n.map(({ streetAddress: o, city: l, state: c, postalCode: u }, f) => /* @__PURE__ */ d(
          "a",
          {
            href: Da({ streetAddress: o, city: l, state: c, postalCode: u }),
            className: "font-lato text-body1 xl:text-heading5 text-white font-medium",
            children: Va({ streetAddress: o, city: l, state: c, postalCode: u })
          },
          `service-area-location-${f}`
        ))
      ] })
    ] })
  ] }),
  /* @__PURE__ */ I("div", { className: "gap-10 flex flex-col justify-start items-start w-full", children: [
    /* @__PURE__ */ d("h2", { className: "font-tomorrow xl:text-heading1 md:text-heading2 text-heading3 text-white", children: t }),
    /* @__PURE__ */ d(
      $6,
      {
        locations: n,
        hideLocation: i,
        serviceArea: s,
        containerStyle: {
          maxWidth: "100%",
          width: "100%"
        }
      }
    )
  ] })
] }) }) });
const Jc = ({
  sectionHeader: t = "What Our Clients Say",
  sectionDescription: e = "Discover the experiences of our valued clients and their satisfaction with our services.",
  testimonials: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ d("div", { "data-testid": "testimonials", id: "testimonials", className: "bg-neutral-400", children: /* @__PURE__ */ d("div", { className: "flex flex-col justify-center items-center py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px] 2xl:max-w-8xl 2xl:mx-auto w-full", children: /* @__PURE__ */ I("div", { className: "flex flex-col justify-center items-center gap-6 md:gap-8 xl:gap-10 w-full", children: [
  /* @__PURE__ */ I("div", { className: "flex flex-col justify-center items-center gap-3 xl:gap-5  ", children: [
    /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1  text-center text-white   font-normal", children: t }),
    /* @__PURE__ */ d("svg", { width: "100", height: "3", viewBox: "0 0 100 3", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { x1: "100", y1: "1.5", y2: "1.5", stroke: "#B8FF51", strokeWidth: "3" }) })
  ] }),
  /* @__PURE__ */ d("div", { className: "gap-6 md:gap-8 xl:gap-10 w-full items-center flex flex-row mx-auto max-w-7xl", children: /* @__PURE__ */ d(
    ti,
    {
      modules: [cl, ul],
      pagination: {
        clickable: !0
      },
      navigation: {
        prevEl: "#services_prev_slide",
        nextEl: "#services_next_slide"
      },
      wrapperClass: "w-full flex max-md:items-center",
      spaceBetween: 35,
      autoplay: !0,
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 15
        },
        1280: {
          slidesPerView: 1,
          spaceBetween: 35
        }
      },
      className: "w-full max-h-[600px] h-full  [--swiper-pagination-color:#98F217] [--swiper-pagination-bullet-inactive-color:#DDDDDE] [--swiper-pagination-bullet-inactive-opacity:1] [--swiper-pagination-bullet-size:12px] [--swiper-pagination-bullet-horizontal-gap:6px]",
      children: r.map((n, i) => /* @__PURE__ */ d(ri, { className: "text-center !w-full", children: /* @__PURE__ */ I("div", { className: "w-full flex flex-col justify-center items-center gap-8 pb-10 ", children: [
        /* @__PURE__ */ d("span", { className: "font-lato text-body2 md:text-body1  text-center  text-white font-normal", children: n.text }),
        /* @__PURE__ */ d("div", { className: "flex flex-row justify-center items-center", children: /* @__PURE__ */ I("span", { className: "font-lato text-heading6 md:text-heading4  text-white font-medium", children: [
          n.authorName,
          " / Client"
        ] }) })
      ] }) }, `testimonial-${i}`))
    }
  ) })
] }) }) }), Zc = ({
  sectionHeader: t = "Trade Categories in Our Belt",
  sectionDescription: e = "Explore options for your project needs",
  categories: r
}) => !r || r.length === 0 ? null : /* @__PURE__ */ d("div", { "data-testid": "trade-categories", id: "trade-categories", className: "bg-neutral-100", children: /* @__PURE__ */ d("div", { className: "flex justify-center items-center py-14 md:py-16 xl:py-20 px-5 md:px-10 xl:px-[100px] 2xl:max-w-8xl w-full 2xl:mx-auto", children: /* @__PURE__ */ I("div", { className: "gap-6 md:gap-32 flex flex-col md:flex-row justify-start items-center w-full", children: [
  /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-start gap-6 md:gap-8 xl:gap-10 max-w-sm mr-auto", children: [
    /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-start gap-3 xl:gap-5", children: [
      /* @__PURE__ */ d("h2", { className: "text-heading3 md:text-heading2 xl:text-heading1 text-neutral-400 text-opacity-100 leading-none font-normal", children: t }),
      /* @__PURE__ */ d("svg", { width: "100", height: "4", viewBox: "0 0 100 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ d("line", { y1: "2.30078", x2: "100", y2: "2.30078", stroke: "#282931", strokeWidth: "3" }) })
    ] }),
    /* @__PURE__ */ d("span", { className: "font-lato text-heading6 md:text-heading5  xl:text-heading4  text-neutral-400 text-opacity-100  font-medium", children: e })
  ] }),
  /* @__PURE__ */ d("div", { className: "grid grid-cols-1 xl:grid-cols-2 items-start gap-6 xl:gap-10 w-full", children: r.map((n, i) => /* @__PURE__ */ d("div", { className: "flex  items-center md:max-w-sm w-full p-4 bg-neutral-400", children: /* @__PURE__ */ I("div", { className: "flex flex-row justify-start items-start gap-3  ", children: [
    /* @__PURE__ */ d("div", { className: " bg-primary-400 py-4 px-4 rounded-full", children: /* @__PURE__ */ I("svg", { width: "12", height: "11", viewBox: "0 0 12 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
      /* @__PURE__ */ d(
        "path",
        {
          d: "M1.02637 6.85547L3.30127 8.93384",
          stroke: "#282931",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M10.667 1.98438L3.55589 9.09548",
          stroke: "#282931",
          strokeWidth: "2",
          strokeLinecap: "round"
        }
      )
    ] }) }),
    /* @__PURE__ */ d("span", { className: "font-lato text-body2 md:text-body1 self-center text-white text-opacity-100  font-normal", children: n })
  ] }) }, `category-${i}`)) })
] }) }) }), Kc = ({
  sectionHeader: t = "404-Error",
  shortDescription: e = "The page you were looking for doesn’t exist.",
  actionButtonText: r = "Home"
}) => /* @__PURE__ */ d("div", { "data-testid": "error-page", id: "error-page", children: /* @__PURE__ */ I("div", { className: "flex flex-col justify-start items-center  relative overflow-hidden gap-10 py-12 bg-neutral-400 h-[64rem]", children: [
  /* @__PURE__ */ I("div", { className: "flex flex-col justify-center items-center  absolute h-full gap-10  max-w-sm", children: [
    /* @__PURE__ */ d("p", { className: " text-heading3 md:text-heading2 xl:text-heading1 text-center text-white", children: t }),
    /* @__PURE__ */ d("p", { className: " text-center text-white text-heading3 md:text-heading2 xl:text-heading1", children: "error" }),
    /* @__PURE__ */ d("p", { className: " text-heading6 font-medium text-center text-white", children: e }),
    /* @__PURE__ */ d(
      "a",
      {
        href: "/",
        className: "flex uppercase cursor-pointer text-button justify-center border transition-all border-neutral-400 active:bg-white hover:bg-neutral-100 items-center gap-2.5 px-4 py-2 h-fit   font-medium  bg-primary-300 text-neutral-400",
        children: /* @__PURE__ */ d("p", { className: " text-base font-medium text-left uppercase text-black", children: r })
      }
    )
  ] }),
  /* @__PURE__ */ I(
    "svg",
    {
      height: "547",
      viewBox: "0 0 911 547",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "flex-grow-0 w-full flex-shrink-0 ",
      children: [
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-23.3922 526.855C-4.90976 541.533 18.4372 544.992 40.6608 545.954C86.4708 547.941 84.1844 484.906 117.2 479.522C145.959 474.834 163.886 464.001 177.295 437.431C199.982 392.48 243.719 411.791 271.543 436.859C314.645 475.691 361.136 529.769 425.459 504.807C474.132 485.921 501.806 457.213 520.088 407.612C527.801 386.685 535.485 363.324 538.338 341.082C541.205 318.732 533.182 288.948 553.088 273.984C592.805 244.131 660.477 279.407 705.031 263.324C737.665 251.542 749.66 234.089 734.354 199.306C713.311 151.478 774.323 132.06 808.624 121.242C838.404 111.847 887.172 123.908 910.74 98.8521",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-25.412 520.169C-7.13222 534.24 15.8323 537.442 37.5327 538.114C62.9278 538.902 77.9684 514.245 88.3332 494.032C95.4808 480.093 102.968 467.373 112.666 466.296C142.499 462.982 157.676 452.043 172.763 426.6C177.113 419.265 181.956 413.16 187.432 409.008C215.1 388.024 245.121 407.9 266.295 425.529C289.574 444.91 312.862 471.733 339.259 487.362C367.501 504.081 393.848 507.693 425.492 498.093C444.788 492.238 466.464 481.665 479.98 467.108C496.473 449.344 508.071 426.946 517.601 403.561C519.529 398.83 521.203 393.671 522.813 388.505C529.197 368.007 533.356 349.569 534.547 328.122C535.686 307.596 529.595 284.933 545.911 269.517C546.514 268.949 547.237 268.379 547.943 267.889C590.085 238.711 656.68 275.339 701.639 260.019C735.438 248.502 744.073 230.933 729.132 196.102C718.151 170.502 732.978 153.536 752.471 141.477C768.496 131.561 788.976 124.715 807.979 118.955C838.016 109.851 885.62 121.261 909.214 97.0683",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-27.4536 513.305C-8.95056 526.29 12.9634 529.132 34.2472 529.045C59.8529 528.939 73.9486 501.358 84.0515 480.97C91.1398 466.667 98.6222 454.271 108.22 453.149C136.879 449.797 152.196 440.22 168.55 416.593C173.096 410.025 178.235 404.915 183.921 401.426C212.349 383.983 238.495 397.797 261.091 414.99C285.767 433.769 310.372 459.701 336.551 476.256C364.718 494.066 392.923 500.639 425.452 491.353C444.05 486.044 464.989 475.461 477.941 460.873C493.428 443.425 506.054 422.398 515.129 399.58C517.022 394.816 518.789 389.795 520.448 384.652C527.427 363.021 529.884 345.496 529.994 322.792C530.096 302.012 524.011 278.94 540.875 263.492C541.488 262.93 542.22 262.369 542.935 261.891C585.809 233.21 653.098 271.507 698.228 256.704C732.883 245.339 737.884 227.664 723.958 192.895C713.352 166.422 731.505 150.348 751.492 138.905C768.056 129.421 788.361 122.528 807.424 116.7C837.385 107.541 883.591 118.47 907.693 95.2973",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-29.5107 506.328C-11.9293 517.657 10.3658 520.991 30.8405 519.023C57.2185 516.489 69.6444 488.262 79.7775 467.69C86.8613 453.31 94.3921 441.483 103.913 440.346C129.654 437.269 148.642 428.521 164.711 407.622C169.133 401.871 175.023 397.922 181.079 394.562C209.21 378.958 233.214 389.023 256.416 405.625C281.849 423.823 307.131 448.155 333.373 464.93C362.36 483.459 392.004 493.226 425.118 484.515C442.878 479.842 462.099 469.068 475.404 454.514C491.158 437.282 503.808 417.277 512.669 395.661C514.595 390.959 516.372 385.973 518.103 380.825C525.824 357.869 526.125 341.326 525.132 317.362C524.261 296.402 518.537 272.971 536.024 257.594C536.652 257.042 537.392 256.492 538.115 256.026C581.744 227.91 649.725 267.697 694.811 253.384C729.829 242.264 731.395 224.157 718.863 189.686C708.936 162.382 730.35 147.303 750.742 136.41C767.743 127.329 787.851 120.411 806.949 114.474C836.606 105.256 882.049 115.858 906.177 93.5379",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-31.5734 499.304C-14.0874 509.442 7.87748 511.429 27.3454 508.315C53.2562 504.169 65.162 475.112 75.5526 454.461C82.6828 440.289 90.3203 429.273 99.7898 428.154C124.66 425.216 143.466 417.605 161.297 399.903C166.032 395.202 172.539 391.229 178.823 388.032C206.51 373.945 229.649 380.74 252.652 396.922C277.604 414.477 303.673 436.997 329.69 453.568C359.549 472.587 392.565 486.296 424.256 477.496C441.057 472.831 458.763 462.712 472.584 448.41C488.298 432.144 501.349 412.819 510.22 391.789C512.181 387.137 513.96 382.156 515.775 377.011C523.001 356.51 523.22 341.516 521.293 320.059C519.23 297.085 510.749 269.058 531.388 251.915C532.065 251.353 532.807 250.79 533.542 250.335C577.93 222.839 646.483 263.941 691.394 250.065C726.459 239.23 724.839 220.555 713.881 186.47C704.93 158.623 729.781 144.242 750.208 133.984C767.552 125.275 787.452 118.318 806.54 112.272C835.891 102.973 880.516 113.267 904.666 91.7905",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-33.6343 492.289C-16.1926 501.097 5.3486 501.44 23.7945 497.164C48.9784 491.325 60.556 462.087 71.4151 441.545C78.6432 427.873 86.4782 417.9 95.8923 416.843C119.907 414.148 139.389 408.487 158.565 392.916C164.028 388.48 170.53 384.984 177.014 381.887C204.142 368.93 226.663 372.897 249.536 388.558C273.974 405.292 299.799 426.317 325.499 442.384C356.169 461.558 390.76 478.111 422.511 470.099C438.638 466.031 455.54 455.946 469.704 442.629C486.09 427.223 498.879 408.497 507.781 387.947C509.78 383.332 511.533 378.226 513.463 373.188C527.803 335.74 491.378 274.079 526.99 246.474C527.707 245.919 528.48 245.363 529.246 244.902C574.5 217.638 641.573 260.67 687.555 246.56C723.45 235.545 718.207 216.88 709.05 183.244C701.397 155.131 729.529 141.299 749.876 131.619C767.475 123.248 787.152 116.242 806.186 110.085C835.233 100.686 878.989 110.695 903.16 90.0505",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-35.687 485.343C-18.2389 492.696 2.78486 491.203 20.2161 485.806C44.5177 478.283 55.8003 449.48 67.3959 429.223C74.7727 416.337 82.8306 407.646 92.2568 406.692C115.579 404.331 136.67 400.328 156.322 386.54C162.113 382.477 168.931 379.206 175.542 376.137C202.363 363.684 224.363 365.914 246.993 380.471C270.573 395.64 295.673 416.274 320.837 431.646C349.23 448.989 387.785 471.638 419.765 462.311C436.084 457.552 452.688 449.462 466.762 437.149C483.444 422.554 496.394 404.289 505.352 384.12C507.391 379.532 509.122 374.269 511.169 369.346C526.914 331.478 482.066 270.54 522.88 241.289C523.642 240.744 524.448 240.207 525.252 239.745C571.581 213.196 633.882 252.889 683.592 243.132C723.045 235.39 710.282 207.437 704.404 180.01C698.37 151.85 729.386 138.545 749.724 129.315C767.499 121.247 786.938 114.181 805.875 107.913C834.625 98.3979 877.46 108.148 901.659 88.3245",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-37.7251 478.514C-19.5407 484.811 0.264611 480.015 16.6389 474.454C39.2655 466.768 50.8926 437.456 63.5226 417.764C71.0983 405.952 79.4316 398.774 88.914 397.97C112.356 395.981 133.912 393.446 154.451 380.766C160.558 376.996 167.561 373.85 174.306 370.764C200.501 358.777 222.481 358.746 244.938 372.601C267.713 386.652 291.95 406.779 316.171 421.47C344.68 438.761 383.188 461.999 415.97 454.251C432.643 450.311 449.364 443.738 463.758 431.926C480.708 418.018 493.894 400.168 502.933 380.283C505.011 375.712 506.842 370.569 508.89 365.461C524.429 326.718 474.313 265.816 519.113 236.385C519.924 235.853 520.764 235.334 521.608 234.877C568.787 209.377 629.721 248.611 679.546 239.793C719.108 232.793 703.977 203.2 699.985 176.761C695.769 148.844 729.279 135.978 749.735 127.056C767.615 119.26 786.791 112.125 805.59 105.751C834.055 96.0959 875.926 105.621 900.164 86.6091",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-39.7417 471.848C-21.5682 476.393 -2.47293 469.849 13.0879 463.304C34.9048 454.127 45.7368 426.202 59.8177 407.445C67.6657 396.989 76.1934 391.731 85.7381 391.108C109.311 389.57 131.745 387.367 152.848 375.562C159.217 371.997 166.324 368.598 173.208 365.742C199.524 354.827 219.617 351.05 243.269 364.894C265.334 377.808 288.749 397.546 312.049 411.76C340.979 429.412 378.593 451.911 411.834 446.558C428.865 443.815 445.815 438.423 460.697 426.913C477.91 413.598 491.378 396.102 500.524 376.419C502.645 371.853 504.887 366.733 506.629 361.511C519.298 323.516 468.344 260.106 515.745 231.784C516.604 231.272 517.487 230.772 518.377 230.321C566.119 206.077 625.948 244.477 675.456 236.555C714.769 230.263 697.935 198.757 695.831 173.497C693.558 146.212 729.096 133.616 749.89 124.839C767.806 117.279 786.697 110.066 805.318 103.588C833.516 93.7769 874.378 103.114 898.676 84.9032",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-41.7319 465.389C-23.1368 467.302 -5.89928 460.273 9.5862 452.541C30.583 442.055 40.3195 415.727 56.2967 398.545C64.4917 389.732 73.1365 386.28 82.8088 385.69C106.633 384.235 129.813 382.184 151.415 370.879C157.992 367.437 165.169 364.045 172.156 361.033C197.885 349.943 218.546 344.485 241.872 357.302C263.266 369.06 286.092 388.587 308.434 402.396C339.327 421.495 374.467 440.739 407.616 439.247C424.225 438.499 442.153 433.363 457.574 422.06C475.053 409.248 488.849 392.058 498.123 372.499C500.288 367.929 502.808 362.798 503.876 357.345C511.425 318.81 463.104 254.345 512.834 227.515C513.743 227.024 514.659 226.561 515.584 226.139C564.217 203.959 621.901 240.615 671.353 233.427C710.347 227.76 692.626 194.894 692.06 170.247C691.447 143.505 729.447 131.1 750.166 122.656C768.137 115.333 786.636 107.999 805.043 101.424C832.996 91.4375 872.81 100.628 897.191 83.2081",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-43.6916 459.172C-25.2902 459.169 -8.76987 450.878 6.15434 442.327C26.0543 430.927 34.9153 405.857 52.9279 391.397C61.381 384.611 70.2917 382.07 80.0971 381.459C104.221 379.956 128.074 377.766 150.061 366.649C156.794 363.243 164.011 359.789 171.064 356.577C196.221 345.126 217.437 338.11 240.619 349.787C261.511 360.312 283.729 379.671 305.263 393.257C335.826 412.542 370.164 431.781 403.375 432.186C420.497 432.394 438.396 428.482 454.395 417.308C472.138 404.918 486.308 387.997 495.73 368.496C497.945 363.915 499.825 358.561 500.319 352.906C503.686 314.374 457.424 248.27 510.249 223.906C511.197 223.47 512.167 223.049 513.145 222.656C562.554 202.756 617.708 236.817 667.265 230.417C706.037 225.409 687.284 190.88 688.682 167.019C690.219 140.778 729.419 128.956 750.538 120.496C768.409 113.336 786.6 105.891 804.747 99.2486C832.844 88.9626 870.481 97.7968 895.711 81.5241",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-45.6154 453.23C-27.525 451.377 -11.4165 442.102 2.81249 432.813C20.8624 421.03 30.8867 397.206 49.7489 385.861C58.3648 380.677 67.5941 378.91 77.5315 378.236C101.979 376.58 126.435 374.013 148.701 362.789C155.545 359.338 162.774 355.754 169.854 352.305C191.107 341.95 216.29 329.265 239.369 342.309C260.959 354.512 281.646 370.78 302.462 384.234C332.621 403.729 366.037 423.088 399.157 425.25C416.704 426.397 434.617 423.688 451.16 412.589C469.129 400.537 484.624 383.895 493.214 364.355C495.208 359.82 495.997 354.052 496.009 348.227C496.084 309.87 452.807 242.5 508.117 220.901C509.111 220.514 510.139 220.115 511.159 219.751C560.887 202.025 613.889 233.404 663.219 227.529C701.488 222.973 682.051 186.486 685.599 163.77C689.568 138.363 728.976 127.077 750.984 118.35C768.712 111.318 786.544 103.778 804.413 97.0544C832.312 86.5575 868.869 95.3142 894.237 79.8457",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-47.5005 447.594C-29.8387 444.036 -14.3173 433.959 -0.422972 424.131C16.2887 412.31 27.5779 390.879 46.7458 381.668C55.719 377.357 64.9857 376.597 75.0466 375.829C99.8264 373.936 124.821 370.803 147.258 359.202C154.168 355.63 161.382 351.856 168.451 348.13C189.56 337.004 214.574 323.328 237.967 334.839C259.382 345.377 279.717 361.831 299.93 375.226C329.669 394.935 362.109 414.564 394.987 418.324C412.792 420.361 430.859 418.896 447.877 407.834C465.774 396.2 483.401 379.692 489.816 359.914C491.288 355.376 491.38 349.307 490.998 343.347C488.48 304.08 448.338 237.977 506.419 218.392C507.457 218.043 508.53 217.672 509.591 217.338C559.407 201.662 610.341 230.219 659.24 224.773C696.91 220.577 677.093 181.676 682.818 160.491C689.37 136.241 728.142 125.537 751.474 116.208C769.021 109.193 786.529 101.659 804.023 94.8386C831.65 84.0682 867.219 92.8348 892.762 78.1804",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-49.3437 442.285C-32.2123 437.23 -17.016 426.622 -3.53763 416.396C11.7419 404.801 24.9467 385.938 43.8688 378.798C53.0473 375.334 62.4144 374.902 72.5829 374.016C97.6929 371.826 123.201 367.973 145.657 355.769C152.581 352.007 159.766 347.989 166.785 343.95C187.764 331.88 212.311 317.337 236.244 327.35C257.68 336.316 277.795 352.74 297.548 366.134C326.907 386.042 358.343 406.077 390.878 411.294C408.781 414.164 427.117 414.021 444.543 402.96C462.017 391.867 481.522 376.156 485.472 355.181C486.377 350.382 486.033 344.353 485.344 338.292C480.687 297.266 444.383 234.269 505.117 216.289C506.193 215.969 507.302 215.63 508.399 215.326C558.008 201.593 607.116 227.262 655.351 222.145C692.477 218.208 672.706 177.538 680.598 157.374C689.768 133.94 727.719 123.825 751.983 114.059C769.194 107.133 786.402 99.4667 803.555 92.5902C831.036 81.5758 865.526 90.3491 891.291 76.5202",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-51.142 437.328C-34.619 431.03 -20.1732 420.082 -6.51779 409.708C8.34595 398.419 22.4873 382.434 41.103 376.797C50.4611 373.964 59.8378 373.582 70.0926 372.562C95.5211 370.034 121.494 365.372 143.835 352.363C150.73 348.348 157.872 344.034 164.794 339.654C185.523 326.534 209.296 311.204 234.02 319.826C255.755 327.402 275.714 343.439 295.184 356.879C324.252 376.944 354.688 397.501 386.826 404.058C404.696 407.703 423.453 408.93 441.166 397.883C458.517 387.063 478.543 372.501 480.254 350.201C480.636 345.224 480.02 339.226 479.113 333.102C472.725 289.918 441.325 230.945 504.171 214.512C505.281 214.222 506.42 213.911 507.547 213.637C556.509 201.756 604.237 224.538 651.571 219.655C688.229 215.875 668.692 174.113 678.892 154.464C690.783 131.559 727.527 122.069 752.481 111.895C769.327 105.026 786.2 97.2187 802.991 90.3043C830.364 79.0345 863.786 87.8474 889.817 74.8704",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-52.8945 432.734C-37.1272 425.508 -23.0411 414.601 -9.30268 404.556C5.48625 393.743 19.9978 380.062 38.4043 375.329C47.8918 372.889 57.2202 372.366 67.5322 371.208C93.2589 368.318 119.625 362.829 141.731 348.83C148.565 344.503 155.628 339.864 162.42 335.107C182.803 320.831 205.294 304.924 231.1 312.247C253.469 318.595 273.382 333.925 292.68 347.377C321.454 367.433 351.086 388.71 382.814 396.511C400.584 400.881 419.833 403.391 437.75 392.51C455.506 381.728 474.079 367.955 474.235 345.007C474.268 340.062 473.411 333.958 472.373 327.805C464.689 282.245 439.307 227.868 503.539 212.982C504.68 212.716 505.845 212.433 506.993 212.189C554.856 202.037 601.691 222.047 647.915 217.299C684.192 213.575 664.854 171.111 677.593 151.698C692.302 129.285 727.448 120.291 752.937 109.7C769.393 102.863 785.896 94.9023 802.307 87.9714C829.609 76.4413 861.998 85.3151 888.344 73.2263",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-54.621 428.336C-39.5372 420.522 -25.6925 410.081 -11.9566 400.419C2.80135 390.04 17.7055 378.396 35.7349 374.08C45.2616 371.799 54.5334 370.97 64.8692 369.675C90.8631 366.416 117.55 360.137 139.292 345.007C146.034 340.314 152.991 335.307 159.613 330.163C181.747 312.969 201 302.497 227.031 305.16C248.961 307.402 270.671 324.193 289.866 337.557C318.285 357.343 347.457 379.594 378.806 388.566C396.494 393.629 416.17 396.916 434.303 386.739C451.829 376.903 468.348 361.568 467.497 339.636C467.306 334.741 466.283 328.579 465.198 322.429C456.742 274.472 438.398 224.968 503.18 211.625C504.345 211.385 505.53 211.129 506.697 210.912C553.31 202.211 599.434 219.784 644.402 215.078C680.416 211.309 661.057 168.436 676.649 149.046C694.217 127.199 727.448 118.493 753.318 107.464C769.363 100.623 785.464 92.5094 801.482 85.5817C828.747 73.7913 860.16 82.7391 886.866 71.5864",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-56.3271 424.098C-41.8304 416.017 -28.3303 405.969 -14.5261 396.946C0.577575 387.075 15.2429 377.226 33.0567 372.763C42.5678 370.379 51.7573 369.089 62.0771 367.663C88.2936 364.043 115.229 357.071 136.471 340.711C143.093 335.611 150.099 330.156 156.279 324.756C175.981 307.543 197.324 299.091 221.455 299.62C244.507 300.124 267.046 314.165 286.544 327.358C314.75 346.44 342.713 368.092 374.752 380.134C391.814 386.546 413.83 390.483 430.827 380.465C447.669 370.542 461.456 354.711 460.128 334.124C459.817 329.301 458.714 323.121 457.666 317.008C449.069 266.834 438.624 222.193 503.053 210.375C504.237 210.157 505.436 209.928 506.614 209.733C551.873 202.297 597.385 217.75 641.042 212.988C676.949 209.069 657.191 166.006 676.005 146.484C696.435 125.285 727.428 116.736 753.59 105.175C769.22 98.267 784.879 90.026 800.493 83.1281C827.755 71.0838 858.277 80.1059 885.383 69.9517",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-58.0046 420.086C-44.0549 411.863 -30.6802 402.296 -17.037 393.926C-2.00423 384.705 13.1336 376.002 30.3351 371.111C39.7853 368.424 48.8781 366.394 59.1367 364.854C85.516 360.895 112.622 353.382 133.228 335.745C139.7 330.205 146.409 324.979 152.217 320.164C171.311 304.333 191.375 296.425 214.712 295.399C238.253 294.362 262.043 305.98 282.086 317.734C310.904 334.631 338.962 358.12 370.588 371.134C386.927 377.858 410.526 384.095 426.214 373.572C441.043 363.625 453.632 348.03 452.223 328.506C451.882 323.776 450.795 317.617 449.864 311.567C441.863 259.554 439.878 219.516 503.113 209.166C504.309 208.971 505.537 208.741 506.704 208.594C549.424 203.243 595.563 215.746 637.846 211.025C668.521 207.602 661.296 160.494 675.615 143.983C693.206 123.699 727.133 114.842 753.72 102.816C769.083 95.8652 784.102 87.4496 799.315 80.5994C826.61 68.308 856.354 77.3976 883.892 68.3211",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-59.6606 416.242C-46.2241 407.953 -33.2368 398.892 -19.5152 391.172C-4.27492 382.596 11.0334 374.599 27.5398 368.883C36.9171 365.635 45.8904 362.542 56.0375 360.909C82.6719 356.622 108.856 347.994 129.598 330.515C135.707 325.367 142.187 321.009 147.648 316.69C164.758 303.154 185 293.15 207.14 292.23C231.581 291.214 254.753 299.27 275.458 309.546C305.35 324.38 335.534 349.339 366.041 361.365C382.024 367.666 404.58 376.23 419.346 366.073C432.264 357.188 445.066 341.681 443.883 322.815C443.593 318.201 442.613 312.092 441.876 306.137C435.295 252.855 442.033 216.912 503.312 207.941C504.516 207.764 505.747 207.56 506.919 207.433C548.284 202.961 593.819 214.15 634.818 209.188C664.297 205.619 660.044 157.748 675.428 141.523C694.171 121.756 727.179 112.857 753.669 100.376C768.549 93.3629 783.111 84.789 797.874 77.9504C825.166 65.3079 854.393 74.6052 882.39 66.6938",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-61.3018 412.512C-61.3018 412.512 -50.3718 403.719 -21.9802 388.509C-6.95057 380.457 8.94178 372.727 24.6428 365.859C33.9346 361.795 42.8537 357.056 52.7788 355.458C78.8762 351.254 104.157 342.517 125.544 326.454C131.5 321.98 137.587 318.063 142.729 314.149C159.219 301.601 177.994 291.585 199.056 289.848C223.152 287.859 246.09 293.798 267.15 302.601C297.799 315.411 328.75 338.485 359.249 351.183C374.297 357.448 396.965 367.39 410.435 357.948C422.367 349.581 435.878 335.517 435.214 317.082C435.053 312.603 434.268 306.58 433.802 300.745C429.491 246.924 444.861 214.369 503.607 206.646C504.815 206.487 506.044 206.303 507.214 206.196C547.264 202.508 592.152 212.761 631.966 207.468C647.784 205.365 650.313 196.864 655.412 184.414C663.402 164.902 659.912 154.303 675.404 139.082C694.957 119.867 727.28 110.601 753.399 97.842C767.761 90.8254 781.997 81.8281 796.21 75.1164C823.2 62.3685 852.455 71.6987 880.876 65.0677",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-62.9351 408.848C-62.9351 408.848 -52.6842 399.971 -24.4548 385.781C-9.12123 378.074 6.6055 370.246 21.619 361.846C30.8047 356.706 39.6144 350.24 49.3515 348.615C74.2516 344.457 99.7041 338.146 121.177 323.447C126.916 319.519 132.743 315.958 137.6 312.362C153.414 300.654 170.71 290.394 190.751 287.98C214.171 285.157 236.682 289.437 257.703 296.738C288.712 307.507 320.101 327.784 350.24 341.224C364.606 347.631 386.06 358.733 399.994 349.404C415.253 339.189 423.446 329.791 426.33 311.34C426.958 307.326 425.865 301.11 425.735 295.415C424.519 241.884 448.031 211.868 503.948 205.228C505.152 205.086 506.377 204.921 507.542 204.83C546.371 201.84 590.52 211.567 629.291 205.859C645.267 203.507 647.225 194.686 652.615 182.263C661.233 162.401 659.086 151.896 675.497 136.637C695.606 117.94 727.171 108.218 752.871 95.198C766.82 88.132 780.45 78.6814 794.498 72.1773C821.716 59.581 850.558 68.641 879.346 63.4436",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-64.5654 405.199C-64.5654 405.199 -54.9396 396.288 -26.9549 382.846C-11.2577 375.307 4.23804 366.835 18.4469 356.668C27.4967 350.192 36.0598 344.291 45.8338 342.816C70.6914 339.064 94.8024 335.007 116.628 321.292C122.168 317.81 127.852 314.517 132.39 311.141C148.426 299.21 164.054 290.536 182.498 286.354C203.194 281.662 227.046 285.863 247.624 291.75C278.509 300.588 309.698 318.566 339.588 331.604C353.549 337.693 374.79 349.216 388.441 340.611C400.795 332.825 415.65 323.749 417.351 305.617C417.751 301.354 417.511 295.705 417.786 290.173C420.385 237.796 451.193 209.387 504.286 203.644C505.485 203.514 506.702 203.365 507.853 203.293C545.598 200.915 588.889 210.567 626.795 204.349C642.919 201.706 644.349 192.542 650.02 180.116C659.226 159.938 658.483 149.497 675.67 134.173C696.112 115.945 726.93 105.764 752.046 92.4263C765.601 85.2284 778.721 75.4302 792.738 69.1386C820.303 56.7648 848.747 65.6534 877.809 61.8254",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-66.1991 401.527C-66.1991 401.527 -57.1262 392.617 -29.4981 379.579C-12.903 371.747 1.15149 361.763 15.0965 350.223C23.9133 342.926 32.5473 339.408 42.2657 338.261C66.586 335.392 90.3674 332.449 112.01 319.785C117.38 316.644 122.888 313.535 127.211 310.302C142.453 298.898 157.143 289.43 174.546 284.697C194.023 279.399 217.48 282.739 237.388 287.385C267.769 294.472 298.415 310.114 327.844 322.395C341.651 328.158 362.525 339.65 376.179 331.712C388.996 324.261 404.966 318.224 408.403 299.94C409.179 295.82 409.286 290.418 410.059 285.041C417.343 234.388 453.57 206.943 504.573 201.849C505.761 201.73 506.965 201.595 508.101 201.538C544.925 199.697 587.236 209.747 624.475 202.928C640.77 199.944 641.649 190.416 647.617 177.957C657.366 157.602 658.302 146.88 675.885 131.668C696.463 113.863 726.738 103.325 750.877 89.5123C763.922 82.0475 776.966 72.1126 790.932 65.9974C818.746 53.8213 847.063 62.5879 876.377 60.2776",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-67.8403 397.797C-67.8403 397.797 -59.2291 388.918 -32.0965 375.875C-15.426 367.862 -2.03268 354.786 11.6085 344.091C19.5988 337.826 28.9691 335.45 38.6618 334.631C62.5991 332.604 85.991 330.612 107.421 318.731C112.653 315.83 117.969 312.831 122.163 309.662C136.575 298.768 151.044 288.504 167.119 282.736C185.265 276.226 208.011 279.92 227.442 283.343C257.456 288.629 286.847 302.946 315.53 313.644C329.647 318.91 350.127 329.552 363.593 322.831C376.964 316.158 393.998 312.706 399.619 294.341C400.831 290.382 401.367 285.23 402.672 280.049C414.741 232.094 455.692 204.398 504.756 199.812C505.927 199.702 507.092 199.603 508.233 199.534C545.606 197.285 584.998 209.225 622.324 201.587C638.798 198.217 639.134 188.299 645.396 175.773C655.606 155.351 658.363 144.161 676.104 129.116C696.654 111.686 725.975 100.82 749.295 86.4279C762.035 78.5643 775.101 68.7315 789.082 62.7662C817.08 50.8159 845.463 59.4045 874.942 58.7273",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-69.4934 393.977C-69.4934 393.977 -61.2244 385.147 -34.7633 371.643C-18.4739 363.33 -6.21079 348.263 8.08312 338.882C16.0398 333.66 25.3554 332.103 35.0328 331.615C58.6899 330.423 81.7336 329.291 102.943 317.924C108.071 315.176 113.268 312.229 117.333 309.034C131.226 298.11 145.133 286.617 160.423 280.2C177.577 272.999 199.297 276.586 218.197 279.277C246.845 283.355 275.442 295.747 303.139 305.346C317.415 310.293 337.314 320.33 351.051 314.065C365.396 307.523 383.097 306.744 391.135 288.844C392.8 285.14 393.848 280.187 395.741 275.213C412.765 230.512 457.022 201.773 504.784 197.498C505.932 197.396 507.079 197.307 508.198 197.248C545.13 195.32 583.209 208.793 620.335 200.313C636.993 196.508 636.796 186.178 643.343 173.547C653.925 153.131 658.557 141.382 676.298 126.498C696.664 109.413 724.599 98.1848 747.346 83.1991C760.02 74.8511 773.11 65.2803 787.188 59.4419C815.345 47.7684 843.967 56.1165 873.505 57.1712",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-71.1621 390.035C-71.1621 390.035 -62.6679 381.366 -37.5076 366.805C-22.0666 357.869 -11.1225 342.364 4.53157 334.326C12.8154 330.071 21.777 329.074 31.3898 328.929C54.7155 328.58 77.644 328.263 98.6446 317.158C103.702 314.484 108.807 311.534 112.791 308.23C126.378 296.96 139.799 284.267 154.64 276.804C170.825 268.665 192.083 272.01 210.036 274.792C236.874 278.951 264.421 288.924 291.146 297.461C305.618 302.084 325.761 311.666 338.908 305.483C353.074 298.819 373.172 300.927 383.099 283.476C385.084 279.987 386.838 275.314 389.393 270.557C411.519 229.382 457.259 199.054 504.604 194.882C505.724 194.783 506.883 194.664 507.941 194.651C542.925 194.193 582.484 208.057 618.501 199.087C631.381 195.88 634.126 187.925 639.753 177.419C651.602 155.3 656.537 140.252 676.433 123.806C696.735 107.026 722.814 95.3244 745.177 79.7669C757.922 70.8998 771.044 61.7377 785.255 56.0328C813.542 44.6773 842.584 52.737 872.064 55.6076",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-72.8481 385.949C-72.8481 385.949 -63.4488 377.415 -40.3355 361.302C-26.8352 351.89 -14.9179 336.747 0.964092 330.174C9.36178 326.697 18.2009 326.122 27.745 326.311C50.7972 326.769 73.7533 327.295 94.577 316.23C99.5983 313.562 104.697 310.558 108.597 307.063C122.195 294.87 134.772 280.408 149.93 272.275C165.586 263.874 185.495 266.527 203.31 269.447C228.51 273.58 254.673 282.453 279.994 289.913C294.648 294.229 313.875 302.974 327.5 297.133C342.926 290.518 363.234 294.63 375.661 278.256C378.137 274.992 380.429 270.63 383.76 266.098C411.462 228.403 456.106 196.244 504.159 191.938C505.25 191.841 506.386 191.722 507.412 191.717C542.017 191.567 581.001 207.777 616.807 197.897C629.801 194.309 632.101 185.974 637.889 175.332C650.017 153.03 656.595 137.558 676.485 121.029C696.416 104.464 721.654 91.5582 742.927 76.1556C755.319 67.1813 769.406 57.1541 783.283 52.54C811.506 43.1538 839.88 49.0531 870.62 54.0346",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-74.5557 381.703C-74.5557 381.703 -65.47 372.927 -43.2546 355.097C-31.0024 345.264 -18.3229 331.547 -2.61088 326.206C5.84728 323.331 14.6202 323.031 24.1069 323.522C46.9808 324.708 70.0798 326.145 90.7759 314.937C95.8001 312.216 100.878 309.11 104.794 305.344C118.582 292.086 131.155 275.894 146.481 266.367C161.83 256.828 180.344 259.298 198.337 262.759C221.868 267.284 246.369 275.998 270.102 282.589C284.837 286.682 303.102 294.569 317.148 289.045C333.892 282.462 354.197 288.248 368.979 273.213C371.95 270.192 374.848 266.129 378.971 261.862C411.663 228.05 454.513 193.22 503.395 188.653C504.453 188.554 505.519 188.475 506.554 188.433C543.183 187.001 578.266 208.19 615.24 196.724C628.395 192.644 630.203 183.986 636.142 173.174C648.471 150.727 656.648 134.794 676.426 118.16C695.938 101.751 719.784 87.4752 740.6 72.3874C752.994 63.4049 767.279 53.4205 781.274 48.9729C809.659 39.9508 838.604 45.43 869.171 52.4565",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-76.286 377.277C-76.286 377.277 -68.5373 366.611 -46.2479 348.314C-34.36 338.554 -21.5879 326.624 -6.18485 322.211C2.33065 319.772 11.0451 319.589 20.4849 320.337C43.2724 322.138 66.6411 324.551 87.2639 313.065C92.3304 310.244 97.3307 306.999 101.412 302.881C115.482 288.695 126.432 270.394 144.774 260.729C161.891 251.712 177.938 251.524 195.197 254.8C216.476 258.839 239.446 269.357 261.864 275.331C276.655 279.272 293.79 286.432 308.157 281.213C326.175 274.668 346.33 281.882 363.214 268.363C366.671 265.595 370.269 262.003 375.244 257.756C410.361 227.79 453.888 189.93 502.256 185.005C503.274 184.901 504.309 184.818 505.308 184.779C542.031 183.355 576.629 208.2 613.782 195.544C627.059 191.022 628.41 181.934 634.494 170.914C646.944 148.371 656.664 131.94 676.231 115.193C695.241 98.9216 717.518 83.1022 738.209 68.4774C750.841 59.5476 765.119 49.6011 779.232 45.3315C807.747 36.7049 837.473 41.7671 867.716 50.8633",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-78.04 372.664C-78.04 372.664 -70.9992 359.147 -49.2591 341.844C-37.5939 332.56 -24.8211 321.832 -9.75088 318.009C-1.18313 315.836 7.48233 315.618 16.886 316.558C39.6762 318.833 63.4453 322.246 84.0449 310.414C89.199 307.453 94.3022 304.034 98.4695 299.487C112.602 284.073 124.063 265.785 143.741 255.975C160.652 247.543 176.658 245.953 193.76 248.16C213.931 250.76 235.17 261.736 255.647 267.949C269.624 272.189 286.683 278.383 300.816 273.616C319.968 267.16 339.96 275.611 358.541 263.73C362.466 261.221 367.077 257.574 372.579 253.477C408.906 226.421 453.499 186.404 500.682 180.991C501.66 180.879 502.66 180.788 503.621 180.749C540.467 179.239 575.059 208.26 612.413 194.345C625.691 189.398 626.81 179.813 633.008 168.62C645.536 145.992 656.542 129.059 675.882 112.123C694.328 95.9711 715.258 78.5564 735.759 64.4425C748.625 55.5852 762.924 45.7079 777.161 41.6245C805.781 33.4164 836.476 38.0947 866.258 49.259",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-79.8188 367.859C-79.8188 367.859 -74.6525 352.01 -52.2834 335.713C-39.5465 326.434 -28.3025 316.962 -13.3016 313.439C-4.62397 311.4 3.93916 310.955 13.3183 312.01C36.1651 314.579 60.5149 318.944 81.11 306.771C86.4006 303.645 91.7941 300.009 95.9671 294.973C109.24 278.955 122.93 260.981 143.12 251.83C160.07 244.148 177.4 241.175 193.753 242.963C212.118 244.973 232.641 253.857 251.772 260.219C267.686 265.511 283.327 270.726 295.396 266.209C314.597 259.024 336.845 267.02 355.209 259.081C359.5 257.227 364.677 253.122 370.634 249.172C407.586 224.663 452.924 182.687 498.614 176.607C499.547 176.483 500.511 176.382 501.43 176.338C538.507 174.585 573.495 208.353 611.111 193.102C624.305 187.751 625.343 177.617 631.62 166.279C644.19 143.577 656.274 126.131 675.358 108.953C693.298 92.8044 712.975 74.1127 733.257 60.3036C746.27 51.443 760.72 41.7535 775.06 37.8596C803.754 30.0685 835.594 34.4354 864.793 47.643",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-81.623 362.859C-81.623 362.859 -77.0039 345.44 -55.3164 329.793C-43.0147 320.918 -31.8954 312.064 -16.8323 308.358C-8.14245 306.219 0.443924 305.459 9.78781 306.535C32.6544 309.17 57.8668 314.351 78.4355 301.933C83.9165 298.624 89.1633 294.526 93.4041 289.305C106.91 272.683 122.041 256.345 142.682 248.044C159.194 241.402 178.046 237.127 194.813 238.956C212.97 240.937 231.94 246.907 249.886 252.813C264.781 257.714 278.486 263.488 292.259 258.975C312.244 252.426 334.001 261.43 352.861 254.283C357.391 252.566 363.003 248.611 369.346 244.806C406.657 222.425 451.912 179.048 496.027 171.817C496.928 171.671 497.871 171.544 498.771 171.483C536.35 168.927 571.722 208.524 609.852 191.791C622.881 186.073 623.981 175.327 630.302 163.883C642.882 141.109 655.845 123.148 674.642 105.68C692.172 89.3896 710.568 69.7108 730.714 56.073C743.817 47.2026 758.489 37.7406 772.934 34.0427C801.713 26.6768 834.8 30.8096 863.321 46.0145",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-83.4516 357.668C-83.4516 357.668 -79.3667 339.199 -58.3531 323.971C-46.4801 315.366 -35.4748 306.826 -20.3377 302.644C-11.6291 300.237 -2.97002 299.011 6.29922 299.999C29.005 302.418 55.1178 308.293 75.5211 295.756C80.9397 292.427 86.1872 288.583 90.5578 283.61C104.865 267.33 121.035 251.87 142.224 244.39C160.268 238.018 179.071 235.087 196.603 235.85C213.551 236.586 232.317 241.182 249.565 246.31C263.691 250.509 276.091 256.583 290.854 251.979C310.737 245.78 332.606 255.581 351.296 249.392C355.998 247.836 361.978 244.013 368.642 240.355C391.542 227.782 413.884 213.274 436.105 199.229C453.424 188.282 472.599 170.34 493.294 166.728C494.198 166.572 495.135 166.432 496.033 166.364C534.045 163.488 570.248 208.442 608.607 190.39C621.342 184.397 622.733 172.87 629.031 161.414C641.587 138.574 655.245 120.102 673.724 102.305C690.887 85.7736 707.993 65.2857 728.135 51.7666C741.338 42.9027 756.228 33.6747 770.787 30.1796C799.677 23.2454 834.073 27.2249 861.841 44.3709",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-85.3032 352.289C-85.3032 352.289 -81.7353 333.215 -61.3899 318.145C-49.9366 309.662 -39.0368 301.151 -23.8135 296.196C-15.0791 293.353 -6.22763 291.499 2.84272 292.252C25.1527 294.103 51.4052 300.788 72.084 289.331C77.6172 286.264 83.0164 282.71 87.5346 277.977C102.705 262.087 120.276 246.656 141.577 240.666C160.409 235.373 179.663 232.414 198.659 233.079C215.276 233.661 233.567 236.52 250.454 240.654C263.978 243.967 275.455 250.009 290.681 245.267C309.64 239.363 332.338 249.604 350.433 244.387C355.248 242.999 361.53 239.307 368.453 235.795C391.864 223.916 414.861 209.834 436.857 195.238C453.207 184.388 470.64 165.151 490.539 161.508C491.443 161.343 492.378 161.186 493.273 161.112C531.687 157.907 568.889 208.083 607.35 188.869C619.658 182.719 621.578 170.218 627.78 158.864C640.291 135.964 654.466 116.954 672.589 98.8293C689.442 81.9733 705.284 60.8395 725.527 47.3962C738.812 38.5736 753.947 29.5663 768.623 26.2772C797.655 19.7681 833.389 23.6884 860.357 42.7113",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-87.1323 346.883C-87.1323 346.883 -84.1088 327.425 -64.4233 312.231C-53.3826 303.71 -42.5782 294.957 -27.2568 288.936C-18.491 285.49 -9.72899 282.825 -0.910276 283.641C21.1589 285.681 47.2768 293.199 68.3348 282.867C74.025 280.073 79.6046 276.825 84.281 272.328C101.136 256.117 118.956 243.743 140.601 236.697C159.007 230.707 180.766 228.835 200.586 230.234C217.564 231.433 235.262 232.755 252.199 235.756C265.312 238.081 275.982 243.903 291.49 238.89C309.358 233.114 332.904 243.583 350.187 239.253C355.067 238.03 361.584 234.474 368.706 231.109C392.376 219.926 415.949 206.282 437.437 191.062C453.169 179.919 468.132 160.046 487.766 156.182C488.667 156.006 489.597 155.844 490.495 155.757C529.45 151.952 567.715 207.65 606.046 187.2C617.993 180.826 620.378 167.547 626.529 156.225C638.992 133.277 653.492 113.649 671.228 95.2571C687.828 78.0452 702.311 56.4647 722.896 42.9769C736.303 34.1922 751.635 25.4157 766.443 22.3391C795.681 16.2667 832.728 20.2018 858.863 41.0341",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-88.9604 341.609C-88.9604 341.609 -86.4835 321.782 -67.4494 306.169C-56.8123 297.445 -46.096 288.194 -30.6648 280.808C-21.8596 276.596 -13.5217 274.062 -4.95988 274.924C16.8961 277.125 42.8429 285.439 64.2607 276.314C70.1415 273.81 75.9238 270.873 80.7677 266.6C98.5099 250.949 117.084 239.007 139.186 232.338C158.6 226.48 181.277 225.013 202.035 226.946C219.313 228.554 237.031 229.685 254.465 231.506C267.308 232.845 277.407 238.272 293.033 232.887C309.828 227.099 334.017 237.588 350.471 233.989C355.384 232.915 362.061 229.518 369.328 226.3C392.996 215.821 417.117 202.615 437.778 186.717C452.991 175.012 465.199 154.928 484.982 150.788C485.883 150.599 486.809 150.427 487.705 150.333C527 146.164 567.334 206.763 604.664 185.362C616.124 178.792 619.063 164.882 625.256 153.492C637.74 130.536 652.309 110.425 669.636 91.6052C685.945 73.8874 699.29 52.0449 720.25 38.5291C733.789 29.7987 749.304 21.2413 764.253 18.3839C793.753 12.7433 832.075 16.7691 857.363 39.3448",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-90.7927 336.43C-90.7927 336.43 -88.8598 316.229 -70.4688 299.897C-60.2262 290.802 -49.1334 279.86 -34.1449 272.058C-25.6159 267.618 -17.5234 265.224 -9.21766 266.119C12.5566 268.462 38.1403 277.365 59.8684 269.63C65.9417 267.468 71.9647 264.797 76.9798 260.737C95.5518 245.702 114.777 233.974 137.252 227.456C157.56 221.565 181.249 220.156 202.696 222.869C220.652 225.138 238.695 227.031 256.923 227.743C269.592 228.239 279.454 233.094 295.073 227.264C310.94 221.34 335.068 231.42 351.196 228.579C356.125 227.71 363.046 224.497 370.242 221.361C395.021 210.564 422.156 197.284 442.529 178.192C455.418 166.113 463.544 149.529 482.186 145.343C483.086 145.142 484.012 144.961 484.905 144.859C524.609 140.311 568.017 205.65 603.164 183.317C613.884 176.508 617.553 162.241 623.944 150.658C636.575 127.762 650.919 107.322 667.807 87.8724C683.765 69.4904 696.274 47.5557 717.595 34.0581C731.271 25.3986 746.309 17.9831 762.056 14.4122C791.881 7.64772 833.308 14.755 855.854 37.6373",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-92.6279 331.312C-92.6279 331.312 -90.8327 310.729 -73.4772 293.379C-62.5524 282.457 -51.2201 270.915 -37.8306 263.246C-29.8287 258.665 -21.7652 256.42 -13.5999 257.248C8.60509 259.497 32.9169 269.279 55.1869 262.794C61.4687 260.965 67.737 258.567 72.9259 254.703C92.2362 240.326 112.009 228.576 134.75 221.95C155.772 215.825 180.44 214.106 202.306 217.697C221.046 220.775 239.907 224.397 259.26 224.292C272.089 224.221 281.862 228.331 297.377 222.013C312.522 215.845 336.774 225.632 352.298 222.985C357.219 222.146 364.152 219.302 371.371 216.3C395.744 206.164 422.784 193.353 441.733 173.45C453.965 160.602 460.431 144.357 479.388 139.873C480.286 139.661 481.213 139.471 482.102 139.361C521.999 134.45 567.332 203.916 601.406 180.973C611.878 173.922 616.021 159.49 622.575 147.719C635.29 124.883 649.402 104.472 665.737 84.0734C681.189 64.7769 693.426 42.9147 714.936 29.5769C728.755 21.008 743.942 13.7673 759.857 10.4337C790.107 4.09927 832.585 11.4982 854.339 35.9113",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-94.4642 326.234C-94.4642 326.234 -93.151 305.222 -76.4755 286.592C-66.0173 274.91 -55.1748 262.485 -41.6546 254.414C-33.8697 249.767 -25.987 247.526 -18.0316 248.338C4.14123 250.602 27.8074 261.035 50.2654 255.805C56.7622 254.292 63.27 252.168 68.6301 248.483C88.5641 234.778 108.784 222.773 131.663 215.75C153.148 209.155 178.381 206.88 200.643 211.167C220.378 214.967 240.412 221.265 261.168 220.936C274.579 220.723 284.367 223.935 299.722 217.113C314.338 210.619 338.527 220 353.623 217.451C358.518 216.623 365.437 214.005 372.637 211.131C396.717 201.519 422.756 189.185 440.441 168.58C452.003 155.107 457.434 139.167 476.59 134.403C477.485 134.181 478.406 133.985 479.3 133.863C519.519 128.355 563.756 201.568 599.251 178.254C612.147 169.786 617.516 150.676 625.228 136.829C636.379 116.801 650.013 98.2391 663.43 80.2213C677.907 60.7798 690.658 38.214 712.278 25.1036C726.249 16.6302 741.594 9.57076 757.659 6.46289C788.357 0.525629 831.832 8.27886 852.814 34.1701",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-96.3006 321.168C-96.3006 321.168 -95.303 299.672 -79.4622 279.521C-69.7139 267.121 -59.0105 253.994 -45.5561 245.572C-38.0009 240.843 -30.207 238.613 -22.4461 239.401C-0.369797 241.644 22.6669 252.742 45.1744 248.67C51.8759 247.457 58.6116 245.592 64.137 242.064C84.5699 229.016 105.18 216.451 128.002 208.795C150.618 201.208 175.032 198.646 197.39 202.848C217.624 206.65 239.927 217.324 262.355 217.425C276.678 217.489 286.71 219.824 301.89 212.506C316.202 205.608 340.192 214.548 355.065 212.004C359.923 211.173 366.591 208.518 373.958 205.87C398.276 197.127 422.4 184.257 438.582 163.602C449.483 149.686 454.715 133.911 473.794 128.946C474.689 128.714 475.608 128.509 476.5 128.379C517.853 122.365 560.432 198.405 597.072 175.416C610.346 167.088 615.983 147.603 623.751 133.539C634.81 113.517 648.229 94.7151 660.886 76.3266C674.598 56.4055 687.83 33.5463 709.627 20.6402C723.757 12.2724 739.85 4.63292 755.465 2.50223C786.213 -1.69488 829.939 3.59316 851.282 32.4094",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-98.1377 316.094C-97.3317 299.365 -90.7795 285.696 -82.4385 272.177C-74.2404 258.888 -62.8534 245.468 -49.4799 236.741C-42.1057 231.929 -34.3704 229.703 -26.7832 230.461C-4.84597 232.649 17.8476 244.606 40.0063 241.422C46.6671 240.465 53.836 238.847 59.5089 235.46C80.3196 223.034 101.033 210.181 123.888 201.028C147.167 191.703 171.052 187.31 193.402 192.214C214.541 196.853 238.414 212.02 262.537 213.486C278.116 214.432 288.644 215.917 303.671 208.132C322.078 198.596 337.319 212.641 356.528 206.676C361.299 205.194 367.956 203.063 375.251 200.544C399.702 192.1 420.886 179.695 436.127 158.711C446.464 144.479 452.185 128.624 471.004 123.523C471.897 123.282 472.815 123.068 473.704 122.931C516.177 116.404 557.103 195.043 594.857 172.458C608.498 164.297 614.368 144.421 622.162 130.144C633.079 110.147 646.013 91.1783 658.109 72.4091C671.338 51.88 684.918 28.9451 706.986 16.2021C721.281 7.94963 737.562 0.514456 753.285 -1.43662C784.452 -5.30251 829.174 0.38594 849.739 30.6309",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-99.9733 311.004C-99.5677 293.654 -93.4013 278.842 -85.4038 264.577C-77.7871 250.992 -66.7167 236.924 -53.3781 227.938C-46.1164 223.044 -38.4282 220.813 -30.9902 221.531C-9.15088 223.641 12.9079 236.176 35.001 234.148C41.6625 233.536 49.013 231.982 54.8294 228.7C76.2001 216.644 97.4274 203.014 120.008 191.881C143.365 180.366 167.154 174.439 189.475 179.822C211.38 185.104 236.12 205.206 261.443 208.808C278.728 211.267 289.943 212.109 304.861 203.903C323.311 193.753 338.707 207.6 357.912 201.49C362.63 199.989 369.217 197.812 376.411 195.268C400.31 186.822 419.221 175.057 433.521 154.007C443.402 139.461 449.56 123.399 468.222 118.153C469.114 117.902 470.032 117.68 470.92 117.536C514.423 110.506 553.796 191.502 592.593 169.38C606.592 161.399 612.659 141.129 620.454 126.646C631.194 106.69 643.478 87.5962 655.163 68.481C668.113 47.2977 681.944 24.4023 704.363 11.8027C718.829 3.67052 735.303 -3.55372 751.119 -5.33836C782.73 -8.90434 828.37 -2.78912 848.19 28.8383",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-101.807 305.875C-101.792 287.834 -96.0378 271.888 -88.3423 256.825C-81.2713 242.983 -70.5171 228.374 -57.2111 219.166C-50.0192 214.189 -42.3418 211.948 -35.0243 212.621C-13.2505 214.626 8.22131 227.71 30.2228 226.809C36.8877 226.535 44.1995 225.006 50.1993 221.816C72.5891 209.913 94.2881 194.547 116.483 181.376C139.348 167.809 161.942 161.222 185.647 166.092C210.784 171.253 232.681 195.31 258.815 203.042C273.838 207.488 291.889 207.224 305.262 199.703C324.051 189.137 339.934 202.668 359.127 196.45C363.812 194.932 370.273 192.711 377.341 190.145C400.81 181.628 417.448 170.275 430.911 149.267C440.393 134.471 446.932 118.218 465.452 112.839C466.342 112.58 467.258 112.351 468.145 112.201C512.547 104.692 550.531 187.794 590.27 166.176C617.456 151.386 635.711 92.5095 652.183 64.4925C664.918 42.8346 678.992 19.8782 701.759 7.44007C716.404 -0.560311 733.072 -7.56864 748.974 -9.20167C781.046 -12.4958 827.528 -5.94391 846.633 27.02",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-103.641 300.715C-104.124 282.994 -99.3856 264.915 -91.2544 249.321C-83.6556 234.749 -74.3007 219.894 -60.9472 210.455C-53.7816 205.389 -46.0785 203.135 -38.8465 203.758C-17.1025 205.631 3.84534 219.244 25.7356 219.437C32.4056 219.497 39.6439 218.03 45.7385 214.881C69.3152 202.696 91.3425 183.881 113.292 169.807C133.464 156.871 156.782 144.359 181.943 151.456C209.709 159.29 230.603 185.356 255.186 195.12C271.119 201.449 288.236 204.997 304.686 195.42C323.752 184.318 340.579 198.101 360.078 191.578C364.713 190.028 371.034 187.795 377.967 185.167C400.938 176.463 415.563 165.287 428.299 144.525C437.493 129.538 444.264 113.114 462.694 107.608C463.584 107.344 464.498 107.106 465.385 106.951C510.595 98.9931 547.28 183.931 587.879 162.861C615.532 148.511 633.02 88.6264 649.184 60.4677C661.777 38.5296 676.071 15.392 699.18 3.13845C714.008 -4.72352 730.87 -11.5062 746.855 -13.0024C779.41 -16.0526 826.648 -9.06566 845.066 25.1934",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-105.472 295.508C-106.309 277.177 -101.993 258.235 -94.2261 241.862C-87.1338 226.91 -78.0249 211.468 -64.5614 201.799C-57.379 196.641 -49.6128 194.37 -42.4291 194.939C-20.667 196.661 -0.167105 210.784 21.5976 212.038C28.2739 212.422 35.4241 211.098 41.5862 207.952C66.5205 195.222 88.1822 173.427 110.405 157.44C129.813 143.477 153.011 129.23 178.373 136.326C207.145 144.377 227.472 171.977 251.472 185.546C267.379 194.538 284.921 201.565 302.95 190.891C322.561 179.282 340.618 193.792 360.675 186.862C365.269 185.274 371.432 183.038 378.214 180.325C400.548 171.394 413.49 160.05 425.688 139.781C434.781 124.669 441.506 108.103 459.952 102.46C460.84 102.189 461.751 101.95 462.638 101.783C508.556 93.2077 544.037 180.217 585.415 159.425C613.8 145.165 630.097 84.647 646.167 56.4059C658.699 34.3806 673.182 10.9397 696.631 -1.10787C711.647 -8.82152 728.697 -15.3669 744.767 -16.7412C777.827 -19.5673 825.732 -12.1683 843.492 23.3448",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-107.301 290.258C-108.486 271.293 -104.597 251.739 -97.2331 234.458C-90.6404 218.986 -81.6684 203.104 -68.0363 193.21C-60.7959 187.955 -52.928 185.666 -45.7496 186.175C-23.9127 187.726 -3.77663 202.346 17.8613 204.628C24.5447 205.335 31.621 204.3 37.9086 201.123C63.9674 187.957 85.5126 162.079 107.777 144.552C126.481 129.83 149.439 114.238 174.927 121.118C204.428 129.079 224.773 158.04 247.68 174.617C262.735 185.513 280.644 196.954 299.901 185.912C320.396 174.158 339.891 189.759 360.831 182.296C365.394 180.67 371.409 178.383 378.007 175.621C399.5 166.625 411.409 154.665 423.077 135.05C432.122 119.844 438.742 103.168 457.224 97.4016C458.113 97.1248 459.021 96.8809 459.909 96.7095C506.589 87.7385 540.794 176.061 582.872 155.878C611.873 141.968 627.121 80.5786 643.14 52.3193C655.649 30.2544 670.33 6.53341 694.113 -5.28673C709.321 -12.8455 725.971 -18.4548 742.717 -20.4026C776.81 -24.3673 825.84 -13.6035 841.909 21.4763",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-109.13 284.973C-110.653 265.394 -107.202 245.302 -100.254 227.119C-94.129 211.092 -85.2188 194.81 -71.3619 184.7C-64.0213 179.343 -56.0671 177.061 -48.7939 177.482C-26.5787 178.776 -6.81653 193.786 14.654 197.051C21.317 198.064 28.3982 197.468 34.8809 193.762C61.6059 178.486 82.1726 150.556 105.357 131.423C123.797 116.207 146.031 99.7906 171.582 106.247C201.534 113.814 222.21 143.136 243.825 162.568C257.36 174.735 276.553 190.947 296.344 179.971C317.392 168.296 338.707 185.745 360.462 177.871C365.032 176.219 370.886 173.827 377.269 171.052C414.416 154.903 418.385 103.892 454.514 92.446C455.402 92.1642 456.31 91.9154 457.197 91.7424C504.691 82.4023 537.481 171.422 580.248 152.227C609.303 139.188 624.401 76.47 640.11 48.2272C652.548 25.8624 667.52 2.18422 691.63 -9.38874C707.036 -16.7827 723.861 -22.1433 740.709 -23.9707C775.418 -27.7345 824.797 -16.636 840.319 19.5956",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-110.956 279.656C-112.871 258.911 -109.224 239.084 -103.273 219.852C-98.1926 203.434 -88.6715 186.583 -74.5367 176.268C-67.0537 170.807 -59.0565 168.692 -51.6269 168.719C-28.8181 168.798 -9.23096 184.186 12.0677 188.379C18.6674 189.68 25.9869 189.149 32.3814 185.235C59.2487 168.791 79.578 138.635 103.079 118.317C121.04 102.788 142.738 86.2711 168.3 92.1144C198.608 99.0453 219.553 128.626 239.919 149.643C252.603 162.73 272.024 183.622 292.735 173.16C314.319 162.256 336.606 182.056 359.487 173.562C364.043 171.869 369.749 169.449 375.927 166.603C411.986 149.992 416.12 99.0206 451.821 87.591C452.71 87.3059 453.616 87.0538 454.504 86.8759C502.673 77.2424 534.249 166.588 577.539 148.475C606.506 136.353 621.687 72.2989 637.078 44.1303C649.465 21.4589 664.752 -2.10718 689.186 -13.4115C704.797 -20.6341 721.752 -25.703 738.759 -27.4168C774.185 -30.986 823.738 -19.629 838.72 17.6935",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-112.783 274.328C-115.044 253.097 -111.829 232.556 -106.281 212.663C-101.566 195.766 -92.0278 178.432 -77.5658 167.926C-69.8981 162.354 -61.8705 159.984 -54.2775 159.533C-31.0497 158.147 -11.2791 173.757 9.89663 178.749C16.4565 180.294 23.8667 179.838 30.3166 175.715C57.3171 158.449 77.1861 126.526 100.865 105.509C118.475 89.8794 139.504 74.0763 165.024 79.1385C195.737 85.2307 216.467 114.017 235.979 136.137C248.172 149.956 267.486 175.038 289.082 165.538C311.56 155.647 333.253 178.572 357.821 169.346C362.395 167.627 367.957 165.175 373.912 162.262C408.998 145.089 413.873 94.2083 449.147 82.8446C450.037 82.5579 450.943 82.3025 451.828 82.1245C500.475 72.2966 531.117 161.682 574.746 144.636C603.519 133.395 618.984 68.0814 634.051 40.0462C646.403 17.0635 662.028 -6.32633 686.782 -17.344C702.602 -24.3853 719.667 -29.141 736.864 -30.7411C773.061 -34.1077 822.654 -22.5957 837.115 15.7814",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-114.609 268.996C-117.175 247.272 -115.049 224.934 -109.272 205.55C-104.195 188.516 -96.322 171.209 -80.5843 159.759C-72.9365 154.198 -64.5698 151.001 -56.8061 150.058C-33.241 147.196 -13.0335 162.493 8.03856 168.382C14.5793 170.212 22.0436 169.722 28.5757 165.433C55.6272 147.67 74.8518 114.453 98.6274 93.2563C116.019 77.7532 136.279 63.5749 161.684 67.7045C192.742 72.7552 213.083 99.5593 232.024 122.349C244.073 136.846 263.126 165.271 285.385 157.165C309.292 148.458 328.66 175.348 355.39 165.179C359.974 163.434 365.369 160.993 371.183 158.149C406.419 140.908 411.104 89.6062 446.492 78.198C447.382 77.9113 448.287 77.6559 449.171 77.4763C498.141 67.5529 528.173 156.676 571.872 140.712C600.317 130.32 616.275 63.8501 631.032 35.9765C643.366 12.6806 659.355 -10.4851 684.421 -21.1896C700.454 -28.0365 717.653 -32.489 735.02 -33.9639C771.921 -37.0981 821.54 -25.5696 835.502 13.8473",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M-116.436 263.688C-121.382 226.378 -115.674 175.894 -83.6372 151.57C-42.3549 120.224 -5.80066 175.339 27.064 154.625C69.4624 127.9 95.677 50.3516 158.21 58.2037C189.137 62.0877 208.146 84.8727 226.978 107.231C240.127 122.841 258.786 154.923 281.651 148.141C296.176 143.832 303.12 153.646 315.639 158.04C335.869 165.14 348.27 164.799 368.257 154.304C402.295 136.429 408.791 84.52 443.854 73.6606C493.921 58.1526 524.037 152.188 568.886 136.667C592.668 128.436 601.794 83.7373 612.566 61.3626C628.194 28.898 647.245 -11.9393 682.106 -24.9344C727.44 -41.8349 813.408 -49.6606 833.882 11.9036",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ I(
    "svg",
    {
      height: "654",
      viewBox: "0 0 975 654",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "flex-grow-0 w-full flex-shrink-0 ",
      children: [
        /* @__PURE__ */ d(
          "path",
          {
            d: "M1 615.559C27.4824 609.893 55.2557 604.428 79.7305 593.355C121.843 574.302 110.446 511.821 137.952 481.49C163.687 453.112 196.048 438.839 235.977 439.324C278.564 439.841 319.576 452.07 361.128 459.568C404.818 467.449 419.415 428.478 431.691 394.506C443.549 361.689 453.854 330.851 488.674 316.689C523.012 302.724 557.292 289.911 586.111 268.829C623.874 241.204 633.688 214.946 623.529 167.666C616.001 132.634 625.178 97.7741 650.664 71.9811C676.666 45.6651 711.507 33.2118 746.367 28.0273C795.993 20.6464 848.628 44.8957 900.374 38.7994C923.069 36.1264 946.147 22.5788 955.374 0.999392",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M4.94775 618.965C31.6861 612.931 59.5858 607.27 84.5741 596.761C87.2807 595.622 89.8833 594.208 92.3132 592.734C127.375 571.466 120.981 517.69 145.678 488.997C170.663 459.971 201.504 444.922 241.122 444.947C283.433 444.974 323.443 456.89 364.603 464.858C403.07 472.305 418.91 445.585 431.486 414.432C432.963 410.775 434.354 406.771 435.78 402.71C445.904 373.836 454.107 343.063 482.53 327.15C485.507 325.485 488.717 323.907 492.209 322.46C525.215 308.786 556.997 296.094 586.602 276.23C600.826 266.683 616.337 254.676 625.208 241.477C638.591 221.566 637.73 200.633 632.578 175.532C630.623 166.011 628.564 154.775 628.219 143.622C627.518 120.986 638.988 96.6372 653.706 80.1543C662.5 70.3068 673.061 61.8702 684.898 55.126C703.755 44.3811 725.31 37.7041 746.543 34.8407C769.734 31.7134 793.811 35.9844 817.019 39.107C845.04 42.8774 874.243 47.1757 902.569 43.7252C925.532 40.929 947.572 27.3527 957.855 6.26113",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M8.92139 622.398C35.8789 615.974 63.7642 610.058 89.3443 600.094C92.1277 599.011 94.7976 597.668 97.3251 596.284C132.972 576.77 129.889 524.938 153.604 496.71C177.873 467.825 206.639 450.998 246.265 450.571C288.464 450.117 327.153 461.612 367.988 470.047C406.168 477.935 422.458 454.076 435.503 422.748C437.008 419.135 438.44 415.148 439.875 411.074C449.921 382.529 458.085 348.741 486.35 332.823C489.231 331.2 492.345 329.637 495.711 328.237C527.456 315.04 557.991 302.529 586.602 283.662C601.188 274.044 616.722 262.326 627.163 249.426C643.177 229.643 646.41 209.91 641.498 183.402C639.732 173.863 637.569 162.592 636.464 151.598C634.166 128.74 642.445 105.919 656.365 88.2494C664.218 78.2819 674.084 69.607 685.444 62.6341C703.772 51.3853 725.074 44.6891 746.12 41.5329C769.747 37.9897 794.232 42.1824 817.931 44.9466C846.589 48.2915 875.992 52.3482 904.808 48.661C928.027 45.6921 949.031 32.0742 960.336 11.5233",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M12.9097 625.848C40.0383 618.956 67.946 612.797 94.0365 603.35C96.8871 602.318 99.6257 601.046 102.243 599.743C138.529 581.653 138.619 532.835 161.667 504.568C185.206 475.7 211.839 457.341 251.23 456.019C293.249 454.61 330.927 466.262 371.35 474.996C407.496 482.807 426.836 463.329 439.522 431.111C440.95 427.481 442.531 423.604 443.973 419.545C453.803 391.895 461.973 353.788 490.21 338.5C493.184 336.889 495.998 335.381 499.237 334.021C529.643 321.254 558.788 309.185 586.268 291.12C601.175 281.32 616.361 269.638 628.008 257.457C645.857 238.79 654.201 219.222 650.008 191.459C648.572 181.956 646.406 170.689 644.819 159.773C641.541 137.201 645.953 115.108 658.85 96.3148C665.795 86.1938 674.774 77.274 685.604 70.0676C703.344 58.2669 724.511 51.5003 745.334 48.1538C769.529 44.265 794.691 48.2866 819.001 50.8236C848.086 53.8566 877.954 57.5566 907.099 53.6119C930.395 50.459 950.708 36.7994 962.815 16.7893",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M16.8989 629.297C44.1587 621.886 72.0952 615.485 98.6432 606.513C101.553 605.529 104.36 604.315 107.057 603.093C143.827 586.418 147.26 541.214 169.823 512.515C192.634 483.502 216.937 463.529 256.021 461.291C297.907 458.895 334.964 470.615 374.716 479.697C411.938 488.201 429.219 470.812 443.54 439.443C445.114 435.993 446.621 432.069 448.073 428.047C458.189 400.042 466.122 361.525 493.577 344.527C496.444 342.755 499.505 341.177 502.767 339.811C531.868 327.62 559.534 315.944 585.783 298.582C600.59 288.787 615.612 277.346 627.925 265.545C646.573 247.672 660.617 228.014 657.888 199.745C656.976 190.283 655.029 179.069 653.202 168.229C649.606 146.894 649.898 123.569 661.431 104.394C667.574 94.1834 675.398 84.9214 685.652 77.475C702.742 65.0664 723.888 58.1878 744.469 54.755C769.317 50.6119 795.26 54.4286 820.309 56.7433C849.758 59.466 880.039 62.7997 909.442 58.5686C932.817 55.2061 952.358 41.4666 965.296 22.0515",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M20.8857 632.742C48.2383 624.76 76.3108 617.903 103.156 609.582C106.111 608.665 108.997 607.479 111.766 606.333C147.612 591.514 157.842 548.769 177.812 520.297C198.251 491.156 222.12 469.609 260.595 466.35C302.199 462.824 338.658 475.07 378.106 484.151C414.781 492.594 432.464 479.127 447.554 447.676C449.16 444.326 450.708 440.471 452.172 436.51C462.63 408.191 470.437 369.483 497.153 351.141C499.933 349.231 502.924 347.503 506.084 346.04C533.39 333.388 560.234 322.917 585.355 306.034C599.859 296.287 614.569 285.086 627.133 273.681C645.673 256.849 665.509 236.081 665.008 208.234C664.839 198.855 663.342 187.748 661.512 177.018C657.932 156.016 655.422 132.504 664.444 112.561C669.18 102.088 676.296 92.6197 685.918 84.927C702.295 71.8306 723.447 64.9792 743.985 61.4344C769.591 57.0145 796.278 60.6426 821.93 62.7285C851.633 65.144 882.277 68.0858 911.838 63.5363C935.244 59.9339 954.046 46.0984 967.778 27.3136",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M24.8589 636.18C52.2387 627.59 80.3383 620.575 107.574 612.556C110.585 611.67 113.522 610.54 116.361 609.46C152.635 595.668 165.991 557.15 185.425 527.7C204.787 498.354 227.075 475.422 264.925 471.166C306.153 466.532 342.422 479.405 381.538 488.366C417.452 496.593 435.741 486.899 451.56 455.73C453.198 452.502 454.792 448.734 456.265 444.855C467.098 416.349 474.927 377.634 501.012 358.272C503.738 356.25 506.682 354.409 509.788 352.849C535.459 339.961 561.451 329.76 585.217 313.462C599.196 303.877 613.219 292.851 625.888 281.86C644.934 265.337 668.423 244.37 671.21 216.875C672.159 207.53 671.223 196.748 669.626 186.157C666.448 165.07 662.575 142.142 668.754 121.366C672.002 110.445 677.863 100.453 686.783 92.5045C702.909 78.1348 723.876 72.2976 744.161 68.252C769.443 63.2099 797.75 67.6954 823.92 68.7912C853.736 70.0405 884.875 73.3054 914.278 68.5176C937.611 64.7184 955.775 50.707 970.259 32.5812",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M28.8179 639.594C56.1897 630.353 84.3037 623.181 111.89 615.42C114.952 614.557 117.938 613.482 120.84 612.46C157.826 599.435 173.366 565.385 192.582 534.632C211.005 505.144 231.756 480.886 268.999 475.72C309.774 470.063 346.267 483.599 385.032 492.335C416.886 499.513 440.793 495.002 455.556 463.509C457.066 460.289 458.861 456.762 460.35 452.983C471.607 424.454 479.682 385.865 505.221 365.845C507.921 363.727 510.848 361.793 513.936 360.158C538.179 347.326 563.277 336.747 585.626 320.837C598.947 311.354 612.409 300.557 624.834 290.002C645.15 272.745 669.069 252.343 676.325 225.574C678.738 216.675 678.517 205.953 677.405 195.611C675.134 174.47 670.525 152.134 674.523 131.041C676.653 119.79 680.558 108.503 688.694 100.287C703.857 84.9736 725.086 79.402 745.212 75.2413C770.888 69.9304 799.718 74.2622 826.324 74.9325C856.162 75.6843 887.49 78.6437 916.758 73.4992C940.013 69.4105 957.547 55.2839 972.739 37.8396",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M32.7583 642.996C60.0837 633.064 88.2009 625.735 116.105 618.185C119.212 617.344 122.24 616.317 125.198 615.344C162.934 602.947 180.119 573.195 199.224 541.05C216.81 511.459 236.158 485.959 272.818 480.024C313.073 473.505 350.179 487.653 388.598 496.078C418.907 502.723 444.391 501.34 459.54 470.935C461.072 467.859 462.894 464.478 464.425 460.813C476.341 432.298 484.674 394.196 509.827 373.802C512.529 371.61 515.47 369.601 518.574 367.91C541.894 355.203 565.778 344.007 586.866 328.151C599.376 318.746 612.343 308.369 624.383 298.042C645.358 280.051 668.04 260.611 679.794 234.751C684.145 225.182 685.06 215.331 684.686 205.337C683.897 184.338 679.085 162.581 681.592 141.613C682.963 130.154 685.897 117.882 692.545 108.792C704.931 91.8584 727.95 86.7139 747.312 82.4508C773.105 76.772 802.349 80.9727 829.181 81.1726C858.898 81.3934 890.274 84.012 919.26 78.4916C942.399 74.0861 959.367 59.8492 975.221 43.1055",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M36.6753 646.371C63.9143 635.71 92.03 628.226 120.216 620.839C123.363 620.015 126.427 619.028 129.435 618.1C167.87 606.225 186.28 580.454 205.313 546.899C222.137 517.243 240.251 490.599 276.397 484.084C316.136 476.921 354.31 492.479 392.25 499.593C420.848 504.955 447.649 507.658 463.503 477.893C465.056 474.977 466.958 471.722 468.625 468.185C481.941 439.935 489.747 402.727 514.864 382.064C517.594 379.818 520.576 377.753 523.724 376.022C546.702 363.396 568.524 352.336 589.246 335.367C601.146 325.62 613.291 315.963 624.787 305.933C645.78 287.62 667.741 268.413 682.089 243.984C687.566 234.66 690.668 224.764 691.284 215.227C692.607 194.74 688.089 173.497 689.782 153.036C690.735 141.489 692.887 128.756 698.61 118.577C709.366 99.4455 731.229 94.6817 750.609 89.9003C776.005 83.636 805.701 87.8239 832.513 87.5056C861.953 87.1569 893.201 89.382 921.769 83.4825C944.761 78.7331 961.233 64.3921 977.701 48.3667",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M40.5742 649.727C67.6837 638.3 95.7881 630.657 124.224 623.388C127.404 622.575 130.498 621.63 133.55 620.731C172.556 609.245 191.923 587.05 210.834 552.173C226.931 522.488 244.016 494.842 279.773 487.938C319.051 480.356 358.268 496.093 395.993 502.893C423.183 507.795 451.174 511.775 467.501 484.264C469.136 481.512 471.217 478.483 472.963 475.168C487.507 447.563 495.31 411.121 520.351 390.572C523.133 388.289 526.18 386.186 529.402 384.432C552.52 371.851 574.247 360.61 593.107 342.475C601.19 334.704 613.993 324.787 626.247 313.673C646.787 295.042 667.873 276.015 683.807 253.019C690.075 243.971 695.13 234.127 697 225.157C701.052 205.726 697.384 184.87 698.879 165.226C699.756 153.71 701.063 139.235 706.491 129.469C717.128 110.327 732.632 104.021 755.215 97.6179C780.283 90.5122 809.666 93.5324 836.334 93.9387C865.491 94.3818 895.943 94.9625 924.264 88.4694C947.195 83.213 963.15 68.9232 980.183 53.6289",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M44.4531 653.062C71.385 640.835 99.5359 633.012 128.127 625.831C131.328 625.027 134.455 624.109 137.545 623.238C176.879 612.156 197.085 592.775 215.791 556.87C231.25 527.198 247.508 498.663 282.993 491.636C321.94 483.922 362.194 499.564 399.837 505.994C426.097 510.48 454.336 515.1 471.591 490.095C473.321 487.59 475.534 484.824 477.373 481.751C493.35 455.056 501.206 419.475 526.29 399.257C529.147 396.954 532.284 394.831 535.602 393.071C559.118 380.592 581.367 370.3 598.998 350.176C606.379 341.751 617.42 332.286 628.905 321.278C648.591 302.412 668.622 283.424 685.38 261.737C692.148 252.978 698.201 243.242 701.61 234.956C708.893 217.256 706.791 196.69 708.647 178.045C709.778 166.681 710.899 151.948 715.957 141.326C725.317 121.668 739.856 113.438 761.32 105.761C784.837 97.3499 814.722 100.527 840.639 100.471C869.219 100.408 899.024 100.319 926.72 93.4499C949.522 87.7951 965.117 73.4478 982.664 58.8909",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M48.3159 656.383C75.0191 643.32 103.245 635.304 131.93 628.171C135.142 627.373 138.302 626.474 141.421 625.624C180.741 614.926 201.903 597.37 220.207 561.019C235.06 531.52 250.803 502.072 286.118 495.241C324.937 487.734 365.993 502.887 403.783 508.91C429.566 513.018 457.264 518.506 475.742 495.418C477.534 493.181 479.877 490.698 481.824 487.885C499.455 462.418 507.443 427.761 532.674 408.055C535.627 405.75 538.871 403.625 542.307 401.872C566.516 389.511 589.281 380.604 606.67 358.68C613.817 349.667 622.202 339.77 632.85 328.795C651.406 309.669 670.182 290.6 687.171 270.068C694.177 261.598 700.243 252.678 705.049 244.725C714.909 228.402 716.003 209.484 718.815 191.305C720.533 180.202 721.845 165.325 726.756 153.971C735.306 134.202 748.921 124.225 769.352 114.869C791.149 104.89 820.815 107.563 845.422 107.102C873.139 106.581 903.48 106.379 929.076 98.4115C951.2 91.525 965.968 77.5568 985.145 64.1548",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M52.1694 659.691C78.5862 645.756 106.879 637.539 135.633 630.41C138.855 629.611 142.04 628.725 145.18 627.891C184.023 617.588 206.31 601.01 224.131 564.66C238.528 535.298 254.024 505.076 289.228 498.829C328.169 491.919 369.584 506.068 407.833 511.652C433.591 515.413 460.197 520.75 480.347 500.114C482.237 498.178 484.217 496.044 486.274 493.514C505.665 469.658 514.135 435.937 539.476 416.898C542.529 414.606 545.91 412.499 549.482 410.763C574.496 398.614 598.118 391.252 615.584 367.683C622.66 358.136 628.434 347.316 638.114 336.291C655.195 316.836 672.616 297.622 689.476 277.959C696.527 269.735 702.905 260.981 708.28 253.969C719.473 239.372 724.429 222.643 729.092 204.765C731.921 193.91 733.639 179.217 738.61 167.173C746.779 147.373 759.797 135.207 778.927 124.499C798.872 113.337 826.948 114.714 850.693 113.695C877.633 112.54 905.265 110.82 931.404 103.364C954.602 96.7482 968.414 81.7561 987.624 69.4164",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M56.0186 663C82.0898 648.157 110.441 639.729 139.244 632.556C142.469 631.754 145.675 630.874 148.831 630.051C187.322 620.002 210.056 603.501 227.629 567.871C241.867 539.004 258.174 506.656 292.418 502.502C331.125 497.805 372.492 508.868 411.985 514.25C437.57 517.735 463.62 522.347 485.203 504.204C487.175 502.545 489.279 500.708 491.2 498.539C511.383 475.746 521.309 443.762 546.657 425.729C549.839 423.467 553.372 421.354 557.077 419.69C581.982 408.499 609.111 401.257 625.259 376.93C631.861 366.983 638.457 355.114 645.441 344.03C658.339 323.562 676.223 304.296 692.524 285.405C699.447 277.381 706.007 269.231 711.695 262.599C723.563 248.76 732.176 234.942 739.15 218.141C743.385 207.94 746.472 194.73 751.231 180.651C757.899 160.929 772.956 145.132 789.792 134.402C808.902 122.224 834.477 122.259 856.87 120.275C882.666 117.989 908.942 115.855 933.732 108.324C956.471 101.415 970.578 86.2154 990.105 74.685",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M59.8706 666.309C85.5292 650.518 113.933 641.864 142.767 634.607C145.99 633.794 149.213 632.909 152.376 632.095C190.417 622.305 213.317 605.095 230.777 570.719C245.11 542.5 261.031 509.899 295.918 506.376C335.297 502.401 376.464 511.972 416.234 516.71C441.793 519.754 467.506 523.44 490.205 507.745C492.251 506.331 494.463 504.783 496.38 502.903C517.439 482.252 528.931 451.309 554.161 434.476C557.485 432.258 561.169 430.189 565.029 428.574C590.072 418.088 620.273 411.339 635.267 386.176C641.387 375.905 647.917 363.949 654.265 352.15C665.723 330.845 680.614 311.2 696.465 292.417C703.134 284.514 709.702 276.836 715.592 270.557C727.702 257.645 739.423 245.672 748.64 231.083C754.499 221.808 758.817 208.462 764.297 193.806C771.723 173.946 785.638 157.038 801.696 144.343C818.63 130.957 842.844 129.648 863.913 126.826C888.121 123.585 912.864 120.647 936.059 113.277C958.432 106.168 972.812 90.6836 992.587 79.9467",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M63.7373 669.633C88.908 652.857 117.364 643.958 146.206 636.574C149.425 635.751 152.672 634.837 155.825 634.043C192.974 624.7 216.156 606.094 233.597 573.161C248.405 545.202 264.044 513.5 299.809 510.486C339.904 507.107 380.64 515.051 420.572 519.066C446.171 521.64 471.702 524.206 495.27 510.811C497.38 509.611 499.666 508.301 501.628 506.69C524.003 488.324 536.586 458.801 561.92 443.083C565.396 440.926 569.238 438.915 573.258 437.359C598.889 427.433 630.921 421.577 645.24 395.232C650.987 384.655 657.466 372.666 663.38 360.321C673.874 338.418 686.137 318.031 701.391 299.057C707.727 291.177 714.182 283.705 720.185 277.852C732.231 266.111 746.197 255.078 757.181 243.208C764.864 234.904 771.002 221.315 777.452 206.307C785.987 186.447 799.212 168.755 814.381 154.142C828.973 140.086 852.287 136.608 871.689 133.3C894.038 129.49 917.252 125.4 938.837 118.127C960.613 110.79 975.272 95.094 995.068 85.2113",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M67.6274 672.977C92.2302 655.174 120.741 646.01 149.568 638.46C152.781 637.618 156.046 636.671 159.182 635.895C195.269 626.977 218.567 606.719 236.334 575.335C252.256 547.211 267.476 517.725 304.07 514.821C344.526 511.613 384.995 518.114 424.99 521.334C450.633 523.397 476.134 524.781 500.313 513.456C502.482 512.438 504.799 511.327 506.856 509.954C530.812 493.967 544.386 466.054 569.846 451.478C573.482 449.398 577.487 447.46 581.667 445.972C611.914 435.214 637.99 431.967 654.86 403.919C661.094 393.555 666.616 380.818 672.344 368.297C682.38 346.36 692.825 324.779 707.314 305.404C713.281 297.428 719.558 290.028 725.618 284.507C737.633 273.556 751.906 264.062 764.363 254.066C775.727 244.948 783.633 230.715 790.345 217.913C800.453 198.633 813.162 180.243 827.598 163.638C840.371 148.947 861.726 143.82 880.068 139.64C900.777 134.921 922.206 130.015 942.221 122.828C963.137 115.318 977.985 99.4457 997.549 90.47",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M71.5493 676.359C95.541 657.522 124.044 648.039 152.865 640.281C156.064 639.418 159.328 638.461 162.461 637.67C197.734 628.769 220.572 607.414 239.09 577.35C256.784 548.623 272.014 522.949 308.729 519.42C348.731 515.575 389.53 521.192 429.477 523.55C455.11 525.062 480.682 525.316 505.27 515.753C507.497 514.888 509.853 513.943 511.989 512.775C536.999 499.104 552.374 472.972 577.844 459.615C581.641 457.623 585.812 455.771 590.147 454.363C621.871 444.063 647.208 442.048 663.873 412.116C669.853 401.376 675.121 388.47 680.796 375.9C690.647 354.079 700.672 331.413 714.184 311.589C719.781 303.376 725.862 295.931 731.952 290.6C743.716 280.3 757.623 271.833 770.62 263.057C783.654 254.255 794.454 241.754 802.621 228.461C814.342 209.39 827.634 190.75 841.092 172.721C852.336 157.658 871.569 150.957 888.915 145.824C908.022 140.169 927.286 134.233 946.121 127.412C966.336 120.09 980.849 103.817 1000.03 95.7338",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M75.4692 679.738C99.085 660.072 127.148 650.088 156.105 642.043C159.29 641.158 162.531 640.209 165.671 639.372C200.371 630.132 222.451 608.165 241.96 579.289C261.233 550.766 277.841 528.53 313.804 524.306C353.266 519.67 394.237 524.304 434.017 525.739C459.609 526.662 485.234 525.903 510.083 517.764C512.361 517.019 514.76 516.211 516.963 515.216C542.708 503.582 560.266 479.604 585.801 467.425C589.759 465.537 594.091 463.784 598.573 462.464C631.707 452.705 655.821 451.512 672.08 419.715C677.77 408.591 682.752 395.504 688.451 382.979C698.467 360.971 709.621 338.299 721.881 317.757C726.994 309.193 733.05 301.518 739.175 296.232C750.744 286.251 764.774 278.894 777.762 270.502C791.964 261.328 803.833 250.372 813.935 237.829C827.849 220.556 841.737 200.331 854.611 181.3C865.275 165.539 881.415 158.591 898.101 151.821C915.008 144.96 933.259 138.81 950.449 131.893C969.536 124.213 984.104 109.454 1002.51 100.997",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M79.3896 683.117C102.874 662.818 130.062 652.172 159.298 643.758C162.463 642.846 165.717 641.953 168.86 641.022C202.981 630.926 225.085 608.887 245.022 581.239C264.35 554.434 285.596 534.206 319.296 529.524C358.374 524.093 398.952 527.584 438.592 527.935C464.158 528.159 489.727 526.6 514.701 519.555C517.025 518.9 519.46 518.2 521.721 517.346C548.052 507.398 567.867 485.925 593.585 474.851C597.701 473.079 602.186 471.441 606.803 470.215C641.283 461.062 663.687 460.265 679.334 426.65C684.693 415.141 689.454 402.14 695.107 389.434C705.204 366.746 718.969 345.4 730.21 324.101C735.014 314.995 741.003 306.938 747.197 301.549C758.833 291.424 773.526 284.458 786.696 276.388C800.451 267.957 813.191 257.125 823.931 245.965C839.729 229.55 855.286 209.707 867.901 189.328C877.091 174.48 892.017 164.64 907.492 157.626C923.176 150.517 939.228 143.077 955.119 136.296C973.199 128.582 987.02 113.688 1004.99 106.262",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M83.3091 686.492C106.685 665.617 132.955 654.248 162.454 645.432C165.6 644.491 168.886 643.559 171.967 642.524C205.149 631.36 227.232 609.726 248.341 583.269C268.678 557.78 293.111 540.587 325.197 535.118C363.526 528.585 403.96 530.825 443.185 530.16C468.581 529.731 494.112 527.45 519.089 521.179C521.451 520.587 523.92 519.967 526.225 519.223C552.955 510.611 575.029 491.873 601.054 481.828C605.318 480.182 609.948 478.672 614.681 477.548C650.453 469.052 670.709 468.223 685.549 432.877C690.542 420.987 694.97 407.886 700.641 395.208C710.923 372.223 727.171 351.987 738.909 330.83C744.177 321.338 749.539 312.367 755.851 306.723C767.631 296.191 782.938 289.223 796.38 281.06C809.368 273.173 821.874 263.171 832.958 252.576C850.607 235.705 868.188 217.864 880.708 196.778C889.241 182.409 902.639 171.355 916.955 163.232C930.856 155.342 945.307 147.27 960.058 140.63C977.145 132.938 990.091 118.021 1007.47 111.521",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M87.228 689.871C110.377 668.378 135.919 656.363 165.672 647.121C168.838 646.138 171.976 645.036 174.997 643.895C207.262 631.721 229.58 610.603 251.972 585.459C273.462 561.33 300.485 547.41 331.49 541.159C369.234 533.547 409.065 534.179 447.768 532.464C472.953 531.35 498.382 528.483 523.22 522.71C525.604 522.156 528.103 521.59 530.443 520.928C557.344 513.31 582.325 497.574 608.05 488.309C612.361 486.757 617.212 485.431 622.035 484.415C658.761 476.676 676.94 474.995 690.694 438.404C695.297 426.154 699.361 412.957 705.009 400.305C715.327 377.187 731.459 357.71 746.562 337.751C753.832 328.141 758.395 318.033 764.892 311.98C776.805 300.882 792.389 293.638 806.135 284.858C818.627 276.877 830.762 267.535 841.99 257.692C860.581 241.393 880.1 224.803 892.779 203.683C901.081 189.854 913.082 177.824 926.357 168.663C938.676 160.163 951.477 151.489 965.184 144.926C981.21 137.251 993.322 122.503 1010 116.777",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M91.1475 693.25C113.599 671.535 139.632 658.049 168.833 648.696C171.926 647.706 175.011 646.389 177.972 645.151C209.319 632.047 232.19 611.559 255.956 587.867C278.404 565.491 308.017 553.614 338.378 547.231C375.798 539.366 414.345 537.669 452.321 534.877C477.23 533.047 502.475 529.76 527.077 524.206C529.474 523.663 531.988 523.129 534.354 522.516C561.677 515.44 587.714 502.389 614.403 494.23C618.903 492.854 623.795 491.653 628.68 490.749C666.062 483.837 682.296 480.536 694.792 443.253C699.006 430.678 702.685 417.393 708.245 404.757C718.531 381.383 735.838 362.694 752.75 344.117C760.961 335.097 767.262 323.727 773.998 317.566C786.018 306.577 801.445 297.93 815.423 288.075C824.634 281.58 836.538 273.104 850.347 261.801C869.523 246.105 889.772 230.59 903.862 210.085C913.162 196.549 922.81 184.43 935.569 173.939C947.512 164.119 957.767 155.631 970.43 149.189C984.411 142.079 997 125.735 1012.78 121.969",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M95.0664 696.629C117.174 674.333 143.114 660.438 171.943 650.163C174.961 649.086 178.004 647.643 180.909 646.312C211.403 632.339 235.249 612.525 260.318 590.553C283.612 570.136 315.407 559.458 345.09 553.154C381.854 545.349 419.614 541.336 456.812 537.441C481.381 534.867 506.382 531.312 530.656 525.728C533.05 525.178 535.57 524.648 537.952 524.056C565.411 517.231 592.308 506.434 619.429 499.501C624.116 498.303 629.188 497.281 634.198 496.494C672.194 490.526 686.653 485.084 697.926 447.489C701.776 434.644 705.079 421.278 710.469 408.653C720.591 384.939 738.954 366.904 757.588 349.855C766.761 341.46 775.682 330.632 782.77 323.775C794.764 312.17 810.313 301.83 823.848 291C832.371 284.181 843.861 275.762 857.641 265.17C877.147 250.177 898.942 235.922 913.699 216.077C923.284 203.183 932.807 190.317 944.454 179.099C955.342 168.612 964.026 159.877 975.728 153.444C988.621 146.352 1000.68 130.297 1015.77 127.113",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M98.9873 700.004C120.773 677.081 146.436 663.004 175.016 651.532C177.98 650.342 180.968 648.81 183.824 647.391C213.547 632.603 238.879 613.499 265.072 593.562C289.094 575.278 322.274 565.272 351.529 558.934C387.637 551.112 424.798 545.2 461.211 540.19C485.398 536.862 510.108 533.18 533.957 527.336C536.338 526.753 538.852 526.21 541.236 525.612C568.731 518.711 596.268 510.015 623.75 504.061C628.47 503.039 633.52 502.172 638.508 501.519C676.31 496.568 690.163 488.18 700.234 451.202C703.784 438.166 706.746 424.75 711.873 412.121C721.67 387.993 740.846 370.429 760.993 354.935C771.091 347.168 781.686 339.003 790.586 330.895C804.071 318.609 818.021 306.057 831.149 293.899C838.981 286.65 849.899 278.085 863.606 268.05C883.405 253.556 906.491 240.122 922.038 221.772C932.152 209.837 942.028 196.16 952.883 184.188C962.95 173.087 970.233 164.133 981.016 157.696C992.907 150.595 1004.44 134.874 1018.91 132.217",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M102.906 703.383C124.383 679.825 149.672 665.725 178.065 652.829C180.994 651.498 183.921 649.913 186.732 648.409C215.78 632.863 243.035 614.4 270.218 596.947C295.246 580.874 328.17 571.155 357.617 564.586C393.19 556.653 429.703 549.305 465.489 543.177C489.285 539.103 513.659 535.407 536.998 529.098C539.353 528.462 541.848 527.882 544.224 527.251C571.631 519.966 599.686 513.084 627.395 507.994C632.127 507.126 637.123 506.413 642.078 505.855C678.987 501.702 691.994 488.868 701.87 454.495C705.537 441.734 707.963 427.992 712.735 415.346C722.002 390.782 741.601 373.432 762.984 359.4C773.91 352.229 786.342 344.99 795.756 337.891C811.113 326.311 823.883 311.517 837.205 297.034C844.381 289.229 854.528 280.325 868.098 270.686C887.881 256.634 912.042 244.143 928.168 227.441C938.932 216.294 948.308 200.208 960.723 189.274C966.542 176.023 975.809 168.311 986.232 161.968C1002.39 152.137 1014.17 136.204 1022.16 137.3",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M106.825 706.762C127.827 682.755 153.14 668.135 181.104 654.062C183.993 652.608 186.875 650.962 189.646 649.38C218.118 633.126 247.779 615.492 275.745 600.738C301.774 587.005 333.468 577.031 363.292 570.124C398.499 561.97 434.213 553.809 469.604 546.444C493.046 541.566 517.053 538.039 539.804 531.073C542.12 530.364 544.585 529.727 546.937 529.037C574.118 521.073 602.589 515.719 630.386 511.374C635.108 510.637 640.072 510.115 644.942 509.58C680.307 505.681 692.597 489.816 703.03 457.579C707.042 445.182 709.082 431.217 713.407 418.549C721.928 393.596 741.343 376.121 763.675 363.338C775.275 356.698 788.097 349.653 799.221 344.215C818.33 334.873 829.672 316.977 842.028 300.632C848.439 292.147 857.751 282.709 871.097 273.297C890.744 259.439 914.902 247.829 932.46 232.582C945.071 221.631 955.284 206.633 967.839 194.43C973.629 180.691 981.686 172.661 991.327 166.268C1006.09 156.48 1017.36 141.184 1025.45 142.371",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M110.745 710.141C131.177 685.82 156.733 670.255 184.143 655.25C186.994 653.69 189.843 651.976 192.578 650.323C220.566 633.416 252.791 617.741 281.627 604.971C308.384 593.121 338.843 582.748 368.516 575.558C403.425 567.097 438.91 558.783 473.522 550.04C496.285 544.29 520.327 541.119 542.411 533.321C544.675 532.521 547.099 531.809 549.415 531.038C576.209 522.114 605.005 517.999 632.754 514.285C637.447 513.657 642.483 513.336 647.14 512.776C678.135 509.054 693.944 491.395 704.195 460.931C708.311 448.693 710.523 434.69 714.327 422.003C721.887 396.793 740.269 378.744 763.286 366.905C775.349 360.7 789.868 355.198 801.065 349.948C822.229 340.026 833.766 325.569 845.77 304.915C851.135 295.686 859.709 285.453 872.705 276.09C892.089 262.127 914.869 250.96 935.037 237.268C950.501 226.77 960.851 212.561 974.102 199.74C980.306 185.457 987.309 177.076 996.245 170.614C1009.76 160.838 1020.6 146.156 1028.75 147.442",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M114.664 713.516C134.459 688.988 160.425 672.088 187.195 656.398C190.008 654.751 192.826 652.959 195.541 651.244C223.215 633.771 257.782 621.183 287.825 609.663C315.322 599.119 344.143 588.331 373.257 580.894C407.849 572.059 442.786 563.451 477.159 553.978C499.617 547.789 523.522 544.681 544.862 535.896C547.063 534.99 549.435 534.184 551.704 533.306C577.937 523.154 606.961 520 634.544 516.795C639.197 516.257 644.316 516.13 648.73 515.519C677.103 511.587 693.947 492.919 705.551 464.725C710.313 453.156 714.848 440.494 716.997 427.096C721.029 401.938 739.181 381.34 762.133 370.299C774.393 364.399 789.38 359.786 800.934 354.677C822.002 345.363 840.051 331.814 848.721 310.078C852.669 300.181 860.6 289.223 873.146 279.253C892.086 264.205 915.876 254.215 935.963 241.64C952.048 231.57 965.856 219.339 979.378 205.295C986.487 190.363 992.623 181.563 1000.94 175.004C1013.37 165.208 1023.83 151.123 1032.02 152.516",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M118.584 716.895C137.772 692.155 164.085 673.831 190.268 657.529C193.047 655.8 195.848 653.94 198.544 652.167C225.898 634.178 263.016 625.373 293.914 614.7C321.717 605.097 349.086 593.863 377.512 586.159C411.762 576.877 446.289 567.399 480.314 557.896C502.361 551.739 526.735 548.762 547.217 538.87C549.344 537.841 551.656 536.925 553.863 535.917C579.351 524.288 608.489 521.808 635.819 518.995C640.419 518.522 645.797 518.672 649.72 517.85C677.578 512.008 692.895 494.822 707.252 469.118C712.929 458.955 717.867 446.59 720.284 433.226C724.925 407.573 735.558 385.677 760.632 373.796C772.774 368.044 787.756 363.692 799.608 359.012C821.208 350.482 842.613 340.224 851.308 316.314C855.443 304.938 860.958 293.411 872.769 282.97C890.773 267.055 914.534 257.253 935.373 245.85C952.356 236.556 970.994 226.52 983.532 211.216C994.82 197.441 997.571 186.143 1005.37 179.461C1016.88 169.607 1027.01 156.104 1035.21 157.611",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M122.503 720.273C141.098 695.219 167.665 675.611 193.37 658.654C196.123 656.837 198.911 654.925 201.591 653.103C228.748 634.635 269.1 629.747 299.805 619.943C326.846 611.309 353.63 599.369 381.29 591.364C415.141 581.567 449.457 571.054 482.896 561.671C504.499 555.611 529.87 553.473 549.539 542.298C551.584 541.135 553.833 540.089 555.962 538.933C580.482 525.615 609.621 523.501 636.657 520.959C641.197 520.531 646.189 520.551 650.02 519.626C676.346 513.269 693.459 497.064 709.413 474.209C715.795 465.066 721.095 453.917 724.229 440.424C730.175 414.823 733.123 390.77 759.3 377.72C770.958 371.909 785.67 367.727 797.596 363.397C819.86 355.311 841.405 346.017 852.944 323.217C858.631 311.979 861.265 298.529 872.041 287.404C888.651 270.254 912.274 260.699 933.477 250.026C951.755 240.825 971.671 231.582 986.248 217.308C999.74 204.098 1002.1 190.824 1009.5 183.992C1020.28 174.042 1030.12 161.107 1038.32 162.729",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M126.423 723.652C144.569 698.229 171.122 677.411 196.507 659.78C199.239 657.882 202.021 655.926 204.693 654.061C231.796 635.137 274.908 634.751 305.558 625.408C331.799 617.408 357.838 604.863 384.618 596.521C418.015 586.117 452.143 574.559 485.028 565.35C505.968 559.487 533.402 558.678 551.909 546.237C553.857 544.929 556.05 543.734 558.083 542.411C581.386 527.243 610.391 525.154 637.148 522.759C641.622 522.359 646.285 522.119 650.078 521.139C675.131 514.652 694.531 499.75 712.118 480.059C719.264 472.059 725.437 461.926 728.902 448.717C734.942 425.685 735.222 395.522 759.071 382.811C769.8 377.094 783.493 372.167 795.289 368.133C819.889 359.72 838.68 350.703 853.278 330.538C860.467 320.608 862.193 304.74 871.558 292.694C886.07 274.025 909.383 264.428 930.553 254.29C949.831 245.058 970.701 236.618 987.216 223.002C1003.22 209.81 1006.18 195.617 1013.3 188.601C1023.53 178.514 1033.12 166.134 1041.3 167.874",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M130.342 727.027C148.123 701.135 174.6 679.202 199.684 660.916C202.388 658.947 205.184 656.951 207.852 655.05C235.024 635.707 280.408 640.239 311.187 631.106C336.649 623.551 361.709 610.343 387.541 601.646C420.47 590.555 454.344 577.905 486.793 568.953C506.178 563.606 537.981 563.928 554.411 550.746C556.241 549.279 558.394 547.92 560.317 546.414C582.216 529.251 610.648 527.143 637.38 524.446C641.765 524.005 646.259 523.557 650.055 522.562C674.23 516.222 696.221 503.033 715.413 486.688C723.364 479.917 730.484 470.882 734.318 458.082C740.757 436.599 739.356 403.443 759.719 388.8C768.954 382.158 781.679 376.946 793.051 373.462C817.011 366.123 837.205 356.854 852.789 338.572C861.031 328.904 864.555 312.213 872.031 298.974C883.543 278.588 906.56 268.427 926.956 258.754C946.814 249.338 970.139 241.391 986.735 228.349C999.66 218.189 1006.49 205.395 1016.72 193.294C1025.32 183.114 1035.98 171.19 1044.14 173.049",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M134.261 730.406C151.709 704.004 178.039 680.926 202.907 662.082C205.585 660.053 208.386 658.015 211.074 656.091C239.788 635.524 283.444 647.88 316.738 637.06C341.896 628.884 365.321 615.845 390.119 606.759C422.471 594.908 455.859 580.935 488.263 572.51C507.416 567.531 540.895 569.796 557.232 555.866C559.066 554.303 560.968 552.713 562.767 551.009C583.124 531.721 611 529.18 637.561 526.095C641.851 525.597 646.257 525.026 650.094 524.057C673.998 518.018 698.502 507.11 719.313 494.079C728.094 488.583 736.204 480.711 740.454 468.444C748.026 446.585 745.344 413.231 761.488 395.761C768.426 388.253 780.444 382.856 791.207 379.566C814.725 372.374 835.481 364.51 851.877 347.517C862.108 336.912 869.603 321.415 874.503 306.564C881.687 284.791 903.545 272.558 923.112 263.531C943.922 253.928 966.957 245.704 985.102 233.435C999.756 223.525 1009.18 211.329 1019.75 198.083C1028.01 187.733 1038.68 176.287 1046.84 178.263",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M138.182 733.785C155.305 706.865 181.344 682.617 206.181 663.282C208.85 661.202 211.661 659.129 214.358 657.187C244.004 635.837 287.795 655.091 322.081 643.358C346.208 635.102 368.68 621.411 392.437 611.877C424.067 599.183 457.151 583.876 489.511 576.038C509.094 571.293 543.208 574.518 560.257 561.166C562.203 559.645 564.132 558.085 565.703 556.236C584.073 534.619 611.311 531.297 637.865 527.853C642.091 527.304 646.414 526.657 650.322 525.749C674.734 520.087 701.242 512.064 723.797 502.171C733.414 497.952 742.52 491.282 747.229 479.657C756.864 455.87 753.066 425.164 764.621 403.722C768.957 395.676 780.054 389.645 790.049 386.545C812.921 379.451 833.887 373.185 850.897 357.468C862.712 346.552 872.244 329.833 877.381 315.512C884.36 296.059 899.678 278.477 919.516 268.711C940.303 258.476 963.036 249.856 982.597 238.338C998.828 228.78 1010.79 217.095 1022.37 202.97C1031.1 192.305 1041.21 181.424 1049.37 183.515",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M142.102 737.16C158.828 709.71 184.585 684.14 209.506 664.499C212.173 662.397 214.993 660.299 217.708 658.347C248.482 636.209 291.751 663.507 327.517 650.198C350.829 641.525 371.886 627.073 394.589 617.016C425.406 603.363 458.339 586.845 490.602 579.552C510.636 575.025 545.507 579.333 563.275 566.499C565.327 565.018 567.507 563.476 569.001 561.666C586.7 540.234 610.866 533.741 638.409 529.84C642.595 529.246 646.809 528.539 650.843 527.749C676.499 522.726 704.202 518.443 728.811 510.854C739.421 507.583 749.214 502.44 754.516 491.521C766.256 467.342 761.757 438.305 769.218 413.291C772.282 403.023 780.753 397.343 789.839 394.443C811.862 387.415 832.861 382.896 850.153 368.434C863.067 357.636 872.183 341.008 879.835 325.577C889.676 305.732 895.862 286.019 917.093 274.398C937.509 263.224 959.402 254.028 979.482 243.129C996.28 234.013 1012.84 222.522 1024.55 207.957C1033.35 197.006 1043.54 186.605 1051.74 188.801",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M146.021 740.539C162.534 712.531 187.709 685.719 212.859 665.752C215.535 663.627 218.386 661.527 221.12 659.58C253.174 636.742 295.747 672.41 333.254 657.508C355.755 648.57 375.154 632.826 396.692 622.198C426.667 607.407 459.426 589.918 491.597 583.078C512.082 578.722 547.833 584.25 566.343 571.882C568.501 570.441 570.678 568.94 572.336 567.142C592.756 545.001 608.055 537.046 639.292 532.159C643.472 531.505 647.666 530.855 651.748 530.147C678.995 525.413 707.541 524.839 734.261 519.995C745.685 517.926 756.488 513.825 762.139 503.786C775.258 480.483 770.127 450.123 774.708 424.374C776.712 413.116 782.754 405.917 790.801 403.238C811.759 396.258 832.619 393.584 849.908 380.332C863.752 369.72 873.621 352.549 882.13 336.729C891.598 319.121 898.576 292.682 916.18 280.665C934.845 267.924 955.855 258.28 976.003 247.882C994.049 238.567 1012.65 228.392 1026.28 213.052C1036.41 201.647 1045.68 191.836 1053.95 194.128",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M149.939 743.918C166.338 715.34 190.734 687.333 216.244 667.059C218.931 664.924 221.806 662.826 224.581 660.899C258.323 637.461 299.711 681.512 339.309 665.202C361.098 656.226 378.576 638.722 398.875 627.441C427.879 611.325 460.416 593.036 492.552 586.628C513.565 582.437 550.226 589.275 569.513 577.325C571.775 575.923 573.97 574.453 575.76 572.674C597.337 551.232 608.089 539.556 640.592 534.889C644.691 534.301 648.955 533.609 653.108 533.003C682.054 528.786 711.512 531.745 740.026 529.405C752.175 528.407 763.742 525.692 769.738 515.854C783.77 492.832 778.608 462.175 780.953 436.346C782.047 424.302 786.235 415.277 793.125 412.839C812.761 405.89 833.201 405.06 850.37 392.981C864.572 382.991 875.848 365.181 884.489 348.851C894.777 329.412 902.738 303.173 916.879 287.576C930.932 272.075 953.029 262.46 972.383 252.656C991.686 242.877 1011.46 233.13 1027.45 218.237C1039.81 206.737 1047.6 197.117 1056.01 199.492",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M153.86 747.297C170.129 718.141 193.724 688.959 219.666 668.44C222.371 666.301 225.284 664.221 228.099 662.323C263.472 638.458 303.899 690.838 345.689 673.197C367.087 664.164 382.039 645.253 401.294 632.771C429.069 614.762 461.672 596.255 493.52 590.216C515.321 586.083 552.736 594.47 572.824 582.834C575.179 581.47 577.457 580.028 579.314 578.27C601.071 557.665 609.62 542.88 642.376 538.088C646.458 537.49 650.736 536.848 654.97 536.365C685.388 532.896 716.503 538.68 745.946 538.858C758.502 538.933 770.621 536.495 777.018 527.39C792.362 505.556 787.203 474.269 787.889 448.883C788.23 436.275 791.362 425.744 796.975 423.25C813.992 415.695 835.071 417.076 851.709 406.115C866.388 396.445 878.04 378.263 887.094 361.75C898.995 340.041 909.599 315.005 919.432 295.193C927.811 278.305 950.605 266.834 968.83 257.511C988.976 247.206 1010.03 237.437 1027.9 223.322C1041.92 212.252 1049.32 202.448 1057.93 204.89",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M157.797 750.707C173.701 720.935 196.771 690.528 223.135 669.904C225.859 667.771 228.806 665.717 231.679 663.86C268.972 639.769 308.088 700.283 352.388 681.416C373.986 672.217 385.902 651.854 404.113 638.197C430.36 618.511 462.921 599.458 494.549 593.854C517.022 589.871 555.388 599.706 576.31 588.407C578.762 587.083 581.11 585.667 583.03 583.927C604.427 564.532 612.724 546.373 644.686 541.785C648.741 541.203 653.125 540.505 657.371 540.246C688.91 538.315 720.554 544.623 751.828 548.081C765.031 549.54 776.968 546.598 783.891 538.279C800.752 518.014 795.895 486.362 795.434 461.687C795.193 448.72 797.194 437.617 802.142 434.705C816.651 426.17 838.587 429.016 854.041 419.362C868.955 410.047 880.844 391.649 890.08 375.16C902.911 352.251 916.886 329.206 924.006 303.711C929.555 283.838 948.568 271.751 965.534 262.496C986.264 251.186 1008.3 241.65 1027.9 228.279C1043.54 217.616 1050.83 207.822 1059.73 210.313",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M161.737 754.125C176.998 723.784 199.902 691.997 226.656 671.467C229.414 669.351 232.399 667.336 235.33 665.533C274.459 641.459 312.501 709.717 359.398 689.791C381.257 680.504 391.119 659.029 407.519 643.75C430.978 621.895 464.563 602.699 495.682 597.555C518.892 593.717 558.196 605.041 579.988 594.052C582.536 592.766 584.95 591.37 586.927 589.651C607.8 571.474 616.692 550.283 647.549 546.003C651.568 545.444 655.932 544.877 660.321 544.651C693.421 542.962 725.173 553.02 757.445 556.773C770.875 558.336 782.658 555.863 790.231 548.375C808.791 530.027 804.654 498.384 803.492 474.512C802.853 461.374 804.049 449.444 808.389 446.609C820.986 438.377 843.074 440.46 857.439 432.275C872.195 423.865 884.184 404.981 893.501 388.687C907.206 364.72 924.627 338.376 928.964 313.558C932.251 294.744 945.691 277.872 962.667 267.66C983.598 255.071 1006.54 245.734 1027.56 233.143C1044.73 222.854 1052.15 213.248 1061.43 215.761",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M165.669 757.523C180.453 726.644 203.007 693.557 230.236 673.138C233.026 671.047 236.052 669.078 239.057 667.341C280.229 643.539 316.987 719.038 366.702 698.251C388.823 689 397.775 666.461 411.713 649.449C431.229 625.628 466.904 605.955 496.957 601.325C520.957 597.625 561.256 610.438 583.868 599.757C586.498 598.516 588.982 597.134 591.011 595.43C611.35 578.355 621.297 554.769 650.974 550.727C654.959 550.184 659.379 549.646 663.819 549.551C697.415 548.83 729.375 562.507 762.475 564.523C775.767 565.332 787.558 564.155 795.9 557.558C816.281 541.443 813.42 510.281 811.942 487.138C811.102 473.997 811.582 461.797 815.614 458.684C826.289 450.443 849.35 451.158 861.925 444.297C876.35 436.426 888.271 417.632 897.464 401.943C911.815 377.452 927.152 351.379 933.601 324.299C938.521 303.632 941.45 286.063 960.381 273.042C980.979 258.876 1004.87 249.73 1026.95 237.928C1045.57 227.98 1053.28 218.713 1063.06 221.223",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M169.596 760.918C183.93 729.552 206.124 695.156 233.88 674.936C236.706 672.878 239.784 670.966 242.863 669.308C286.064 646.03 321.653 728.17 374.269 706.742C396.922 697.517 405.104 674.399 416.946 655.379C432.973 629.639 469.507 609.409 498.406 605.178C517.074 602.446 533.886 603.254 553.004 605.628C565.432 607.172 575.662 611.015 587.95 605.525C590.662 604.313 593.21 602.951 595.283 601.265C616.019 584.394 624.789 561.058 654.954 555.937C659.009 555.25 663.36 554.895 667.839 554.909C701.424 555.021 733.841 569.061 767.027 571.64C780.311 572.671 791.861 571.35 800.851 565.699C823.032 551.756 822.099 522.03 820.651 499.395C819.821 486.392 819.826 474.043 823.697 470.711C833.49 462.284 855.612 461.588 867.475 454.756C881.701 446.561 892.774 429.42 902.085 414.676C917.01 391.044 931.543 363.325 938.055 335.669C942.662 316.097 941.733 292.74 958.811 278.687C978.301 262.648 1003.39 253.685 1026.17 242.671C1046.13 233.02 1054.3 224.229 1064.82 226.708",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M173.521 764.305C187.439 732.505 209.268 696.785 237.594 676.856C240.459 674.839 243.591 672.996 246.754 671.427C292.114 648.939 326.409 737.01 382.066 715.193C405.343 706.071 413.042 682.228 422.805 661.611C435.759 634.26 471.757 612.983 500.062 609.112C519.138 606.503 536.737 606.898 556.25 610.44C568.764 612.711 579.738 616.602 592.225 611.331C595.008 610.157 597.628 608.806 599.727 607.133C620.502 590.572 630.017 567.255 659.662 561.861C663.61 561.143 667.973 560.708 672.44 560.777C705.917 561.288 738.368 575.68 771.555 578.731C784.851 579.953 796.618 578.872 805.706 573.396C827.856 560.047 830.576 534.424 829.472 511.127C828.869 498.388 828.642 486.009 832.497 482.488C842.188 473.633 862.759 471.764 874.511 463.832C887.589 455.007 898.542 440.551 907.456 426.659C922.448 403.295 936.133 375.221 942.445 347.417C946.599 329.119 944.211 299.125 958.074 284.613C975.376 266.5 1003.03 257.908 1025.28 247.379C1037.81 241.452 1051.89 230.819 1066.91 232.173",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M177.446 767.695C190.985 735.521 212.44 698.463 241.379 678.919C244.292 676.953 247.482 675.185 250.736 673.718C298.342 652.253 331.269 745.533 390.052 723.566C414.111 714.574 421.231 689.965 429.38 668.182C440.117 639.481 473.313 616.807 501.945 613.142C521.618 610.626 539.675 611.253 559.722 615.327C572.503 617.924 583.768 622.347 596.667 617.175C599.516 616.033 602.197 614.689 604.322 613.029C625.13 596.752 635 573.231 664.511 567.914C668.454 567.203 672.821 566.786 677.281 566.882C710.685 567.606 742.95 582.306 776.037 585.795C789.339 587.198 801.51 586.505 810.561 581.101C831.63 568.527 838.506 545.579 838.235 522.243C838.091 509.868 837.875 497.563 841.854 493.878C851.978 484.498 871.531 481.69 883.477 472.505C895.039 463.614 905.183 450.307 913.639 437.735C928.867 415.093 941.07 386.518 946.878 359.335C951.032 339.898 947.559 306.932 958.269 290.859C971.61 270.833 1002.02 261.758 1024.36 252.086C1038.07 246.148 1053.02 236.218 1068.94 237.59",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M181.368 771.078C194.723 738.645 215.517 700.204 245.242 681.116C248.211 679.21 251.441 677.496 254.807 676.174C305.605 656.211 335.685 753.826 398.171 731.795C423.169 722.981 429.638 697.527 436.654 675.161C445.889 645.714 474.194 620.917 504.078 617.261C522.516 615.005 540.053 615.338 558.894 619.056C573.645 621.966 586.381 628.537 601.25 623.025C604.132 621.958 606.863 620.568 609.026 618.918C630.076 602.872 639.928 579.304 669.432 574.018C673.369 573.312 677.734 572.907 682.181 573.029C715.482 573.936 747.494 588.782 780.506 592.844C793.972 594.5 806.258 594.063 815.416 588.802C835.109 577.487 845.712 554.698 846.751 532.665C847.316 520.727 847.35 508.59 851.589 504.762C862.506 494.903 881.576 491.173 894.137 480.991C902.314 474.362 910.375 464.419 920.675 447.758C935.145 424.352 946.132 397.775 951.443 371.22C956.027 348.297 951.361 317.104 959.475 297.431C968.401 275.791 1001.43 265.637 1023.47 256.794C1038.37 250.817 1054.11 241.563 1070.96 242.958",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M185.291 774.461C198.352 741.777 218.773 701.974 249.183 683.466C252.208 681.625 255.517 680.036 258.969 678.804C283.82 669.934 303.945 695.094 319.984 709.676C344.487 731.958 371.728 751.269 406.367 739.846C431.856 731.441 438.506 705.482 444.432 682.465C452.258 652.074 474.935 625.114 506.475 621.478C525.23 619.316 543.571 619.402 562.676 623.939C577.497 627.46 590.896 634.222 605.931 628.868C608.852 627.828 611.605 626.428 613.8 624.789C635.019 608.938 644.979 585.429 674.404 580.161C678.332 579.458 682.689 579.064 687.122 579.207C720.294 580.268 752.126 595.239 784.976 599.895C798.586 601.824 811.006 601.624 820.271 596.503C838.808 586.259 851.98 562.976 854.824 542.367C856.409 530.872 856.855 519.045 861.504 515.084C873.484 504.878 892.854 500.252 905.888 489.403C913.811 482.809 920.818 471.662 928.813 456.607C941.519 432.678 951.139 408.54 956.217 382.915C961.249 357.522 958.335 327.368 961.758 304.356C965.095 281.922 1001.33 269.694 1022.67 261.53C1038.12 255.619 1055.71 246.293 1073.01 248.296",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M189.208 777.832C202.005 744.96 222.015 703.84 253.202 685.96C256.294 684.188 259.706 682.647 263.225 681.608C290.815 673.461 312.46 704.03 330.384 720.321C354.243 742.004 381.536 757.761 414.566 747.675C440.439 739.775 447.799 713.5 452.574 689.996C458.776 659.465 476.476 629.35 509.148 625.786C528.38 623.687 547.14 623.938 566.665 628.871C581.689 632.667 595.334 639.97 610.656 634.674C613.602 633.655 616.288 632.207 618.509 630.593C640.128 614.874 650.02 591.592 679.4 586.322C683.308 585.622 687.655 585.234 692.077 585.394C725.164 586.593 756.844 601.671 789.445 606.945C803.172 609.165 815.752 609.185 825.126 604.203C844.161 594.09 856.46 571.313 862.226 551.357C865.383 540.438 866.162 529.256 871.381 524.813C884.569 513.591 904.419 510.733 918.234 497.775C926.066 490.428 932.213 479.591 938.468 464.945C948.2 442.158 957.161 418.414 961.26 394.275C965.764 367.749 965.397 338.023 965.174 311.665C964.96 286.09 1001.33 273.939 1022.01 266.302C1038.42 260.241 1056.94 251.667 1075.11 253.606",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M193.118 781.191C205.75 748.19 225.407 705.716 257.304 688.606C260.457 686.916 263.93 685.538 267.577 684.585C296.048 677.133 318.483 710.202 336.382 726.696C360.817 749.212 388.734 764.769 422.698 755.247C448.927 747.893 456.652 721.275 460.955 697.68C466.409 667.777 477.443 633.784 512.101 630.185C531.782 628.142 550.93 628.534 570.846 633.84C586.001 637.878 599.843 645.691 615.367 640.413C618.32 639.409 620.907 637.93 623.172 636.364C645.164 621.176 655.049 597.782 684.404 592.487C688.301 591.783 692.634 591.405 697.028 591.579C729.95 592.886 761.594 608.111 793.917 613.993C807.751 616.513 820.498 616.745 829.981 611.904C850.118 601.625 859.941 579.137 868.727 559.675C873.386 549.351 875.117 538.47 880.985 533.969C895.521 522.82 916.345 519.388 930.739 506.133C938.518 498.97 944.506 488.409 949.002 473.222C955.748 450.446 963.5 428.145 966.621 405.186C970.375 377.557 971.733 347.074 969.073 319.611C966.386 291.846 1000.29 278.492 1021.54 271.124C1039.33 264.955 1057.97 257.008 1077.28 258.894",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M197.014 784.531C209.308 751.482 229.031 707.581 261.485 691.407C264.702 689.804 268.314 688.479 272.017 687.737C299.538 682.222 320.638 711.961 338.253 728.933C364.232 753.962 393.462 771.995 430.673 762.534C457.201 755.79 466.052 729.61 469.456 705.444C473.572 676.22 480.175 638.181 515.339 634.68C535.453 632.676 554.916 633.157 575.185 638.823C590.329 643.057 604.363 651.439 619.878 646.026C622.738 645.03 625.474 643.62 627.787 642.104C650.137 627.464 660.089 603.976 689.393 598.647C693.279 597.941 697.594 597.566 701.958 597.752C734.734 599.152 766.321 614.583 798.386 621.048C812.333 623.859 825.23 624.317 834.836 619.608C855.356 609.547 864.541 586.786 874.221 567.622C879.525 557.119 883.429 547.141 890.059 542.611C906.01 531.716 927.949 528.118 943.027 514.512C950.867 507.435 956.804 496.749 960.017 481.469C964.615 459.599 970.228 437.36 972.328 415.565C975.07 387.124 976.26 354.933 972.787 327.937C969.11 299.343 998.257 283.815 1021.29 276.012C1039.97 269.685 1059.33 262.381 1079.54 264.168",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            d: "M200.896 787.836C213.859 753.37 236.67 698.148 276.551 691.056C304.525 686.082 326.579 717.953 344.19 735.026C370.757 760.779 400.276 778.392 438.402 769.502C502.948 754.454 454.778 645.316 518.855 639.253C541.673 637.095 562.139 638.88 584.707 645.56C598.187 649.55 610.199 656.507 624.283 651.569C652.296 641.747 661.951 610.193 694.354 604.782C741.646 596.881 795.742 646.959 839.691 627.308C871.211 613.215 872.758 568.607 898.33 550.833C924.884 532.378 965.309 531.514 971.166 489.706C978.329 438.572 980.527 387.067 976.371 336.532C972.364 287.808 1041.05 265.98 1081.9 269.42",
            stroke: "#98F215",
            strokeWidth: "0.666667",
            strokeMiterlimit: "10"
          }
        )
      ]
    }
  )
] }) });
export {
  $c as AboutUs,
  jc as CTA,
  Kc as ErrorPage,
  Rc as FAQs,
  Ic as Footer,
  Dc as Guarantees,
  Vc as Header,
  zc as Hero,
  Bc as HighlightedFeatures,
  Wc as HighlightedServices,
  Hc as OurProcess,
  Gc as OurTeam,
  qc as OurWork,
  Uc as Qualifications,
  Qc as RequestQuote,
  Yc as ServiceArea,
  Jc as Testimonials,
  Zc as TradeCategories
};
